(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._unmatchedHeader_qcj19_1{opacity:.55}._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as RI, getPartnerDevApiHeaders as PI, WidgetContextProvider as AI, makeExecuteQuery as LI, makeUseLazyQuery as VI, makeUseQuery as zI, makeUseMutation as UI, useWidgetSettingsMutations as Gr, useWidgetSettingsQuery as Yr, useRenderConditions as Qr, PartnerSettingsWrapper as Jr, handleWidgetSubmit as Xr, MisconfigurationBanner as Zr, validateApiHostName as Ey, PartnerHookFormSecretText as Da, WidgetSettingsFormFooter as ei, useTracking as En, useWidgetContext as _n, hasDownstreamApiForbiddenError as Ul, hasDownstreamApiAuthorizationError as Ml, DisplayErrors as Tn, settingsToFormValues as MI, useCopyWithDelay as ir, defaultDateFormat as It, displayAttributeValue as Gi, OAuthSettings as Oa, useData as $y, isDownstreamApiNotFoundError as BI, isDownstreamApiAuthorizationError as Hw, KlaviyoSubscribeSetting as qI, isDownstreamApiPermissionError as HI, capitalizeFirstCharacter as Ww, humanizeKey as WI, hasDownstreamApiTooManyRequestsError as KI, hasDownstreamApiPermissionError as Kw, PartnerHookFormBasicAuth as GI, hasDownstreamApiNotFoundError as Ra, getCountryNameFromCountryCode as YI, parseBoolean as QI, parseString as JI, IntegrationModal as Gw, useInboundOAuthContext as XI, getWidgetConfigurationByIdQuery as ZI, createWidgetConfigurationMutation as eE, updateWidgetConfigurationMutation as nE, trackRenderConditionsSaved as tE, deleteWidgetConfigurationMutation as rE } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import $e, { useMemo as Xn, useState as de, useEffect as Je, useRef as Bi, useCallback as ft, useReducer as iE, useLayoutEffect as aE, useContext as Ty, isValidElement as Yw, createContext as Qw, createElement as oE, Fragment as sE } from "react";
import { FlexBox as b, Switch as hl, FieldLabel as Jw, FieldWrapper as en, InputText as _r, InputSelectionList as _i, FormGrid as mt, FormField as ce, Text as P, Spinner as vn, Icon as he, Tooltip as Xe, List as Qe, Badge as Bn, Button as nt, IconButton as mr, Tag as Yn, NavigationButton as Bt, Select as Or, CollapseCard as xr, Box as ct, Modal as $t, ModalHead as Tt, ModalBody as Dt, ModalFoot as Ht, Textarea as Uh, TagsInput as Bl, Image as Pa, Banner as ql, Divider as Dy, SelectionList as kt, FieldText as ur, FieldTextarea as lE, CopyToClipboardButton as cE, getSelectionListContext as uE, Avatar as Oy, Timestamp as dE, Attachment as mE, FieldSwitch as Ry, EmptyState as yl, Table as st, Checkbox as Sv, TextWithHighlight as pE, ErrorBoundaryContext as Xw } from "@dixa/lib-shared-habla";
import dt from "classnames";
import { ApolloLink as Py, Observable as Zw, ApolloClient as fE, InMemoryCache as hE, createHttpLink as yE, ApolloProvider as gE, useApolloClient as vE, ApolloConsumer as kE, NetworkStatus as dr, isApolloError as e1, ApolloError as n1, gql as Hl, useQuery as bE, useMutation as Nv } from "@apollo/client";
import _E from "cross-fetch";
import { config as Yo } from "lib-shared-backend-config";
import Qn from "moment";
import "moment-timezone";
import { __rest as xE, __assign as vc } from "tslib";
import { useLocation as SE } from "react-router-dom";
function Ay(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var gs = { exports: {} }, Ya = {};
var jv;
function NE() {
  if (jv) return Ya;
  jv = 1;
  var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ya.Fragment = r, Ya.jsx = s, Ya.jsxs = s, Ya;
}
var Qa = {};
var wv;
function jE() {
  return wv || (wv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var g = _.ReactDebugCurrentFrame, E = g.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var $ = !1, C = !1, F = !1, z = !1, Q = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === d || z || t === v || $ || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, N = E._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (E) {
            var g = E.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (ie) {
              g = ie;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var S = ie.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var ue = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = E;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ae(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ae(t.type, c, p);
          case h: {
            var g = t, E = g._payload, O = g._init;
            try {
              return ae(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, p, g, E) {
      {
        var O = Function.call.bind(le);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + p + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe(E), y("Failed %s type: %s", p, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, p, g, E, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, p, g, E) {
      {
        var O, N = {}, S = null, ne = null;
        p !== void 0 && (A(p), S = "" + p), gn(c) && (A(c.key), S = "" + c.key), rn(c) && (ne = c.ref, tn(c, E));
        for (O in c)
          le.call(c, O) && !oe.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, E, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function An(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = j(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          yn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var E = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, p, g, E, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, p, E, O);
        if (W == null)
          return W;
        if (N) {
          var ue = c.children;
          if (ue !== void 0)
            if (g)
              if (x(ue)) {
                for (var Ue = 0; Ue < ue.length; Ue++)
                  Sn(ue[Ue], t);
                Object.freeze && Object.freeze(ue);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ue, t);
        }
        if (le.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var Rn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, Rn, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, p) {
      return Fn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return Fn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Qa.Fragment = i, Qa.jsx = Un, Qa.jsxs = Kn;
  })()), Qa;
}
var Cv;
function wE() {
  return Cv || (Cv = 1, process.env.NODE_ENV === "production" ? gs.exports = NE() : gs.exports = jE()), gs.exports;
}
var We = wE();
function t1(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: CE } = Object.prototype, { getPrototypeOf: Ca } = Object, { iterator: es, toStringTag: r1 } = Symbol, gl = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), Qo = (e, n) => {
  let r = e;
  const i = [];
  for (; r != null && r !== Object.prototype; ) {
    if (i.indexOf(r) !== -1)
      return !1;
    if (i.push(r), gl(r, n))
      return !0;
    r = Ca(r);
  }
  return !1;
}, FE = (e, n) => e != null && Qo(e, n) ? e[n] : void 0, Ly = /* @__PURE__ */ ((e) => (n) => {
  const r = CE.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Rr = (e) => (e = e.toLowerCase(), (n) => Ly(n) === e), Wl = (e) => (n) => typeof n === e, { isArray: Yi } = Array, Fa = Wl("undefined");
function Aa(e) {
  return e !== null && !Fa(e) && e.constructor !== null && !Fa(e.constructor) && lr(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const i1 = Rr("ArrayBuffer");
function IE(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && i1(e.buffer), n;
}
const EE = Wl("string"), lr = Wl("function"), a1 = Wl("number"), La = (e) => e !== null && typeof e == "object", $E = (e) => e === !0 || e === !1, Xs = (e) => {
  if (!La(e))
    return !1;
  const n = Ca(e);
  return (n === null || n === Object.prototype || Ca(n) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
  // Symbol.iterator as evidence the value is a tagged/iterable type rather
  // than a plain object, while ignoring keys injected onto Object.prototype.
  !Qo(e, r1) && !Qo(e, es);
}, TE = (e) => {
  if (!La(e) || Aa(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, DE = Rr("Date"), OE = Rr("File"), RE = (e) => !!(e && typeof e.uri < "u"), PE = (e) => e && typeof e.getParts < "u", AE = Rr("Blob"), LE = Rr("FileList"), VE = (e) => La(e) && lr(e.pipe);
function zE() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const Fv = zE(), Iv = typeof Fv.FormData < "u" ? Fv.FormData : void 0, UE = (e) => {
  if (!e) return !1;
  if (Iv && e instanceof Iv) return !0;
  const n = Ca(e);
  if (!n || n === Object.prototype || !lr(e.append)) return !1;
  const r = Ly(e);
  return r === "formdata" || // detect form-data instance
  r === "object" && lr(e.toString) && e.toString() === "[object FormData]";
}, ME = Rr("URLSearchParams"), [BE, qE, HE, WE] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Rr), KE = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ns(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Yi(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (Aa(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function o1(e, n) {
  if (Aa(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const Vi = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, s1 = (e) => !Fa(e) && e !== Vi;
function Mh(...e) {
  const { caseless: n, skipUndefined: r } = s1(this) && this || {}, i = {}, a = (o, s) => {
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    const l = n && typeof s == "string" && o1(i, s) || s, u = gl(i, l) ? i[l] : void 0;
    Xs(u) && Xs(o) ? i[l] = Mh(u, o) : Xs(o) ? i[l] = Mh({}, o) : Yi(o) ? i[l] = o.slice() : (!r || !Fa(o)) && (i[l] = o);
  };
  for (let o = 0, s = e.length; o < s; o++) {
    const l = e[o];
    if (!l || Aa(l) || (ns(l, a), typeof l != "object" || Yi(l)))
      continue;
    const u = Object.getOwnPropertySymbols(l);
    for (let m = 0; m < u.length; m++) {
      const d = u[m];
      a$.call(l, d) && a(l[d], d);
    }
  }
  return i;
}
const GE = (e, n, r, { allOwnKeys: i } = {}) => (ns(
  n,
  (a, o) => {
    r && lr(a) ? Object.defineProperty(e, o, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot
      // hijack defineProperty's accessor-vs-data resolution.
      __proto__: null,
      value: t1(a, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      __proto__: null,
      value: a,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), YE = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), QE = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    __proto__: null,
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    __proto__: null,
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, JE = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && Ca(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, XE = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, ZE = (e) => {
  if (!e) return null;
  if (Yi(e)) return e;
  let n = e.length;
  if (!a1(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, e$ = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && Ca(Uint8Array)), n$ = (e, n) => {
  const i = (e && e[es]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, t$ = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, r$ = Rr("HTMLFormElement"), i$ = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, i, a) {
  return i.toUpperCase() + a;
}), { propertyIsEnumerable: a$ } = Object.prototype, o$ = Rr("RegExp"), l1 = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  ns(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, s$ = (e) => {
  l1(e, (n, r) => {
    if (lr(e) && ["arguments", "caller", "callee"].includes(r))
      return !1;
    const i = e[r];
    if (lr(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, l$ = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return Yi(e) ? i(e) : i(String(e).split(n)), r;
}, c$ = () => {
}, u$ = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function d$(e) {
  return !!(e && lr(e.append) && e[r1] === "FormData" && e[es]);
}
const m$ = (e) => {
  const n = /* @__PURE__ */ new WeakSet(), r = (i) => {
    if (La(i)) {
      if (n.has(i))
        return;
      if (Aa(i))
        return i;
      if (!("toJSON" in i)) {
        n.add(i);
        const a = Yi(i) ? [] : {};
        return ns(i, (o, s) => {
          const l = r(o);
          !Fa(l) && (a[s] = l);
        }), n.delete(i), a;
      }
    }
    return i;
  };
  return r(e);
}, p$ = Rr("AsyncFunction"), f$ = (e) => e && (La(e) || lr(e)) && lr(e.then) && lr(e.catch), c1 = ((e, n) => e ? setImmediate : n ? ((r, i) => (Vi.addEventListener(
  "message",
  ({ source: a, data: o }) => {
    a === Vi && o === r && i.length && i.shift()();
  },
  !1
), (a) => {
  i.push(a), Vi.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", lr(Vi.postMessage)), h$ = typeof queueMicrotask < "u" ? queueMicrotask.bind(Vi) : typeof process < "u" && process.nextTick || c1, u1 = (e) => e != null && lr(e[es]), y$ = (e) => e != null && Qo(e, es) && u1(e), pe = {
  isArray: Yi,
  isArrayBuffer: i1,
  isBuffer: Aa,
  isFormData: UE,
  isArrayBufferView: IE,
  isString: EE,
  isNumber: a1,
  isBoolean: $E,
  isObject: La,
  isPlainObject: Xs,
  isEmptyObject: TE,
  isReadableStream: BE,
  isRequest: qE,
  isResponse: HE,
  isHeaders: WE,
  isUndefined: Fa,
  isDate: DE,
  isFile: OE,
  isReactNativeBlob: RE,
  isReactNative: PE,
  isBlob: AE,
  isRegExp: o$,
  isFunction: lr,
  isStream: VE,
  isURLSearchParams: ME,
  isTypedArray: e$,
  isFileList: LE,
  forEach: ns,
  merge: Mh,
  extend: GE,
  trim: KE,
  stripBOM: YE,
  inherits: QE,
  toFlatObject: JE,
  kindOf: Ly,
  kindOfTest: Rr,
  endsWith: XE,
  toArray: ZE,
  forEachEntry: n$,
  matchAll: t$,
  isHTMLForm: r$,
  hasOwnProperty: gl,
  hasOwnProp: gl,
  // an alias to avoid ESLint no-prototype-builtins detection
  hasOwnInPrototypeChain: Qo,
  getSafeProp: FE,
  reduceDescriptors: l1,
  freezeMethods: s$,
  toObjectSet: l$,
  toCamelCase: i$,
  noop: c$,
  toFiniteNumber: u$,
  findKey: o1,
  global: Vi,
  isContextDefined: s1,
  isSpecCompliantForm: d$,
  toJSONObject: m$,
  isAsyncFn: p$,
  isThenable: f$,
  setImmediate: c1,
  asap: h$,
  isIterable: u1,
  isSafeIterable: y$
}, g$ = pe.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), v$ = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && g$[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
};
function k$(e) {
  let n = 0, r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; r > n; ) {
    const i = e.charCodeAt(r - 1);
    if (i !== 9 && i !== 32)
      break;
    r -= 1;
  }
  return n === 0 && r === e.length ? e : e.slice(n, r);
}
const b$ = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), _$ = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function Vy(e, n) {
  return pe.isArray(e) ? e.map((r) => Vy(r, n)) : k$(String(e).replace(n, ""));
}
const x$ = (e) => Vy(e, b$), S$ = (e) => Vy(e, _$);
function d1(e) {
  const n = /* @__PURE__ */ Object.create(null);
  return pe.forEach(e.toJSON(), (r, i) => {
    n[i] = S$(r);
  }), n;
}
const Ev = /* @__PURE__ */ Symbol("internals");
function Ja(e) {
  return e && String(e).trim().toLowerCase();
}
function Zs(e) {
  return e === !1 || e == null ? e : pe.isArray(e) ? e.map(Zs) : x$(String(e));
}
function N$(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const j$ = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function kc(e, n, r, i, a) {
  if (pe.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!pe.isString(n)) {
    if (pe.isString(i))
      return n.indexOf(i) !== -1;
    if (pe.isRegExp(i))
      return i.test(n);
  }
}
function w$(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function C$(e, n) {
  const r = pe.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Kt = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, u, m) {
      const d = Ja(u);
      if (!d)
        return;
      const f = pe.findKey(a, d);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || u] = Zs(l));
    }
    const s = (l, u) => pe.forEach(l, (m, d) => o(m, d, u));
    if (pe.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (pe.isString(n) && (n = n.trim()) && !j$(n))
      s(v$(n), r);
    else if (pe.isObject(n) && pe.isSafeIterable(n)) {
      let l = /* @__PURE__ */ Object.create(null), u, m;
      for (const d of n) {
        if (!pe.isArray(d))
          throw new TypeError("Object iterator must return a key-value pair");
        m = d[0], pe.hasOwnProp(l, m) ? (u = l[m], l[m] = pe.isArray(u) ? [...u, d[1]] : [u, d[1]]) : l[m] = d[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = Ja(n), n) {
      const i = pe.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return N$(a);
        if (pe.isFunction(r))
          return r.call(this, a, i);
        if (pe.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = Ja(n), n) {
      const i = pe.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || kc(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = Ja(s), s) {
        const l = pe.findKey(i, s);
        l && (!r || kc(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return pe.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || kc(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return pe.forEach(this, (a, o) => {
      const s = pe.findKey(i, o);
      if (s) {
        r[s] = Zs(a), delete r[o];
        return;
      }
      const l = n ? w$(o) : String(o).trim();
      l !== o && delete r[o], r[l] = Zs(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return pe.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && pe.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[Ev] = this[Ev] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = Ja(s);
      i[l] || (C$(a, s), i[l] = !0);
    }
    return pe.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Kt.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
pe.reduceDescriptors(Kt.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
pe.freezeMethods(Kt);
const F$ = "[REDACTED ****]";
function I$(e) {
  if (pe.hasOwnProp(e, "toJSON"))
    return !0;
  let n = Object.getPrototypeOf(e);
  for (; n && n !== Object.prototype; ) {
    if (pe.hasOwnProp(n, "toJSON"))
      return !0;
    n = Object.getPrototypeOf(n);
  }
  return !1;
}
function E$(e, n) {
  const r = new Set(n.map((o) => String(o).toLowerCase())), i = [], a = (o) => {
    if (o === null || typeof o != "object" || pe.isBuffer(o)) return o;
    if (i.indexOf(o) !== -1) return;
    o instanceof Kt && (o = o.toJSON()), i.push(o);
    let s;
    if (pe.isArray(o))
      s = [], o.forEach((l, u) => {
        const m = a(l);
        pe.isUndefined(m) || (s[u] = m);
      });
    else {
      if (!pe.isPlainObject(o) && I$(o))
        return i.pop(), o;
      s = /* @__PURE__ */ Object.create(null);
      for (const [l, u] of Object.entries(o)) {
        const m = r.has(l.toLowerCase()) ? F$ : a(u);
        pe.isUndefined(m) || (s[l] = m);
      }
    }
    return i.pop(), s;
  };
  return a(e);
}
let cn = class m1 extends Error {
  static from(n, r, i, a, o, s) {
    const l = new m1(n.message, r || n.code, i, a, o);
    return l.cause = n, l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, r, i, a, o) {
    super(n), Object.defineProperty(this, "message", {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), i && (this.config = i), a && (this.request = a), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    const n = this.config, r = n && pe.hasOwnProp(n, "redact") ? n.redact : void 0, i = pe.isArray(r) && r.length > 0 ? E$(n, r) : pe.toJSONObject(n);
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: i,
      code: this.code,
      status: this.status
    };
  }
};
cn.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
cn.ERR_BAD_OPTION = "ERR_BAD_OPTION";
cn.ECONNABORTED = "ECONNABORTED";
cn.ETIMEDOUT = "ETIMEDOUT";
cn.ECONNREFUSED = "ECONNREFUSED";
cn.ERR_NETWORK = "ERR_NETWORK";
cn.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
cn.ERR_DEPRECATED = "ERR_DEPRECATED";
cn.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
cn.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
cn.ERR_CANCELED = "ERR_CANCELED";
cn.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
cn.ERR_INVALID_URL = "ERR_INVALID_URL";
cn.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const $$ = null, p1 = 100;
function Bh(e) {
  return pe.isPlainObject(e) || pe.isArray(e);
}
function f1(e) {
  return pe.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function bc(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = f1(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function T$(e) {
  return pe.isArray(e) && !e.some(Bh);
}
const D$ = pe.toFlatObject(pe, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Kl(e, n, r) {
  if (!pe.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = pe.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(y, L) {
      return !pe.isUndefined(L[y]);
    }
  );
  const i = r.metaTokens, a = r.visitor || I, o = r.dots, s = r.indexes, l = r.Blob || typeof Blob < "u" && Blob, u = r.maxDepth === void 0 ? p1 : r.maxDepth, m = l && pe.isSpecCompliantForm(n), d = [];
  if (!pe.isFunction(a))
    throw new TypeError("visitor must be a function");
  function f(_) {
    if (_ === null) return "";
    if (pe.isDate(_))
      return _.toISOString();
    if (pe.isBoolean(_))
      return _.toString();
    if (!m && pe.isBlob(_))
      throw new cn("Blob is not supported. Use a Buffer instead.");
    return pe.isArrayBuffer(_) || pe.isTypedArray(_) ? m && typeof Blob == "function" ? new Blob([_]) : Buffer.from(_) : _;
  }
  function h(_) {
    if (_ > u)
      throw new cn(
        "Object is too deeply nested (" + _ + " levels). Max depth: " + u,
        cn.ERR_FORM_DATA_DEPTH_EXCEEDED
      );
  }
  function v(_, y) {
    if (u === 1 / 0)
      return JSON.stringify(_);
    const L = [];
    return JSON.stringify(_, function(C, F) {
      if (!pe.isObject(F))
        return F;
      for (; L.length && L[L.length - 1] !== this; )
        L.pop();
      return L.push(F), h(y + L.length - 1), F;
    });
  }
  function I(_, y, L) {
    let $ = _;
    if (pe.isReactNative(n) && pe.isReactNativeBlob(_))
      return n.append(bc(L, y, o), f(_)), !1;
    if (_ && !L && typeof _ == "object") {
      if (pe.endsWith(y, "{}"))
        y = i ? y : y.slice(0, -2), _ = v(_, 1);
      else if (pe.isArray(_) && T$(_) || (pe.isFileList(_) || pe.endsWith(y, "[]")) && ($ = pe.toArray(_)))
        return y = f1(y), $.forEach(function(F, z) {
          !(pe.isUndefined(F) || F === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? bc([y], z, o) : s === null ? y : y + "[]",
            f(F)
          );
        }), !1;
    }
    return Bh(_) ? !0 : (n.append(bc(L, y, o), f(_)), !1);
  }
  const w = Object.assign(D$, {
    defaultVisitor: I,
    convertValue: f,
    isVisitable: Bh
  });
  function j(_, y, L = 0) {
    if (!pe.isUndefined(_)) {
      if (h(L), d.indexOf(_) !== -1)
        throw new Error("Circular reference detected in " + y.join("."));
      d.push(_), pe.forEach(_, function(C, F) {
        (!(pe.isUndefined(C) || C === null) && a.call(n, C, pe.isString(F) ? F.trim() : F, y, w)) === !0 && j(C, y ? y.concat(F) : [F], L + 1);
      }), d.pop();
    }
  }
  if (!pe.isObject(e))
    throw new TypeError("data must be an object");
  return j(e), n;
}
function $v(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function zy(e, n) {
  this._pairs = [], e && Kl(e, this, n);
}
const h1 = zy.prototype;
h1.append = function(n, r) {
  this._pairs.push([n, r]);
};
h1.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, $v);
  } : $v;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function O$(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function y1(e, n, r) {
  if (!n)
    return e;
  const i = pe.isFunction(r) ? {
    serialize: r
  } : r, a = pe.getSafeProp(i, "encode") || O$, o = pe.getSafeProp(i, "serialize");
  let s;
  if (o ? s = o(n, i) : s = pe.isURLSearchParams(n) ? n.toString() : new zy(n, i).toString(a), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class Tv {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    pe.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const Uy = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0,
  advertiseZstdAcceptEncoding: !1,
  validateStatusUndefinedResolves: !0
}, R$ = typeof URLSearchParams < "u" ? URLSearchParams : zy, P$ = typeof FormData < "u" ? FormData : null, A$ = typeof Blob < "u" ? Blob : null, L$ = {
  isBrowser: !0,
  classes: {
    URLSearchParams: R$,
    FormData: P$,
    Blob: A$
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, My = typeof window < "u" && typeof document < "u", qh = typeof navigator == "object" && navigator || void 0, V$ = My && (!qh || ["ReactNative", "NativeScript", "NS"].indexOf(qh.product) < 0), z$ = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", U$ = My && window.location.href || "http://localhost", M$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: My,
  hasStandardBrowserEnv: V$,
  hasStandardBrowserWebWorkerEnv: z$,
  navigator: qh,
  origin: U$
}, Symbol.toStringTag, { value: "Module" })), Ut = {
  ...M$,
  ...L$
};
function B$(e, n) {
  return Kl(e, new Ut.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return Ut.isNode && pe.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
const Dv = p1;
function g1(e) {
  if (e > Dv)
    throw new cn(
      "FormData field is too deeply nested (" + e + " levels). Max depth: " + Dv,
      cn.ERR_FORM_DATA_DEPTH_EXCEEDED
    );
}
function q$(e) {
  const n = [], r = /\w+|\[(\w*)]/g;
  let i;
  for (; (i = r.exec(e)) !== null; )
    g1(n.length), n.push(i[0] === "[]" ? "" : i[1] || i[0]);
  return n;
}
function H$(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function v1(e) {
  function n(r, i, a, o) {
    g1(o);
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), u = o >= r.length;
    return s = !s && pe.isArray(a) ? a.length : s, u ? (pe.hasOwnProp(a, s) ? a[s] = pe.isArray(a[s]) ? a[s].concat(i) : [a[s], i] : a[s] = i, !l) : ((!pe.hasOwnProp(a, s) || !pe.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && pe.isArray(a[s]) && (a[s] = H$(a[s])), !l);
  }
  if (pe.isFormData(e) && pe.isFunction(e.entries)) {
    const r = {};
    return pe.forEachEntry(e, (i, a) => {
      n(q$(i), a, r, 0);
    }), r;
  }
  return null;
}
const aa = (e, n) => e != null && pe.hasOwnProp(e, n) ? e[n] : void 0;
function W$(e, n, r) {
  if (pe.isString(e))
    try {
      return (n || JSON.parse)(e), pe.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const ts = {
  transitional: Uy,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, r) {
      const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = pe.isObject(n);
      if (o && pe.isHTMLForm(n) && (n = new FormData(n)), pe.isFormData(n))
        return a ? JSON.stringify(v1(n)) : n;
      if (pe.isArrayBuffer(n) || pe.isBuffer(n) || pe.isStream(n) || pe.isFile(n) || pe.isBlob(n) || pe.isReadableStream(n))
        return n;
      if (pe.isArrayBufferView(n))
        return n.buffer;
      if (pe.isURLSearchParams(n))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let l;
      if (o) {
        const u = aa(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return B$(n, u).toString();
        if ((l = pe.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const m = aa(this, "env"), d = m && m.FormData;
          return Kl(
            l ? { "files[]": n } : n,
            d && new d(),
            u
          );
        }
      }
      return o || a ? (r.setContentType("application/json", !1), W$(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const r = aa(this, "transitional") || ts.transitional, i = r && r.forcedJSONParsing, a = aa(this, "responseType"), o = a === "json";
      if (pe.isResponse(n) || pe.isReadableStream(n))
        return n;
      if (n && pe.isString(n) && (i && !a || o)) {
        const l = !(r && r.silentJSONParsing) && o;
        try {
          return JSON.parse(n, aa(this, "parseReviver"));
        } catch (u) {
          if (l)
            throw u.name === "SyntaxError" ? cn.from(u, cn.ERR_BAD_RESPONSE, this, null, aa(this, "response")) : u;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ut.classes.FormData,
    Blob: Ut.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
pe.forEach(["delete", "get", "head", "post", "put", "patch", "query"], (e) => {
  ts.headers[e] = {};
});
function _c(e, n) {
  const r = this || ts, i = n || r, a = Kt.from(i.headers);
  let o = i.data;
  return pe.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function k1(e) {
  return !!(e && e.__CANCEL__);
}
let rs = class extends cn {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, r, i) {
    super(n ?? "canceled", cn.ERR_CANCELED, r, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function b1(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(new cn(
    "Request failed with status code " + r.status,
    r.status >= 400 && r.status < 500 ? cn.ERR_BAD_REQUEST : cn.ERR_BAD_RESPONSE,
    r.config,
    r.request,
    r
  ));
}
function K$(e) {
  const n = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
  return n && n[1] || "";
}
function G$(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(u) {
    const m = Date.now(), d = i[o];
    s || (s = m), r[a] = u, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const v = d && m - d;
    return v ? Math.round(h * 1e3 / v) : void 0;
  };
}
function Y$(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (m, d = Date.now()) => {
    r = d, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const d = Date.now(), f = d - r;
    f >= i ? s(m, d) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const vl = (e, n, r = 3) => {
  let i = 0;
  const a = G$(50, 250);
  return Y$((o) => {
    if (!o || typeof o.loaded != "number")
      return;
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, u = l != null ? Math.min(s, l) : s, m = Math.max(0, u - i), d = a(m);
    i = Math.max(i, u);
    const f = {
      loaded: u,
      total: l,
      progress: l ? u / l : void 0,
      bytes: m,
      rate: d || void 0,
      estimated: d && l ? (l - u) / d : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, Ov = (e, n) => {
  const r = e != null;
  return [
    (i) => n[0]({
      lengthComputable: r,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, Rv = (e) => (...n) => pe.asap(() => e(...n)), Q$ = Ut.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, Ut.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(Ut.origin),
  Ut.navigator && /(msie|trident)/i.test(Ut.navigator.userAgent)
) : () => !0, J$ = Ut.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(n)}`];
      pe.isNumber(r) && l.push(`expires=${new Date(r).toUTCString()}`), pe.isString(i) && l.push(`path=${i}`), pe.isString(a) && l.push(`domain=${a}`), o === !0 && l.push("secure"), pe.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.split(";");
      for (let r = 0; r < n.length; r++) {
        const i = n[r].replace(/^\s+/, ""), a = i.indexOf("=");
        if (a !== -1 && i.slice(0, a) === e)
          return decodeURIComponent(i.slice(a + 1));
      }
      return null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function X$(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Z$(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
const eT = /^https?:(?!\/\/)/i, nT = /[\t\n\r]/g;
function tT(e) {
  let n = 0;
  for (; n < e.length && e.charCodeAt(n) <= 32; )
    n++;
  return e.slice(n);
}
function rT(e) {
  return tT(e).replace(nT, "");
}
function Pv(e, n) {
  if (typeof e == "string" && eT.test(rT(e)))
    throw new cn(
      'Invalid URL: missing "//" after protocol',
      cn.ERR_INVALID_URL,
      n
    );
}
function _1(e, n, r, i) {
  Pv(n, i);
  let a = !X$(n);
  return e && (a || r === !1) ? (Pv(e, i), Z$(e, n)) : n;
}
const Av = (e) => e instanceof Kt ? { ...e } : e;
function Qi(e, n) {
  n = n || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", {
    // Null-proto descriptor so a polluted Object.prototype.get cannot turn
    // this data descriptor into an accessor descriptor on the way in.
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(d, f, h, v) {
    return pe.isPlainObject(d) && pe.isPlainObject(f) ? pe.merge.call({ caseless: v }, d, f) : pe.isPlainObject(f) ? pe.merge({}, f) : pe.isArray(f) ? f.slice() : f;
  }
  function a(d, f, h, v) {
    if (pe.isUndefined(f)) {
      if (!pe.isUndefined(d))
        return i(void 0, d, h, v);
    } else return i(d, f, h, v);
  }
  function o(d, f) {
    if (!pe.isUndefined(f))
      return i(void 0, f);
  }
  function s(d, f) {
    if (pe.isUndefined(f)) {
      if (!pe.isUndefined(d))
        return i(void 0, d);
    } else return i(void 0, f);
  }
  function l(d) {
    const f = pe.hasOwnProp(n, "transitional") ? n.transitional : void 0;
    if (!pe.isUndefined(f))
      if (pe.isPlainObject(f)) {
        if (pe.hasOwnProp(f, d))
          return f[d];
      } else
        return;
    const h = pe.hasOwnProp(e, "transitional") ? e.transitional : void 0;
    if (pe.isPlainObject(h) && pe.hasOwnProp(h, d))
      return h[d];
  }
  function u(d, f, h) {
    if (pe.hasOwnProp(n, h))
      return i(d, f);
    if (pe.hasOwnProp(e, h))
      return i(void 0, d);
  }
  const m = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: u,
    headers: (d, f, h) => a(Av(d), Av(f), h, !0)
  };
  return pe.forEach(Object.keys({ ...e, ...n }), function(f) {
    if (f === "__proto__" || f === "constructor" || f === "prototype") return;
    const h = pe.hasOwnProp(m, f) ? m[f] : a, v = pe.hasOwnProp(e, f) ? e[f] : void 0, I = pe.hasOwnProp(n, f) ? n[f] : void 0, w = h(v, I, f);
    pe.isUndefined(w) && h !== u || (r[f] = w);
  }), pe.hasOwnProp(n, "validateStatus") && pe.isUndefined(n.validateStatus) && l("validateStatusUndefinedResolves") === !1 && (pe.hasOwnProp(e, "validateStatus") ? r.validateStatus = i(void 0, e.validateStatus) : delete r.validateStatus), r;
}
const iT = ["content-type", "content-length"];
function aT(e, n, r) {
  if (r !== "content-only") {
    e.set(n);
    return;
  }
  Object.entries(n).forEach(([i, a]) => {
    iT.includes(i.toLowerCase()) && e.set(i, a);
  });
}
const oT = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
);
function x1(e) {
  const n = Qi({}, e), r = (h) => pe.hasOwnProp(n, h) ? n[h] : void 0, i = r("data");
  let a = r("withXSRFToken");
  const o = r("xsrfHeaderName"), s = r("xsrfCookieName");
  let l = r("headers");
  const u = r("auth"), m = r("baseURL"), d = r("allowAbsoluteUrls"), f = r("url");
  if (n.headers = l = Kt.from(l), n.url = y1(
    _1(m, f, d, n),
    r("params"),
    r("paramsSerializer")
  ), u) {
    const h = pe.getSafeProp(u, "username") || "", v = pe.getSafeProp(u, "password") || "";
    l.set(
      "Authorization",
      "Basic " + btoa(h + ":" + (v ? oT(v) : ""))
    );
  }
  if (pe.isFormData(i) && (Ut.hasStandardBrowserEnv || Ut.hasStandardBrowserWebWorkerEnv || pe.isReactNative(i) ? l.setContentType(void 0) : pe.isFunction(i.getHeaders) && aT(l, i.getHeaders(), r("formDataHeaderPolicy"))), Ut.hasStandardBrowserEnv && (pe.isFunction(a) && (a = a(n)), a === !0 || a == null && Q$(n.url))) {
    const v = o && s && J$.read(s);
    v && l.set(o, v);
  }
  return n;
}
const sT = typeof XMLHttpRequest < "u", lT = sT && function(e) {
  return new Promise(function(r, i) {
    const a = x1(e);
    let o = a.data;
    const s = Kt.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: u, onDownloadProgress: m } = a, d, f, h, v, I;
    function w() {
      v && v(), I && I(), a.cancelToken && a.cancelToken.unsubscribe(d), a.signal && a.signal.removeEventListener("abort", d);
    }
    let j = new XMLHttpRequest();
    j.open(a.method.toUpperCase(), a.url, !0), j.timeout = a.timeout;
    function _() {
      if (!j)
        return;
      const L = Kt.from(
        "getAllResponseHeaders" in j && j.getAllResponseHeaders()
      ), C = {
        data: !l || l === "text" || l === "json" ? j.responseText : j.response,
        status: j.status,
        statusText: j.statusText,
        headers: L,
        config: e,
        request: j
      };
      b1(
        function(z) {
          r(z), w();
        },
        function(z) {
          i(z), w();
        },
        C
      ), j = null;
    }
    "onloadend" in j ? j.onloadend = _ : j.onreadystatechange = function() {
      !j || j.readyState !== 4 || j.status === 0 && !(j.responseURL && j.responseURL.startsWith("file:")) || setTimeout(_);
    }, j.onabort = function() {
      j && (i(new cn("Request aborted", cn.ECONNABORTED, e, j)), w(), j = null);
    }, j.onerror = function($) {
      const C = $ && $.message ? $.message : "Network Error", F = new cn(C, cn.ERR_NETWORK, e, j);
      F.event = $ || null, i(F), w(), j = null;
    }, j.ontimeout = function() {
      let $ = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const C = a.transitional || Uy;
      a.timeoutErrorMessage && ($ = a.timeoutErrorMessage), i(
        new cn(
          $,
          C.clarifyTimeoutError ? cn.ETIMEDOUT : cn.ECONNABORTED,
          e,
          j
        )
      ), w(), j = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in j && pe.forEach(d1(s), function($, C) {
      j.setRequestHeader(C, $);
    }), pe.isUndefined(a.withCredentials) || (j.withCredentials = !!a.withCredentials), l && l !== "json" && (j.responseType = a.responseType), m && ([h, I] = vl(m, !0), j.addEventListener("progress", h)), u && j.upload && ([f, v] = vl(u), j.upload.addEventListener("progress", f), j.upload.addEventListener("loadend", v)), (a.cancelToken || a.signal) && (d = (L) => {
      j && (i(!L || L.type ? new rs(null, e, j) : L), j.abort(), w(), j = null);
    }, a.cancelToken && a.cancelToken.subscribe(d), a.signal && (a.signal.aborted ? d() : a.signal.addEventListener("abort", d)));
    const y = K$(a.url);
    if (y && !Ut.protocols.includes(y)) {
      i(
        new cn(
          "Unsupported protocol " + y + ":",
          cn.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    j.send(o || null);
  });
}, cT = (e, n) => {
  if (e = e ? e.filter(Boolean) : [], !n && !e.length)
    return;
  const r = new AbortController();
  let i = !1;
  const a = function(u) {
    if (!i) {
      i = !0, s();
      const m = u instanceof Error ? u : this.reason;
      r.abort(
        m instanceof cn ? m : new rs(m instanceof Error ? m.message : m)
      );
    }
  };
  let o = n && setTimeout(() => {
    o = null, a(new cn(`timeout of ${n}ms exceeded`, cn.ETIMEDOUT));
  }, n);
  const s = () => {
    e && (o && clearTimeout(o), o = null, e.forEach((u) => {
      u.unsubscribe ? u.unsubscribe(a) : u.removeEventListener("abort", a);
    }), e = null);
  };
  e.forEach((u) => u.addEventListener("abort", a));
  const { signal: l } = r;
  return l.unsubscribe = () => pe.asap(s), l;
}, uT = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, dT = async function* (e, n) {
  for await (const r of mT(e))
    yield* uT(r, n);
}, mT = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, Lv = (e, n, r, i) => {
  const a = dT(e, n);
  let o = 0, s, l = (u) => {
    s || (s = !0, i && i(u));
  };
  return new ReadableStream(
    {
      async pull(u) {
        try {
          const { done: m, value: d } = await a.next();
          if (m) {
            l(), u.close();
            return;
          }
          let f = d.byteLength;
          if (r) {
            let h = o += f;
            r(h);
          }
          u.enqueue(new Uint8Array(d));
        } catch (m) {
          throw l(m), m;
        }
      },
      cancel(u) {
        return l(u), a.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, kl = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, pT = (e, n, r) => n + 2 < r && kl(e.charCodeAt(n + 1)) && kl(e.charCodeAt(n + 2));
function fT(e) {
  if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
  const n = e.indexOf(",");
  if (n < 0) return 0;
  const r = e.slice(5, n), i = e.slice(n + 1);
  if (/;base64/i.test(r)) {
    let s = i.length;
    const l = i.length;
    for (let v = 0; v < l; v++)
      if (i.charCodeAt(v) === 37 && v + 2 < l) {
        const I = i.charCodeAt(v + 1), w = i.charCodeAt(v + 2);
        kl(I) && kl(w) && (s -= 2, v += 2);
      }
    let u = 0, m = l - 1;
    const d = (v) => v >= 2 && i.charCodeAt(v - 2) === 37 && // '%'
    i.charCodeAt(v - 1) === 51 && // '3'
    (i.charCodeAt(v) === 68 || i.charCodeAt(v) === 100);
    m >= 0 && (i.charCodeAt(m) === 61 ? (u++, m--) : d(m) && (u++, m -= 3)), u === 1 && m >= 0 && (i.charCodeAt(m) === 61 || d(m)) && u++;
    const h = Math.floor(s / 4) * 3 - (u || 0);
    return h > 0 ? h : 0;
  }
  let o = 0;
  for (let s = 0, l = i.length; s < l; s++) {
    const u = i.charCodeAt(s);
    if (u === 37 && pT(i, s, l))
      o += 1, s += 2;
    else if (u < 128)
      o += 1;
    else if (u < 2048)
      o += 2;
    else if (u >= 55296 && u <= 56319 && s + 1 < l) {
      const m = i.charCodeAt(s + 1);
      m >= 56320 && m <= 57343 ? (o += 4, s++) : o += 3;
    } else
      o += 3;
  }
  return o;
}
const By = "1.18.0", Vv = 64 * 1024, { isFunction: vs } = pe, hT = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
), zv = (e) => {
  if (!pe.isString(e))
    return e;
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}, Uv = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, yT = (e) => {
  const n = e.indexOf("://");
  let r = e;
  return n !== -1 && (r = r.slice(n + 3)), r.includes("@") || r.includes(":");
}, gT = (e) => {
  const n = pe.global !== void 0 && pe.global !== null ? pe.global : globalThis, { ReadableStream: r, TextEncoder: i } = n;
  e = pe.merge.call(
    {
      skipUndefined: !0
    },
    {
      Request: n.Request,
      Response: n.Response
    },
    e
  );
  const { fetch: a, Request: o, Response: s } = e, l = a ? vs(a) : typeof fetch == "function", u = vs(o), m = vs(s);
  if (!l)
    return !1;
  const d = l && vs(r), f = l && (typeof i == "function" ? /* @__PURE__ */ ((_) => (y) => _.encode(y))(new i()) : async (_) => new Uint8Array(await new o(_).arrayBuffer())), h = u && d && Uv(() => {
    let _ = !1;
    const y = new o(Ut.origin, {
      body: new r(),
      method: "POST",
      get duplex() {
        return _ = !0, "half";
      }
    }), L = y.headers.has("Content-Type");
    return y.body != null && y.body.cancel(), _ && !L;
  }), v = m && d && Uv(() => pe.isReadableStream(new s("").body)), I = {
    stream: v && ((_) => _.body)
  };
  l && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((_) => {
    !I[_] && (I[_] = (y, L) => {
      let $ = y && y[_];
      if ($)
        return $.call(y);
      throw new cn(
        `Response type '${_}' is not supported`,
        cn.ERR_NOT_SUPPORT,
        L
      );
    });
  });
  const w = async (_) => {
    if (_ == null)
      return 0;
    if (pe.isBlob(_))
      return _.size;
    if (pe.isSpecCompliantForm(_))
      return (await new o(Ut.origin, {
        method: "POST",
        body: _
      }).arrayBuffer()).byteLength;
    if (pe.isArrayBufferView(_) || pe.isArrayBuffer(_))
      return _.byteLength;
    if (pe.isURLSearchParams(_) && (_ = _ + ""), pe.isString(_))
      return (await f(_)).byteLength;
  }, j = async (_, y) => {
    const L = pe.toFiniteNumber(_.getContentLength());
    return L ?? w(y);
  };
  return async (_) => {
    let {
      url: y,
      method: L,
      data: $,
      signal: C,
      cancelToken: F,
      timeout: z,
      onDownloadProgress: Q,
      onUploadProgress: J,
      responseType: te,
      headers: G,
      withCredentials: B = "same-origin",
      fetchOptions: R,
      maxContentLength: U,
      maxBodyLength: ee
    } = x1(_);
    const Se = pe.isNumber(U) && U > -1, fe = pe.isNumber(ee) && ee > -1, ye = (we) => pe.hasOwnProp(_, we) ? _[we] : void 0;
    let ve = a || fetch;
    te = te ? (te + "").toLowerCase() : "text";
    let K = cT(
      [C, F && F.toAbortSignal()],
      z
    ), _e = null;
    const Te = K && K.unsubscribe && (() => {
      K.unsubscribe();
    });
    let X, Ke = null;
    const an = () => new cn(
      "Request body larger than maxBodyLength limit",
      cn.ERR_BAD_REQUEST,
      _,
      _e
    );
    try {
      let we;
      const Me = ye("auth");
      if (Me) {
        const le = pe.getSafeProp(Me, "username") || "", xe = pe.getSafeProp(Me, "password") || "";
        we = {
          username: le,
          password: xe
        };
      }
      if (yT(y)) {
        const le = new URL(y, Ut.origin);
        if (!we && (le.username || le.password)) {
          const xe = zv(le.username), Le = zv(le.password);
          we = {
            username: xe,
            password: Le
          };
        }
        (le.username || le.password) && (le.username = "", le.password = "", y = le.href);
      }
      if (we && (G.delete("authorization"), G.set(
        "Authorization",
        "Basic " + btoa(hT((we.username || "") + ":" + (we.password || "")))
      )), Se && typeof y == "string" && y.startsWith("data:") && fT(y) > U)
        throw new cn(
          "maxContentLength size of " + U + " exceeded",
          cn.ERR_BAD_RESPONSE,
          _,
          _e
        );
      if (fe && L !== "get" && L !== "head") {
        const le = await w($);
        if (typeof le == "number" && isFinite(le) && (X = le, le > ee))
          throw an();
      }
      const Re = fe && (pe.isReadableStream($) || pe.isStream($)), Be = (le, xe, Le) => Lv(
        le,
        Vv,
        (Pe) => {
          if (fe && Pe > ee)
            throw Ke = an();
          xe && xe(Pe);
        },
        Le
      );
      if (h && L !== "get" && L !== "head" && (J || Re)) {
        if (X = X ?? await j(G, $), X !== 0 || Re) {
          let le = new o(y, {
            method: "POST",
            body: $,
            duplex: "half"
          }), xe;
          if (pe.isFormData($) && (xe = le.headers.get("content-type")) && G.setContentType(xe), le.body) {
            const [Le, Pe] = J && Ov(
              X,
              vl(Rv(J))
            ) || [];
            $ = Be(le.body, Le, Pe);
          }
        }
      } else if (Re && !u && d && L !== "get" && L !== "head")
        $ = Be($);
      else if (Re && u && !h && L !== "get" && L !== "head")
        throw new cn(
          "Stream request bodies are not supported by the current fetch implementation",
          cn.ERR_NOT_SUPPORT,
          _,
          _e
        );
      pe.isString(B) || (B = B ? "include" : "omit");
      const Ae = u && "credentials" in o.prototype;
      if (pe.isFormData($)) {
        const le = G.getContentType();
        le && /^multipart\/form-data/i.test(le) && !/boundary=/i.test(le) && G.delete("content-type");
      }
      G.set("User-Agent", "axios/" + By, !1);
      const Ge = {
        ...R,
        signal: K,
        method: L.toUpperCase(),
        headers: d1(G.normalize()),
        body: $,
        duplex: "half",
        credentials: Ae ? B : void 0
      };
      _e = u && new o(y, Ge);
      let Ce = await (u ? ve(_e, R) : ve(y, Ge));
      const qe = Kt.from(Ce.headers);
      if (Se) {
        const le = pe.toFiniteNumber(qe.getContentLength());
        if (le != null && le > U)
          throw new cn(
            "maxContentLength size of " + U + " exceeded",
            cn.ERR_BAD_RESPONSE,
            _,
            _e
          );
      }
      const nn = v && (te === "stream" || te === "response");
      if (v && Ce.body && (Q || Se || nn && Te)) {
        const le = {};
        ["status", "statusText", "headers"].forEach((x) => {
          le[x] = Ce[x];
        });
        const xe = pe.toFiniteNumber(qe.getContentLength()), [Le, Pe] = Q && Ov(
          xe,
          vl(Rv(Q), !0)
        ) || [];
        let yn = 0;
        const T = (x) => {
          if (Se && (yn = x, yn > U))
            throw new cn(
              "maxContentLength size of " + U + " exceeded",
              cn.ERR_BAD_RESPONSE,
              _,
              _e
            );
          Le && Le(x);
        };
        Ce = new s(
          Lv(Ce.body, Vv, T, () => {
            Pe && Pe(), Te && Te();
          }),
          le
        );
      }
      te = te || "text";
      let ae = await I[pe.findKey(I, te) || "text"](
        Ce,
        _
      );
      if (Se && !v && !nn) {
        let le;
        if (ae != null && (typeof ae.byteLength == "number" ? le = ae.byteLength : typeof ae.size == "number" ? le = ae.size : typeof ae == "string" && (le = typeof i == "function" ? new i().encode(ae).byteLength : ae.length)), typeof le == "number" && le > U)
          throw new cn(
            "maxContentLength size of " + U + " exceeded",
            cn.ERR_BAD_RESPONSE,
            _,
            _e
          );
      }
      return !nn && Te && Te(), await new Promise((le, xe) => {
        b1(le, xe, {
          data: ae,
          headers: Kt.from(Ce.headers),
          status: Ce.status,
          statusText: Ce.statusText,
          config: _,
          request: _e
        });
      });
    } catch (we) {
      if (Te && Te(), K && K.aborted && K.reason instanceof cn) {
        const Me = K.reason;
        throw Me.config = _, _e && (Me.request = _e), we !== Me && (Me.cause = we), Me;
      }
      throw Ke ? (_e && !Ke.request && (Ke.request = _e), Ke) : we instanceof cn ? (_e && !we.request && (we.request = _e), we) : we && we.name === "TypeError" && /Load failed|fetch/i.test(we.message) ? Object.assign(
        new cn(
          "Network Error",
          cn.ERR_NETWORK,
          _,
          _e,
          we && we.response
        ),
        {
          cause: we.cause || we
        }
      ) : cn.from(we, we && we.code, _, _e, we && we.response);
    }
  };
}, vT = /* @__PURE__ */ new Map(), S1 = (e) => {
  let n = e && e.env || {};
  const { fetch: r, Request: i, Response: a } = n, o = [i, a, r];
  let s = o.length, l = s, u, m, d = vT;
  for (; l--; )
    u = o[l], m = d.get(u), m === void 0 && d.set(u, m = l ? /* @__PURE__ */ new Map() : gT(n)), d = m;
  return m;
};
S1();
const qy = {
  http: $$,
  xhr: lT,
  fetch: {
    get: S1
  }
};
pe.forEach(qy, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { __proto__: null, value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { __proto__: null, value: n });
  }
});
const Mv = (e) => `- ${e}`, kT = (e) => pe.isFunction(e) || e === null || e === !1;
function bT(e, n) {
  e = pe.isArray(e) ? e : [e];
  const { length: r } = e;
  let i, a;
  const o = {};
  for (let s = 0; s < r; s++) {
    i = e[s];
    let l;
    if (a = i, !kT(i) && (a = qy[(l = String(i)).toLowerCase()], a === void 0))
      throw new cn(`Unknown adapter '${l}'`);
    if (a && (pe.isFunction(a) || (a = a.get(n))))
      break;
    o[l || "#" + s] = a;
  }
  if (!a) {
    const s = Object.entries(o).map(
      ([u, m]) => `adapter ${u} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = r ? s.length > 1 ? `since :
` + s.map(Mv).join(`
`) : " " + Mv(s[0]) : "as no adapter specified";
    throw new cn(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const N1 = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: bT,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: qy
};
function xc(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new rs(null, e);
}
function Bv(e) {
  return xc(e), e.headers = Kt.from(e.headers), e.data = _c.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), N1.getAdapter(e.adapter || ts.adapter, e)(e).then(
    function(i) {
      xc(e), e.response = i;
      try {
        i.data = _c.call(e, e.transformResponse, i);
      } finally {
        delete e.response;
      }
      return i.headers = Kt.from(i.headers), i;
    },
    function(i) {
      if (!k1(i) && (xc(e), i && i.response)) {
        e.response = i.response;
        try {
          i.response.data = _c.call(
            e,
            e.transformResponse,
            i.response
          );
        } finally {
          delete e.response;
        }
        i.response.headers = Kt.from(i.response.headers);
      }
      return Promise.reject(i);
    }
  );
}
const Gl = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  Gl[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const qv = {};
Gl.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + By + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new cn(
        a(s, " has been removed" + (r ? " in " + r : "")),
        cn.ERR_DEPRECATED
      );
    return r && !qv[s] && (qv[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
Gl.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function _T(e, n, r) {
  if (typeof e != "object")
    throw new cn("options must be an object", cn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : void 0;
    if (s) {
      const l = e[o], u = l === void 0 || s(l, o, e);
      if (u !== !0)
        throw new cn(
          "option " + o + " must be " + u,
          cn.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new cn("Unknown option " + o, cn.ERR_BAD_OPTION);
  }
}
const el = {
  assertOptions: _T,
  validators: Gl
}, Wt = el.validators;
let qi = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new Tv(),
      response: new Tv()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = (() => {
          if (!a.stack)
            return "";
          const s = a.stack.indexOf(`
`);
          return s === -1 ? "" : a.stack.slice(s + 1);
        })();
        try {
          if (!i.stack)
            i.stack = o;
          else if (o) {
            const s = o.indexOf(`
`), l = s === -1 ? -1 : o.indexOf(`
`, s + 1), u = l === -1 ? "" : o.slice(l + 1);
            String(i.stack).endsWith(u) || (i.stack += `
` + o);
          }
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = Qi(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && el.assertOptions(
      i,
      {
        silentJSONParsing: Wt.transitional(Wt.boolean),
        forcedJSONParsing: Wt.transitional(Wt.boolean),
        clarifyTimeoutError: Wt.transitional(Wt.boolean),
        legacyInterceptorReqResOrdering: Wt.transitional(Wt.boolean),
        advertiseZstdAcceptEncoding: Wt.transitional(Wt.boolean),
        validateStatusUndefinedResolves: Wt.transitional(Wt.boolean)
      },
      !1
    ), a != null && (pe.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : el.assertOptions(
      a,
      {
        encode: Wt.function,
        serialize: Wt.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), el.assertOptions(
      r,
      {
        baseUrl: Wt.spelling("baseURL"),
        withXsrfToken: Wt.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && pe.merge(o.common, o[r.method]);
    o && pe.forEach(["delete", "get", "head", "post", "put", "patch", "query", "common"], (I) => {
      delete o[I];
    }), r.headers = Kt.concat(s, o);
    const l = [];
    let u = !0;
    this.interceptors.request.forEach(function(w) {
      if (typeof w.runWhen == "function" && w.runWhen(r) === !1)
        return;
      u = u && w.synchronous;
      const j = r.transitional || Uy;
      j && j.legacyInterceptorReqResOrdering ? l.unshift(w.fulfilled, w.rejected) : l.push(w.fulfilled, w.rejected);
    });
    const m = [];
    this.interceptors.response.forEach(function(w) {
      m.push(w.fulfilled, w.rejected);
    });
    let d, f = 0, h;
    if (!u) {
      const I = [Bv.bind(this), void 0];
      for (I.unshift(...l), I.push(...m), h = I.length, d = Promise.resolve(r); f < h; )
        d = d.then(I[f++], I[f++]);
      return d;
    }
    h = l.length;
    let v = r;
    for (; f < h; ) {
      const I = l[f++], w = l[f++];
      try {
        v = I(v);
      } catch (j) {
        w.call(this, j);
        break;
      }
    }
    try {
      d = Bv.call(this, v);
    } catch (I) {
      return Promise.reject(I);
    }
    for (f = 0, h = m.length; f < h; )
      d = d.then(m[f++], m[f++]);
    return d;
  }
  getUri(n) {
    n = Qi(this.defaults, n);
    const r = _1(n.baseURL, n.url, n.allowAbsoluteUrls, n);
    return y1(r, n.params, n.paramsSerializer);
  }
};
pe.forEach(["delete", "get", "head", "options"], function(n) {
  qi.prototype[n] = function(r, i) {
    return this.request(
      Qi(i || {}, {
        method: n,
        url: r,
        data: i && pe.hasOwnProp(i, "data") ? i.data : void 0
      })
    );
  };
});
pe.forEach(["post", "put", "patch", "query"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(
        Qi(l || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  qi.prototype[n] = r(), n !== "query" && (qi.prototype[n + "Form"] = r(!0));
});
let xT = class j1 {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new rs(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new j1(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function ST(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function NT(e) {
  return pe.isObject(e) && e.isAxiosError === !0;
}
const Hh = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Hh).forEach(([e, n]) => {
  Hh[n] = e;
});
function w1(e) {
  const n = new qi(e), r = t1(qi.prototype.request, n);
  return pe.extend(r, qi.prototype, n, { allOwnKeys: !0 }), pe.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return w1(Qi(e, a));
  }, r;
}
const St = w1(ts);
St.Axios = qi;
St.CanceledError = rs;
St.CancelToken = xT;
St.isCancel = k1;
St.VERSION = By;
St.toFormData = Kl;
St.AxiosError = cn;
St.Cancel = St.CanceledError;
St.all = function(n) {
  return Promise.all(n);
};
St.spread = ST;
St.isAxiosError = NT;
St.mergeConfig = Qi;
St.AxiosHeaders = Kt;
St.formToJSON = (e) => v1(pe.isHTMLForm(e) ? new FormData(e) : e);
St.getAdapter = N1.getAdapter;
St.HttpStatusCode = Hh;
St.default = St;
const {
  Axios: NY,
  AxiosError: jY,
  CanceledError: wY,
  isCancel: CY,
  CancelToken: FY,
  VERSION: IY,
  all: EY,
  Cancel: $Y,
  isAxiosError: jT,
  spread: TY,
  toFormData: DY,
  AxiosHeaders: OY,
  HttpStatusCode: RY,
  formToJSON: PY,
  getAdapter: AY,
  mergeConfig: LY,
  create: VY
} = St;
class wT {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const Hv = new wT();
function CT(e, n) {
  return Wv(e), Wv(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function Wv(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const FT = Object.prototype.toString;
function IT(e, n) {
  return FT.call(e) === `[object ${n}]`;
}
function ET(e) {
  return IT(e, "Object");
}
function $T(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const Po = "8.36.0", pi = globalThis;
function Hy(e, n, r) {
  const i = r || pi, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[Po] = a[Po] || {};
  return o[e] || (o[e] = n());
}
const C1 = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, TT = "Sentry Logger ", Kv = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Gv = {};
function F1(e) {
  if (!("console" in pi))
    return e();
  const n = pi.console, r = {}, i = Object.keys(Gv);
  i.forEach((a) => {
    const o = Gv[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function DT() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return C1 ? Kv.forEach((r) => {
    n[r] = (...i) => {
      e && F1(() => {
        pi.console[r](`${TT}[${r}]:`, ...i);
      });
    };
  }) : Kv.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const nl = Hy("logger", DT);
function OT(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    C1 && nl.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const I1 = 1e3;
function Wy() {
  return Date.now() / I1;
}
function RT() {
  const { performance: e } = pi;
  if (!e || !e.now)
    return Wy;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / I1;
}
const PT = RT();
(() => {
  const { performance: e } = pi;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, u = typeof s == "number" ? Math.abs(s + r - i) : n, m = u < n;
  return o || m ? a <= u ? e.timeOrigin : s : i;
})();
function _a() {
  const e = pi, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function Yv() {
  return {
    traceId: _a(),
    spanId: _a().substring(16)
  };
}
function Ky() {
  return Gy(pi), pi;
}
function Gy(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || Po, n[Po] = n[Po] || {};
}
function AT(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || PT(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : _a()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const Wh = "_sentrySpan";
function Qv(e, n) {
  n ? OT(e, Wh, n) : delete e[Wh];
}
function Jv(e) {
  return e[Wh];
}
const LT = 100;
class Yy {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Yv();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new Yy();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, Qv(n, Jv(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && AT(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof Ia ? [r.getScopeData(), r.getRequestSession()] : ET(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: u, level: m, fingerprint: d = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...u }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), d.length && (this._fingerprint = d), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Qv(this, void 0), this._attachments = [], this._propagationContext = Yv(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : LT;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Wy(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Jv(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : _a();
    if (!this._client)
      return nl.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : _a();
    if (!this._client)
      return nl.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : _a();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (nl.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const Ia = Yy;
function VT() {
  return Hy("defaultCurrentScope", () => new Ia());
}
function zT() {
  return Hy("defaultIsolationScope", () => new Ia());
}
class UT {
  constructor(n, r) {
    let i;
    n ? i = n : i = new Ia();
    let a;
    r ? a = r : a = new Ia(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return $T(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Ea() {
  const e = Ky(), n = Gy(e);
  return n.stack = n.stack || new UT(VT(), zT());
}
function MT(e) {
  return Ea().withScope(e);
}
function BT(e, n) {
  const r = Ea();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function Xv(e) {
  return Ea().withScope(() => e(Ea().getIsolationScope()));
}
function qT() {
  return {
    withIsolationScope: Xv,
    withScope: MT,
    withSetScope: BT,
    withSetIsolationScope: (e, n) => Xv(n),
    getCurrentScope: () => Ea().getScope(),
    getIsolationScope: () => Ea().getIsolationScope()
  };
}
function E1(e) {
  const n = Gy(e);
  return n.acs ? n.acs : qT();
}
function Qy() {
  const e = Ky();
  return E1(e).getCurrentScope();
}
function $1() {
  const e = Ky();
  return E1(e).getIsolationScope();
}
function HT() {
  return Qy().getClient();
}
function WT(e) {
  if (e)
    return KT(e) ? { captureContext: e } : YT(e) ? {
      captureContext: e
    } : e;
}
function KT(e) {
  return e instanceof Ia || typeof e == "function";
}
const GT = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function YT(e) {
  return Object.keys(e).some((n) => GT.includes(n));
}
function Zv(e, n) {
  return Qy().captureException(e, WT(n));
}
function QT(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return Qy().captureMessage(e, r, i);
}
function JT(e, n) {
  $1().setContext(e, n);
}
const XT = 100;
function Pi(e, n) {
  const r = HT(), i = $1();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = XT } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Wy(), ...e }, u = a ? F1(() => a(l, n)) : l;
  u !== null && (r.emit && r.emit("beforeAddBreadcrumb", u, n), i.addBreadcrumb(u, o));
}
var Jo;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Jo || (Jo = {}));
function xa(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const ZT = Yo.backendDomain ? {
  "backend-domain": Yo.backendDomain
} : void 0;
function tl() {
  const e = new URLSearchParams({
    noToken: "true",
    ...ZT
  }).toString();
  document.location.href = `${Yo.url.logIn}?${e}`;
}
const Sc = "authData", Nc = 30, eD = 600, jc = 5;
class nD {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= jc || this.clientServerTimeDiff <= -jc ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + eD, a = xa(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > jc) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(Sc, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(Sc), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(Sc);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - Nc;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = xa(n), i = r.exp - Nc;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - Nc - this.estimatedServerTime()) * 1e3;
  }
}
const Ot = new nD();
async function tD(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? xa(o).exp : "None", l = await Yl.getAuthData({ localStorageOnly: !0 }), u = Math.floor(Date.now() / 1e3), m = l?.access_token, d = l?.refresh_token, f = m ? xa(m).exp : "None", h = d ? xa(d).exp : "None", v = typeof s == "number" ? u - s : "Unknown", I = typeof f == "number" ? u - f : "Unknown", w = typeof h == "number" ? u - h : "Unknown", j = e.response.headers["x-dixa-rid"];
      JT("Expires", {
        currentTimestamp: u,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: v,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: I,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: w,
        xDixaRid: j,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    QT("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: Jo.Platform,
        domain: n
      }
    });
  }
}
const wc = /* @__PURE__ */ new Map(), rD = 3;
function iD(e) {
  e.interceptors.response.use((n) => (wc.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case Kh.Unauthorized:
          if (!Yl.isRefreshTokenExpired() && n.config) {
            Pi({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = wc.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= rD)
              return wc.set(n.config.url, i + 1), e(n.config);
          }
          tD(n), console.error("401 unauthorized interceptor"), tl();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const T1 = St.create();
iD(T1);
const ai = console.log;
async function ek(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class aD extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function oD(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const sD = 5;
class lD {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      Ot.setAuthData(r);
    else {
      const i = Ot.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new aD("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = Ot.getAccessToken();
    if (!n)
      return {};
    const r = xa(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return Ot.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = Ot.getAuthData();
    return r ? Ot.isAccessTokenExpired() ? (Pi({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && Ot.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return Ot.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return Ot.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return Ot.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = Ot.getAuthData();
    return n ? Ot.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!Hv.isElectron())
      return !0;
    const n = await Hv.getVersion();
    return CT(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = sD) {
    try {
      return await T1.post(`${Yo.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (ai("AUTH", "Network connection offline - waiting..."), Pi({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await ek(5);
    n && (ai("AUTH", "Network connection restored"), Pi({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = oD(this.retryCount);
    return ai("AUTH", `Retrying in ${i} seconds`), await ek(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if (Ot.isRefreshTokenExpired(r))
      return ai("AUTH", "Refresh token expired"), Pi({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), Ot.removeAuthData(), tl(), null;
    if (jT(n)) {
      if (n.message === "timeout exceeded")
        return ai("AUTH", "Timeout exceeded"), Pi({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return ai("AUTH", "Network error"), Pi({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return ai("AUTH", "Refresh token invalid (401)"), Ot.removeAuthData(), tl(), null;
      Zv(n, {
        level: "error",
        tags: {
          team: Jo.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (ai("AUTH", "Retries exhausted, logging out"), Zv(n, {
      level: "error",
      tags: {
        team: Jo.Platform,
        errorSource: "authManager.refresh"
      }
    }), Ot.removeAuthData(), tl(), null) : (ai("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return Ot.accessTokenExpiresInMs();
  }
}
const Yl = new lD();
var Kh;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Kh || (Kh = {}));
const cD = new Py((e, n) => new Zw((r) => {
  Yl.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), uD = new Py(
  (e, n) => new Zw((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Yl.getAuthData().then((u) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...RI(Yo.url.partnerIntegrations) && u?.access_token && PI(u.access_token)
      }
    }), n(e).subscribe(r))).catch((u) => r.error(u));
  })
), dD = new AbortController(), D1 = (e) => new fE({
  queryDeduplication: !1,
  cache: new hE(),
  link: Py.from([
    cD,
    uD,
    yE({
      uri: `${e}/graphql`,
      fetch: _E,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: dD.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), mD = ({
  configuration: e,
  children: n
}) => {
  const r = Xn(
    () => D1(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ We.jsx(gE, { client: r, children: n });
};
function pD() {
  try {
    return vE(), !0;
  } catch {
    return !1;
  }
}
const fD = ({
  configuration: e,
  children: n
}) => pD() ? n : /* @__PURE__ */ We.jsx(mD, { configuration: e, children: n }), hD = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ We.jsx(kE, { children: (o) => /* @__PURE__ */ We.jsx(
  AI,
  {
    value: {
      useMutation: UI(e, n),
      useQuery: zI(e, n),
      useLazyQuery: VI(e, n),
      executeQuery: LI(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), O1 = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ We.jsx(fD, { configuration: r, children: s ? /* @__PURE__ */ We.jsx(
    hD,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, yD = "_unmatchedHeader_qcj19_1", gD = {
  unmatchedHeader: yD
};
var is = (e) => e.type === "checkbox", zi = (e) => e instanceof Date, nr = (e) => e == null;
const R1 = (e) => typeof e == "object";
var bt = (e) => !nr(e) && !Array.isArray(e) && R1(e) && !zi(e), P1 = (e) => bt(e) && e.target ? is(e.target) ? e.target.checked : e.target.value : e, vD = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, A1 = (e, n) => e.has(vD(n)), kD = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return bt(n) && n.hasOwnProperty("isPrototypeOf");
}, Jy = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function At(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Jy && (e instanceof Blob || i)) && (r || bt(e)))
    if (n = r ? [] : {}, !r && !kD(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = At(e[a]));
  else
    return e;
  return n;
}
var Ql = (e) => Array.isArray(e) ? e.filter(Boolean) : [], yt = (e) => e === void 0, on = (e, n, r) => {
  if (!n || !bt(e))
    return r;
  const i = Ql(n.split(/[,[\].]+?/)).reduce((a, o) => nr(a) ? a : a[o], e);
  return yt(i) || i === e ? yt(e[n]) ? r : e[n] : i;
}, fr = (e) => typeof e == "boolean", Xy = (e) => /^\w*$/.test(e), L1 = (e) => Ql(e.replace(/["|']|\]/g, "").split(/\.|\[/)), it = (e, n, r) => {
  let i = -1;
  const a = Xy(n) ? [n] : L1(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let u = r;
    if (i !== s) {
      const m = e[l];
      u = bt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = u, e = e[l];
  }
};
const bl = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, wr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, oi = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, V1 = $e.createContext(null), ni = () => $e.useContext(V1), Zy = (e) => {
  const { children: n, ...r } = e;
  return $e.createElement(V1.Provider, { value: r }, n);
};
var z1 = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== wr.all && (n._proxyFormState[s] = !i || wr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function bD(e) {
  const n = ni(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = $e.useState(r._formState), u = $e.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = $e.useRef(a);
  return m.current = a, $e.useEffect(() => r._subscribe({
    name: m.current,
    formState: u.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...r._formState,
        ...d
      });
    }
  }), [r, i, o]), $e.useEffect(() => {
    u.current.isValid && r._setValid(!0);
  }, [r]), $e.useMemo(() => z1(s, r, u.current, !1), [s, r]);
}
var Br = (e) => typeof e == "string", U1 = (e, n, r, i, a) => Br(e) ? (i && n.watch.add(e), on(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), on(r, o))) : (i && (n.watchAll = !0), r);
function Ao(e) {
  const n = ni(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = $e.useRef(i), u = $e.useRef(a);
  l.current = i, $e.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && d(U1(l.current, r._names, f.values || r._formValues, !1, u.current))
  }), [r, o, s]);
  const [m, d] = $e.useState(r._getWatch(i, a));
  return $e.useEffect(() => r._removeUnmounted()), m;
}
function eg(e) {
  const n = ni(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = A1(a._names.array, r), l = Ao({
    control: a,
    name: r,
    defaultValue: on(a._formValues, r, on(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), u = bD({
    control: a,
    name: r,
    exact: !0
  }), m = $e.useRef(e), d = $e.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...fr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = $e.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!on(u.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!on(u.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!on(u.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!on(u.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => on(u.errors, r)
    }
  }), [u, r]), h = $e.useCallback((j) => d.current.onChange({
    target: {
      value: P1(j),
      name: r
    },
    type: bl.CHANGE
  }), [r]), v = $e.useCallback(() => d.current.onBlur({
    target: {
      value: on(a._formValues, r),
      name: r
    },
    type: bl.BLUR
  }), [r, a._formValues]), I = $e.useCallback((j) => {
    const _ = on(a._fields, r);
    _ && j && (_._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (y) => j.setCustomValidity(y),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), w = $e.useMemo(() => ({
    name: r,
    value: l,
    ...fr(i) || u.disabled ? { disabled: u.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: I
  }), [r, i, u.disabled, h, v, I, l]);
  return $e.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...fr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const _ = (y, L) => {
      const $ = on(a._fields, y);
      $ && $._f && ($._f.mount = L);
    };
    if (_(r, !0), j) {
      const y = At(on(a._options.defaultValues, r));
      it(a._defaultValues, r, y), yt(on(a._formValues, r)) && it(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : _(r, !1);
    };
  }, [r, a, s, o]), $e.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), $e.useMemo(() => ({
    field: w,
    formState: u,
    fieldState: f
  }), [w, u, f]);
}
const zt = (e) => e.render(eg(e));
var _D = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Lo = (e) => Array.isArray(e) ? e : [e], nk = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Gh = (e) => nr(e) || !R1(e);
function xi(e, n) {
  if (Gh(e) || Gh(n))
    return e === n;
  if (zi(e) && zi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (zi(o) && zi(s) || bt(o) && bt(s) || Array.isArray(o) && Array.isArray(s) ? !xi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Xt = (e) => bt(e) && !Object.keys(e).length, ng = (e) => e.type === "file", Cr = (e) => typeof e == "function", _l = (e) => {
  if (!Jy)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, M1 = (e) => e.type === "select-multiple", tg = (e) => e.type === "radio", xD = (e) => tg(e) || is(e), Cc = (e) => _l(e) && e.isConnected;
function SD(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = yt(e) ? i++ : e[n[i++]];
  return e;
}
function ND(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !yt(e[n]))
      return !1;
  return !0;
}
function wt(e, n) {
  const r = Array.isArray(n) ? n : Xy(n) ? [n] : L1(n), i = r.length === 1 ? e : SD(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (bt(i) && Xt(i) || Array.isArray(i) && ND(i)) && wt(e, r.slice(0, -1)), e;
}
var B1 = (e) => {
  for (const n in e)
    if (Cr(e[n]))
      return !0;
  return !1;
};
function xl(e, n = {}) {
  const r = Array.isArray(e);
  if (bt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || bt(e[i]) && !B1(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, xl(e[i], n[i])) : nr(e[i]) || (n[i] = !0);
  return n;
}
function q1(e, n, r) {
  const i = Array.isArray(e);
  if (bt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || bt(e[a]) && !B1(e[a]) ? yt(n) || Gh(r[a]) ? r[a] = Array.isArray(e[a]) ? xl(e[a], []) : { ...xl(e[a]) } : q1(e[a], nr(n) ? {} : n[a], r[a]) : r[a] = !xi(e[a], n[a]);
  return r;
}
var Xa = (e, n) => q1(e, n, xl(n));
const tk = {
  value: !1,
  isValid: !1
}, rk = { value: !0, isValid: !0 };
var H1 = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !yt(e[0].attributes.value) ? yt(e[0].value) || e[0].value === "" ? rk : { value: e[0].value, isValid: !0 } : rk
    ) : tk;
  }
  return tk;
}, W1 = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => yt(e) ? e : n ? e === "" ? NaN : e && +e : r && Br(e) ? new Date(e) : i ? i(e) : e;
const ik = {
  isValid: !1,
  value: null
};
var K1 = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, ik) : ik;
function ak(e) {
  const n = e.ref;
  return ng(n) ? n.files : tg(n) ? K1(e.refs).value : M1(n) ? [...n.selectedOptions].map(({ value: r }) => r) : is(n) ? H1(e.refs).value : W1(yt(n.value) ? e.ref.value : n.value, e);
}
var jD = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = on(n, o);
    s && it(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Sl = (e) => e instanceof RegExp, Za = (e) => yt(e) ? e : Sl(e) ? e.source : bt(e) ? Sl(e.value) ? e.value.source : e.value : e, ok = (e) => ({
  isOnSubmit: !e || e === wr.onSubmit,
  isOnBlur: e === wr.onBlur,
  isOnChange: e === wr.onChange,
  isOnAll: e === wr.all,
  isOnTouch: e === wr.onTouched
});
const sk = "AsyncFunction";
var wD = (e) => !!e && !!e.validate && !!(Cr(e.validate) && e.validate.constructor.name === sk || bt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === sk)), CD = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), lk = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Vo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = on(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Vo(l, n))
          break;
      } else if (bt(l) && Vo(l, n))
        break;
    }
  }
};
function ck(e, n, r) {
  const i = on(e, r);
  if (i || Xy(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = on(n, o), l = on(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var FD = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Xt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || wr.all));
}, ID = (e, n, r) => !e || !n || e === n || Lo(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), ED = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, $D = (e, n) => !Ql(on(e, n)).length && wt(e, n), TD = (e, n, r) => {
  const i = Lo(on(e, r));
  return it(i, "root", n[r]), it(e, r, i), e;
}, rl = (e) => Br(e);
function uk(e, n, r = "validate") {
  if (rl(e) || Array.isArray(e) && e.every(rl) || fr(e) && !e)
    return {
      type: r,
      message: rl(e) ? e : "",
      ref: n
    };
}
var oa = (e) => bt(e) && !Sl(e) ? e : {
  value: e,
  message: ""
}, dk = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: u, maxLength: m, minLength: d, min: f, max: h, pattern: v, validate: I, name: w, valueAsNumber: j, mount: _ } = e._f, y = on(r, w);
  if (!_ || n.has(w))
    return {};
  const L = l ? l[0] : s, $ = (B) => {
    a && L.reportValidity && (L.setCustomValidity(fr(B) ? "" : B || ""), L.reportValidity());
  }, C = {}, F = tg(s), z = is(s), Q = F || z, J = (j || ng(s)) && yt(s.value) && yt(y) || _l(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, te = _D.bind(null, w, i, C), G = (B, R, U, ee = oi.maxLength, Se = oi.minLength) => {
    const fe = B ? R : U;
    C[w] = {
      type: B ? ee : Se,
      message: fe,
      ref: s,
      ...te(B ? ee : Se, fe)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : u && (!Q && (J || nr(y)) || fr(y) && !y || z && !H1(l).isValid || F && !K1(l).isValid)) {
    const { value: B, message: R } = rl(u) ? { value: !!u, message: u } : oa(u);
    if (B && (C[w] = {
      type: oi.required,
      message: R,
      ref: L,
      ...te(oi.required, R)
    }, !i))
      return $(R), C;
  }
  if (!J && (!nr(f) || !nr(h))) {
    let B, R;
    const U = oa(h), ee = oa(f);
    if (!nr(y) && !isNaN(y)) {
      const Se = s.valueAsNumber || y && +y;
      nr(U.value) || (B = Se > U.value), nr(ee.value) || (R = Se < ee.value);
    } else {
      const Se = s.valueAsDate || new Date(y), fe = (K) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + K), ye = s.type == "time", ve = s.type == "week";
      Br(U.value) && y && (B = ye ? fe(y) > fe(U.value) : ve ? y > U.value : Se > new Date(U.value)), Br(ee.value) && y && (R = ye ? fe(y) < fe(ee.value) : ve ? y < ee.value : Se < new Date(ee.value));
    }
    if ((B || R) && (G(!!B, U.message, ee.message, oi.max, oi.min), !i))
      return $(C[w].message), C;
  }
  if ((m || d) && !J && (Br(y) || o && Array.isArray(y))) {
    const B = oa(m), R = oa(d), U = !nr(B.value) && y.length > +B.value, ee = !nr(R.value) && y.length < +R.value;
    if ((U || ee) && (G(U, B.message, R.message), !i))
      return $(C[w].message), C;
  }
  if (v && !J && Br(y)) {
    const { value: B, message: R } = oa(v);
    if (Sl(B) && !y.match(B) && (C[w] = {
      type: oi.pattern,
      message: R,
      ref: s,
      ...te(oi.pattern, R)
    }, !i))
      return $(R), C;
  }
  if (I) {
    if (Cr(I)) {
      const B = await I(y, r), R = uk(B, L);
      if (R && (C[w] = {
        ...R,
        ...te(oi.validate, R.message)
      }, !i))
        return $(R.message), C;
    } else if (bt(I)) {
      let B = {};
      for (const R in I) {
        if (!Xt(B) && !i)
          break;
        const U = uk(await I[R](y, r), L, R);
        U && (B = {
          ...U,
          ...te(R, U.message)
        }, $(U.message), i && (C[w] = B));
      }
      if (!Xt(B) && (C[w] = {
        ref: L,
        ...B
      }, !i))
        return C;
    }
  }
  return $(!0), C;
};
const DD = {
  mode: wr.onSubmit,
  reValidateMode: wr.onChange,
  shouldFocusError: !0
};
function OD(e = {}) {
  let n = {
    ...DD,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Cr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = bt(n.defaultValues) || bt(n.values) ? At(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : At(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, m = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...d
  };
  const h = {
    array: nk(),
    state: nk()
  }, v = ok(n.mode), I = ok(n.reValidateMode), w = n.criteriaMode === wr.all, j = (x) => (D) => {
    clearTimeout(m), m = setTimeout(x, D);
  }, _ = async (x) => {
    if (!n.disabled && (d.isValid || f.isValid || x)) {
      const D = n.resolver ? Xt((await J()).errors) : await G(i, !0);
      D !== r.isValid && h.state.next({
        isValid: D
      });
    }
  }, y = (x, D) => {
    !n.disabled && (d.isValidating || d.validatingFields || f.isValidating || f.validatingFields) && ((x || Array.from(l.mount)).forEach((H) => {
      H && (D ? it(r.validatingFields, H, D) : wt(r.validatingFields, H));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Xt(r.validatingFields)
    }));
  }, L = (x, D = [], H, Y, A = !0, M = !0) => {
    if (Y && H && !n.disabled) {
      if (s.action = !0, M && Array.isArray(on(i, x))) {
        const oe = H(on(i, x), Y.argA, Y.argB);
        A && it(i, x, oe);
      }
      if (M && Array.isArray(on(r.errors, x))) {
        const oe = H(on(r.errors, x), Y.argA, Y.argB);
        A && it(r.errors, x, oe), $D(r.errors, x);
      }
      if ((d.touchedFields || f.touchedFields) && M && Array.isArray(on(r.touchedFields, x))) {
        const oe = H(on(r.touchedFields, x), Y.argA, Y.argB);
        A && it(r.touchedFields, x, oe);
      }
      (d.dirtyFields || f.dirtyFields) && (r.dirtyFields = Xa(a, o)), h.state.next({
        name: x,
        isDirty: R(x, D),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      it(o, x, D);
  }, $ = (x, D) => {
    it(r.errors, x, D), h.state.next({
      errors: r.errors
    });
  }, C = (x) => {
    r.errors = x, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, F = (x, D, H, Y) => {
    const A = on(i, x);
    if (A) {
      const M = on(o, x, yt(H) ? on(a, x) : H);
      yt(M) || Y && Y.defaultChecked || D ? it(o, x, D ? M : ak(A._f)) : Se(x, M), s.mount && _();
    }
  }, z = (x, D, H, Y, A) => {
    let M = !1, oe = !1;
    const ge = {
      name: x
    };
    if (!n.disabled) {
      if (!H || Y) {
        (d.isDirty || f.isDirty) && (oe = r.isDirty, r.isDirty = ge.isDirty = R(), M = oe !== ge.isDirty);
        const Ne = xi(on(a, x), D);
        oe = !!on(r.dirtyFields, x), Ne ? wt(r.dirtyFields, x) : it(r.dirtyFields, x, !0), ge.dirtyFields = r.dirtyFields, M = M || (d.dirtyFields || f.dirtyFields) && oe !== !Ne;
      }
      if (H) {
        const Ne = on(r.touchedFields, x);
        Ne || (it(r.touchedFields, x, H), ge.touchedFields = r.touchedFields, M = M || (d.touchedFields || f.touchedFields) && Ne !== H);
      }
      M && A && h.state.next(ge);
    }
    return M ? ge : {};
  }, Q = (x, D, H, Y) => {
    const A = on(r.errors, x), M = (d.isValid || f.isValid) && fr(D) && r.isValid !== D;
    if (n.delayError && H ? (u = j(() => $(x, H)), u(n.delayError)) : (clearTimeout(m), u = null, H ? it(r.errors, x, H) : wt(r.errors, x)), (H ? !xi(A, H) : A) || !Xt(Y) || M) {
      const oe = {
        ...Y,
        ...M && fr(D) ? { isValid: D } : {},
        errors: r.errors,
        name: x
      };
      r = {
        ...r,
        ...oe
      }, h.state.next(oe);
    }
  }, J = async (x) => {
    y(x, !0);
    const D = await n.resolver(o, n.context, jD(x || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(x), D;
  }, te = async (x) => {
    const { errors: D } = await J(x);
    if (x)
      for (const H of x) {
        const Y = on(D, H);
        Y ? it(r.errors, H, Y) : wt(r.errors, H);
      }
    else
      r.errors = D;
    return D;
  }, G = async (x, D, H = {
    valid: !0
  }) => {
    for (const Y in x) {
      const A = x[Y];
      if (A) {
        const { _f: M, ...oe } = A;
        if (M) {
          const ge = l.array.has(M.name), Ne = A._f && wD(A._f);
          Ne && d.validatingFields && y([Y], !0);
          const rn = await dk(A, l.disabled, o, w, n.shouldUseNativeValidation && !D, ge);
          if (Ne && d.validatingFields && y([Y]), rn[M.name] && (H.valid = !1, D))
            break;
          !D && (on(rn, M.name) ? ge ? TD(r.errors, rn, M.name) : it(r.errors, M.name, rn[M.name]) : wt(r.errors, M.name));
        }
        !Xt(oe) && await G(oe, D, H);
      }
    }
    return H.valid;
  }, B = () => {
    for (const x of l.unMount) {
      const D = on(i, x);
      D && (D._f.refs ? D._f.refs.every((H) => !Cc(H)) : !Cc(D._f.ref)) && Be(x);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (x, D) => !n.disabled && (x && D && it(o, x, D), !xi(Te(), a)), U = (x, D, H) => U1(x, l, {
    ...s.mount ? o : yt(D) ? a : Br(x) ? { [x]: D } : D
  }, H, D), ee = (x) => Ql(on(s.mount ? o : a, x, n.shouldUnregister ? on(a, x, []) : [])), Se = (x, D, H = {}) => {
    const Y = on(i, x);
    let A = D;
    if (Y) {
      const M = Y._f;
      M && (!M.disabled && it(o, x, W1(D, M)), A = _l(M.ref) && nr(D) ? "" : D, M1(M.ref) ? [...M.ref.options].forEach((oe) => oe.selected = A.includes(oe.value)) : M.refs ? is(M.ref) ? M.refs.length > 1 ? M.refs.forEach((oe) => (!oe.defaultChecked || !oe.disabled) && (oe.checked = Array.isArray(A) ? !!A.find((ge) => ge === oe.value) : A === oe.value)) : M.refs[0] && (M.refs[0].checked = !!A) : M.refs.forEach((oe) => oe.checked = oe.value === A) : ng(M.ref) ? M.ref.value = "" : (M.ref.value = A, M.ref.type || h.state.next({
        name: x,
        values: At(o)
      })));
    }
    (H.shouldDirty || H.shouldTouch) && z(x, A, H.shouldTouch, H.shouldDirty, !0), H.shouldValidate && _e(x);
  }, fe = (x, D, H) => {
    for (const Y in D) {
      const A = D[Y], M = `${x}.${Y}`, oe = on(i, M);
      (l.array.has(x) || bt(A) || oe && !oe._f) && !zi(A) ? fe(M, A, H) : Se(M, A, H);
    }
  }, ye = (x, D, H = {}) => {
    const Y = on(i, x), A = l.array.has(x), M = At(D);
    it(o, x, M), A ? (h.array.next({
      name: x,
      values: At(o)
    }), (d.isDirty || d.dirtyFields || f.isDirty || f.dirtyFields) && H.shouldDirty && h.state.next({
      name: x,
      dirtyFields: Xa(a, o),
      isDirty: R(x, M)
    })) : Y && !Y._f && !nr(M) ? fe(x, M, H) : Se(x, M, H), lk(x, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? x : void 0,
      values: At(o)
    });
  }, ve = async (x) => {
    s.mount = !0;
    const D = x.target;
    let H = D.name, Y = !0;
    const A = on(i, H), M = (oe) => {
      Y = Number.isNaN(oe) || zi(oe) && isNaN(oe.getTime()) || xi(oe, on(o, H, oe));
    };
    if (A) {
      let oe, ge;
      const Ne = D.type ? ak(A._f) : P1(x), rn = x.type === bl.BLUR || x.type === bl.FOCUS_OUT, gn = !CD(A._f) && !n.resolver && !on(r.errors, H) && !A._f.deps || ED(rn, on(r.touchedFields, H), r.isSubmitted, I, v), tn = lk(H, l, rn);
      it(o, H, Ne), rn ? (A._f.onBlur && A._f.onBlur(x), u && u(0)) : A._f.onChange && A._f.onChange(x);
      const dn = z(H, Ne, rn), wn = !Xt(dn) || tn;
      if (!rn && h.state.next({
        name: H,
        type: x.type,
        values: At(o)
      }), gn)
        return (d.isValid || f.isValid) && (n.mode === "onBlur" ? rn && _() : rn || _()), wn && h.state.next({ name: H, ...tn ? {} : dn });
      if (!rn && tn && h.state.next({ ...r }), n.resolver) {
        const { errors: xn } = await J([H]);
        if (M(Ne), Y) {
          const Cn = ck(r.errors, i, H), Ze = ck(xn, i, Cn.name || H);
          oe = Ze.error, H = Ze.name, ge = Xt(xn);
        }
      } else
        y([H], !0), oe = (await dk(A, l.disabled, o, w, n.shouldUseNativeValidation))[H], y([H]), M(Ne), Y && (oe ? ge = !1 : (d.isValid || f.isValid) && (ge = await G(i, !0)));
      Y && (A._f.deps && _e(A._f.deps), Q(H, ge, oe, dn));
    }
  }, K = (x, D) => {
    if (on(r.errors, D) && x.focus)
      return x.focus(), 1;
  }, _e = async (x, D = {}) => {
    let H, Y;
    const A = Lo(x);
    if (n.resolver) {
      const M = await te(yt(x) ? x : A);
      H = Xt(M), Y = x ? !A.some((oe) => on(M, oe)) : H;
    } else x ? (Y = (await Promise.all(A.map(async (M) => {
      const oe = on(i, M);
      return await G(oe && oe._f ? { [M]: oe } : oe);
    }))).every(Boolean), !(!Y && !r.isValid) && _()) : Y = H = await G(i);
    return h.state.next({
      ...!Br(x) || (d.isValid || f.isValid) && H !== r.isValid ? {} : { name: x },
      ...n.resolver || !x ? { isValid: H } : {},
      errors: r.errors
    }), D.shouldFocus && !Y && Vo(i, K, x ? A : l.mount), Y;
  }, Te = (x) => {
    const D = {
      ...s.mount ? o : a
    };
    return yt(x) ? D : Br(x) ? on(D, x) : x.map((H) => on(D, H));
  }, X = (x, D) => ({
    invalid: !!on((D || r).errors, x),
    isDirty: !!on((D || r).dirtyFields, x),
    error: on((D || r).errors, x),
    isValidating: !!on(r.validatingFields, x),
    isTouched: !!on((D || r).touchedFields, x)
  }), Ke = (x) => {
    x && Lo(x).forEach((D) => wt(r.errors, D)), h.state.next({
      errors: x ? r.errors : {}
    });
  }, an = (x, D, H) => {
    const Y = (on(i, x, { _f: {} })._f || {}).ref, A = on(r.errors, x) || {}, { ref: M, message: oe, type: ge, ...Ne } = A;
    it(r.errors, x, {
      ...Ne,
      ...D,
      ref: Y
    }), h.state.next({
      name: x,
      errors: r.errors,
      isValid: !1
    }), H && H.shouldFocus && Y && Y.focus && Y.focus();
  }, we = (x, D) => Cr(x) ? h.state.subscribe({
    next: (H) => x(U(void 0, D), H)
  }) : U(x, D, !0), Me = (x) => h.state.subscribe({
    next: (D) => {
      ID(x.name, D.name, x.exact) && FD(D, x.formState || d, Pe, x.reRenderRoot) && x.callback({
        values: { ...o },
        ...r,
        ...D
      });
    }
  }).unsubscribe, Re = (x) => (s.mount = !0, f = {
    ...f,
    ...x.formState
  }, Me({
    ...x,
    formState: f
  })), Be = (x, D = {}) => {
    for (const H of x ? Lo(x) : l.mount)
      l.mount.delete(H), l.array.delete(H), D.keepValue || (wt(i, H), wt(o, H)), !D.keepError && wt(r.errors, H), !D.keepDirty && wt(r.dirtyFields, H), !D.keepTouched && wt(r.touchedFields, H), !D.keepIsValidating && wt(r.validatingFields, H), !n.shouldUnregister && !D.keepDefaultValue && wt(a, H);
    h.state.next({
      values: At(o)
    }), h.state.next({
      ...r,
      ...D.keepDirty ? { isDirty: R() } : {}
    }), !D.keepIsValid && _();
  }, Ae = ({ disabled: x, name: D }) => {
    (fr(x) && s.mount || x || l.disabled.has(D)) && (x ? l.disabled.add(D) : l.disabled.delete(D));
  }, Ge = (x, D = {}) => {
    let H = on(i, x);
    const Y = fr(D.disabled) || fr(n.disabled);
    return it(i, x, {
      ...H || {},
      _f: {
        ...H && H._f ? H._f : { ref: { name: x } },
        name: x,
        mount: !0,
        ...D
      }
    }), l.mount.add(x), H ? Ae({
      disabled: fr(D.disabled) ? D.disabled : n.disabled,
      name: x
    }) : F(x, !0, D.value), {
      ...Y ? { disabled: D.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!D.required,
        min: Za(D.min),
        max: Za(D.max),
        minLength: Za(D.minLength),
        maxLength: Za(D.maxLength),
        pattern: Za(D.pattern)
      } : {},
      name: x,
      onChange: ve,
      onBlur: ve,
      ref: (A) => {
        if (A) {
          Ge(x, D), H = on(i, x);
          const M = yt(A.value) && A.querySelectorAll && A.querySelectorAll("input,select,textarea")[0] || A, oe = xD(M), ge = H._f.refs || [];
          if (oe ? ge.find((Ne) => Ne === M) : M === H._f.ref)
            return;
          it(i, x, {
            _f: {
              ...H._f,
              ...oe ? {
                refs: [
                  ...ge.filter(Cc),
                  M,
                  ...Array.isArray(on(a, x)) ? [{}] : []
                ],
                ref: { type: M.type, name: x }
              } : { ref: M }
            }
          }), F(x, !1, void 0, M);
        } else
          H = on(i, x, {}), H._f && (H._f.mount = !1), (n.shouldUnregister || D.shouldUnregister) && !(A1(l.array, x) && s.action) && l.unMount.add(x);
      }
    };
  }, Ce = () => n.shouldFocusError && Vo(i, K, l.mount), qe = (x) => {
    fr(x) && (h.state.next({ disabled: x }), Vo(i, (D, H) => {
      const Y = on(i, H);
      Y && (D.disabled = Y._f.disabled || x, Array.isArray(Y._f.refs) && Y._f.refs.forEach((A) => {
        A.disabled = Y._f.disabled || x;
      }));
    }, 0, !1));
  }, nn = (x, D) => async (H) => {
    let Y;
    H && (H.preventDefault && H.preventDefault(), H.persist && H.persist());
    let A = At(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: M, values: oe } = await J();
      r.errors = M, A = oe;
    } else
      await G(i);
    if (l.disabled.size)
      for (const M of l.disabled)
        it(A, M, void 0);
    if (wt(r.errors, "root"), Xt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await x(A, H);
      } catch (M) {
        Y = M;
      }
    } else
      D && await D({ ...r.errors }, H), Ce(), setTimeout(Ce);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Xt(r.errors) && !Y,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), Y)
      throw Y;
  }, ae = (x, D = {}) => {
    on(i, x) && (yt(D.defaultValue) ? ye(x, At(on(a, x))) : (ye(x, D.defaultValue), it(a, x, At(D.defaultValue))), D.keepTouched || wt(r.touchedFields, x), D.keepDirty || (wt(r.dirtyFields, x), r.isDirty = D.defaultValue ? R(x, At(on(a, x))) : R()), D.keepError || (wt(r.errors, x), d.isValid && _()), h.state.next({ ...r }));
  }, le = (x, D = {}) => {
    const H = x ? At(x) : a, Y = At(H), A = Xt(x), M = A ? a : Y;
    if (D.keepDefaultValues || (a = H), !D.keepValues) {
      if (D.keepDirtyValues) {
        const oe = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Xa(a, o))
        ]);
        for (const ge of Array.from(oe))
          on(r.dirtyFields, ge) ? it(M, ge, on(o, ge)) : ye(ge, on(M, ge));
      } else {
        if (Jy && yt(x))
          for (const oe of l.mount) {
            const ge = on(i, oe);
            if (ge && ge._f) {
              const Ne = Array.isArray(ge._f.refs) ? ge._f.refs[0] : ge._f.ref;
              if (_l(Ne)) {
                const rn = Ne.closest("form");
                if (rn) {
                  rn.reset();
                  break;
                }
              }
            }
          }
        for (const oe of l.mount)
          ye(oe, on(M, oe));
      }
      o = At(M), h.array.next({
        values: { ...M }
      }), h.state.next({
        values: { ...M }
      });
    }
    l = {
      mount: D.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!D.keepIsValid || !!D.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: D.keepSubmitCount ? r.submitCount : 0,
      isDirty: A ? !1 : D.keepDirty ? r.isDirty : !!(D.keepDefaultValues && !xi(x, a)),
      isSubmitted: D.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: A ? {} : D.keepDirtyValues ? D.keepDefaultValues && o ? Xa(a, o) : r.dirtyFields : D.keepDefaultValues && x ? Xa(a, x) : D.keepDirty ? r.dirtyFields : {},
      touchedFields: D.keepTouched ? r.touchedFields : {},
      errors: D.keepErrors ? r.errors : {},
      isSubmitSuccessful: D.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, xe = (x, D) => le(Cr(x) ? x(o) : x, D), Le = (x, D = {}) => {
    const H = on(i, x), Y = H && H._f;
    if (Y) {
      const A = Y.refs ? Y.refs[0] : Y.ref;
      A.focus && (A.focus(), D.shouldSelect && Cr(A.select) && A.select());
    }
  }, Pe = (x) => {
    r = {
      ...r,
      ...x
    };
  }, T = {
    control: {
      register: Ge,
      unregister: Be,
      getFieldState: X,
      handleSubmit: nn,
      setError: an,
      _subscribe: Me,
      _runSchema: J,
      _getWatch: U,
      _getDirty: R,
      _setValid: _,
      _setFieldArray: L,
      _setDisabledField: Ae,
      _setErrors: C,
      _getFieldArray: ee,
      _reset: le,
      _resetDefaultValues: () => Cr(n.defaultValues) && n.defaultValues().then((x) => {
        xe(x, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: qe,
      _subjects: h,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(x) {
        s = x;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(x) {
        l = x;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(x) {
        n = {
          ...n,
          ...x
        };
      }
    },
    subscribe: Re,
    trigger: _e,
    register: Ge,
    handleSubmit: nn,
    watch: we,
    setValue: ye,
    getValues: Te,
    reset: xe,
    resetField: ae,
    clearErrors: Ke,
    unregister: Be,
    setError: an,
    setFocus: Le,
    getFieldState: X
  };
  return {
    ...T,
    formControl: T
  };
}
function ht(e = {}) {
  const n = $e.useRef(void 0), r = $e.useRef(void 0), [i, a] = $e.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Cr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Cr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : OD(e),
    formState: i
  }, e.formControl && e.defaultValues && !Cr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, $e.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), $e.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), $e.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), $e.useEffect(() => {
    e.values && !xi(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), $e.useEffect(() => {
    e.errors && !Xt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), $e.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), $e.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = z1(i, o), n.current;
}
var ks = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function G1(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Fc = { exports: {} }, eo = {}, mk;
function RD() {
  if (mk) return eo;
  mk = 1;
  var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return eo.Fragment = r, eo.jsx = s, eo.jsxs = s, eo;
}
var bs = {}, pk;
function PD() {
  return pk || (pk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var g = _.ReactDebugCurrentFrame, E = g.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var $ = !1, C = !1, F = !1, z = !1, Q = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === d || z || t === v || $ || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, N = E._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (E) {
            var g = E.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (ie) {
              g = ie;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var S = ie.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var ue = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = E;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ae(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ae(t.type, c, p);
          case h: {
            var g = t, E = g._payload, O = g._init;
            try {
              return ae(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, p, g, E) {
      {
        var O = Function.call.bind(le);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + p + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe(E), y("Failed %s type: %s", p, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, p, g, E, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, p, g, E) {
      {
        var O, N = {}, S = null, ne = null;
        p !== void 0 && (A(p), S = "" + p), gn(c) && (A(c.key), S = "" + c.key), rn(c) && (ne = c.ref, tn(c));
        for (O in c)
          le.call(c, O) && !oe.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, E, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function An(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = j(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          yn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var E = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, p, g, E, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, p, E, O);
        if (W == null)
          return W;
        if (N) {
          var ue = c.children;
          if (ue !== void 0)
            if (g)
              if (x(ue)) {
                for (var Ue = 0; Ue < ue.length; Ue++)
                  Sn(ue[Ue], t);
                Object.freeze && Object.freeze(ue);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ue, t);
        }
        if (le.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var Rn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, Rn, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, p) {
      return Fn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return Fn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    bs.Fragment = i, bs.jsx = Un, bs.jsxs = Kn;
  })()), bs;
}
var fk;
function AD() {
  return fk || (fk = 1, process.env.NODE_ENV === "production" ? Fc.exports = RD() : Fc.exports = PD()), Fc.exports;
}
var Hi = AD();
function LD(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Ic, hk;
function wi() {
  if (hk) return Ic;
  hk = 1;
  var e = Array.isArray;
  return Ic = e, Ic;
}
var Ec, yk;
function Y1() {
  if (yk) return Ec;
  yk = 1;
  var e = typeof ks == "object" && ks && ks.Object === Object && ks;
  return Ec = e, Ec;
}
var $c, gk;
function ti() {
  if (gk) return $c;
  gk = 1;
  var e = Y1(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return $c = r, $c;
}
var Tc, vk;
function as() {
  if (vk) return Tc;
  vk = 1;
  var e = ti(), n = e.Symbol;
  return Tc = n, Tc;
}
var Dc, kk;
function VD() {
  if (kk) return Dc;
  kk = 1;
  var e = as(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), u = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var d = i.call(s);
    return m && (l ? s[a] = u : delete s[a]), d;
  }
  return Dc = o, Dc;
}
var Oc, bk;
function zD() {
  if (bk) return Oc;
  bk = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Oc = r, Oc;
}
var Rc, _k;
function Va() {
  if (_k) return Rc;
  _k = 1;
  var e = as(), n = VD(), r = zD(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Rc = s, Rc;
}
var Pc, xk;
function Ji() {
  if (xk) return Pc;
  xk = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Pc = e, Pc;
}
var Ac, Sk;
function rg() {
  if (Sk) return Ac;
  Sk = 1;
  var e = Va(), n = Ji(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return Ac = i, Ac;
}
var Lc, Nk;
function UD() {
  if (Nk) return Lc;
  Nk = 1;
  var e = wi(), n = rg(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return Lc = a, Lc;
}
var Vc, jk;
function za() {
  if (jk) return Vc;
  jk = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return Vc = e, Vc;
}
var zc, wk;
function Q1() {
  if (wk) return zc;
  wk = 1;
  var e = Va(), n = za(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var u = e(l);
    return u == i || u == a || u == r || u == o;
  }
  return zc = s, zc;
}
var Uc, Ck;
function MD() {
  if (Ck) return Uc;
  Ck = 1;
  var e = ti(), n = e["__core-js_shared__"];
  return Uc = n, Uc;
}
var Mc, Fk;
function BD() {
  if (Fk) return Mc;
  Fk = 1;
  var e = MD(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return Mc = r, Mc;
}
var Bc, Ik;
function J1() {
  if (Ik) return Bc;
  Ik = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return Bc = r, Bc;
}
var qc, Ek;
function qD() {
  if (Ek) return qc;
  Ek = 1;
  var e = Q1(), n = BD(), r = za(), i = J1(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, u = s.toString, m = l.hasOwnProperty, d = RegExp(
    "^" + u.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? d : o;
    return v.test(i(h));
  }
  return qc = f, qc;
}
var Hc, $k;
function HD() {
  if ($k) return Hc;
  $k = 1;
  function e(n, r) {
    return n?.[r];
  }
  return Hc = e, Hc;
}
var Wc, Tk;
function Xi() {
  if (Tk) return Wc;
  Tk = 1;
  var e = qD(), n = HD();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Wc = r, Wc;
}
var Kc, Dk;
function Jl() {
  if (Dk) return Kc;
  Dk = 1;
  var e = Xi(), n = e(Object, "create");
  return Kc = n, Kc;
}
var Gc, Ok;
function WD() {
  if (Ok) return Gc;
  Ok = 1;
  var e = Jl();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Gc = n, Gc;
}
var Yc, Rk;
function KD() {
  if (Rk) return Yc;
  Rk = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return Yc = e, Yc;
}
var Qc, Pk;
function GD() {
  if (Pk) return Qc;
  Pk = 1;
  var e = Jl(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Qc = a, Qc;
}
var Jc, Ak;
function YD() {
  if (Ak) return Jc;
  Ak = 1;
  var e = Jl(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Jc = i, Jc;
}
var Xc, Lk;
function QD() {
  if (Lk) return Xc;
  Lk = 1;
  var e = Jl(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return Xc = r, Xc;
}
var Zc, Vk;
function JD() {
  if (Vk) return Zc;
  Vk = 1;
  var e = WD(), n = KD(), r = GD(), i = YD(), a = QD();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Zc = o, Zc;
}
var eu, zk;
function XD() {
  if (zk) return eu;
  zk = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return eu = e, eu;
}
var nu, Uk;
function X1() {
  if (Uk) return nu;
  Uk = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return nu = e, nu;
}
var tu, Mk;
function Xl() {
  if (Mk) return tu;
  Mk = 1;
  var e = X1();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return tu = n, tu;
}
var ru, Bk;
function ZD() {
  if (Bk) return ru;
  Bk = 1;
  var e = Xl(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return ru = i, ru;
}
var iu, qk;
function eO() {
  if (qk) return iu;
  qk = 1;
  var e = Xl();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return iu = n, iu;
}
var au, Hk;
function nO() {
  if (Hk) return au;
  Hk = 1;
  var e = Xl();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return au = n, au;
}
var ou, Wk;
function tO() {
  if (Wk) return ou;
  Wk = 1;
  var e = Xl();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return ou = n, ou;
}
var su, Kk;
function Zl() {
  if (Kk) return su;
  Kk = 1;
  var e = XD(), n = ZD(), r = eO(), i = nO(), a = tO();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, su = o, su;
}
var lu, Gk;
function ig() {
  if (Gk) return lu;
  Gk = 1;
  var e = Xi(), n = ti(), r = e(n, "Map");
  return lu = r, lu;
}
var cu, Yk;
function rO() {
  if (Yk) return cu;
  Yk = 1;
  var e = JD(), n = Zl(), r = ig();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return cu = i, cu;
}
var uu, Qk;
function iO() {
  if (Qk) return uu;
  Qk = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return uu = e, uu;
}
var du, Jk;
function ec() {
  if (Jk) return du;
  Jk = 1;
  var e = iO();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return du = n, du;
}
var mu, Xk;
function aO() {
  if (Xk) return mu;
  Xk = 1;
  var e = ec();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return mu = n, mu;
}
var pu, Zk;
function oO() {
  if (Zk) return pu;
  Zk = 1;
  var e = ec();
  function n(r) {
    return e(this, r).get(r);
  }
  return pu = n, pu;
}
var fu, eb;
function sO() {
  if (eb) return fu;
  eb = 1;
  var e = ec();
  function n(r) {
    return e(this, r).has(r);
  }
  return fu = n, fu;
}
var hu, nb;
function lO() {
  if (nb) return hu;
  nb = 1;
  var e = ec();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return hu = n, hu;
}
var yu, tb;
function Z1() {
  if (tb) return yu;
  tb = 1;
  var e = rO(), n = aO(), r = oO(), i = sO(), a = lO();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, yu = o, yu;
}
var gu, rb;
function cO() {
  if (rb) return gu;
  rb = 1;
  var e = Z1(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], u = o.cache;
      if (u.has(l))
        return u.get(l);
      var m = i.apply(this, s);
      return o.cache = u.set(l, m) || u, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, gu = r, gu;
}
var vu, ib;
function uO() {
  if (ib) return vu;
  ib = 1;
  var e = cO(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return vu = r, vu;
}
var ku, ab;
function dO() {
  if (ab) return ku;
  ab = 1;
  var e = uO(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, u, m) {
      o.push(u ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return ku = i, ku;
}
var bu, ob;
function eC() {
  if (ob) return bu;
  ob = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return bu = e, bu;
}
var _u, sb;
function mO() {
  if (sb) return _u;
  sb = 1;
  var e = as(), n = eC(), r = wi(), i = rg(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var u = l + "";
    return u == "0" && 1 / l == -1 / 0 ? "-0" : u;
  }
  return _u = s, _u;
}
var xu, lb;
function pO() {
  if (lb) return xu;
  lb = 1;
  var e = mO();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return xu = n, xu;
}
var Su, cb;
function Ua() {
  if (cb) return Su;
  cb = 1;
  var e = wi(), n = UD(), r = dO(), i = pO();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return Su = a, Su;
}
var Nu, ub;
function nc() {
  if (ub) return Nu;
  ub = 1;
  var e = rg();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return Nu = n, Nu;
}
var ju, db;
function nC() {
  if (db) return ju;
  db = 1;
  var e = Ua(), n = nc();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return ju = r, ju;
}
var wu, mb;
function tC() {
  if (mb) return wu;
  mb = 1;
  var e = Xi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return wu = n, wu;
}
var Cu, pb;
function rC() {
  if (pb) return Cu;
  pb = 1;
  var e = tC();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return Cu = n, Cu;
}
var Fu, fb;
function ag() {
  if (fb) return Fu;
  fb = 1;
  var e = rC(), n = X1(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var u = o[s];
    (!(i.call(o, s) && n(u, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Fu = a, Fu;
}
var Iu, hb;
function og() {
  if (hb) return Iu;
  hb = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Iu = r, Iu;
}
var Eu, yb;
function fO() {
  if (yb) return Eu;
  yb = 1;
  var e = ag(), n = Ua(), r = og(), i = za(), a = nc();
  function o(s, l, u, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var d = -1, f = l.length, h = f - 1, v = s; v != null && ++d < f; ) {
      var I = a(l[d]), w = u;
      if (I === "__proto__" || I === "constructor" || I === "prototype")
        return s;
      if (d != h) {
        var j = v[I];
        w = m ? m(j, I, v) : void 0, w === void 0 && (w = i(j) ? j : r(l[d + 1]) ? [] : {});
      }
      e(v, I, w), v = v[I];
    }
    return s;
  }
  return Eu = o, Eu;
}
var $u, gb;
function hO() {
  if (gb) return $u;
  gb = 1;
  var e = nC(), n = fO(), r = Ua();
  function i(a, o, s) {
    for (var l = -1, u = o.length, m = {}; ++l < u; ) {
      var d = o[l], f = e(a, d);
      s(f, d) && n(m, r(d, a), f);
    }
    return m;
  }
  return $u = i, $u;
}
var Tu, vb;
function yO() {
  if (vb) return Tu;
  vb = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Tu = e, Tu;
}
var Du, kb;
function gO() {
  if (kb) return Du;
  kb = 1;
  var e = Va(), n = Ji(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Du = i, Du;
}
var Ou, bb;
function sg() {
  if (bb) return Ou;
  bb = 1;
  var e = gO(), n = Ji(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Ou = o, Ou;
}
var Ru, _b;
function lg() {
  if (_b) return Ru;
  _b = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Ru = n, Ru;
}
var Pu, xb;
function vO() {
  if (xb) return Pu;
  xb = 1;
  var e = Ua(), n = sg(), r = wi(), i = og(), a = lg(), o = nc();
  function s(l, u, m) {
    u = e(u, l);
    for (var d = -1, f = u.length, h = !1; ++d < f; ) {
      var v = o(u[d]);
      if (!(h = l != null && m(l, v)))
        break;
      l = l[v];
    }
    return h || ++d != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return Pu = s, Pu;
}
var Au, Sb;
function kO() {
  if (Sb) return Au;
  Sb = 1;
  var e = yO(), n = vO();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return Au = r, Au;
}
var Lu, Nb;
function bO() {
  if (Nb) return Lu;
  Nb = 1;
  var e = hO(), n = kO();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return Lu = r, Lu;
}
var Vu, jb;
function cg() {
  if (jb) return Vu;
  jb = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return Vu = e, Vu;
}
var zu, wb;
function _O() {
  if (wb) return zu;
  wb = 1;
  var e = as(), n = sg(), r = wi(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return zu = a, zu;
}
var Uu, Cb;
function xO() {
  if (Cb) return Uu;
  Cb = 1;
  var e = cg(), n = _O();
  function r(i, a, o, s, l) {
    var u = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++u < m; ) {
      var d = i[u];
      a > 0 && o(d) ? a > 1 ? r(d, a - 1, o, s, l) : e(l, d) : s || (l[l.length] = d);
    }
    return l;
  }
  return Uu = r, Uu;
}
var Mu, Fb;
function SO() {
  if (Fb) return Mu;
  Fb = 1;
  var e = xO();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return Mu = n, Mu;
}
var Bu, Ib;
function NO() {
  if (Ib) return Bu;
  Ib = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return Bu = e, Bu;
}
var qu, Eb;
function jO() {
  if (Eb) return qu;
  Eb = 1;
  var e = NO(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, u = n(s.length - a, 0), m = Array(u); ++l < u; )
        m[l] = s[a + l];
      l = -1;
      for (var d = Array(a + 1); ++l < a; )
        d[l] = s[l];
      return d[a] = o(m), e(i, this, d);
    };
  }
  return qu = r, qu;
}
var Hu, $b;
function wO() {
  if ($b) return Hu;
  $b = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Hu = e, Hu;
}
var Wu, Tb;
function iC() {
  if (Tb) return Wu;
  Tb = 1;
  function e(n) {
    return n;
  }
  return Wu = e, Wu;
}
var Ku, Db;
function CO() {
  if (Db) return Ku;
  Db = 1;
  var e = wO(), n = tC(), r = iC(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Ku = i, Ku;
}
var Gu, Ob;
function FO() {
  if (Ob) return Gu;
  Ob = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), u = n - (l - s);
      if (s = l, u > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Gu = i, Gu;
}
var Yu, Rb;
function IO() {
  if (Rb) return Yu;
  Rb = 1;
  var e = CO(), n = FO(), r = n(e);
  return Yu = r, Yu;
}
var Qu, Pb;
function aC() {
  if (Pb) return Qu;
  Pb = 1;
  var e = SO(), n = jO(), r = IO();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Qu = i, Qu;
}
var Ju, Ab;
function EO() {
  if (Ab) return Ju;
  Ab = 1;
  var e = bO(), n = aC(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Ju = r, Ju;
}
var $O = EO();
const oC = /* @__PURE__ */ G1($O), TO = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function sC(e) {
  const n = oC(e, TO);
  return {
    controller: eg(n),
    controllerProps: n
  };
}
const DO = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function lC(e) {
  const { controller: n, controllerProps: r } = sC(e), i = {
    ...oC(e, DO),
    required: LD(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var Xu, Lb;
function OO() {
  if (Lb) return Xu;
  Lb = 1;
  var e = Zl();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return Xu = n, Xu;
}
var Zu, Vb;
function RO() {
  if (Vb) return Zu;
  Vb = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return Zu = e, Zu;
}
var ed, zb;
function PO() {
  if (zb) return ed;
  zb = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return ed = e, ed;
}
var nd, Ub;
function AO() {
  if (Ub) return nd;
  Ub = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return nd = e, nd;
}
var td, Mb;
function LO() {
  if (Mb) return td;
  Mb = 1;
  var e = Zl(), n = ig(), r = Z1(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var u = l.__data__;
      if (!n || u.length < i - 1)
        return u.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(u);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return td = a, td;
}
var rd, Bb;
function VO() {
  if (Bb) return rd;
  Bb = 1;
  var e = Zl(), n = OO(), r = RO(), i = PO(), a = AO(), o = LO();
  function s(l) {
    var u = this.__data__ = new e(l);
    this.size = u.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, rd = s, rd;
}
var id, qb;
function zO() {
  if (qb) return id;
  qb = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return id = e, id;
}
var ad, Hb;
function os() {
  if (Hb) return ad;
  Hb = 1;
  var e = ag(), n = rC();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var u = -1, m = a.length; ++u < m; ) {
      var d = a[u], f = s ? s(o[d], i[d], d, o, i) : void 0;
      f === void 0 && (f = i[d]), l ? n(o, d, f) : e(o, d, f);
    }
    return o;
  }
  return ad = r, ad;
}
var od, Wb;
function UO() {
  if (Wb) return od;
  Wb = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return od = e, od;
}
var il = { exports: {} }, sd, Kb;
function MO() {
  if (Kb) return sd;
  Kb = 1;
  function e() {
    return !1;
  }
  return sd = e, sd;
}
il.exports;
var Gb;
function cC() {
  return Gb || (Gb = 1, (function(e, n) {
    var r = ti(), i = MO(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, u = l ? l.isBuffer : void 0, m = u || i;
    e.exports = m;
  })(il, il.exports)), il.exports;
}
var ld, Yb;
function BO() {
  if (Yb) return ld;
  Yb = 1;
  var e = Va(), n = lg(), r = Ji(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", u = "[object Function]", m = "[object Map]", d = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", I = "[object String]", w = "[object WeakMap]", j = "[object ArrayBuffer]", _ = "[object DataView]", y = "[object Float32Array]", L = "[object Float64Array]", $ = "[object Int8Array]", C = "[object Int16Array]", F = "[object Int32Array]", z = "[object Uint8Array]", Q = "[object Uint8ClampedArray]", J = "[object Uint16Array]", te = "[object Uint32Array]", G = {};
  G[y] = G[L] = G[$] = G[C] = G[F] = G[z] = G[Q] = G[J] = G[te] = !0, G[i] = G[a] = G[j] = G[o] = G[_] = G[s] = G[l] = G[u] = G[m] = G[d] = G[f] = G[h] = G[v] = G[I] = G[w] = !1;
  function B(R) {
    return r(R) && n(R.length) && !!G[e(R)];
  }
  return ld = B, ld;
}
var cd, Qb;
function ug() {
  if (Qb) return cd;
  Qb = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return cd = e, cd;
}
var al = { exports: {} };
al.exports;
var Jb;
function dg() {
  return Jb || (Jb = 1, (function(e, n) {
    var r = Y1(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var u = a && a.require && a.require("util").types;
        return u || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(al, al.exports)), al.exports;
}
var ud, Xb;
function qO() {
  if (Xb) return ud;
  Xb = 1;
  var e = BO(), n = ug(), r = dg(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return ud = a, ud;
}
var dd, Zb;
function uC() {
  if (Zb) return dd;
  Zb = 1;
  var e = UO(), n = sg(), r = wi(), i = cC(), a = og(), o = qO(), s = Object.prototype, l = s.hasOwnProperty;
  function u(m, d) {
    var f = r(m), h = !f && n(m), v = !f && !h && i(m), I = !f && !h && !v && o(m), w = f || h || v || I, j = w ? e(m.length, String) : [], _ = j.length;
    for (var y in m)
      (d || l.call(m, y)) && !(w && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      I && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      a(y, _))) && j.push(y);
    return j;
  }
  return dd = u, dd;
}
var md, e_;
function mg() {
  if (e_) return md;
  e_ = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return md = n, md;
}
var pd, n_;
function dC() {
  if (n_) return pd;
  n_ = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return pd = e, pd;
}
var fd, t_;
function HO() {
  if (t_) return fd;
  t_ = 1;
  var e = dC(), n = e(Object.keys, Object);
  return fd = n, fd;
}
var hd, r_;
function WO() {
  if (r_) return hd;
  r_ = 1;
  var e = mg(), n = HO(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return hd = a, hd;
}
var yd, i_;
function mC() {
  if (i_) return yd;
  i_ = 1;
  var e = Q1(), n = lg();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return yd = r, yd;
}
var gd, a_;
function pg() {
  if (a_) return gd;
  a_ = 1;
  var e = uC(), n = WO(), r = mC();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return gd = i, gd;
}
var vd, o_;
function KO() {
  if (o_) return vd;
  o_ = 1;
  var e = os(), n = pg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return vd = r, vd;
}
var kd, s_;
function GO() {
  if (s_) return kd;
  s_ = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return kd = e, kd;
}
var bd, l_;
function YO() {
  if (l_) return bd;
  l_ = 1;
  var e = za(), n = mg(), r = GO(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), u = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || u.push(m);
    return u;
  }
  return bd = o, bd;
}
var _d, c_;
function fg() {
  if (c_) return _d;
  c_ = 1;
  var e = uC(), n = YO(), r = mC();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return _d = i, _d;
}
var xd, u_;
function QO() {
  if (u_) return xd;
  u_ = 1;
  var e = os(), n = fg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return xd = r, xd;
}
var ol = { exports: {} };
ol.exports;
var d_;
function JO() {
  return d_ || (d_ = 1, (function(e, n) {
    var r = ti(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function u(m, d) {
      if (d)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = u;
  })(ol, ol.exports)), ol.exports;
}
var Sd, m_;
function XO() {
  if (m_) return Sd;
  m_ = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return Sd = e, Sd;
}
var Nd, p_;
function ZO() {
  if (p_) return Nd;
  p_ = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Nd = e, Nd;
}
var jd, f_;
function pC() {
  if (f_) return jd;
  f_ = 1;
  function e() {
    return [];
  }
  return jd = e, jd;
}
var wd, h_;
function hg() {
  if (h_) return wd;
  h_ = 1;
  var e = ZO(), n = pC(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return wd = o, wd;
}
var Cd, y_;
function eR() {
  if (y_) return Cd;
  y_ = 1;
  var e = os(), n = hg();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Cd = r, Cd;
}
var Fd, g_;
function yg() {
  if (g_) return Fd;
  g_ = 1;
  var e = dC(), n = e(Object.getPrototypeOf, Object);
  return Fd = n, Fd;
}
var Id, v_;
function fC() {
  if (v_) return Id;
  v_ = 1;
  var e = cg(), n = yg(), r = hg(), i = pC(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return Id = o, Id;
}
var Ed, k_;
function nR() {
  if (k_) return Ed;
  k_ = 1;
  var e = os(), n = fC();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Ed = r, Ed;
}
var $d, b_;
function hC() {
  if (b_) return $d;
  b_ = 1;
  var e = cg(), n = wi();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return $d = r, $d;
}
var Td, __;
function tR() {
  if (__) return Td;
  __ = 1;
  var e = hC(), n = hg(), r = pg();
  function i(a) {
    return e(a, r, n);
  }
  return Td = i, Td;
}
var Dd, x_;
function yC() {
  if (x_) return Dd;
  x_ = 1;
  var e = hC(), n = fC(), r = fg();
  function i(a) {
    return e(a, r, n);
  }
  return Dd = i, Dd;
}
var Od, S_;
function rR() {
  if (S_) return Od;
  S_ = 1;
  var e = Xi(), n = ti(), r = e(n, "DataView");
  return Od = r, Od;
}
var Rd, N_;
function iR() {
  if (N_) return Rd;
  N_ = 1;
  var e = Xi(), n = ti(), r = e(n, "Promise");
  return Rd = r, Rd;
}
var Pd, j_;
function aR() {
  if (j_) return Pd;
  j_ = 1;
  var e = Xi(), n = ti(), r = e(n, "Set");
  return Pd = r, Pd;
}
var Ad, w_;
function oR() {
  if (w_) return Ad;
  w_ = 1;
  var e = Xi(), n = ti(), r = e(n, "WeakMap");
  return Ad = r, Ad;
}
var Ld, C_;
function gg() {
  if (C_) return Ld;
  C_ = 1;
  var e = rR(), n = ig(), r = iR(), i = aR(), a = oR(), o = Va(), s = J1(), l = "[object Map]", u = "[object Object]", m = "[object Promise]", d = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), I = s(n), w = s(r), j = s(i), _ = s(a), y = o;
  return (e && y(new e(new ArrayBuffer(1))) != h || n && y(new n()) != l || r && y(r.resolve()) != m || i && y(new i()) != d || a && y(new a()) != f) && (y = function(L) {
    var $ = o(L), C = $ == u ? L.constructor : void 0, F = C ? s(C) : "";
    if (F)
      switch (F) {
        case v:
          return h;
        case I:
          return l;
        case w:
          return m;
        case j:
          return d;
        case _:
          return f;
      }
    return $;
  }), Ld = y, Ld;
}
var Vd, F_;
function sR() {
  if (F_) return Vd;
  F_ = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Vd = r, Vd;
}
var zd, I_;
function lR() {
  if (I_) return zd;
  I_ = 1;
  var e = ti(), n = e.Uint8Array;
  return zd = n, zd;
}
var Ud, E_;
function vg() {
  if (E_) return Ud;
  E_ = 1;
  var e = lR();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return Ud = n, Ud;
}
var Md, $_;
function cR() {
  if ($_) return Md;
  $_ = 1;
  var e = vg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return Md = n, Md;
}
var Bd, T_;
function uR() {
  if (T_) return Bd;
  T_ = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return Bd = n, Bd;
}
var qd, D_;
function dR() {
  if (D_) return qd;
  D_ = 1;
  var e = as(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return qd = i, qd;
}
var Hd, O_;
function mR() {
  if (O_) return Hd;
  O_ = 1;
  var e = vg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Hd = n, Hd;
}
var Wd, R_;
function pR() {
  if (R_) return Wd;
  R_ = 1;
  var e = vg(), n = cR(), r = uR(), i = dR(), a = mR(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", u = "[object Number]", m = "[object RegExp]", d = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", I = "[object DataView]", w = "[object Float32Array]", j = "[object Float64Array]", _ = "[object Int8Array]", y = "[object Int16Array]", L = "[object Int32Array]", $ = "[object Uint8Array]", C = "[object Uint8ClampedArray]", F = "[object Uint16Array]", z = "[object Uint32Array]";
  function Q(J, te, G) {
    var B = J.constructor;
    switch (te) {
      case v:
        return e(J);
      case o:
      case s:
        return new B(+J);
      case I:
        return n(J, G);
      case w:
      case j:
      case _:
      case y:
      case L:
      case $:
      case C:
      case F:
      case z:
        return a(J, G);
      case l:
        return new B();
      case u:
      case f:
        return new B(J);
      case m:
        return r(J);
      case d:
        return new B();
      case h:
        return i(J);
    }
  }
  return Wd = Q, Wd;
}
var Kd, P_;
function fR() {
  if (P_) return Kd;
  P_ = 1;
  var e = za(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Kd = r, Kd;
}
var Gd, A_;
function hR() {
  if (A_) return Gd;
  A_ = 1;
  var e = fR(), n = yg(), r = mg();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Gd = i, Gd;
}
var Yd, L_;
function yR() {
  if (L_) return Yd;
  L_ = 1;
  var e = gg(), n = Ji(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Yd = i, Yd;
}
var Qd, V_;
function gR() {
  if (V_) return Qd;
  V_ = 1;
  var e = yR(), n = ug(), r = dg(), i = r && r.isMap, a = i ? n(i) : e;
  return Qd = a, Qd;
}
var Jd, z_;
function vR() {
  if (z_) return Jd;
  z_ = 1;
  var e = gg(), n = Ji(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Jd = i, Jd;
}
var Xd, U_;
function kR() {
  if (U_) return Xd;
  U_ = 1;
  var e = vR(), n = ug(), r = dg(), i = r && r.isSet, a = i ? n(i) : e;
  return Xd = a, Xd;
}
var Zd, M_;
function bR() {
  if (M_) return Zd;
  M_ = 1;
  var e = VO(), n = zO(), r = ag(), i = KO(), a = QO(), o = JO(), s = XO(), l = eR(), u = nR(), m = tR(), d = yC(), f = gg(), h = sR(), v = pR(), I = hR(), w = wi(), j = cC(), _ = gR(), y = za(), L = kR(), $ = pg(), C = fg(), F = 1, z = 2, Q = 4, J = "[object Arguments]", te = "[object Array]", G = "[object Boolean]", B = "[object Date]", R = "[object Error]", U = "[object Function]", ee = "[object GeneratorFunction]", Se = "[object Map]", fe = "[object Number]", ye = "[object Object]", ve = "[object RegExp]", K = "[object Set]", _e = "[object String]", Te = "[object Symbol]", X = "[object WeakMap]", Ke = "[object ArrayBuffer]", an = "[object DataView]", we = "[object Float32Array]", Me = "[object Float64Array]", Re = "[object Int8Array]", Be = "[object Int16Array]", Ae = "[object Int32Array]", Ge = "[object Uint8Array]", Ce = "[object Uint8ClampedArray]", qe = "[object Uint16Array]", nn = "[object Uint32Array]", ae = {};
  ae[J] = ae[te] = ae[Ke] = ae[an] = ae[G] = ae[B] = ae[we] = ae[Me] = ae[Re] = ae[Be] = ae[Ae] = ae[Se] = ae[fe] = ae[ye] = ae[ve] = ae[K] = ae[_e] = ae[Te] = ae[Ge] = ae[Ce] = ae[qe] = ae[nn] = !0, ae[R] = ae[U] = ae[X] = !1;
  function le(xe, Le, Pe, yn, T, x) {
    var D, H = Le & F, Y = Le & z, A = Le & Q;
    if (Pe && (D = T ? Pe(xe, yn, T, x) : Pe(xe)), D !== void 0)
      return D;
    if (!y(xe))
      return xe;
    var M = w(xe);
    if (M) {
      if (D = h(xe), !H)
        return s(xe, D);
    } else {
      var oe = f(xe), ge = oe == U || oe == ee;
      if (j(xe))
        return o(xe, H);
      if (oe == ye || oe == J || ge && !T) {
        if (D = Y || ge ? {} : I(xe), !H)
          return Y ? u(xe, a(D, xe)) : l(xe, i(D, xe));
      } else {
        if (!ae[oe])
          return T ? xe : {};
        D = v(xe, oe, H);
      }
    }
    x || (x = new e());
    var Ne = x.get(xe);
    if (Ne)
      return Ne;
    x.set(xe, D), L(xe) ? xe.forEach(function(tn) {
      D.add(le(tn, Le, Pe, tn, xe, x));
    }) : _(xe) && xe.forEach(function(tn, dn) {
      D.set(dn, le(tn, Le, Pe, dn, xe, x));
    });
    var rn = A ? Y ? d : m : Y ? C : $, gn = M ? void 0 : rn(xe);
    return n(gn || xe, function(tn, dn) {
      gn && (dn = tn, tn = xe[dn]), r(D, dn, le(tn, Le, Pe, dn, xe, x));
    }), D;
  }
  return Zd = le, Zd;
}
var em, B_;
function _R() {
  if (B_) return em;
  B_ = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return em = e, em;
}
var nm, q_;
function xR() {
  if (q_) return nm;
  q_ = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return nm = e, nm;
}
var tm, H_;
function SR() {
  if (H_) return tm;
  H_ = 1;
  var e = nC(), n = xR();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return tm = r, tm;
}
var rm, W_;
function NR() {
  if (W_) return rm;
  W_ = 1;
  var e = Ua(), n = _R(), r = SR(), i = nc(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, u) {
    u = e(u, l);
    var m = -1, d = u.length;
    if (!d)
      return !0;
    for (; ++m < d; ) {
      var f = i(u[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < d - 1)
        return !1;
    }
    var h = r(l, u);
    return h == null || delete h[i(n(u))];
  }
  return rm = s, rm;
}
var im, K_;
function jR() {
  if (K_) return im;
  K_ = 1;
  var e = Va(), n = yg(), r = Ji(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, u = s.call(Object);
  function m(d) {
    if (!r(d) || e(d) != i)
      return !1;
    var f = n(d);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == u;
  }
  return im = m, im;
}
var am, G_;
function wR() {
  if (G_) return am;
  G_ = 1;
  var e = jR();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return am = n, am;
}
var om, Y_;
function CR() {
  if (Y_) return om;
  Y_ = 1;
  var e = eC(), n = bR(), r = NR(), i = Ua(), a = os(), o = wR(), s = aC(), l = yC(), u = 1, m = 2, d = 4, f = s(function(h, v) {
    var I = {};
    if (h == null)
      return I;
    var w = !1;
    v = e(v, function(_) {
      return _ = i(_, h), w || (w = _.length > 1), _;
    }), a(h, l(h), I), w && (I = n(I, u | m | d, o));
    for (var j = v.length; j--; )
      r(I, v[j]);
    return I;
  });
  return om = f, om;
}
CR();
const Dr = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = lC(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...u
  } = r.field;
  return /* @__PURE__ */ Hi.jsx(en, { ...a, children: /* @__PURE__ */ Hi.jsx(
    _i,
    {
      ...n.componentProps,
      ...u,
      multiple: !1,
      value: u.value ? [u.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: en.getStatus(a.meta),
      children: e
    }
  ) });
};
var FR = iC();
const IR = /* @__PURE__ */ G1(FR), Dn = ({
  transformValue: e = IR,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = sC(a);
  return /* @__PURE__ */ Hi.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ Hi.jsx(
      hl,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ Hi.jsx(Jw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, Zn = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = lC(e);
  return /* @__PURE__ */ Hi.jsx(en, { ...i, children: /* @__PURE__ */ Hi.jsx(
    _r,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: en.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._copyIcon_10dvk_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_10dvk_59{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_10dvk_69{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_10dvk_69:last-child:not(:only-child){border-bottom:none}._collapsible_10dvk_78{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_10dvk_78:hover,._collapsibleIsOpen_10dvk_86{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_10dvk_89{cursor:pointer}._collapsibleIconTrue_10dvk_92{color:var(--dixa-color-green-500)}._collapsibleIconFalse_10dvk_95{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var sm = { exports: {} }, no = {}, Q_;
function ER() {
  if (Q_) return no;
  Q_ = 1;
  var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return no.Fragment = r, no.jsx = s, no.jsxs = s, no;
}
var _s = {}, J_;
function $R() {
  return J_ || (J_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var g = _.ReactDebugCurrentFrame, E = g.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var $ = !1, C = !1, F = !1, z = !1, Q = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === d || z || t === v || $ || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, N = E._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (E) {
            var g = E.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (ie) {
              g = ie;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var S = ie.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var ue = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = E;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ae(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ae(t.type, c, p);
          case h: {
            var g = t, E = g._payload, O = g._init;
            try {
              return ae(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, p, g, E) {
      {
        var O = Function.call.bind(le);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + p + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe(E), y("Failed %s type: %s", p, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, p, g, E, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, p, g, E) {
      {
        var O, N = {}, S = null, ne = null;
        p !== void 0 && (A(p), S = "" + p), gn(c) && (A(c.key), S = "" + c.key), rn(c) && (ne = c.ref, tn(c));
        for (O in c)
          le.call(c, O) && !oe.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, E, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function An(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = j(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          yn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var E = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, p, g, E, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, p, E, O);
        if (W == null)
          return W;
        if (N) {
          var ue = c.children;
          if (ue !== void 0)
            if (g)
              if (x(ue)) {
                for (var Ue = 0; Ue < ue.length; Ue++)
                  Sn(ue[Ue], t);
                Object.freeze && Object.freeze(ue);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ue, t);
        }
        if (le.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var Rn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, Rn, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, p) {
      return Fn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return Fn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    _s.Fragment = i, _s.jsx = Un, _s.jsxs = Kn;
  })()), _s;
}
var X_;
function TR() {
  return X_ || (X_ = 1, process.env.NODE_ENV === "production" ? sm.exports = ER() : sm.exports = $R()), sm.exports;
}
var re = TR();
const DR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, OR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, RR = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": DR,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": OR
};
function gC(e) {
  return RR[e] ?? {};
}
const PR = gC(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), AR = gC(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), LR = "_copyIcon_10dvk_54", VR = "_list_10dvk_59", zR = "_listItem_10dvk_69", UR = "_collapsible_10dvk_78", MR = "_collapsibleIsOpen_10dvk_86", BR = "_collapsibleHeader_10dvk_89", qR = "_collapsibleIconTrue_10dvk_92", HR = "_collapsibleIconFalse_10dvk_95", Mn = {
  copyIcon: LR,
  list: VR,
  listItem: zR,
  collapsible: UR,
  collapsibleIsOpen: MR,
  collapsibleHeader: BR,
  collapsibleIconTrue: qR,
  collapsibleIconFalse: HR
}, WR = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = de(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: u,
    last_used: m
  } = e;
  return /* @__PURE__ */ re.jsxs(
    b,
    {
      className: dt(Mn.collapsible, {
        [Mn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ re.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Mn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ re.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ re.jsxs(Qe, { className: Mn.list, children: [
          /* @__PURE__ */ re.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ re.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ re.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ re.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "5", color: "secondary", children: Qn(u).format(It) })
          ] }) }),
          /* @__PURE__ */ re.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "5", color: "secondary", children: Qn(m).format(It) })
          ] }) })
        ] })
      ]
    }
  );
}, KR = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ re.jsx(P.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ re.jsx(Bn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ re.jsx(
      P.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ re.jsx(WR, { app: r, openByDefault: i === 0 }, i))
  ] });
}, GR = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ re.jsx(re.Fragment, { children: /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ re.jsx(P.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ re.jsx(Qe, { className: Mn.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ re.jsx(
      Qe.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ re.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", children: i }),
          Gi(a)
        ] })
      },
      o
    )) })
  ] }) });
}, YR = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ re.jsx(re.Fragment, { children: /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ re.jsx(P.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ re.jsx(Qe, { className: Mn.list, children: r.map((a, o) => /* @__PURE__ */ re.jsx(
      Qe.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ re.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ re.jsx(
            Xe,
            {
              content: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ re.jsx(b, { children: `First ${Qn(a?.first).format(
                  It
                )}` }),
                /* @__PURE__ */ re.jsx(b, { children: `Last ${Qn(a?.last).format(
                  It
                )}` })
              ] }),
              children: /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, Nl = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const u = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${u}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${u}.` : `Opted in: The user has explicitly confirmed they want to receive ${u}.`;
  };
  return /* @__PURE__ */ re.jsx(Xe, { content: n ? null : l(), children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(he, { size: 14, name: o(), color: s() }) }) });
}, QR = "_wrapper_1xucg_1", JR = "_externalLink_1xucg_7", lm = {
  wrapper: QR,
  externalLink: JR
}, XR = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = ir(), { isCopied: i, copy: a } = ir(), { isCopied: o, copy: s } = ir(), { isCopied: l, copy: u } = ir(), { isCopied: m, copy: d } = ir();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: v,
    last_name: I,
    home_city: w,
    country: j,
    email: _,
    phone: y,
    dob: L,
    created_at: $,
    email_subscribe: C,
    push_subscribe: F
  } = e, z = 14, Q = `${v || ""} ${I || ""}`.trim() || "A customer has no name", J = `${w ? `${w} /` : ""} ${j || ""}`.trim(), te = L ? Qn(L).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ re.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ re.jsxs(b, { className: lm.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ re.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: lm.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ re.jsx(P.Heading, { variant: "heading-2", children: Q }),
          te && /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    $ && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", children: Qn($).format(It) })
    ] }),
    J && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(he, { size: z, name: "map-pin" }),
        /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", children: J })
      ] }),
      /* @__PURE__ */ re.jsx(Xe, { content: "Copy location", children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(
        he,
        {
          size: z,
          name: o ? "done" : "copy",
          onClick: () => s(J),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    _ && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(he, { size: z, name: "mail" }),
        /* @__PURE__ */ re.jsx("span", { className: lm.externalLink, children: _ })
      ] }),
      /* @__PURE__ */ re.jsx(Xe, { content: "Copy email", children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(
        he,
        {
          size: z,
          name: n ? "done" : "copy",
          onClick: () => r(_),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    y && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(he, { size: z, name: "phone" }),
        /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", children: y })
      ] }),
      /* @__PURE__ */ re.jsx(Xe, { content: "Copy phone number", children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(
        he,
        {
          size: z,
          name: i ? "done" : "copy",
          onClick: () => a(y),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(he, { size: z, name: "user" }),
        /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ re.jsxs(P.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ re.jsx(Xe, { content: "Copy Braze ID", children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(
        he,
        {
          size: z,
          name: l ? "done" : "copy",
          onClick: () => u(h),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(he, { size: z, name: "tag" }),
        /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ re.jsxs(P.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ re.jsx(Xe, { content: "Copy External ID", children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(
        he,
        {
          size: z,
          name: m ? "done" : "copy",
          onClick: () => d(f),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    C && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(he, { size: z, name: "sync" }),
        /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ re.jsx(Nl, { state: C })
    ] }),
    F && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(he, { size: z, name: "bell" }),
        /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ re.jsx(Nl, { isPush: !0, state: F })
    ] })
  ] }) });
}, ZR = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = de(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: u,
    idfa: m,
    idfv: d,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ re.jsxs(
    b,
    {
      className: dt(Mn.collapsible, {
        [Mn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ re.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Mn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ re.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ re.jsxs(Qe, { className: Mn.list, children: [
          /* @__PURE__ */ re.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ re.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ re.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ re.jsx(
              he,
              {
                size: a,
                className: dt({
                  [Mn.collapsibleIconTrue]: u,
                  [Mn.collapsibleIconFalse]: !u
                }),
                name: u ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ re.jsx(Xe, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ re.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "5", color: "secondary", children: d })
              ]
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Xe, { content: "For iOS", children: /* @__PURE__ */ re.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ re.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, eP = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ re.jsx(P.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ re.jsx(Bn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ re.jsx(
      P.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ re.jsx(ZR, { device: r, openByDefault: i === 0 }, i))
  ] });
}, to = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, xs = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = En(), { useMutation: a } = _n(), [o, s] = de(!1), [l] = a(
    AR,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), u = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: to[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ re.jsx(Xe, { content: to[n].tooltipContent, children: /* @__PURE__ */ re.jsx(
    nt,
    {
      variant: "secondary",
      color: to[n].color,
      isLoading: o,
      onClick: () => u(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ re.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(
          Nl,
          {
            noTooltip: !0,
            state: to[n].parameter
          }
        ),
        to[n].label
      ] })
    }
  ) });
}, nP = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ re.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ re.jsx(P.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ re.jsx(Qe, { className: Mn.list, children: /* @__PURE__ */ re.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(he, { size: 14, name: "sync" }),
        /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ re.jsx(Nl, { state: a })
    ] }) }) }),
    /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
        /* @__PURE__ */ re.jsx(
          xs,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ re.jsx(
          xs,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ re.jsx(
        xs,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ re.jsx(
        xs,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, tP = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ re.jsx(re.Fragment, { children: /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ re.jsx(P.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ re.jsx(Qe, { className: Mn.list, children: r.map((a, o) => /* @__PURE__ */ re.jsx(
      Qe.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ re.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ re.jsx(
            Xe,
            {
              content: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ re.jsx(b, { children: `First ${Qn(a?.first).format(
                  It
                )}` }),
                /* @__PURE__ */ re.jsx(b, { children: `Last ${Qn(a?.last).format(
                  It
                )}` })
              ] }),
              children: /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, rP = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = En(), { useMutation: i } = _n(), [a, o] = de(), [s, l] = de(!1), [u, m] = de(!1), d = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, v = n.updateEmailSubscriptionState ?? !1, I = n.displayCustomAttributes ?? !1, w = n.displayCustomEvents ?? !1, j = n.displayPuchases ?? !1, _ = n.displayDevices ?? !1, y = n.displayApps ?? !1, L = !h && !v && !I && !w && !j, [$, { error: C }] = i(
    PR,
    {
      onError: () => {
      },
      onCompleted: (z) => {
        const Q = z?.Braze?.exportUserDetails?.users?.[0];
        Q ? (o(Q), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), F = async () => {
    d || f ? await $({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...d ? { email_address: d } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (Je(() => {
    async function z() {
      m(!0), await F();
    }
    z().finally(() => m(!1));
  }, [d, f]), C) {
    const z = C.graphQLErrors;
    return Ul({ errors: z }) ? /* @__PURE__ */ re.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Ml({ errors: z }) ? /* @__PURE__ */ re.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ re.jsx(Tn, { error: C });
  }
  return u ? /* @__PURE__ */ re.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ re.jsx(vn, {}) }) : L ? /* @__PURE__ */ re.jsx(
    P.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ re.jsx(
    P.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ re.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ re.jsx(XR, { customerDetails: a }),
        v && !!a && /* @__PURE__ */ re.jsx(
          nP,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await F()
          }
        ),
        I && !!a && /* @__PURE__ */ re.jsx(GR, { customerDetails: a }),
        w && !!a && /* @__PURE__ */ re.jsx(YR, { customerDetails: a }),
        j && !!a && /* @__PURE__ */ re.jsx(tP, { customerDetails: a }),
        _ && !!a && /* @__PURE__ */ re.jsx(eP, { devices: a?.devices }),
        y && !!a && /* @__PURE__ */ re.jsx(KR, { apps: a?.apps })
      ]
    }
  );
}, jl = [
  {
    key: "apiHostName",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "brazeApiKey",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "updateEmailSubscriptionState",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCustomAttributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCustomEvents",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    // Yeah, there is a typo 😅 We need to stick with it now, since customers
    // might have used it in the past..
    key: "displayPuchases",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDevices",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayApps",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], iP = {
  enabled: !1,
  name: "",
  brazeApiKey: "",
  ...MI([], jl)
}, aP = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ht({
    mode: "onChange",
    defaultValues: iP
  }), {
    create: l,
    update: u,
    remove: m,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = Gr({
    integrationId: e,
    integrationType: "BRAZE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: I,
    error: w,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: y
  } = Yr({
    integrationId: e,
    fieldDefinitions: jl,
    form: s,
    onMisconfigured: v
  }), { renderConditions: L, setRenderConditions: $, renderConditionsForSubmit: C } = Qr({
    integrationId: e,
    widgetConfiguration: y,
    renderConditionsEditor: a
  }), F = (Q) => Xr(Q, {
    fieldDefinitions: jl,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: C
  }), z = s.watch("name");
  return /* @__PURE__ */ re.jsxs(
    Jr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: w ?? f,
      onRetry: w ? _ : void 0,
      isLoading: d || I,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ re.jsx(Zr, { cause: h }),
        /* @__PURE__ */ re.jsxs(mt, { children: [
          /* @__PURE__ */ re.jsx(ce, { children: /* @__PURE__ */ re.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ re.jsx(
            Dn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(ce, { span: 3, children: /* @__PURE__ */ re.jsx(
            Zn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ re.jsx(ce, { span: 3 }),
          /* @__PURE__ */ re.jsx(ce, { span: 3, children: /* @__PURE__ */ re.jsx(
            Zn,
            {
              name: "apiHostName",
              label: "API endpoint",
              control: s.control,
              rules: {
                required: "API endpoint is required",
                validate: (Q) => Ey(Q) || !0
              },
              componentProps: {
                placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ re.jsx(ce, { span: 3 }),
          /* @__PURE__ */ re.jsx(ce, { span: 3, children: /* @__PURE__ */ re.jsx(
            Da,
            {
              name: "brazeApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ re.jsx(ce, { span: 3 }),
          /* @__PURE__ */ re.jsx(ce, { span: 3, children: /* @__PURE__ */ re.jsx(en, { label: "Display customer details", children: /* @__PURE__ */ re.jsx(
            Dn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(ce, { span: 3 }),
          /* @__PURE__ */ re.jsx(ce, { span: 3, children: /* @__PURE__ */ re.jsx(en, { label: "Display the button to change the email subscription state", children: /* @__PURE__ */ re.jsx(
            Dn,
            {
              name: "updateEmailSubscriptionState",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(ce, { span: 3 }),
          /* @__PURE__ */ re.jsx(ce, { span: 3, children: /* @__PURE__ */ re.jsx(en, { label: "Display a list of custom attributes", children: /* @__PURE__ */ re.jsx(
            Dn,
            {
              name: "displayCustomAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(ce, { span: 3 }),
          /* @__PURE__ */ re.jsx(ce, { span: 3, children: /* @__PURE__ */ re.jsx(en, { label: "Display a list of custom events", children: /* @__PURE__ */ re.jsx(
            Dn,
            {
              name: "displayCustomEvents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(ce, { span: 3 }),
          /* @__PURE__ */ re.jsx(ce, { span: 3, children: /* @__PURE__ */ re.jsx(en, { label: "Display a list of purchases", children: /* @__PURE__ */ re.jsx(
            Dn,
            {
              name: "displayPuchases",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(ce, { span: 3 }),
          /* @__PURE__ */ re.jsx(ce, { span: 3, children: /* @__PURE__ */ re.jsx(en, { label: "Display customer devices", children: /* @__PURE__ */ re.jsx(
            Dn,
            {
              name: "displayDevices",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(ce, { span: 3 }),
          /* @__PURE__ */ re.jsx(ce, { span: 3, children: /* @__PURE__ */ re.jsx(en, { label: "Display customer apps", children: /* @__PURE__ */ re.jsx(
            Dn,
            {
              name: "displayApps",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(ce, { span: 3 }),
          a && L !== null && /* @__PURE__ */ re.jsx(ce, { children: a({
            value: L,
            onChange: $,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ re.jsx(
          ei,
          {
            integrationType: "BRAZE",
            integrationId: e,
            widgetName: z,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
function oP() {
  var e = Bi(!1), n = ft(function() {
    return e.current;
  }, []);
  return Je(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var sP = function(e) {
  e === void 0 && (e = {});
  var n = de(e), r = n[0], i = n[1], a = ft(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, lP = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, Z_ = function(e) {
  return iE(lP, e);
}, cm, ex;
function cP() {
  return ex || (ex = 1, cm = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), cm;
}
var um, nx;
function uP() {
  if (nx) return um;
  nx = 1;
  var e = cP(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, u, m, d, f, h, v = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), d = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(w) {
        if (w.stopPropagation(), s.format)
          if (w.preventDefault(), typeof w.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var j = n[s.format] || n.default;
            window.clipboardData.setData(j, o);
          } else
            w.clipboardData.clearData(), w.clipboardData.setData(s.format, o);
        s.onCopy && (w.preventDefault(), s.onCopy(w.clipboardData));
      }), document.body.appendChild(h), d.selectNodeContents(h), f.addRange(d);
      var I = document.execCommand("copy");
      if (!I)
        throw new Error("copy command was unsuccessful");
      v = !0;
    } catch (w) {
      l && console.error("unable to copy using execCommand: ", w), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), v = !0;
      } catch (j) {
        l && console.error("unable to copy using clipboardData: ", j), l && console.error("falling back to prompt"), u = i("message" in s ? s.message : r), window.prompt(u, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(d) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return v;
  }
  return um = a, um;
}
var dP = uP();
const mP = /* @__PURE__ */ Ay(dP);
var vC = function() {
  var e = oP(), n = sP({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = ft(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var u = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(u), i({
            value: o,
            error: u,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var u = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(u), i({
            value: o,
            error: u,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = mP(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function pP(e, n) {
  n === void 0 && (n = 0);
  var r = Bi(!1), i = Bi(), a = Bi(e), o = ft(function() {
    return r.current;
  }, []), s = ft(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = ft(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return Je(function() {
    a.current = e;
  }, [e]), Je(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function Zi(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = pP(e, n), a = i[0], o = i[1], s = i[2];
  return Je(s, r), [a, o];
}
var fP = function(e) {
  Je(e, []);
}, hP = function(e, n) {
  var r = Bi(function() {
  });
  Je(function() {
    r.current = e;
  }), Je(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, yP = function(e) {
  e === void 0 && (e = {});
  var n = de(e), r = n[0], i = n[1], a = Xn(function() {
    return {
      set: function(s, l) {
        i(function(u) {
          var m;
          return vc(vc({}, u), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var u = l, m = s;
          u[m];
          var d = xE(u, [typeof m == "symbol" ? m : m + ""]);
          return d;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = vc({ get: ft(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, gP = function(e) {
  var n = Bi(e);
  n.current = e, fP(function() {
    return function() {
      return n.current();
    };
  });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var dm = { exports: {} }, ro = {}, tx;
function vP() {
  if (tx) return ro;
  tx = 1;
  var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ro.Fragment = r, ro.jsx = s, ro.jsxs = s, ro;
}
var Ss = {}, rx;
function kP() {
  return rx || (rx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var g = _.ReactDebugCurrentFrame, E = g.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var $ = !1, C = !1, F = !1, z = !1, Q = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === d || z || t === v || $ || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, N = E._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (E) {
            var g = E.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (ie) {
              g = ie;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var S = ie.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var ue = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = E;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ae(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ae(t.type, c, p);
          case h: {
            var g = t, E = g._payload, O = g._init;
            try {
              return ae(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, p, g, E) {
      {
        var O = Function.call.bind(le);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + p + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe(E), y("Failed %s type: %s", p, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, p, g, E, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, p, g, E) {
      {
        var O, N = {}, S = null, ne = null;
        p !== void 0 && (A(p), S = "" + p), gn(c) && (A(c.key), S = "" + c.key), rn(c) && (ne = c.ref, tn(c));
        for (O in c)
          le.call(c, O) && !oe.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, E, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function An(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = j(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          yn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var E = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, p, g, E, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, p, E, O);
        if (W == null)
          return W;
        if (N) {
          var ue = c.children;
          if (ue !== void 0)
            if (g)
              if (x(ue)) {
                for (var Ue = 0; Ue < ue.length; Ue++)
                  Sn(ue[Ue], t);
                Object.freeze && Object.freeze(ue);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ue, t);
        }
        if (le.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var Rn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, Rn, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, p) {
      return Fn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return Fn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Ss.Fragment = i, Ss.jsx = Un, Ss.jsxs = Kn;
  })()), Ss;
}
var ix;
function bP() {
  return ix || (ix = 1, process.env.NODE_ENV === "production" ? dm.exports = vP() : dm.exports = kP()), dm.exports;
}
var be = bP();
const _P = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, xP = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, SP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, NP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, jP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, wP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, CP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, FP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, IP = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": SP,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": NP,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": jP,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": _P,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": xP,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": wP,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": CP,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": FP
};
function Ma(e) {
  return IP[e] ?? {};
}
const EP = Ma(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), $P = Ma(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), TP = Ma(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), ax = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, kr = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, DP = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), ox = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, Yh = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ be.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ be.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ be.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ be.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ be.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ be.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ be.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ be.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ be.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ be.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ be.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ be.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function OP({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = de(
    []
  ), [o, s] = de([]), [l, u] = de([]), [m, d] = de([]), [f, h] = de(), { showNotification: v, showModal: I, executeQuery: w } = _n(), { track: j } = En(), {
    loading: _,
    data: y,
    error: L,
    store: $
  } = $y(e ?? null), C = y?.github?.issues || [], F = y?.github?.pullRequests || [], [z, Q] = de(!1), [J, te] = de();
  Je(
    () => h(L || J || void 0),
    [L, J]
  ), Je(
    () => {
      !_ && (C?.length || F?.length) ? (a(C), s(F), B(C, F)) : (a([]), s([]), u([]), d([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [y]
  );
  const G = async (ve, K) => {
    await $(ve).then(() => {
      v({
        icon: "check-circle-filled",
        severity: "success",
        title: K.success.title,
        text: K.success.text
      });
    }).catch((_e) => {
      v({
        title: K.error.title,
        text: `${K.error.text} ${_e.message && " (" + _e.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, B = (ve, K) => {
    if (!ve?.length && !K?.length) {
      u([]), d([]);
      return;
    }
    const _e = (ve || []).map(
      (Ke) => w($P, {
        owner: Ke.owner,
        repositoryName: Ke.repository,
        issueNumber: Ke.number
      })
    ), Te = (K || []).map(
      (Ke) => w(TP, {
        owner: Ke.owner,
        repositoryName: Ke.repository,
        prNumber: Ke.number
      })
    ), X = [..._e, ...Te];
    Q(!0), Promise.all(X).then((Ke) => {
      const an = [], we = [];
      Ke.forEach((Me) => {
        const Re = Me?.data?.GitHub;
        if (!Re) {
          u([]), d([]);
          return;
        }
        Object.keys(Re).forEach((Be) => {
          if (Be.startsWith("repository")) {
            const Ae = Re[Be];
            Object.keys(Ae).forEach((Ge) => {
              const Ce = Ae[Ge], qe = {
                number: Ce?.number,
                owner: Ce?.repository?.owner?.login,
                repository: Ce?.repository?.name
              };
              Ge.startsWith("issue") && an.push({
                ...Ce,
                type: "ISSUE",
                key: qe
              }), Ge.startsWith("pullRequest") && we.push({
                ...Ce,
                type: "PR",
                key: qe
              });
            });
          }
        });
      }), u(an), d(we);
    }).catch(te).finally(() => {
      Q(!1);
    });
  }, R = ({ key: ve, type: K }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const _e = y && (C.length || F.length) ? y : r, Te = K === "ISSUE" ? "issues" : "pullRequests";
    _e.github[Te] = Array.from(
      new Set(_e.github[Te]).add(ve)
    ), G(_e, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${kr(
          ve
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${kr(ve)} failed. Please try again.`
      }
    });
  }, U = async ({ key: ve, type: K }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const _e = y && (C.length || F.length) ? y : r, Te = K === "ISSUE" ? "issues" : "pullRequests";
    _e.github[Te] = Array.from(
      new Set(_e.github[Te]).add(ve)
    ), await $(_e).catch((X) => {
      v({
        title: "Linking failed",
        text: `Linking ${ve} failed. Please try again. ${X.message && " (" + X.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ee = ({ key: ve, type: K }) => {
    j("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const _e = K === "ISSUE" ? "issue" : "pull request";
    I({
      headline: `Unlink ${_e} ${kr(ve)}?`,
      text: `You are about to unlink the ${_e} ${kr(
        ve
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${_e}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Te = K === "ISSUE" ? "issues" : "pullRequests";
        if (!y)
          return;
        const X = {
          ...y,
          github: {
            ...y?.github,
            [Te]: y?.github?.[Te].filter(
              (Ke) => Ke.number !== ve.number || Ke.owner !== ve.owner || Ke.repository !== ve.repository
            )
          }
        };
        j("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), G(X, {
          success: {
            title: `GitHub ${_e} unlinked`,
            text: `You unlinked the GitHub ${_e} ${kr(
              ve
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${kr(ve)} failed.`
          }
        });
      },
      onCancel: () => {
        j("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, Se = () => {
    j("github:unlink:all:clicked", {
      githubOrganization: n
    }), I({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        j("github:unlink:all:confirmed", {
          githubOrganization: n
        }), G(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        j("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, fe = C.filter(
    (ve) => !i?.includes(ve)
  ) || [], ye = F.filter(
    (ve) => !o?.includes(ve)
  ) || [];
  return {
    linkGithubItem: R,
    linkGithubItemQuietly: U,
    unlinkGithubItem: ee,
    loadGithubItems: B,
    removeDanglingGithubItemLinks: () => {
      const ve = {
        ...y,
        github: {
          ...y?.github,
          issues: C.filter(
            (K) => !fe.includes(K)
          ) || [],
          pullRequests: F.filter(
            (K) => !ye.includes(K)
          ) || []
        }
      };
      $(ve);
    },
    unlinkAllGithubItems: Se,
    isLoadingGithubItemLinks: _,
    danglingIssueLinks: fe,
    danglingPullRequestLinks: ye,
    isLoadingGithubItems: z,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const RP = "_contentWrapper_1vx3c_1", PP = "_contentWrapperHeadline_1vx3c_4", AP = "_contentWrapperBody_1vx3c_11", LP = "_contentWrapperAssigneeIcon_1vx3c_15", VP = "_contentWrapperStatusTag_1vx3c_20", si = {
  contentWrapper: RP,
  contentWrapperHeadline: PP,
  contentWrapperBody: AP,
  contentWrapperAssigneeIcon: LP,
  contentWrapperStatusTag: VP
}, kC = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ be.jsxs(be.Fragment, { children: [
  e && /* @__PURE__ */ be.jsxs(ct, { className: si.contentWrapper, children: [
    /* @__PURE__ */ be.jsx(ct, { className: si.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ be.jsx(ct, { className: si.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ be.jsxs(ct, { className: si.contentWrapper, children: [
    /* @__PURE__ */ be.jsx(ct, { className: si.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ be.jsx(ct, { className: si.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ be.jsxs(ct, { margin: "100 0", children: [
        /* @__PURE__ */ be.jsx(
          "img",
          {
            className: si.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ be.jsx(ct, { className: si.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ be.jsx(
      Yn,
      {
        className: si.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), zP = "_collapse_1bdjy_1", UP = "_collapseHeader_1bdjy_10", MP = "_collapseHeaderKey_1bdjy_31", BP = "_collapseHeaderKeyIcon_1bdjy_36", qP = "_collapseHeaderKeyLink_1bdjy_41", HP = "_collapseHeaderIcon_1bdjy_44", WP = "_collapseHeaderTitle_1bdjy_49", KP = "_collapseContent_1bdjy_57", GP = "_collapseContentButtonSpacer_1bdjy_60", YP = "_collapseContentButtonLink_1bdjy_63", Pr = {
  collapse: zP,
  collapseHeader: UP,
  collapseHeaderKey: MP,
  collapseHeaderKeyIcon: BP,
  collapseHeaderKeyLink: qP,
  collapseHeaderIcon: HP,
  collapseHeaderTitle: WP,
  collapseContent: KP,
  collapseContentButtonSpacer: GP,
  collapseContentButtonLink: YP
}, QP = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (u, m) => ({ ...u, [m.id]: !1 }),
    {}
  ), [a, o] = de(i), { track: s } = En(), l = (u, m) => {
    o({ ...a, [u]: m });
  };
  return /* @__PURE__ */ be.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((u) => {
    const {
      id: m,
      number: d,
      key: f,
      title: h,
      bodyText: v,
      repository: I,
      type: w,
      state: j,
      assignees: _,
      labels: y
    } = u, L = a[m];
    return /* @__PURE__ */ be.jsxs(
      xr,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: L,
        className: Pr.collapse,
        children: [
          /* @__PURE__ */ be.jsx(xr.Header, { className: Pr.collapseHeader, children: /* @__PURE__ */ be.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ be.jsx(ct, { children: /* @__PURE__ */ be.jsxs(ct, { as: "span", className: Pr.collapseHeaderKey, children: [
                  Yh(
                    w,
                    j,
                    Pr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ be.jsxs(
                    "a",
                    {
                      href: ax(f),
                      className: Pr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: ($) => {
                        $.stopPropagation();
                      },
                      children: [
                        kr(f),
                        /* @__PURE__ */ be.jsx(
                          he,
                          {
                            className: Pr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ be.jsx(ct, { className: Pr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ be.jsx(xr.Content, { className: Pr.collapseContent, children: /* @__PURE__ */ be.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ be.jsx(
              kC,
              {
                description: v,
                assignees: _,
                labels: y
              }
            ),
            /* @__PURE__ */ be.jsxs(
              nt,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Pr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: d,
                    owner: I?.owner.login,
                    repository: u.repository.name
                  },
                  type: w
                }),
                children: [
                  "Unlink ",
                  ox(w)
                ]
              }
            ),
            /* @__PURE__ */ be.jsxs(
              Bt,
              {
                slotEnd: /* @__PURE__ */ be.jsx(he, { name: "external-link" }),
                variant: "tertiary",
                className: Pr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(ax(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  ox(w),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ be.jsx(be.Fragment, {}) });
}, JP = "_result_1uaom_1", XP = "_resultName_1uaom_21", ZP = "_resultItemIcon_1uaom_29", eA = "_resultDescription_1uaom_34", nA = "_resultLinkIcon_1uaom_46", tA = "_tooltip_1uaom_55", rA = "_tooltipName_1uaom_61", iA = "_tooltipTag_1uaom_71", li = {
  result: JP,
  resultName: XP,
  resultItemIcon: ZP,
  resultDescription: eA,
  resultLinkIcon: nA,
  tooltip: tA,
  tooltipName: rA,
  tooltipTag: iA
}, aA = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: u } = e, [m, d] = de(!1);
  return /* @__PURE__ */ be.jsx(
    Xe,
    {
      className: li.tooltip,
      content: /* @__PURE__ */ be.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ be.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ be.jsxs(ct, { as: "span", className: li.tooltipName, children: [
                Yh(a, o, li.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ be.jsx(Yn, { className: li.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ be.jsx(
          kC,
          {
            description: l,
            assignees: u,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ be.jsxs(
        "button",
        {
          className: li.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => d(!0),
          onMouseLeave: () => d(!1),
          children: [
            /* @__PURE__ */ be.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ be.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ be.jsxs(ct, { as: "span", className: li.resultName, children: [
                    Yh(a, o, li.resultItemIcon),
                    kr(r)
                  ] }) }),
                  /* @__PURE__ */ be.jsx(ct, { className: li.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ be.jsx(
              he,
              {
                className: li.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, oA = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ be.jsx(
  Bt,
  {
    slotEnd: /* @__PURE__ */ be.jsx(he, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), wl = "[a-zA-z0-9_.-]+", bC = "[0-9]+", sA = new RegExp(
  `(${wl})/(${wl})/(?:issues|pull)/(${bC})`,
  "i"
), sx = new RegExp(`^${sA.source}$`), lx = new RegExp(
  `https://github.com/(${wl})/(${wl})/(?:issues|pull)/(${bC})`,
  "i"
), lA = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = Xn(() => r?.map((F) => F.id) || [], [r]), o = Xn(() => i?.map((F) => F.id) || [], [i]), [s, l] = de([]), { useLazyQuery: u } = _n(), [m, d] = de(), [f, { loading: h, error: v, data: I, networkStatus: w }] = u(EP, {
    notifyOnNetworkStatusChange: !0
  });
  Zi(
    () => {
      !h && m && w === dr.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), Je(() => {
    let F = I?.GitHub?.issues?.nodes || [], z = I?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (F = F.filter((Q) => !a.includes(Q.id))), o.length > 0 && (z = z.filter(
      (Q) => !o.includes(Q.id)
    )), l([
      ...F.map((Q) => ({
        ...Q,
        type: "ISSUE",
        key: {
          number: Q.number,
          owner: Q.repository.owner.login,
          repository: Q.repository.name
        }
      })),
      ...z.map((Q) => ({
        ...Q,
        type: "PR",
        key: {
          number: Q.number,
          owner: Q.repository.owner.login,
          repository: Q.repository.name
        }
      }))
    ]);
  }, [I, a, o]);
  function j(F) {
    const z = F?.trim();
    if (sx.test(z)) {
      const [Q, J, te, G] = z.match(sx) || [];
      return J !== n ? void 0 : {
        owner: n,
        repository: te,
        number: parseInt(G)
      };
    }
    if (lx.test(z)) {
      const [Q, J, te, G] = z.match(lx) || [];
      return J !== n ? void 0 : {
        owner: n,
        repository: te,
        number: parseInt(G)
      };
    }
  }
  const _ = (F) => {
    e({
      key: DP(F),
      type: F.type
    }), d(void 0);
  }, y = (F) => {
    const z = j(F);
    d(
      z ? `org:${z.owner} repo:${z.repository} ${z.number}` : `org:${n} ${F}`
    );
  }, L = () => {
    d(void 0);
  }, $ = ({ className: F, searched: z }) => /* @__PURE__ */ be.jsx(
    oA,
    {
      className: F,
      searched: z,
      githubOrganization: n
    }
  ), C = ({ item: F, onSelect: z }) => /* @__PURE__ */ be.jsx(aA, { item: F, onSelect: z });
  return !h && v ? /* @__PURE__ */ be.jsx(Tn, { error: v }) : /* @__PURE__ */ be.jsx(
    Or,
    {
      items: s?.map((F) => ({ name: F.title, ...F })),
      loading: h,
      onSearch: y,
      onSelect: _,
      onClear: L,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: $,
      itemComponent: C,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, cA = "_itemButton_3sxfy_1", uA = "_result_3sxfy_6", dA = "_resultName_3sxfy_30", mA = "_resultCheckIcon_3sxfy_38", pA = "_resultAssigneeIcon_3sxfy_41", io = {
  itemButton: cA,
  result: uA,
  resultName: dA,
  resultCheckIcon: mA,
  resultAssigneeIcon: pA
}, _C = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ be.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ be.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: io.itemButton,
        children: /* @__PURE__ */ be.jsxs(b, { className: io.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ be.jsx(ct, { margin: "100 0", children: /* @__PURE__ */ be.jsx(
            "img",
            {
              className: io.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ be.jsx(ct, { className: io.resultName, children: e.name }),
          n && /* @__PURE__ */ be.jsx(ct, { className: io.resultCheckIcon, children: /* @__PURE__ */ be.jsx(he, { name: "done" }) })
        ] })
      }
    )
  }
), fA = Ma(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), hA = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = _n(), [o, s] = de([]), [l, u] = de(""), m = 2, [d, { loading: f, error: h, data: v, networkStatus: I }] = a(
    fA,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return Zi(
    () => {
      !f && l && l.length >= m && I === dr.ready ? d({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Je(() => {
    const w = v?.GitHub?.organization?.teams || { edges: [] }, j = [];
    w?.edges?.forEach((_) => {
      const y = _?.node?.members?.edges;
      (y?.length || 0) > 0 && y?.forEach((L) => {
        const $ = L?.node;
        $ && ($?.id && j.find((C) => C.id === $.id) || j.push($));
      });
    }), s(
      j.sort((_, y) => {
        const L = _.name?.toLowerCase() || _.login?.toLowerCase(), $ = y.name?.toLowerCase() || y.login?.toLowerCase();
        return L.localeCompare($, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [v]), !f && h ? /* @__PURE__ */ be.jsx(Tn, { error: h }) : /* @__PURE__ */ be.jsx(
    Or,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: w, name: j, login: _, avatarUrl: y }) => ({
        id: w,
        name: j || _,
        iconUrl: y
      })) || [],
      loading: f,
      onSearch: (w) => u(w),
      onChange: (w, j) => {
        const _ = w.id;
        i ? (j && !n.find(
          (y) => y.id === _
        ) && n.push(w), j || (n = n.filter(
          (y) => y.id !== _
        ))) : n = j ? [w] : [], r(n);
      },
      onClear: () => u(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: w, onSelect: j, checked: _ }) => /* @__PURE__ */ be.jsx(
        _C,
        {
          item: w,
          checked: _,
          onSelectItem: j
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, yA = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ be.jsx(_r, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ be.jsx(
        Or,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: u }) => ({
            id: s,
            name: l || u
          }))
        }
      ) : /* @__PURE__ */ be.jsx(
        Bl,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ be.jsx(_r, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ be.jsx(
        Or,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: u }) => ({
              id: s,
              name: l || u
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ be.jsx(_r, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ be.jsx(Uh, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ be.jsx(
        hA,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ be.jsx(be.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, gA = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ be.jsx(be.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ be.jsx(
  zt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ be.jsx(
      en,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: yA({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), vA = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ be.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ be.jsxs(P.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ be.jsxs(P.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ be.jsx(he, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ be.jsx(en, { label: "GitHub issue link", children: /* @__PURE__ */ be.jsx(
          _r,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, kA = "_modalBody_1hk1o_1", bA = "_modalBodyFormFields_1hk1o_4", mm = {
  modalBody: kA,
  modalBodyFormFields: bA
}, _A = Ma(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), xA = Ma(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), SA = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], NA = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = _n(), { track: u } = En(), {
    control: m,
    handleSubmit: d,
    formState: { errors: f },
    reset: h,
    getValues: v
  } = ht(), [I, w] = de(""), [j, _] = de([]), [y, L] = de(), [$, C] = de(!1), [F, z] = de(!1), [Q, J] = vC(), [
    te,
    {
      loading: G,
      error: B,
      networkStatus: R
    }
  ] = s(_A, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Te) => {
      _(
        Te.GitHub.search?.edges?.map((X) => X?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), _([]);
    }
  });
  Zi(
    () => {
      !G && I && R === dr.ready ? te({
        variables: {
          query: I,
          maxResults: 10
        }
      }) : _([]);
    },
    500,
    [I]
  );
  const [U, { error: ee }] = l(
    xA,
    {
      onError: (Te) => {
        C(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Te);
      },
      onCompleted: (Te) => {
        C(!1);
        const X = Te.GitHub.createIssue?.issue;
        L(X), o({
          title: "Success",
          text: `GitHub issue '${X.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: X.repository.name,
          number: X.number
        });
      }
    }
  ), Se = (Te) => {
    w(`org:${a} ${Te}`);
  }, fe = (Te, X) => {
    X(Te), w("");
  }, ye = () => {
    w("");
  }, ve = (Te) => {
    u("github:create:issue:confirmed", {
      githubOrganization: a
    }), C(!0), U({
      variables: {
        input: {
          repositoryId: Te.repository.id,
          title: Te.title,
          body: Te.body,
          assigneeIds: Te.assignees?.length > 0 ? Te.assignees.map((X) => X.id) : void 0
        }
      }
    });
  };
  Je(() => {
    const Te = F ? window.setTimeout(() => z(!1), 2e3) : void 0;
    return () => window.clearTimeout(Te);
  }, [F]);
  const K = () => {
    w(""), _([]), L(void 0), C(!1), z(!1);
  }, _e = () => {
    u("github:create:issue:canceled", {
      githubOrganization: a
    }), K(), h(), n();
  };
  return /* @__PURE__ */ be.jsxs(
    $t,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: _e,
      children: [
        /* @__PURE__ */ be.jsx(
          Tt,
          {
            title: y ? "Issue creation successful" : "Create new GitHub issue",
            onClose: _e
          }
        ),
        /* @__PURE__ */ be.jsxs(Dt, { className: mm.modalBody, children: [
          !G && B && /* @__PURE__ */ be.jsx(Tn, { error: B }),
          !$ && ee && /* @__PURE__ */ be.jsx(Tn, { error: ee }),
          y ? /* @__PURE__ */ be.jsx(
            vA,
            {
              createdIssue: y,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: F,
              setIssueLinkCopied: z,
              copyToClipboard: J
            }
          ) : /* @__PURE__ */ be.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: d(ve),
              children: /* @__PURE__ */ be.jsxs(mt, { children: [
                /* @__PURE__ */ be.jsx(ce, { children: /* @__PURE__ */ be.jsx(en, { label: "Repository", required: !0, children: /* @__PURE__ */ be.jsx(
                  zt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Te, value: X } }) => /* @__PURE__ */ be.jsx(
                      Or,
                      {
                        className: mm.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: G,
                        onSearch: Se,
                        onSelect: (Ke) => fe(Ke, Te),
                        onClear: ye,
                        selectedItems: [X],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: B ? "No repositories found" : "No repositories available",
                        items: j || [],
                        itemComponent: ({ item: Ke, onSelect: an, checked: we }) => /* @__PURE__ */ be.jsx(
                          _C,
                          {
                            item: Ke,
                            checked: we,
                            onSelectItem: an
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ be.jsx(ce, { className: mm.modalBodyFormFields, children: /* @__PURE__ */ be.jsx(
                  gA,
                  {
                    control: m,
                    errors: f,
                    getValues: v,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: SA
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ be.jsx(
          Ht,
          {
            confirmOnClick: y ? _e : d(ve),
            confirmProps: {
              isLoading: $,
              loadingIndicator: /* @__PURE__ */ be.jsx(vn, { size: 16 })
            },
            confirmName: y ? "Close" : "Save",
            cancelOnClick: y ? void 0 : _e
          }
        )
      ]
    }
  );
}, jA = "_wrapper_19v8w_1", wA = "_inputWrapper_19v8w_6", CA = "_buttonLink_19v8w_19", FA = "_noItemsFound_19v8w_23", IA = "_createIssueButton_19v8w_28", sa = {
  wrapper: jA,
  inputWrapper: wA,
  buttonLink: CA,
  noItemsFound: FA,
  createIssueButton: IA
}, EA = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = de(!1), { track: a } = En(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: u,
    unlinkGithubItem: m,
    loadGithubItems: d,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: v,
    danglingIssueLinks: I,
    danglingPullRequestLinks: w,
    isLoadingGithubItems: j,
    issues: _,
    pullRequests: y,
    error: L
  } = OP({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), $ = (J) => u({ key: J, type: "ISSUE" }), C = !(!!_?.length).valueOf() && !(!!y?.length).valueOf() && !(!!I?.length).valueOf() && !(!!w?.length).valueOf(), F = !v && !j && !!I?.length && !!w?.length && !!n?.showDanglingLinks, z = n?.enableCreateIssue, Q = !!_?.length || !!y?.length;
  return !j && L ? /* @__PURE__ */ be.jsx(Tn, { error: L, retry: () => d() }) : /* @__PURE__ */ be.jsxs(be.Fragment, { children: [
    /* @__PURE__ */ be.jsxs(b, { className: sa.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ be.jsxs(b, { className: sa.inputWrapper, flexDirection: "column", children: [
        z && /* @__PURE__ */ be.jsxs(be.Fragment, { children: [
          /* @__PURE__ */ be.jsx(
            nt,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: sa.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ be.jsx("div", { className: sa.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ be.jsx(
          lA,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: _,
            linkedPullRequests: y
          }
        )
      ] }),
      j ? /* @__PURE__ */ be.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ be.jsx(vn, { "data-testid": "github-widget-item-spinner" }) }) : Q ? /* @__PURE__ */ be.jsx(
        QP,
        {
          items: [..._, ...y],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ be.jsx(P.Paragraph, { align: "center", className: sa.noItemsFound, children: "No linked items found." }),
      F && /* @__PURE__ */ be.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ be.jsx(P.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ be.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              I.map((J) => /* @__PURE__ */ be.jsx(
                Yn,
                {
                  onDelete: () => m({
                    key: J,
                    type: "ISSUE"
                  }),
                  children: kr(J)
                },
                kr(J)
              )),
              w.map((J) => /* @__PURE__ */ be.jsx(
                Yn,
                {
                  onDelete: () => m({ key: J, type: "PR" }),
                  children: kr(J)
                },
                kr(J)
              ))
            ] }),
            /* @__PURE__ */ be.jsx(
              nt,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && Q && /* @__PURE__ */ be.jsx(
        nt,
        {
          variant: "secondary",
          disabled: C,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ be.jsx(
        Bt,
        {
          slotEnd: /* @__PURE__ */ be.jsx(he, { name: "external-link" }),
          variant: "tertiary",
          className: sa.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ be.jsx(
      NA,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: $,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, Qh = [
  {
    key: "githubOrganization",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], Ei = "GITHUB", $A = {
  enabled: !1,
  name: "",
  githubOrganization: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0
}, TA = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ht({
    mode: "onChange",
    defaultValues: $A
  }), {
    create: u,
    update: m,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: I
  } = Gr({
    integrationId: e,
    integrationType: Ei,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: w,
    error: j,
    isWidgetUnknown: _,
    refetch: y,
    widgetConfiguration: L
  } = Yr({
    integrationId: e,
    fieldDefinitions: Qh,
    form: l,
    onMisconfigured: I
  }), { renderConditions: $, setRenderConditions: C, renderConditionsForSubmit: F } = Qr({
    integrationId: e,
    widgetConfiguration: L,
    renderConditionsEditor: o
  }), z = (J) => Xr(J, {
    fieldDefinitions: Qh,
    isCreationMode: s,
    create: u,
    update: m,
    renderConditions: F
  }), Q = l.watch("name");
  return /* @__PURE__ */ be.jsxs(
    Jr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: z,
      error: j ?? h,
      onRetry: j ? y : void 0,
      isLoading: f || w,
      isWidgetUnknown: _,
      children: [
        v && /* @__PURE__ */ be.jsx(Zr, { cause: v }),
        /* @__PURE__ */ be.jsxs(mt, { children: [
          /* @__PURE__ */ be.jsx(ce, { children: /* @__PURE__ */ be.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ be.jsx(
            Dn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(ce, { span: 3, children: /* @__PURE__ */ be.jsx(
            Zn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ be.jsx(ce, { span: 3 }),
          /* @__PURE__ */ be.jsx(ce, { span: 3, children: /* @__PURE__ */ be.jsx(
            Zn,
            {
              name: "githubOrganization",
              label: "GitHub organization or user",
              control: l.control,
              rules: { required: "GitHub organization or user is required" },
              componentProps: {
                placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ be.jsx(ce, { span: 3 }),
          /* @__PURE__ */ be.jsx(ce, { span: 3, children: /* @__PURE__ */ be.jsx(en, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ be.jsx(
            Dn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(ce, { span: 3 }),
          /* @__PURE__ */ be.jsx(ce, { span: 3, children: /* @__PURE__ */ be.jsx(en, { label: "Show unresolved links to GitHub items", children: /* @__PURE__ */ be.jsx(
            Dn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(ce, { span: 3 }),
          /* @__PURE__ */ be.jsx(ce, { span: 3, children: /* @__PURE__ */ be.jsx(en, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ be.jsx(
            Dn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(ce, { span: 3 }),
          !s && e && /* @__PURE__ */ be.jsx(
            Oa,
            {
              configuration: n,
              integrationId: e,
              integrationType: Ei,
              label: "Authorize with OAuth"
            }
          ),
          o && $ !== null && /* @__PURE__ */ be.jsx(ce, { children: o({
            value: $,
            onChange: C,
            configurationKey: L?.id
          }) })
        ] }),
        /* @__PURE__ */ be.jsx(
          ei,
          {
            integrationType: Ei,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ be.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ be.jsx(
                he,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ be.jsxs(P.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Ei,
                  " integration, all links between Dixa and ",
                  Ei,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ be.jsxs(P.Paragraph, { children: [
                  "All data in ",
                  Ei,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ be.jsxs(P.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Ei,
                  " ",
                  'integration "',
                  Q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var pm = { exports: {} }, ao = {}, cx;
function DA() {
  if (cx) return ao;
  cx = 1;
  var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ao.Fragment = r, ao.jsx = s, ao.jsxs = s, ao;
}
var Ns = {}, ux;
function OA() {
  return ux || (ux = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var g = _.ReactDebugCurrentFrame, E = g.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var $ = !1, C = !1, F = !1, z = !1, Q = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === d || z || t === v || $ || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, N = E._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (E) {
            var g = E.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (ie) {
              g = ie;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var S = ie.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var ue = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = E;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ae(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ae(t.type, c, p);
          case h: {
            var g = t, E = g._payload, O = g._init;
            try {
              return ae(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, p, g, E) {
      {
        var O = Function.call.bind(le);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + p + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe(E), y("Failed %s type: %s", p, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, p, g, E, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, p, g, E) {
      {
        var O, N = {}, S = null, ne = null;
        p !== void 0 && (A(p), S = "" + p), gn(c) && (A(c.key), S = "" + c.key), rn(c) && (ne = c.ref, tn(c));
        for (O in c)
          le.call(c, O) && !oe.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, E, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function An(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = j(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          yn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var E = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, p, g, E, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, p, E, O);
        if (W == null)
          return W;
        if (N) {
          var ue = c.children;
          if (ue !== void 0)
            if (g)
              if (x(ue)) {
                for (var Ue = 0; Ue < ue.length; Ue++)
                  Sn(ue[Ue], t);
                Object.freeze && Object.freeze(ue);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ue, t);
        }
        if (le.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var Rn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, Rn, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, p) {
      return Fn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return Fn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Ns.Fragment = i, Ns.jsx = Un, Ns.jsxs = Kn;
  })()), Ns;
}
var dx;
function RA() {
  return dx || (dx = 1, process.env.NODE_ENV === "production" ? pm.exports = DA() : pm.exports = OA()), pm.exports;
}
var je = RA(), Oo = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(Oo || {}), Ai = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(Ai || {}), or = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(or || {});
const PA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, AA = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": PA
};
function LA(e) {
  return AA[e] ?? {};
}
const VA = LA(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), mx = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, xC = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, zA = "_listItem_16pij_4", UA = "_clickableIcon_16pij_15", Xo = {
  listItem: zA,
  clickableIcon: UA
}, SC = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = de(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ je.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ je.jsx(he, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ je.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ je.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: Xo.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ je.jsx(
              he,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ je.jsx(Qe, { children: e.map((l, u) => {
      if (!l) return null;
      const { name: m, quantity: d, price: f, image: h, sku: v } = l, I = l.currency ?? r;
      return /* @__PURE__ */ je.jsx(
        Qe.Item,
        {
          contentLeft: /* @__PURE__ */ je.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ je.jsx(P.Paragraph, { children: d }),
            /* @__PURE__ */ je.jsx(P.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ je.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: xC(f / 100, I) })
          ] }),
          contentRight: h && /* @__PURE__ */ je.jsx(Pa, { src: h, alt: m ?? "Product image" }),
          className: Xo.listItem
        },
        `item-${u}-${v}`
      );
    }) })
  ] }) });
}, MA = "_boxWrapper_89s7l_1", BA = "_trackButton_89s7l_10", px = {
  boxWrapper: MA,
  trackButton: BA
}, qA = {
  [or.StepUnknown]: "Unknown",
  [or.StepConfirmedByMerchant]: "Confirmed by merchant",
  [or.StepPreparedByMerchant]: "Prepared by merchant",
  [or.StepSubmittedToCarrier]: "Submitted to carrier",
  [or.StepLinehaulToCarrier]: "Linehaul to carrier",
  [or.StepOnRoute]: "On route",
  [or.StepDeliveredToPickupPoint]: "At pickup point",
  [or.StepDeliveredToConsumer]: "Delivered to customer",
  [or.StepDeliveredToMerchant]: "Returned to merchant",
  [or.StepReturnRequested]: "Return requested",
  [or.StepSentBack]: "Sent back",
  [or.StepTerminated]: "Terminated",
  [or.StepAwaitingSupplier]: "Awaiting supplier"
}, HA = {
  [Ai.Delivery]: "Home delivery",
  [Ai.Pickup]: "Pickup point",
  [Ai.Instore]: "In-store pickup",
  [Ai.Mailbox]: "Mailbox",
  [Ai.Inwarehouse]: "Warehouse",
  [Ai.Unknown]: "Unknown"
}, WA = {
  [Oo.Outbound]: "From merchant to customer",
  [Oo.Return]: "Return from customer to merchant",
  [Oo.Unspecified]: "Unspecified",
  [Oo.UnknownDirectionType]: "Unknown"
}, KA = (e) => e ? qA[e] ?? e : "", GA = (e) => e ? HA[e] ?? e : "", YA = (e) => e ? WA[e] ?? e : "", QA = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, JA = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = ir();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: u,
    display_carrier_name: m,
    delivery_type: d,
    direction_type: f,
    estimated_delivery_time: h
  } = e, v = m || l || i, I = a?.filter(($) => $?.time !== ""), w = KA(I?.[0]?.step), j = GA(d), _ = YA(f), y = QA(e.location?.address), L = 14;
  return /* @__PURE__ */ je.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: px.boxWrapper,
      children: [
        /* @__PURE__ */ je.jsx(P.Heading, { variant: "heading-4", children: v }),
        /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ je.jsx(
              he,
              {
                size: L,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ je.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ je.jsx(Xe, { content: "Copy tracking ID", children: /* @__PURE__ */ je.jsx(
            he,
            {
              size: L,
              name: n ? "done" : "copy",
              className: Xo.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        w && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ je.jsx(he, { size: L, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: w })
          ] })
        ] }),
        _ && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ je.jsx(he, { size: L, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: _ })
          ] })
        ] }),
        h && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ je.jsx(he, { size: L, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ je.jsxs(P.Paragraph, { variant: "4", color: "secondary", children: [
              mx(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: mx(h.end) })
          ] })
        ] }),
        d && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ je.jsx(he, { size: L, name: "info", color: "blue.900" }),
          /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: j })
          ] })
        ] }),
        y && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ je.jsx(he, { size: L, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: y })
          ] })
        ] }),
        /* @__PURE__ */ je.jsx(SC, { title: "Parcel items", items: s }),
        u && /* @__PURE__ */ je.jsxs(
          Bt,
          {
            variant: "secondary",
            className: px.trackButton,
            navigate: () => window.open(u, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ je.jsx(he, { name: "external-link" }),
            children: [
              "Track on ",
              v ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, XA = "_order_135ze_1", ZA = "_orderIsOpen_135ze_9", e2 = "_orderHeader_135ze_12", fm = {
  order: XA,
  orderIsOpen: ZA,
  orderHeader: e2
}, fx = "No order number found", n2 = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = de(n), { isCopied: a, copy: o } = ir(), { isCopied: s, copy: l } = ir();
  if (!e)
    return null;
  const { cart: u, parcels: m, sender_name: d, tos_id: f } = e, h = e.external_id?.trim(), v = u?.currency || "", I = u?.prices?.total?.price ?? 0, w = xC(I / 100, v), j = 14, _ = d && d.trim() !== "" ? d : "unknown sender";
  return /* @__PURE__ */ je.jsxs(
    b,
    {
      className: dt(fm.order, {
        [fm.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ je.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: fm.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ je.jsxs(P.Paragraph, { variant: "4", children: [
                  "From ",
                  _
                ] }),
                h ? /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: /* @__PURE__ */ je.jsxs("span", { children: [
                  "#",
                  h
                ] }) }) : /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: fx })
              ] }),
              /* @__PURE__ */ je.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ je.jsx(he, { size: j, name: "tag", color: "blue.900" }),
              /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Order number" }),
                /* @__PURE__ */ je.jsx(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: h ? /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: h }) : /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: fx }) })
              ] })
            ] }),
            h && /* @__PURE__ */ je.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ je.jsx(Xe, { content: "Copy order number", children: /* @__PURE__ */ je.jsx(
              he,
              {
                size: j,
                name: s ? "done" : "copy",
                className: Xo.clickableIcon,
                onClick: () => l(h)
              }
            ) }) })
          ] }),
          /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ je.jsx(
                he,
                {
                  size: j,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !f && /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  f && /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: f })
                ] })
              ] })
            ] }),
            f && /* @__PURE__ */ je.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ je.jsx(Xe, { content: "Copy tracking ID", children: /* @__PURE__ */ je.jsx(
              he,
              {
                size: j,
                name: a ? "done" : "copy",
                className: Xo.clickableIcon,
                onClick: () => o(f)
              }
            ) }) })
          ] }),
          d && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ je.jsx(he, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: d })
            ] })
          ] }),
          /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ je.jsx(he, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: w })
            ] })
          ] }),
          /* @__PURE__ */ je.jsx(
            SC,
            {
              openByDefault: !0,
              title: "Order items",
              items: u?.items?.map((y) => y),
              currency: u?.currency
            }
          ),
          m && /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ je.jsx(P.Heading, { variant: "heading-4", children: "Parcels" }),
              m.length > 0 && /* @__PURE__ */ je.jsx(Bn, { variant: "success", size: "small", children: m.length })
            ] }),
            m.length === 0 && /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            m.map((y, L) => /* @__PURE__ */ je.jsx(
              JA,
              {
                parcel: y
              },
              `parcel-${L}-${y?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, t2 = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, hx = (e) => {
  let n = 1 / 0;
  for (const r of e?.parcels ?? [])
    for (const i of r?.progress ?? []) {
      if (!i?.time)
        continue;
      const a = new Date(i.time).getTime();
      !Number.isNaN(a) && a < n && (n = a);
    }
  return n === 1 / 0 ? -1 / 0 : n;
}, r2 = (e) => [...e].sort(
  (n, r) => hx(r) - hx(n)
), i2 = ({
  customerEmail: e
}) => {
  const { useQuery: n } = _n(), [r, i] = de([]), a = !e, { data: o, loading: s, error: l } = n(VA, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), u = !s && r.length > 0, m = l ? BI({
    error: l.graphQLErrors?.[0]
  }) : !1, d = l ? Hw({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return Je(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(
      r2(
        t2(f.orders)
      )
    );
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ je.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ je.jsx(vn, {}) }) : m || !u && !l ? /* @__PURE__ */ je.jsx(P.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : d ? /* @__PURE__ */ je.jsx(P.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ je.jsx(Tn, { error: l }) : /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ je.jsx(P.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ je.jsx(Bn, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ je.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ je.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ je.jsx(
      n2,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, a2 = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ je.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ je.jsx(i2, { customerEmail: n })
    }
  );
}, Jh = [
  {
    key: "ingridUseStagingEnvironment",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "ingridApiToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], o2 = {
  enabled: !1,
  name: "",
  ingridSiteId: "",
  ingridApiToken: "",
  ingridUseStagingEnvironment: !1
}, s2 = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ht({
    mode: "onChange",
    defaultValues: o2
  }), {
    create: l,
    update: u,
    remove: m,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = Gr({
    integrationId: e,
    integrationType: "INGRID",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: I,
    error: w,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: y
  } = Yr({
    integrationId: e,
    fieldDefinitions: Jh,
    form: s,
    onMisconfigured: v
  }), { renderConditions: L, setRenderConditions: $, renderConditionsForSubmit: C } = Qr({
    integrationId: e,
    widgetConfiguration: y,
    renderConditionsEditor: a
  }), F = (Q) => Xr(Q, {
    fieldDefinitions: Jh,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: C
  }), z = s.watch("name");
  return /* @__PURE__ */ je.jsxs(
    Jr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: w ?? f,
      onRetry: w ? _ : void 0,
      isLoading: d || I,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ je.jsx(Zr, { cause: h }),
        /* @__PURE__ */ je.jsxs(mt, { children: [
          /* @__PURE__ */ je.jsx(ce, { children: /* @__PURE__ */ je.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ je.jsx(
            Dn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(ce, { span: 3, children: /* @__PURE__ */ je.jsx(
            Zn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ je.jsx(ce, { span: 3 }),
          /* @__PURE__ */ je.jsx(ce, { span: 3, children: /* @__PURE__ */ je.jsx(en, { label: "Use Ingrid staging environment", children: /* @__PURE__ */ je.jsx(
            Dn,
            {
              name: "ingridUseStagingEnvironment",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(ce, { span: 3 }),
          /* @__PURE__ */ je.jsx(ce, { span: 3, children: /* @__PURE__ */ je.jsx(
            Zn,
            {
              name: "ingridSiteId",
              label: "Site ID",
              control: s.control,
              rules: { required: "Site ID is required" },
              componentProps: {
                placeholder: "Site ID from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ je.jsx(ce, { span: 3 }),
          /* @__PURE__ */ je.jsx(ce, { span: 3, children: /* @__PURE__ */ je.jsx(
            Da,
            {
              name: "ingridApiToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "API token from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ je.jsx(ce, { span: 3 }),
          a && L !== null && /* @__PURE__ */ je.jsx(ce, { children: a({
            value: L,
            onChange: $,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ je.jsx(
          ei,
          {
            integrationType: "INGRID",
            integrationId: e,
            widgetName: z,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_1wiub_54{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1wiub_54:hover,._result_1wiub_54:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1wiub_74{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_1wiub_82{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_1wiub_87{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1wiub_99{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1wiub_108{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_1wiub_114{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_1wiub_121{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1wiub_126{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_1wiub_131{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_1wiub_139{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_1wiub_143{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var hm = { exports: {} }, oo = {}, yx;
function l2() {
  if (yx) return oo;
  yx = 1;
  var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return oo.Fragment = r, oo.jsx = s, oo.jsxs = s, oo;
}
var js = {}, gx;
function c2() {
  return gx || (gx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var g = _.ReactDebugCurrentFrame, E = g.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var $ = !1, C = !1, F = !1, z = !1, Q = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === d || z || t === v || $ || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, N = E._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (E) {
            var g = E.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (ie) {
              g = ie;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var S = ie.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var ue = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = E;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ae(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ae(t.type, c, p);
          case h: {
            var g = t, E = g._payload, O = g._init;
            try {
              return ae(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, p, g, E) {
      {
        var O = Function.call.bind(le);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + p + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe(E), y("Failed %s type: %s", p, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, p, g, E, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, p, g, E) {
      {
        var O, N = {}, S = null, ne = null;
        p !== void 0 && (A(p), S = "" + p), gn(c) && (A(c.key), S = "" + c.key), rn(c) && (ne = c.ref, tn(c));
        for (O in c)
          le.call(c, O) && !oe.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, E, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function An(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = j(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          yn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var E = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, p, g, E, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, p, E, O);
        if (W == null)
          return W;
        if (N) {
          var ue = c.children;
          if (ue !== void 0)
            if (g)
              if (x(ue)) {
                for (var Ue = 0; Ue < ue.length; Ue++)
                  Sn(ue[Ue], t);
                Object.freeze && Object.freeze(ue);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ue, t);
        }
        if (le.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var Rn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, Rn, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, p) {
      return Fn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return Fn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    js.Fragment = i, js.jsx = Un, js.jsxs = Kn;
  })()), js;
}
var vx;
function u2() {
  return vx || (vx = 1, process.env.NODE_ENV === "production" ? hm.exports = l2() : hm.exports = c2()), hm.exports;
}
var me = u2();
const kg = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => kg(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, d2 = "_jiraCode_h30p6_1", m2 = "_jiraCodeInline_h30p6_8", ym = {
  jiraCode: d2,
  jiraCodeInline: m2
}, NC = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ me.jsx(me.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ me.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ me.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ me.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ me.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ me.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ me.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ me.jsx("pre", { children: /* @__PURE__ */ me.jsx("code", { className: ym.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ me.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ me.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ me.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ me.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ me.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ me.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ me.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ me.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ me.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ me.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ me.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ me.jsx("code", { className: dt(ym.jiraCode, ym.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, Cl = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = de(!1);
  return !e || i ? /* @__PURE__ */ me.jsx(he, { size: r, name: "question", className: n }) : /* @__PURE__ */ me.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, p2 = "_collapse_m2gjh_1", f2 = "_collapseHeader_m2gjh_10", h2 = "_collapseHeaderLink_m2gjh_31", y2 = "_collapseHeaderStatus_m2gjh_40", g2 = "_collapseHeaderTitle_m2gjh_51", v2 = "_collapseContent_m2gjh_59", k2 = "_collapseContentHeadline_m2gjh_62", b2 = "_collapseContentButtonSpacer_m2gjh_68", _2 = "_collapseContentButtonLink_m2gjh_71", x2 = "_collapseContentStatusTag_m2gjh_74", S2 = "_collapseContentDescription_m2gjh_77", jr = {
  collapse: p2,
  collapseHeader: f2,
  collapseHeaderLink: h2,
  collapseHeaderStatus: y2,
  collapseHeaderTitle: g2,
  collapseContent: v2,
  collapseContentHeadline: k2,
  collapseContentButtonSpacer: b2,
  collapseContentButtonLink: _2,
  collapseContentStatusTag: x2,
  collapseContentDescription: S2
}, jC = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, N2 = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (u, m) => m?.id ? { ...u, [m.id]: !1 } : u,
    {}
  ), [a, o] = de(i), { track: s } = En(), l = (u, m) => {
    o({ ...a, [u]: m });
  };
  return /* @__PURE__ */ me.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((u) => {
    const { summary: m, description: d, status: f, issuetype: h } = u?.fields || {}, v = jC({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), I = !!(u?.id && a[u.id]);
    return /* @__PURE__ */ me.jsxs(
      xr,
      {
        onToggle: () => u?.id && l(u.id, !a[u.id]),
        isOpen: I,
        className: jr.collapse,
        children: [
          /* @__PURE__ */ me.jsx(xr.Header, { className: jr.collapseHeader, children: /* @__PURE__ */ me.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ me.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ me.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ me.jsx(Cl, { width: 16, iconUrl: v }),
                    /* @__PURE__ */ me.jsx(
                      "a",
                      {
                        className: jr.collapseHeaderLink,
                        href: `${n}/browse/${u?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (w) => {
                          w.stopPropagation(), u?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: u.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ me.jsxs(b, { alignItems: "center", gap: "200", children: [
                          u?.key,
                          /* @__PURE__ */ me.jsx(he, { name: "external-link", size: 16 })
                        ] })
                      },
                      u?.key
                    )
                  ] }),
                  /* @__PURE__ */ me.jsx("span", { className: jr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ me.jsx(Yn, { className: jr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ me.jsx("div", { className: jr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ me.jsx(xr.Content, { className: jr.collapseContent, children: /* @__PURE__ */ me.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ me.jsx("div", { className: jr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ me.jsx(ct, { className: jr.collapseContentDescription, children: d ? kg(d, NC) : "" }),
            /* @__PURE__ */ me.jsx(
              nt,
              {
                icon: "link-slash",
                variant: "secondary",
                className: jr.collapseContentButtonSpacer,
                onClick: () => u?.key && r(u.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ me.jsx(
              Bt,
              {
                slotEnd: /* @__PURE__ */ me.jsx(he, { name: "external-link" }),
                variant: "tertiary",
                className: jr.collapseContentButtonLink,
                navigate: () => {
                  u?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: u.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${u.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      u?.id
    );
  }) : /* @__PURE__ */ me.jsx(me.Fragment, {}) });
}, j2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, w2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, C2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, F2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, I2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, E2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, $2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, T2 = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': j2,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": w2,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": C2,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": F2,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': I2,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': E2,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": $2
};
function ea(e) {
  return T2[e] ?? {};
}
const wC = ea(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), D2 = ea(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), O2 = ea(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), R2 = ea(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), P2 = ea(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), A2 = ea(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), L2 = ea(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), bg = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), V2 = new RegExp(`^${bg.source}$`), z2 = new RegExp(`/${bg.source}$`), kx = new RegExp(
  `.+?[&?]selectedIssue=(${bg.source})[&?]?.*`
);
function CC(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = de([]), [o, s] = de([]), [l, u] = de(), { track: m } = En(), { showNotification: d, showModal: f, useLazyQuery: h, useMutation: v } = _n(), {
    loading: I,
    data: w,
    error: j,
    store: _
  } = $y(e ?? null), [
    y,
    { loading: L, error: $, data: C }
  ] = h(wC, {
    notifyOnNetworkStatusChange: !0
  });
  Je(() => {
    const ye = C?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    ye?.length && (s(ye), a(ye.map((ve) => ve?.key).filter(Boolean)));
  }, [C]), Je(
    () => u(j || $ || void 0),
    [j, $]
  ), Je(
    () => {
      I || B();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [w?.jira?.issues, I]
  );
  const F = async (ye, ve) => {
    await _(ye).then(() => {
      d({
        icon: "check-circle-filled",
        severity: "success",
        title: ve.success.title,
        text: ve.success.text
      });
    }).catch((K) => {
      d({
        title: ve.error.title,
        text: `${ve.error.text} ${K.message && " (" + K.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [z] = v(D2, {
    onError: (ye) => {
      d({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${ye.message && " (" + ye.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), Q = (ye, ve) => {
    const K = window.location.href, _e = ve ? K.replace(
      e?.toString() ?? "",
      ve?.toString()
    ) : K, Te = ve ? `# ${ve}` : `# ${e}`;
    z({
      variables: {
        issueKey: ye,
        title: Te,
        url: _e,
        globalId: `system=${_e}`
      }
    });
  }, [J] = v(O2, {
    onError: (ye) => {
      d({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${ye.message && " (" + ye.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), te = (ye) => {
    const ve = window.location.href;
    J({
      variables: {
        issueKey: ye,
        globalId: `system=${ve}`
      }
    });
  }, G = (ye) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: ye
  }), B = () => {
    w && w.jira?.issues?.length > 0 ? y({
      variables: {
        jql: `key in (${w?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, R = async (ye, ve) => {
    m("jira:issue:link:clicked", G(ye));
    const K = w?.jira?.issues ? w : r;
    K.jira.issues = Array.from(
      new Set(K.jira.issues).add(ye)
    ), await _(K, ve?.toString()).then(() => Q(ye, ve)).catch((_e) => {
      d({
        title: "Linking failed",
        text: `Linking ${ye} failed. Please try again. ${_e.message && " (" + _e.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, U = (ye) => {
    m("jira:issue:link:clicked", G(ye));
    const ve = w?.jira?.issues ? w : r;
    ve.jira.issues = Array.from(
      new Set(ve.jira.issues).add(ye)
    ), F(ve, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${ye} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${ye} failed. Please try again.`
      }
    }).then(() => Q(ye));
  }, ee = (ye) => {
    m("jira:issue:unlink:clicked", G(ye)), f({
      headline: `Unlink issue ${ye}?`,
      text: `You are about to unlink the issue ${ye}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", G(ye));
        const ve = {
          ...w,
          jira: {
            ...w?.jira,
            issues: w?.jira?.issues.filter((K) => K !== ye) || []
          }
        };
        F(ve, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${ye}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${ye} failed.`
          }
        }).then(() => te(ye));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", G(ye))
    });
  }, Se = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((ye) => ye?.key && te(ye.key)), F(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, fe = w?.jira?.issues?.filter(
    (ye) => !i?.includes(ye)
  ) || [];
  return {
    linkIssue: U,
    linkIssueQuietly: R,
    unlinkIssue: ee,
    loadIssues: B,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const ye = {
        ...w,
        jira: {
          ...w?.jira,
          issues: w?.jira?.issues.filter(
            (ve) => !fe.includes(ve)
          ) || []
        }
      };
      _(ye);
    },
    unlinkAllIssues: Se,
    maybeExtractIssueKey: (ye) => {
      const ve = ye.replace(/\s/g, "");
      if (V2.test(ve))
        return ve;
      if (kx.test(ye))
        return ye.match(kx)?.[1];
      if (ye.startsWith(n) && z2.test(ye))
        return ye.substring(ye.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: I,
    danglingIssueLinks: fe,
    isLoadingIssues: L,
    issues: o,
    error: l
  };
}
function U2(e = !1, n) {
  const [r, i] = de(e);
  return Je(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const M2 = "_result_1wiub_54", B2 = "_resultName_1wiub_74", q2 = "_resultNameIcon_1wiub_82", H2 = "_resultDescription_1wiub_87", W2 = "_resultLinkIcon_1wiub_99", K2 = "_tooltip_1wiub_108", G2 = "_tooltipContent_1wiub_114", Y2 = "_tooltipName_1wiub_121", Q2 = "_tooltipNameIcon_1wiub_126", J2 = "_tooltipDescription_1wiub_131", X2 = "_tooltipSummary_1wiub_139", Z2 = "_tooltipTag_1wiub_143", vr = {
  result: M2,
  resultName: B2,
  resultNameIcon: q2,
  resultDescription: H2,
  resultLinkIcon: W2,
  tooltip: K2,
  tooltipContent: G2,
  tooltipName: Y2,
  tooltipNameIcon: Q2,
  tooltipDescription: J2,
  tooltipSummary: X2,
  tooltipTag: Z2
}, eL = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: u, description: m } = e, [d, f] = de(!1), h = jC({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ me.jsx(
    Xe,
    {
      disabled: i,
      className: vr.tooltip,
      content: /* @__PURE__ */ me.jsxs("div", { className: vr.tooltipContent, children: [
        /* @__PURE__ */ me.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ me.jsxs("span", { className: vr.tooltipName, children: [
                /* @__PURE__ */ me.jsx(
                  Cl,
                  {
                    width: 16,
                    iconUrl: h,
                    className: vr.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ me.jsx(Yn, { className: vr.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ me.jsx("div", { className: vr.tooltipSummary, children: m }),
        u && /* @__PURE__ */ me.jsx("div", { className: vr.tooltipDescription, children: u })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ me.jsxs(
        "button",
        {
          ...a,
          className: vr.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ me.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: d ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ me.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ me.jsxs("span", { className: vr.resultName, children: [
                    /* @__PURE__ */ me.jsx(
                      Cl,
                      {
                        width: 16,
                        iconUrl: h,
                        className: vr.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ me.jsx("div", { className: vr.resultDescription, children: m })
                ]
              }
            ),
            d && /* @__PURE__ */ me.jsx(
              he,
              {
                className: vr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, nL = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ me.jsx(
  Bt,
  {
    slotEnd: /* @__PURE__ */ me.jsx(he, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), tL = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = _n(), [o, s] = de([]), [l, u] = de(""), [m, { loading: d, error: f, data: h, networkStatus: v }] = a(wC, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: I } = CC(null, n);
  Zi(
    () => {
      !d && l && v === dr.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), Je(() => {
    const $ = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      $.map((C) => ({
        id: C?.key ?? "",
        name: C?.key ?? "",
        description: C?.fields.summary,
        status: C?.fields.status,
        issuetype: C?.fields.issuetype,
        text: C?.fields.description ? kg(C?.fields.description, NC) : /* @__PURE__ */ me.jsx(me.Fragment, {})
      }))
    );
  }, [h]);
  const w = ($) => {
    e($.id), u("");
  }, j = ($) => {
    const C = $.trim(), F = I(C);
    if (F) {
      const z = F.replaceAll("[-_|]", "\\\\$0");
      u(`key = '${z}'`);
    } else C !== "" && u(
      `text ~ '${C}'${r ? " and project = " + r : ""}`
    );
  }, _ = () => {
    u("");
  }, y = ($) => /* @__PURE__ */ me.jsx(nL, { ...$, jiraInstanceUrl: n }), L = ($) => /* @__PURE__ */ me.jsx(
    eL,
    {
      ...$,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !d && f ? /* @__PURE__ */ me.jsx(Tn, { error: f }) : /* @__PURE__ */ me.jsx(
    Or,
    {
      items: o,
      loading: d,
      onSearch: j,
      onSelect: w,
      onClear: _,
      emptyMessage: l ? d ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: y,
      itemComponent: L,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, rL = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = de(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: u }) => u !== s.id)
    );
  };
  return Je(() => {
    r(i);
  }, [i]), /* @__PURE__ */ me.jsx(
    Or,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: u }) => ({
          id: s,
          name: l || u
        })
      )
    }
  );
}, iL = "_itemButton_1hl53_1", aL = "_result_1hl53_6", oL = "_resultIcon_1hl53_26", sL = "_resultName_1hl53_30", lL = "_resultCheckIcon_1hl53_38", so = {
  itemButton: iL,
  result: aL,
  resultIcon: oL,
  resultName: sL,
  resultCheckIcon: lL
}, Xh = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ me.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ me.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: so.itemButton,
          children: /* @__PURE__ */ me.jsxs(b, { className: so.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ me.jsx(
              Cl,
              {
                width: 36,
                iconUrl: o || "",
                className: so.resultIcon
              }
            ),
            /* @__PURE__ */ me.jsx(ct, { className: so.resultName, children: e.name }),
            n && /* @__PURE__ */ me.jsx(ct, { className: so.resultCheckIcon, children: /* @__PURE__ */ me.jsx(he, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, cL = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = _n(), [o, s] = de([]), [l, u] = de(), m = 2, [d, { loading: f, error: h, data: v, networkStatus: I }] = a(L2, {
    notifyOnNetworkStatusChange: !0
  });
  return Zi(
    () => {
      !f && l && l.length >= m && I === dr.ready ? d({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Je(() => {
    n && d({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((w) => {
      if (w?.data?.Jira.findUsers?.length === 1) {
        const j = w?.data?.Jira?.findUsers[0];
        r(j.accountId), s([
          {
            id: j.accountId,
            name: j.displayName
          }
        ]);
      }
    });
  }, []), Je(() => {
    const w = v?.Jira?.findUsers || [];
    s(
      w.filter(({ active: j }) => j).map(({ accountId: j, displayName: _, avatarUrls: y, active: L }) => ({
        id: j,
        name: _,
        avatarUrls: y,
        active: L
      }))
    );
  }, [v]), !f && h ? /* @__PURE__ */ me.jsx(Tn, { error: h }) : /* @__PURE__ */ me.jsx(
    Or,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (w) => u(w),
      onSelect: r,
      onClear: () => u(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: w, onSelect: j, checked: _ }) => /* @__PURE__ */ me.jsx(
        Xh,
        {
          item: w,
          checked: _,
          onSelectItem: j,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, bx = ({
  field: e
}) => {
  const [n, r] = de(!1), [i, a] = vC();
  return Je(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ me.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ me.jsx(b, { children: /* @__PURE__ */ me.jsx(he, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ me.jsx(P.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ me.jsx(Xe, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ me.jsx(
      mr,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, uL = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ me.jsx(bx, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ me.jsx(_r, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ me.jsx(Uh, { onChange: n, value: r }) : /* @__PURE__ */ me.jsx(_r, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ me.jsx(Uh, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ me.jsx(_r, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ me.jsx(
        cL,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ me.jsx(
        Or,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: u, value: m }) => ({
              id: l,
              name: u || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ me.jsx(rL, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ me.jsx(bx, { field: e });
  }
}, dL = ["description", "reporter", "summary"], mL = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ me.jsx(me.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || dL.includes(o)
).map((o) => /* @__PURE__ */ me.jsx(
  zt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ me.jsx(
      en,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: uL({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), pL = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ me.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ me.jsxs(P.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ me.jsxs(
          P.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ me.jsx(he, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ me.jsx(en, { label: "Jira issue link", children: /* @__PURE__ */ me.jsx(
        _r,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), fL = "_modalBody_1hk1o_1", hL = "_modalBodyFormFields_1hk1o_4", _x = {
  modalBody: fL,
  modalBodyFormFields: hL
}, yL = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), gL = (e) => e?.custom?.split(":")?.[1] || null, vL = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, kL = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = vL(a, n), l = gL(s) ?? a;
        return r.includes(l) ? i[a] = yL(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, bL = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, u] = de([]), [m, d] = de(), [f, h] = de(0), [v, I] = de([]), [w, j] = de([]), [_, y] = de(!1), [L, $] = de(!1), [C, F] = de({}), { track: z } = En(), { isCopied: Q, copyToClipboard: J } = U2(), te = Xn(() => i?.conversationId, [e]), { useMutation: G, useLazyQuery: B, showNotification: R } = _n(), {
    control: U,
    handleSubmit: ee,
    formState: { errors: Se },
    reset: fe,
    setValue: ye,
    getValues: ve
  } = ht({
    defaultValues: s
  }), K = w.length > 0, _e = `${a}/browse`, Te = Object.keys(C).length > 0, [X, { loading: Ke, error: an }] = B(R2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (le) => {
      u(le.Jira.getAllProjects);
    },
    onError: (le) => {
      R({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", le), u([]);
    }
  }), [
    we,
    { loading: Me, error: Re }
  ] = B(P2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (le) => {
      h(0);
      const xe = le?.Jira?.getCreateIssueMeta?.projects[0];
      if (xe) {
        const Le = xe?.issuetypes.filter(
          ({ subtask: Pe }) => !Pe
        );
        I(Le || []), ye(
          "issuetype",
          Le.length > 0 ? Le[0] : void 0
        );
      } else
        R({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), I([]), j([]);
    },
    onError: (le) => {
      R({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", le), I([]), j([]), h(0);
    }
  }), [Be, { error: Ae }] = G(
    A2,
    {
      onError: () => {
        y(!1), R({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), z("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (le) => {
        if (y(!1), le?.Jira && "key" in le.Jira.createIssue)
          d(le?.Jira?.createIssue), R({
            title: "Success",
            text: `Jira issue '${le.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), z("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: le.Jira.createIssue.key
          }), te && r(
            le.Jira.createIssue.key,
            te
          );
        else if ("errorMessages" in le.Jira.createIssue || "errors" in le.Jira.createIssue) {
          const xe = le?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", xe), R({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), Ge = (le) => {
    y(!0), F({}), Be({
      variables: {
        input: kL(le, w)
      }
    });
  };
  Je(() => {
    if (e)
      try {
        X();
      } catch (le) {
        console.warn("Error when fetching initial projects", le);
      }
  }, [e]), Je(() => {
    const le = L ? window.setTimeout(() => $(!1), 2e3) : void 0;
    return () => window.clearTimeout(le);
  }, [L]), Je(() => {
    if (v?.length > 0) {
      ye("issuetype", v[f]);
      const le = v[f]?.fields?.additionalProperties;
      if (le?.length > 0) {
        const xe = le.map(
          ({ value: T }) => T
        ), Le = (o ? xe.sort(({ name: T }, { name: x }) => T.localeCompare(x)) : xe).sort(
          ({ required: T }, { required: x }) => Number(x) - Number(T)
        ), { project: Pe, issuetype: yn } = ve();
        fe({ project: Pe, issuetype: yn }), j(Le);
      }
    } else
      j([]), ye("issuetype", void 0);
  }, [v, ye, f]), Je(() => {
    if (Ae && e1(Ae)) {
      if (Ae?.graphQLErrors?.length > 0) {
        const { graphQLErrors: le } = Ae, xe = le[0].extensions?.integration?.responseBody;
        try {
          const Le = JSON.parse(xe);
          if (Le?.errors) {
            const Pe = Object.keys(Le.errors).reduce(
              (yn, T) => ({
                ...yn,
                [T]: {
                  type: "required",
                  message: Le.errors[T],
                  ref: {
                    name: T
                  }
                }
              }),
              {}
            );
            F(Pe);
          }
        } catch {
        }
      }
    } else
      F({});
  }, [Ae]);
  const Ce = () => {
    u([]), j([]), I([]), d(void 0), h(0), y(!1), F({});
  }, qe = () => {
    Ce(), fe(s), n();
  }, nn = (le) => {
    le && we({
      variables: {
        projectKey: le
      }
    });
  }, ae = (le) => {
    const xe = v.map((Le) => Le.id).indexOf(le);
    h(xe ?? 0);
  };
  return /* @__PURE__ */ me.jsxs(
    $t,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: qe,
      children: [
        /* @__PURE__ */ me.jsx(
          Tt,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: qe
          }
        ),
        /* @__PURE__ */ me.jsxs(Dt, { className: _x.modalBody, children: [
          !Ke && an && /* @__PURE__ */ me.jsx(Tn, { error: an, retry: X }),
          !Me && Re && /* @__PURE__ */ me.jsx(
            Tn,
            {
              error: Re,
              retry: we
            }
          ),
          !_ && Te && /* @__PURE__ */ me.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ me.jsx(
            ql,
            {
              variant: "warning",
              description: /* @__PURE__ */ me.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ me.jsx(P.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ me.jsx(
                      nt,
                      {
                        icon: Q ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => J(JSON.stringify(w, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ me.jsx(
            pL,
            {
              createdIssue: m,
              issueBaseLink: _e,
              issueLinkCopied: L,
              setIssueLinkCopied: $,
              copyToClipboard: J
            }
          ) : /* @__PURE__ */ me.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ee(Ge),
              children: /* @__PURE__ */ me.jsxs(mt, { children: [
                /* @__PURE__ */ me.jsx(ce, { span: 3, children: /* @__PURE__ */ me.jsx(en, { label: "Project", required: !0, children: /* @__PURE__ */ me.jsx(
                  zt,
                  {
                    control: U,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: le, value: xe } }) => /* @__PURE__ */ me.jsx(
                      Or,
                      {
                        searchable: !0,
                        loading: Ke,
                        onSelect: (Le) => {
                          nn(Le.key), le(Le);
                        },
                        selectedItems: [xe],
                        placeholder: "Select Jira project",
                        emptyMessage: an ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Le, onSelect: Pe, checked: yn }) => /* @__PURE__ */ me.jsx(
                          Xh,
                          {
                            item: Le,
                            checked: yn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ me.jsx(ce, { span: 3, children: /* @__PURE__ */ me.jsx(en, { label: "Issue type", required: !0, children: /* @__PURE__ */ me.jsx(
                  zt,
                  {
                    control: U,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: le, value: xe } }) => /* @__PURE__ */ me.jsx(
                      Or,
                      {
                        disabled: v.length === 0,
                        loading: Me,
                        onSelect: (Le) => {
                          ae(Le.id), le(Le);
                        },
                        selectedItems: [xe],
                        placeholder: v.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: Re ? "No issues found" : "No issues available",
                        items: v,
                        itemComponent: ({ item: Le, onSelect: Pe, checked: yn }) => /* @__PURE__ */ me.jsx(
                          Xh,
                          {
                            item: Le,
                            checked: yn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                K && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ me.jsx(ce, { className: _x.modalBodyFormFields, children: /* @__PURE__ */ me.jsx(
                  mL,
                  {
                    control: U,
                    errors: { ...Se, ...C },
                    getValues: ve,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: w
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ me.jsx(
          Ht,
          {
            confirmOnClick: m ? qe : ee(Ge),
            confirmProps: {
              disabled: !K,
              isLoading: _,
              loadingIndicator: /* @__PURE__ */ me.jsx(vn, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : qe
          }
        )
      ]
    }
  );
}, _L = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, xL = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, SL = "_wrapper_1bylq_1", NL = "_inputWrapper_1bylq_6", jL = "_inputSeparator_1bylq_18", wL = "_buttonLink_1bylq_23", CL = "_noIssuesFound_1bylq_27", lo = {
  wrapper: SL,
  inputWrapper: NL,
  inputSeparator: jL,
  buttonLink: wL,
  noIssuesFound: CL
}, FL = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = En(), i = _L(n?.jiraSiteUrl), [a, o] = de(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: u,
    unlinkIssue: m,
    unlinkAllIssues: d,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: v,
    isLoadingIssueLinks: I,
    isLoadingIssues: w,
    issues: j,
    error: _
  } = CC(
    s ? e.conversationId : null,
    i
  ), y = !!n?.enableCreateIssue, L = !!n?.enableSortIssueTypeByLabel, $ = !!(j?.length || v?.length), C = !!n?.enableRemoveAllLinks && $, F = !I && !w && v?.length > 0 && !!n?.showDanglingLinks;
  return !w && _ ? /* @__PURE__ */ me.jsx(Tn, { error: _, retry: () => f() }) : /* @__PURE__ */ me.jsxs(me.Fragment, { children: [
    /* @__PURE__ */ me.jsxs(b, { className: lo.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ me.jsxs(b, { className: lo.inputWrapper, flexDirection: "column", children: [
        y && /* @__PURE__ */ me.jsxs(me.Fragment, { children: [
          /* @__PURE__ */ me.jsx(
            nt,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ me.jsx("div", { className: lo.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ me.jsx(
          tL,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      w ? /* @__PURE__ */ me.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ me.jsx(vn, { "data-testid": "jira-widget-issue-spinner" }) }) : j?.length ? /* @__PURE__ */ me.jsx(
        N2,
        {
          issues: j,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ me.jsx(P.Paragraph, { align: "center", className: lo.noIssuesFound, children: "No linked issues found" }),
      C && j?.length > 0 && /* @__PURE__ */ me.jsx(
        nt,
        {
          variant: "secondary",
          disabled: !j?.length && !v?.length,
          onClick: d,
          children: "Unlink all issues"
        }
      ),
      F && /* @__PURE__ */ me.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ me.jsx(P.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ me.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: v.map((z) => /* @__PURE__ */ me.jsx(Yn, { onDelete: () => m(z), children: z }, z)) }),
            /* @__PURE__ */ me.jsx(
              nt,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ me.jsx(
        Bt,
        {
          slotEnd: /* @__PURE__ */ me.jsx(he, { name: "external-link" }),
          variant: "tertiary",
          className: lo.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ me.jsx(
      bL,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: u,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: L
      }
    )
  ] });
}, Zh = [
  {
    key: "jiraSiteUrl",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  }
], IL = (e) => {
  const n = xL(e);
  return typeof n == "string" ? n : !0;
}, $i = "JIRA", EL = {
  enabled: !1,
  name: "",
  jiraSiteUrl: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0,
  enableSortIssueTypeByLabel: !1
}, $L = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ht({
    mode: "onChange",
    defaultValues: EL
  }), {
    create: u,
    update: m,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: I
  } = Gr({
    integrationId: e,
    integrationType: $i,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: w,
    error: j,
    isWidgetUnknown: _,
    refetch: y,
    widgetConfiguration: L
  } = Yr({
    integrationId: e,
    fieldDefinitions: Zh,
    form: l,
    onMisconfigured: I
  }), { renderConditions: $, setRenderConditions: C, renderConditionsForSubmit: F } = Qr({
    integrationId: e,
    widgetConfiguration: L,
    renderConditionsEditor: o
  }), z = (J) => Xr(J, {
    fieldDefinitions: Zh,
    isCreationMode: s,
    create: u,
    update: m,
    renderConditions: F
  }), Q = l.watch("name");
  return /* @__PURE__ */ me.jsxs(
    Jr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: z,
      error: j ?? h,
      onRetry: j ? y : void 0,
      isLoading: f || w,
      isWidgetUnknown: _,
      children: [
        v && /* @__PURE__ */ me.jsx(Zr, { cause: v }),
        /* @__PURE__ */ me.jsxs(mt, { children: [
          /* @__PURE__ */ me.jsx(ce, { children: /* @__PURE__ */ me.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ me.jsx(
            Dn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ me.jsx(ce, { span: 3, children: /* @__PURE__ */ me.jsx(
            Zn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ me.jsx(ce, { span: 3 }),
          /* @__PURE__ */ me.jsx(ce, { span: 3, children: /* @__PURE__ */ me.jsx(
            Zn,
            {
              name: "jiraSiteUrl",
              label: "Jira site URL",
              control: l.control,
              rules: {
                validate: (J) => IL(J)
              },
              componentProps: {
                placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ me.jsx(ce, { span: 3 }),
          /* @__PURE__ */ me.jsx(ce, { span: 3, children: /* @__PURE__ */ me.jsx(en, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ me.jsx(
            Dn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ me.jsx(ce, { span: 3 }),
          /* @__PURE__ */ me.jsx(ce, { span: 3, children: /* @__PURE__ */ me.jsx(en, { label: "Show unresolved links to Jira issues", children: /* @__PURE__ */ me.jsx(
            Dn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ me.jsx(ce, { span: 3 }),
          /* @__PURE__ */ me.jsx(ce, { span: 3, children: /* @__PURE__ */ me.jsx(en, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ me.jsx(
            Dn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ me.jsx(ce, { span: 3 }),
          /* @__PURE__ */ me.jsx(ce, { span: 3, children: /* @__PURE__ */ me.jsx(en, { label: "Enable to sort the issue types by label", children: /* @__PURE__ */ me.jsx(
            Dn,
            {
              name: "enableSortIssueTypeByLabel",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ me.jsx(ce, { span: 3 }),
          !s && e && /* @__PURE__ */ me.jsx(
            Oa,
            {
              configuration: n,
              integrationId: e,
              integrationType: $i,
              label: "Authorize with OAuth"
            }
          ),
          o && $ !== null && /* @__PURE__ */ me.jsx(ce, { children: o({
            value: $,
            onChange: C,
            configurationKey: L?.id
          }) })
        ] }),
        /* @__PURE__ */ me.jsx(
          ei,
          {
            integrationType: $i,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ me.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ me.jsx(
                he,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ me.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ me.jsxs(P.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  $i,
                  " integration, all links between Dixa and ",
                  $i,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ me.jsxs(P.Paragraph, { children: [
                  "All data in ",
                  $i,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ me.jsxs(P.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  $i,
                  " ",
                  'integration "',
                  Q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_zrl8q_54{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_zrl8q_54:hover,._messageIsOpen_zrl8q_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_zrl8q_65{cursor:pointer}._messageUnattended_zrl8q_68{text-decoration:line-through}._messageLabel_zrl8q_71{color:var(--dixa-typography-color-secondary)}._messageText_zrl8q_74{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_zrl8q_74::-webkit-scrollbar{width:7px;height:7px}._messageText_zrl8q_74::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_zrl8q_74::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_zrl8q_74::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var gm = { exports: {} }, co = {}, xx;
function TL() {
  if (xx) return co;
  xx = 1;
  var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return co.Fragment = r, co.jsx = s, co.jsxs = s, co;
}
var ws = {}, Sx;
function DL() {
  return Sx || (Sx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var g = _.ReactDebugCurrentFrame, E = g.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var $ = !1, C = !1, F = !1, z = !1, Q = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === d || z || t === v || $ || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, N = E._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (E) {
            var g = E.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (ie) {
              g = ie;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var S = ie.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var ue = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = E;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ae(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ae(t.type, c, p);
          case h: {
            var g = t, E = g._payload, O = g._init;
            try {
              return ae(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, p, g, E) {
      {
        var O = Function.call.bind(le);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + p + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe(E), y("Failed %s type: %s", p, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, p, g, E, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, p, g, E) {
      {
        var O, N = {}, S = null, ne = null;
        p !== void 0 && (A(p), S = "" + p), gn(c) && (A(c.key), S = "" + c.key), rn(c) && (ne = c.ref, tn(c));
        for (O in c)
          le.call(c, O) && !oe.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, E, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function An(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = j(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          yn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var E = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, p, g, E, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, p, E, O);
        if (W == null)
          return W;
        if (N) {
          var ue = c.children;
          if (ue !== void 0)
            if (g)
              if (x(ue)) {
                for (var Ue = 0; Ue < ue.length; Ue++)
                  Sn(ue[Ue], t);
                Object.freeze && Object.freeze(ue);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ue, t);
        }
        if (le.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var Rn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, Rn, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, p) {
      return Fn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return Fn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    ws.Fragment = i, ws.jsx = Un, ws.jsxs = Kn;
  })()), ws;
}
var Nx;
function OL() {
  return Nx || (Nx = 1, process.env.NODE_ENV === "production" ? gm.exports = TL() : gm.exports = DL()), gm.exports;
}
var Oe = OL();
function RL({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = _n(), [a, o] = de([]), [s] = i(e, n), [l, u] = de(
    []
  );
  return Je(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const d = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((I) => {
        const w = setTimeout(I, r);
        u([...l, w]);
      });
      const v = await s({
        variables: h
      });
      d.push(v);
    }
    o(d);
  }, a];
}
var FC = /* @__PURE__ */ ((e) => (e.List = "list", e))(FC || {}), ey = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(ey || {}), ny = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(ny || {}), ty = /* @__PURE__ */ ((e) => (e.Unsubscribed = "UNSUBSCRIBED", e))(ty || {});
const PL = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, AL = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, LL = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, VL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, zL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, UL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, ML = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "definition" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_FlowEmail" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, BL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, qL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, HL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "properties" }, { kind: "EnumValue", value: "predictive_analytics" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "predictive_analytics" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "predictive_analytics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "average_order_value" } }, { kind: "Field", name: { kind: "Name", value: "churn_probability" } }, { kind: "Field", name: { kind: "Name", value: "predicted_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_clv" } }, { kind: "Field", name: { kind: "Name", value: "total_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "predicted_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "average_days_between_orders" } }, { kind: "Field", name: { kind: "Name", value: "expected_date_of_next_order" } }, { kind: "Field", name: { kind: "Name", value: "ranked_channel_affinity" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, WL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, KL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_segments_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, GL = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": PL,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": AL,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": VL,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": zL,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": LL,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": UL,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": ML,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": BL,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": qL,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": HL,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": WL,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": KL
};
function fi(e) {
  return GL[e] ?? {};
}
const YL = fi(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), QL = fi(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {
          data {
            id
            type
            attributes {
              definition {
                ... on Klaviyo_FlowEmail {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), JL = fi(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), XL = fi(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), ZL = fi(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          properties
          predictive_analytics
        ]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          predictive_analytics
        ]
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
              properties
              predictive_analytics {
                average_order_value
                churn_probability
                predicted_clv
                historic_clv
                total_clv
                historic_number_of_orders
                predicted_number_of_orders
                average_days_between_orders
                expected_date_of_next_order
                ranked_channel_affinity
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), eV = fi(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_lists_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), nV = fi(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_segments_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), tV = fi(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      bulk_subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), rV = fi(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      bulk_unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function ry(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function jx(e) {
  return ry(e) && e?.attributes?.event_properties?.$message;
}
function iV(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function wx(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function aV(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function oV(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function sV(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function lV(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function cV(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function uV(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function Cx(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function dV(e) {
  return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function mV(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const pV = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function fV(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function hV(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function yV({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = _n(), { track: a } = En(), [o, s] = de(null), [l, u] = de(
    null
  ), [m, d] = de(null), [f, h] = de(null), [v, I] = de(
    null
  ), [w, j] = de([]), {
    data: _,
    error: y,
    loading: L,
    networkStatus: $
  } = i(JL, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    C,
    {
      data: F,
      error: z,
      loading: Q,
      networkStatus: J
    }
  ] = r(YL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Je(() => {
    if (_ && !L && $ === dr.ready) {
      const te = aV(_);
      s(
        te.find((G) => G?.attributes?.name === "Received Email")?.id || null
      ), u(
        te.find((G) => G?.attributes?.name === "Opened Email")?.id || null
      ), d(
        te.find((G) => G?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        te.find((G) => G?.attributes?.name === "Bounced Email")?.id || null
      ), I(
        te.find((G) => G?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), u(null), d(null), h(null), I(null);
  }, [_]), Je(() => {
    o && l && m && f && v && !Q && J === dr.ready ? C({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${v}")`,
        pageSize: n
      }
    }) : j([]);
  }, [
    o,
    l,
    m,
    f,
    v
  ]), Je(() => {
    if (!Q && F) {
      const te = oV(F), G = lV(
        F
      ).map(
        (fe) => fe?.attributes?.event_properties.$message
      ), B = cV(
        F
      ).map(
        (fe) => fe?.attributes?.event_properties.$message
      );
      te.forEach((fe) => {
        const ye = fe.attributes?.event_properties.$message;
        fe.opened = G.includes(ye), fe.clicked = B.includes(ye);
      });
      const R = sV(F), U = uV(F), ee = [
        ...te,
        ...U,
        ...R
      ].sort((fe, ye) => {
        const ve = wx(fe), K = wx(ye);
        return ve == null && K == null ? 0 : ve == null ? 1 : K == null ? -1 : K - ve;
      }).slice(0, n);
      j(ee);
      const Se = ee.map((fe) => fe.id);
      a("klaviyo:messages:received", {
        emailsReceived: te.filter(
          (fe) => Se.includes(fe.id)
        ).length,
        emailsBounced: U.filter(
          (fe) => Se.includes(fe.id)
        ).length,
        smsReceived: R.filter(
          (fe) => Se.includes(fe.id)
        ).length,
        total: Se.length
      });
    } else
      j([]);
  }, [Q, F]), Xn(
    () => ({
      receivedMessages: w,
      isLoading: L || Q,
      error: y || z
    }),
    [
      w,
      L,
      Q,
      y,
      z
    ]
  );
}
function gV({ profileId: e }) {
  const { useQuery: n } = _n(), [r, i] = de(), [a, o] = de(), {
    data: s,
    error: l,
    loading: u,
    refetch: m
  } = n(ZL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  Je(() => {
    l && o(l);
  }, [l]), Je(() => {
    !u && s && i(s.Klaviyo.get_profile);
  }, [u, s]);
  const d = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Xn(
    () => ({
      profile: r,
      refetchProfile: d,
      isLoading: u,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, u, a]
  );
}
function vV({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = En(), { useLazyQuery: i } = _n(), [a, o] = de(), [s, l] = de(), [
    u,
    { data: m, error: d, loading: f }
  ] = i(XL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Je(() => {
    if (!f && m) {
      const v = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, I = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(v, I);
    }
  }, [f, m]);
  const h = (v, I) => {
    const w = v?.data?.length === 1 && v.data[0]?.id || void 0, j = I?.data?.length === 1 && I.data[0]?.id || void 0, _ = w || j, y = !w || !j || w === j;
    if (_ && y) {
      o(w || j), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), y || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${w}) and phone number ${n} (profile ID ${j}).`
      )
    );
  };
  return Xn(
    () => ({
      profileId: a,
      getProfileId: u,
      isLoading: f,
      error: d || s
    }),
    [a, u, f, d, s]
  );
}
const Fx = 800, kV = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, bV = 3, _V = 1.5, xV = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = bV,
  useDelayRange: a = !1
}) => {
  const o = (z) => Math.floor(Math.random() * (z.max - z.min) + z.min), [s, l] = de(0), [u, m] = de(n || Fx), [d, f] = de(r || kV), [h, v] = de(!1), [I, w] = de(!1), j = a || !!r, _ = j ? o(d) : n || Fx, [y, L] = de(_);
  hP(
    async () => {
      const z = s + 1, Q = _V ** z;
      l(z), L(
        (j ? o(d) : u) * Q
      ), await e().then(() => {
        w(!0), F();
      });
    },
    h ? y : null
  ), gP(() => F());
  const $ = ft(() => {
    l(0), L(_);
  }, [_]), C = ft(
    (z = {}) => {
      const { delay: Q, delayRange: J } = z;
      w(!1), $(), J && (f(J), L(o(J))), Q && (m(Q), L(Q)), v(!0);
    },
    [$]
  ), F = ft(() => {
    v(!1), $();
  }, [$]);
  return Je(() => {
    s >= i && F();
  }, [s, i, F]), Xn(
    () => ({ isRunning: h, isSuccessful: I, start: C, stop: F }),
    [h, I, C, F]
  );
}, SV = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, NV = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function jV({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = _n(), [i, a] = de(), [o, s] = de(), {
    data: l,
    error: u,
    loading: m,
    refetch: d,
    networkStatus: f
  } = r(
    n === "lists" ? eV : nV,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: v,
    stop: I
  } = xV({
    query: d,
    useDelayRange: !0
  }), w = m || h;
  return Je(() => {
    if (u)
      if (KI({
        errors: u.graphQLErrors
      })) {
        if (!h) {
          const j = SV(u);
          v({
            ...j && {
              delayRange: NV(j)
            }
          });
        }
      } else
        s(u);
  }, [u]), Je(() => {
    if (!m && l?.Klaviyo) {
      let j = {}, _ = {};
      n === "lists" && (j = l?.Klaviyo?.get_lists_for_profile), n === "segments" && (_ = l?.Klaviyo?.get_segments_for_profile), (j?.data || _?.data) && (I(), a(
        (n === "lists" ? j?.data : _?.data)?.map((y) => ({
          ...y,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), Xn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: v,
      isLoading: w,
      error: o,
      networkStatus: f
    }),
    [i, w, o, f, v]
  );
}
const wV = "_notificationText_1polx_1", _g = {
  notificationText: wV
}, tc = ({ error: e }) => {
  const { track: n } = En();
  let r = e;
  if (e1(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && Hw({ error: i[0] }), o = i.length === 1 && HI({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ Oe.jsx(Tn, { error: e });
  }
  return /* @__PURE__ */ Oe.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ Oe.jsx(
    Qe.Item,
    {
      contentLeft: /* @__PURE__ */ Oe.jsx(he, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, CV = "_message_zrl8q_54", FV = "_messageIsOpen_zrl8q_62", IV = "_messageHeader_zrl8q_65", EV = "_messageLabel_zrl8q_71", $V = "_messageText_zrl8q_74", Sa = {
  message: CV,
  messageIsOpen: FV,
  messageHeader: IV,
  messageLabel: EV,
  messageText: $V
}, TV = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && dV(e.flowMessage);
  return /* @__PURE__ */ Oe.jsxs(Oe.Fragment, { children: [
    /* @__PURE__ */ Oe.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ Oe.jsx(P.Paragraph, { variant: "4", className: Sa.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ Oe.jsx(P.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ Oe.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ Oe.jsx(vn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ Oe.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ Oe.jsx(b, { children: /* @__PURE__ */ Oe.jsx(
            P.Paragraph,
            {
              variant: "4",
              className: Sa.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ Oe.jsx(P.Paragraph, { variant: "4", className: Sa.messageText, children: i })
        ]
      }
    )
  ] });
}, DV = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ Oe.jsx(Oe.Fragment, { children: /* @__PURE__ */ Oe.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ Oe.jsx(b, { children: /* @__PURE__ */ Oe.jsx(P.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ Oe.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, OV = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = de(r), { attributes: o, eventType: s } = e, l = o?.datetime, u = o?.timestamp, m = "DD MMM YYYY @ HH:mm", d = Xn(
    () => () => l ? Qn(l).format(m) : u ? Qn.unix(u).format(m) : null,
    [u, l]
  )(), f = s === "EMAIL", h = s === "SMS", v = f && e.opened, I = f && e.clicked, w = f && o?.event_properties.Subject, j = h && o?.event_properties["Message Name"], _ = f ? "mail" : "sms";
  return /* @__PURE__ */ Oe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: dt(Sa.message, {
        [Sa.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ Oe.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: Sa.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ Oe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Oe.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ Oe.jsx(he, { size: 16, name: _ }),
                  " ",
                  pV(s),
                  d && /* @__PURE__ */ Oe.jsx(Bn, { size: "small", variant: "info", children: d })
                ] }),
                w && w,
                j && j
              ] }),
              /* @__PURE__ */ Oe.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ Oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ Oe.jsx(Dy, {}),
          iV(e) && /* @__PURE__ */ Oe.jsx(b, { children: /* @__PURE__ */ Oe.jsx(Bn, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ Oe.jsxs(Oe.Fragment, { children: [
            /* @__PURE__ */ Oe.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ Oe.jsx(Yn, { children: /* @__PURE__ */ Oe.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Oe.jsx(
                  he,
                  {
                    size: 16,
                    color: v ? "green.400" : "red.400",
                    name: v ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ Oe.jsx(Yn, { children: /* @__PURE__ */ Oe.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Oe.jsx(
                  he,
                  {
                    size: 16,
                    color: I ? "green.400" : "red.400",
                    name: I ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ Oe.jsx(TV, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ Oe.jsx(DV, { event: e })
        ] })
      ]
    }
  );
}, RV = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, PV = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = de(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = yV({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, u] = RL({
    query: QL,
    options: RV,
    delayMs: 1e3
  }), [m, d] = de([]);
  Je(() => {
    if (a.length > 0) {
      d(a);
      const h = a.filter((v) => ry(v)).map((v) => jx(v));
      h.length > 0 && (i(!0), l(
        h.map((v) => ({
          messageId: v
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), Je(() => {
    u.length > 0 && d(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && ry(h) && !h.flowMessage) {
          const v = jx(h), I = u.find((j) => (j.data && Cx(j.data))?.id === v), w = I?.data && Cx(I.data);
          if (w)
            return {
              ...mV(h),
              flowMessage: w
            };
        }
        return h;
      })
    );
  }, [u]);
  const f = [];
  return s && f.push(s), u.length > 0 && f.push(
    ...u.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ Oe.jsx(Oe.Fragment, { children: f.map((h, v) => h.graphQLErrors ? /* @__PURE__ */ Oe.jsx(
    Tn,
    {
      error: h
    },
    `lastMessagesError${v}`
  ) : /* @__PURE__ */ Oe.jsx(
    tc,
    {
      error: h
    },
    `lastMessagesError${v}`
  )) }) : /* @__PURE__ */ Oe.jsxs(Oe.Fragment, { children: [
    /* @__PURE__ */ Oe.jsx(P.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ Oe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Oe.jsx(vn, {}) }) : /* @__PURE__ */ Oe.jsx(Oe.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ Oe.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, v) => /* @__PURE__ */ Oe.jsx(
      OV,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: v === 0
      },
      h.id
    )) }) : /* @__PURE__ */ Oe.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: _g.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, AV = "_list_ld0hf_1", LV = "_listItem_ld0hf_4", mi = {
  list: AV,
  listItem: LV
}, VV = ({
  profile: e
}) => {
  const n = e?.data?.attributes?.properties, r = Object.entries(
    n ?? {}
  ).filter(([a, o]) => a !== "__typename" && o != null), i = r.length > 0;
  return /* @__PURE__ */ Oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Oe.jsx(P.Heading, { variant: "heading-3", children: "Custom properties" }),
    !i && /* @__PURE__ */ Oe.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom properties available" }),
    i && /* @__PURE__ */ Oe.jsx(Qe, { className: mi.list, children: r.map(([a, o]) => typeof o == "boolean" || typeof o == "string" || typeof o == "number" || Array.isArray(o) && o.every((s) => typeof s == "string") ? /* @__PURE__ */ Oe.jsx(Qe.Text, { variant: "dense", className: mi.listItem, children: /* @__PURE__ */ Oe.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "200",
        children: [
          /* @__PURE__ */ Oe.jsx(P.Paragraph, { variant: "4", children: WI(a) }),
          /* @__PURE__ */ Oe.jsx(
            b,
            {
              style: { flex: 1, minWidth: 0 },
              justifyContent: "flex-end",
              children: Gi(o)
            }
          )
        ]
      }
    ) }, a) : null) })
  ] });
}, Ix = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = de(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: u
  } = jV({ profileId: e, query: n });
  Je(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || u();
  }, d = a || [];
  return o ? /* @__PURE__ */ Oe.jsx(tc, { error: o }) : s ? /* @__PURE__ */ Oe.jsx(Qe.Text, { variant: "dense", className: mi.listItem, children: /* @__PURE__ */ Oe.jsx(vn, { size: 14 }) }, "loading") : d.length > 0 ? /* @__PURE__ */ Oe.jsx(Oe.Fragment, { children: d.map(
    ({ attributes: f, type: h }, v) => /* @__PURE__ */ Oe.jsx(Qe.Text, { variant: "dense", className: mi.listItem, children: /* @__PURE__ */ Oe.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ Oe.jsx(P.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ Oe.jsx(Yn, { children: Ww(h) })
    ] }) }, v)
  ) }) : r && !a ? /* @__PURE__ */ Oe.jsx(Qe.Text, { variant: "dense", className: mi.listItem, children: /* @__PURE__ */ Oe.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ Oe.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Oe.jsx(he, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ Oe.jsxs(P.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ Oe.jsx(Xe, { content: "Refresh lists and segments", children: /* @__PURE__ */ Oe.jsx(nt, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ Oe.jsx(Qe.Text, { variant: "dense", className: mi.listItem, children: /* @__PURE__ */ Oe.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ Oe.jsx(P.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ Oe.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, zV = 0.7, UV = 0.3, MV = (e) => e >= zV ? { variant: "error", label: "High risk" } : e >= UV ? { variant: "warning", label: "Medium risk" } : { variant: "success", label: "Low risk" }, BV = (e) => /* @__PURE__ */ Oe.jsx(P.Paragraph, { as: "span", variant: "4", children: e.toFixed(2) }), qV = (e) => {
  const n = MV(e);
  return /* @__PURE__ */ Oe.jsxs(b, { alignItems: "center", gap: "100", children: [
    /* @__PURE__ */ Oe.jsx(Bn, { size: "small", variant: n.variant, children: n.label }),
    /* @__PURE__ */ Oe.jsx(P.Paragraph, { as: "span", variant: "4", children: `${(e * 100).toFixed(1)}%` })
  ] });
}, HV = (e) => {
  const n = e?.data?.attributes?.predictive_analytics ?? null;
  if (!n)
    return [];
  const r = [
    ["Average order value", n.average_order_value],
    ["Historic lifetime value", n.historic_clv],
    ["Predicted lifetime value", n.predicted_clv],
    ["Total lifetime value", n.total_clv]
  ], i = [
    ["Historic orders", n.historic_number_of_orders],
    ["Predicted orders", n.predicted_number_of_orders],
    [
      "Average days between orders",
      n.average_days_between_orders
    ],
    ["Expected next order", n.expected_date_of_next_order]
  ], a = n.churn_probability, o = n.ranked_channel_affinity?.filter(Boolean) ?? null;
  return [
    ...r.flatMap(
      ([s, l]) => l ? [{ label: s, content: BV(l) }] : []
    ),
    ...i.flatMap(
      ([s, l]) => l ? [{ label: s, content: Gi(l) }] : []
    ),
    ...a ? [
      {
        label: "Churn probability",
        content: qV(a)
      }
    ] : [],
    ...o?.length ? [
      {
        label: "Channel affinity",
        content: Gi(o)
      }
    ] : []
  ];
}, WV = ({
  profile: e
}) => {
  const n = HV(e);
  return /* @__PURE__ */ Oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Oe.jsx(P.Heading, { variant: "heading-3", children: "Predictive analytics" }),
    n.length === 0 && /* @__PURE__ */ Oe.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No predictive analytics available" }),
    n.length > 0 && /* @__PURE__ */ Oe.jsx(Qe, { className: mi.list, children: n.map(({ label: r, content: i }) => /* @__PURE__ */ Oe.jsx(Qe.Text, { variant: "dense", className: mi.listItem, children: /* @__PURE__ */ Oe.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "200",
        children: [
          /* @__PURE__ */ Oe.jsx(P.Paragraph, { as: "span", variant: "4", children: r }),
          i
        ]
      }
    ) }, r)) })
  ] });
}, KV = "_tagHover_kzbzk_1", GV = "_channelUnsubscribed_kzbzk_6", Ex = {
  tagHover: KV,
  channelUnsubscribed: GV
}, $x = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ Oe.jsx(
    Xe,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ Oe.jsx(
        Yn,
        {
          className: Ex.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ Oe.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: dt({
                [Ex.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ Oe.jsx(vn, { size: 16 }) : /* @__PURE__ */ Oe.jsx(he, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, YV = "_subscriptionError_1qhhx_1", QV = {
  subscriptionError: YV
}, JV = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = de(!1), [u, m] = de(!1), [d, f] = de(), { track: h } = En(), [v, I] = yP({
    channel: null,
    request: null
  }), w = fV(n), j = hV(n), _ = !!e, { useMutation: y } = _n(), [L] = y(
    tV
  ), [$] = y(
    rV
  ), C = (Q) => {
    h("klaviyo:profile:subscribe:clicked", { channel: Q }), I.setAll({
      channel: Q,
      request: "subscribed"
    }), ((J) => L({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: ey.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...J === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: ny.Subscribed
                        }
                      }
                    },
                    ...J === "SMS" && {
                      sms: {
                        marketing: {
                          consent: ny.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: FC.List,
              id: e
            }
          }
        }
      }
    }))(Q).then(
      (J) => z({
        channel: Q,
        mutationResponse: J,
        isSubscriptionRequest: !0
      })
    ).catch(
      (J) => z({
        channel: Q,
        mutationErrorResponse: J,
        isSubscriptionRequest: !0
      })
    );
  }, F = (Q) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: Q }), I.setAll({
      channel: Q,
      request: "unsubscribed"
    }), $({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: ey.Profile,
                attributes: {
                  ...Q === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...Q === "SMS" ? { phone_number: i } : {},
                  subscriptions: {
                    ...Q === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: ty.Unsubscribed
                        }
                      }
                    },
                    ...Q === "SMS" && {
                      sms: {
                        marketing: {
                          consent: ty.Unsubscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }).then(
      (J) => z({
        channel: Q,
        mutationResponse: J,
        isSubscriptionRequest: !1
      })
    ).catch(
      (J) => z({
        channel: Q,
        mutationErrorResponse: J,
        isSubscriptionRequest: !1
      })
    );
  }, z = async ({
    channel: Q,
    mutationResponse: J,
    mutationErrorResponse: te,
    isSubscriptionRequest: G
  }) => {
    const B = te?.networkError, R = B ? B?.statusCode : NaN, U = J?.errors, ee = !!U && Kw({
      errors: U
    });
    R === 202 ? (h(
      G ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: Q }
    ), await o()) : ee ? (h(
      G ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Q,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${G ? "opt-in" : "opt-out"}.`
    )) : (h(
      G ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Q,
        reason: B?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${G ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return Je(() => {
    if (v.request === "subscribed") {
      const Q = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${v.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      v.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(Q), I.reset()), v.channel === "SMS" && !u && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(Q), I.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    u
  ]), /* @__PURE__ */ Oe.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ Oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ Oe.jsx(P.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ Oe.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ Oe.jsx(
            $x,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: w,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: _,
              handleAction: () => {
                l(!0), f(void 0), w ? F("EMAIL") : C("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ Oe.jsx(
            $x,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: u,
              isSubscribed: j,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: _,
              handleAction: () => {
                m(!0), f(void 0), j ? F("SMS") : C("SMS");
              }
            }
          )
        ] }),
        d && /* @__PURE__ */ Oe.jsx(b, { className: QV.subscriptionError, children: d })
      ] })
    }
  );
}, XV = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  showCustomProperties: s,
  showPredictiveAnalytics: l,
  noOfMessagesToShow: u,
  subscriptionListId: m
}) => {
  const {
    profile: d,
    error: f,
    isLoading: h,
    refetchProfile: v
  } = gV({ profileId: e });
  return f ? /* @__PURE__ */ Oe.jsx(tc, { error: f }) : h ? /* @__PURE__ */ Oe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Oe.jsx(vn, {}) }) : !d && !h ? /* @__PURE__ */ Oe.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: _g.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ Oe.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ Oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ Oe.jsx(P.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ Oe.jsxs(Qe, { className: mi.list, children: [
        i && /* @__PURE__ */ Oe.jsx(Ix, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ Oe.jsx(
          Ix,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    d && e && o && /* @__PURE__ */ Oe.jsx(
      JV,
      {
        profile: d,
        profileId: e,
        subscriptionListId: m,
        refetchProfile: v,
        email: n,
        phoneNumber: r
      }
    ),
    d && l && /* @__PURE__ */ Oe.jsx(WV, { profile: d }),
    d && s && /* @__PURE__ */ Oe.jsx(VV, { profile: d }),
    /* @__PURE__ */ Oe.jsx(
      PV,
      {
        profileId: e,
        noOfMessagesToShow: u
      }
    )
  ] });
}, ZV = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = n?.showCustomProperties, u = n?.showPredictiveAnalytics, m = Number(n?.noOfMessagesToShow), d = n?.subscriptionListId, {
    profileId: f,
    getProfileId: h,
    isLoading: v,
    error: I
  } = vV({ email: r, phoneNumber: i });
  return aE(() => {
    (r || i) && h({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ Oe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : v ? /* @__PURE__ */ Oe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Oe.jsx(vn, {}) }) : I ? /* @__PURE__ */ Oe.jsx(tc, { error: I }) : f ? /* @__PURE__ */ Oe.jsx(
    XV,
    {
      profileId: f,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      showCustomProperties: l,
      showPredictiveAnalytics: u,
      noOfMessagesToShow: m,
      subscriptionListId: d
    }
  ) : /* @__PURE__ */ Oe.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: _g.notificationText,
      children: "No profile ID found"
    }
  );
}, e3 = [
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showCustomProperties",
    label: "Show custom properties for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPredictiveAnalytics",
    label: "Show predictive analytics for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: qI
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
], n3 = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Oa
  }
], t3 = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
];
function r3(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const i3 = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, a3 = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, o3 = {};
function Tx(e, n) {
  return (o3.jsx ? a3 : i3).test(e);
}
const s3 = /[ \t\n\f\r]/g;
function l3(e) {
  return typeof e == "object" ? e.type === "text" ? Dx(e.value) : !1 : Dx(e);
}
function Dx(e) {
  return e.replace(s3, "") === "";
}
class ss {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
ss.prototype.property = {};
ss.prototype.normal = {};
ss.prototype.space = null;
function IC(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new ss(r, i, n);
}
function iy(e) {
  return e.toLowerCase();
}
class Sr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
Sr.prototype.space = null;
Sr.prototype.boolean = !1;
Sr.prototype.booleanish = !1;
Sr.prototype.overloadedBoolean = !1;
Sr.prototype.number = !1;
Sr.prototype.commaSeparated = !1;
Sr.prototype.spaceSeparated = !1;
Sr.prototype.commaOrSpaceSeparated = !1;
Sr.prototype.mustUseProperty = !1;
Sr.prototype.defined = !1;
let c3 = 0;
const On = na(), Nt = na(), EC = na(), Ye = na(), lt = na(), Na = na(), pr = na();
function na() {
  return 2 ** ++c3;
}
const ay = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: On,
  booleanish: Nt,
  commaOrSpaceSeparated: pr,
  commaSeparated: Na,
  number: Ye,
  overloadedBoolean: EC,
  spaceSeparated: lt
}, Symbol.toStringTag, { value: "Module" })), vm = Object.keys(ay);
class xg extends Sr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), Ox(this, "space", a), typeof i == "number")
      for (; ++o < vm.length; ) {
        const s = vm[o];
        Ox(this, vm[o], (i & ay[s]) === ay[s]);
      }
  }
}
xg.prototype.defined = !0;
function Ox(e, n, r) {
  r && (e[n] = r);
}
const u3 = {}.hasOwnProperty;
function Ba(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (u3.call(e.properties, i)) {
      const a = e.properties[i], o = new xg(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[iy(i)] = i, r[iy(o.attribute)] = i;
    }
  return new ss(n, r, e.space);
}
const $C = Ba({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), TC = Ba({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function DC(e, n) {
  return n in e ? e[n] : n;
}
function OC(e, n) {
  return DC(e, n.toLowerCase());
}
const RC = Ba({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: OC,
  properties: { xmlns: null, xmlnsXLink: null }
}), PC = Ba({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Nt,
    ariaAutoComplete: null,
    ariaBusy: Nt,
    ariaChecked: Nt,
    ariaColCount: Ye,
    ariaColIndex: Ye,
    ariaColSpan: Ye,
    ariaControls: lt,
    ariaCurrent: null,
    ariaDescribedBy: lt,
    ariaDetails: null,
    ariaDisabled: Nt,
    ariaDropEffect: lt,
    ariaErrorMessage: null,
    ariaExpanded: Nt,
    ariaFlowTo: lt,
    ariaGrabbed: Nt,
    ariaHasPopup: null,
    ariaHidden: Nt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: lt,
    ariaLevel: Ye,
    ariaLive: null,
    ariaModal: Nt,
    ariaMultiLine: Nt,
    ariaMultiSelectable: Nt,
    ariaOrientation: null,
    ariaOwns: lt,
    ariaPlaceholder: null,
    ariaPosInSet: Ye,
    ariaPressed: Nt,
    ariaReadOnly: Nt,
    ariaRelevant: null,
    ariaRequired: Nt,
    ariaRoleDescription: lt,
    ariaRowCount: Ye,
    ariaRowIndex: Ye,
    ariaRowSpan: Ye,
    ariaSelected: Nt,
    ariaSetSize: Ye,
    ariaSort: null,
    ariaValueMax: Ye,
    ariaValueMin: Ye,
    ariaValueNow: Ye,
    ariaValueText: null,
    role: null
  }
}), d3 = Ba({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: OC,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Na,
    acceptCharset: lt,
    accessKey: lt,
    action: null,
    allow: null,
    allowFullScreen: On,
    allowPaymentRequest: On,
    allowUserMedia: On,
    alt: null,
    as: null,
    async: On,
    autoCapitalize: null,
    autoComplete: lt,
    autoFocus: On,
    autoPlay: On,
    blocking: lt,
    capture: null,
    charSet: null,
    checked: On,
    cite: null,
    className: lt,
    cols: Ye,
    colSpan: null,
    content: null,
    contentEditable: Nt,
    controls: On,
    controlsList: lt,
    coords: Ye | Na,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: On,
    defer: On,
    dir: null,
    dirName: null,
    disabled: On,
    download: EC,
    draggable: Nt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: On,
    formTarget: null,
    headers: lt,
    height: Ye,
    hidden: On,
    high: Ye,
    href: null,
    hrefLang: null,
    htmlFor: lt,
    httpEquiv: lt,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: On,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: On,
    itemId: null,
    itemProp: lt,
    itemRef: lt,
    itemScope: On,
    itemType: lt,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: On,
    low: Ye,
    manifest: null,
    max: null,
    maxLength: Ye,
    media: null,
    method: null,
    min: null,
    minLength: Ye,
    multiple: On,
    muted: On,
    name: null,
    nonce: null,
    noModule: On,
    noValidate: On,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: On,
    optimum: Ye,
    pattern: null,
    ping: lt,
    placeholder: null,
    playsInline: On,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: On,
    referrerPolicy: null,
    rel: lt,
    required: On,
    reversed: On,
    rows: Ye,
    rowSpan: Ye,
    sandbox: lt,
    scope: null,
    scoped: On,
    seamless: On,
    selected: On,
    shadowRootClonable: On,
    shadowRootDelegatesFocus: On,
    shadowRootMode: null,
    shape: null,
    size: Ye,
    sizes: null,
    slot: null,
    span: Ye,
    spellCheck: Nt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ye,
    step: null,
    style: null,
    tabIndex: Ye,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: On,
    useMap: null,
    value: Nt,
    width: Ye,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: lt,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ye,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ye,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: On,
    // Lists. Use CSS to reduce space between items instead
    declare: On,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ye,
    // `<img>` and `<object>`
    leftMargin: Ye,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ye,
    // `<body>`
    marginWidth: Ye,
    // `<body>`
    noResize: On,
    // `<frame>`
    noHref: On,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: On,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: On,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ye,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Nt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ye,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ye,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: On,
    disableRemotePlayback: On,
    prefix: null,
    property: null,
    results: Ye,
    security: null,
    unselectable: null
  }
}), m3 = Ba({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: DC,
  properties: {
    about: pr,
    accentHeight: Ye,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ye,
    amplitude: Ye,
    arabicForm: null,
    ascent: Ye,
    attributeName: null,
    attributeType: null,
    azimuth: Ye,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ye,
    by: null,
    calcMode: null,
    capHeight: Ye,
    className: lt,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ye,
    diffuseConstant: Ye,
    direction: null,
    display: null,
    dur: null,
    divisor: Ye,
    dominantBaseline: null,
    download: On,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ye,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ye,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ye,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Na,
    g2: Na,
    glyphName: Na,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ye,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ye,
    horizOriginX: Ye,
    horizOriginY: Ye,
    id: null,
    ideographic: Ye,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ye,
    k: Ye,
    k1: Ye,
    k2: Ye,
    k3: Ye,
    k4: Ye,
    kernelMatrix: pr,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ye,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ye,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ye,
    overlineThickness: Ye,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ye,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: lt,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ye,
    pointsAtY: Ye,
    pointsAtZ: Ye,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: pr,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: pr,
    rev: pr,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: pr,
    requiredFeatures: pr,
    requiredFonts: pr,
    requiredFormats: pr,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ye,
    specularExponent: Ye,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ye,
    strikethroughThickness: Ye,
    string: null,
    stroke: null,
    strokeDashArray: pr,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ye,
    strokeOpacity: Ye,
    strokeWidth: null,
    style: null,
    surfaceScale: Ye,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: pr,
    tabIndex: Ye,
    tableValues: null,
    target: null,
    targetX: Ye,
    targetY: Ye,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: pr,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ye,
    underlineThickness: Ye,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ye,
    values: null,
    vAlphabetic: Ye,
    vMathematical: Ye,
    vectorEffect: null,
    vHanging: Ye,
    vIdeographic: Ye,
    version: null,
    vertAdvY: Ye,
    vertOriginX: Ye,
    vertOriginY: Ye,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ye,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), p3 = /^data[-\w.:]+$/i, Rx = /-[a-z]/g, f3 = /[A-Z]/g;
function h3(e, n) {
  const r = iy(n);
  let i = n, a = Sr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && p3.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(Rx, g3);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!Rx.test(o)) {
        let s = o.replace(f3, y3);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = xg;
  }
  return new a(i, n);
}
function y3(e) {
  return "-" + e.toLowerCase();
}
function g3(e) {
  return e.charAt(1).toUpperCase();
}
const v3 = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, k3 = IC([TC, $C, RC, PC, d3], "html"), Sg = IC([TC, $C, RC, PC, m3], "svg");
function b3(e) {
  return e.join(" ").trim();
}
var la = {}, km, Px;
function _3() {
  if (Px) return km;
  Px = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, u = `
`, m = "/", d = "*", f = "", h = "comment", v = "declaration";
  km = function(w, j) {
    if (typeof w != "string")
      throw new TypeError("First argument must be a string");
    if (!w) return [];
    j = j || {};
    var _ = 1, y = 1;
    function L(R) {
      var U = R.match(n);
      U && (_ += U.length);
      var ee = R.lastIndexOf(u);
      y = ~ee ? R.length - ee : y + R.length;
    }
    function $() {
      var R = { line: _, column: y };
      return function(U) {
        return U.position = new C(R), Q(), U;
      };
    }
    function C(R) {
      this.start = R, this.end = { line: _, column: y }, this.source = j.source;
    }
    C.prototype.content = w;
    function F(R) {
      var U = new Error(
        j.source + ":" + _ + ":" + y + ": " + R
      );
      if (U.reason = R, U.filename = j.source, U.line = _, U.column = y, U.source = w, !j.silent) throw U;
    }
    function z(R) {
      var U = R.exec(w);
      if (U) {
        var ee = U[0];
        return L(ee), w = w.slice(ee.length), U;
      }
    }
    function Q() {
      z(r);
    }
    function J(R) {
      var U;
      for (R = R || []; U = te(); )
        U !== !1 && R.push(U);
      return R;
    }
    function te() {
      var R = $();
      if (!(m != w.charAt(0) || d != w.charAt(1))) {
        for (var U = 2; f != w.charAt(U) && (d != w.charAt(U) || m != w.charAt(U + 1)); )
          ++U;
        if (U += 2, f === w.charAt(U - 1))
          return F("End of comment missing");
        var ee = w.slice(2, U - 2);
        return y += 2, L(ee), w = w.slice(U), y += 2, R({
          type: h,
          comment: ee
        });
      }
    }
    function G() {
      var R = $(), U = z(i);
      if (U) {
        if (te(), !z(a)) return F("property missing ':'");
        var ee = z(o), Se = R({
          type: v,
          property: I(U[0].replace(e, f)),
          value: ee ? I(ee[0].replace(e, f)) : f
        });
        return z(s), Se;
      }
    }
    function B() {
      var R = [];
      J(R);
      for (var U; U = G(); )
        U !== !1 && (R.push(U), J(R));
      return R;
    }
    return Q(), B();
  };
  function I(w) {
    return w ? w.replace(l, f) : f;
  }
  return km;
}
var Ax;
function x3() {
  if (Ax) return la;
  Ax = 1;
  var e = la && la.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(la, "__esModule", { value: !0 }), la.default = r;
  var n = e(_3());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(u) {
      if (u.type === "declaration") {
        var m = u.property, d = u.value;
        l ? a(m, d, u) : d && (o = o || {}, o[m] = d);
      }
    }), o;
  }
  return la;
}
var S3 = x3();
const Lx = /* @__PURE__ */ Ay(S3), N3 = Lx.default || Lx, AC = LC("end"), Ng = LC("start");
function LC(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function j3(e) {
  const n = Ng(e), r = AC(e);
  if (n && r)
    return { start: n, end: r };
}
function zo(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Vx(e.position) : "start" in e || "end" in e ? Vx(e) : "line" in e || "column" in e ? oy(e) : "";
}
function oy(e) {
  return zx(e && e.line) + ":" + zx(e && e.column);
}
function Vx(e) {
  return oy(e && e.start) + "-" + oy(e && e.end);
}
function zx(e) {
  return e && typeof e == "number" ? e : 1;
}
class Yt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const u = i.indexOf(":");
      u === -1 ? o.ruleId = i : (o.source = i.slice(0, u), o.ruleId = i.slice(u + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const u = o.ancestors[o.ancestors.length - 1];
      u && (o.place = u.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = zo(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Yt.prototype.file = "";
Yt.prototype.name = "";
Yt.prototype.reason = "";
Yt.prototype.message = "";
Yt.prototype.stack = "";
Yt.prototype.column = void 0;
Yt.prototype.line = void 0;
Yt.prototype.ancestors = void 0;
Yt.prototype.cause = void 0;
Yt.prototype.fatal = void 0;
Yt.prototype.place = void 0;
Yt.prototype.ruleId = void 0;
Yt.prototype.source = void 0;
const jg = {}.hasOwnProperty, w3 = /* @__PURE__ */ new Map(), C3 = /[A-Z]/g, F3 = /-([a-z])/g, I3 = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), E3 = /* @__PURE__ */ new Set(["td", "th"]), VC = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function $3(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = V3(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = L3(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? Sg : k3,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = zC(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function zC(e, n, r) {
  if (n.type === "element")
    return T3(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return D3(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return R3(e, n, r);
  if (n.type === "mdxjsEsm")
    return O3(e, n);
  if (n.type === "root")
    return P3(e, n, r);
  if (n.type === "text")
    return A3(e, n);
}
function T3(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = Sg, e.schema = a), e.ancestors.push(n);
  const o = MC(e, n.tagName, !1), s = z3(e, n);
  let l = Cg(e, n);
  return I3.has(n.tagName) && (l = l.filter(function(u) {
    return typeof u == "string" ? !l3(u) : !0;
  })), UC(e, s, o, n), wg(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function D3(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Zo(e, n.position);
}
function O3(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Zo(e, n.position);
}
function R3(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = Sg, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : MC(e, n.name, !0), s = U3(e, n), l = Cg(e, n);
  return UC(e, s, o, n), wg(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function P3(e, n, r) {
  const i = {};
  return wg(i, Cg(e, n)), e.create(n, e.Fragment, i, r);
}
function A3(e, n) {
  return n.value;
}
function UC(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function wg(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function L3(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? r : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function V3(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), u = Ng(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: u ? u.column - 1 : void 0,
        fileName: e,
        lineNumber: u ? u.line : void 0
      },
      void 0
    );
  }
}
function z3(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && jg.call(n.properties, a)) {
      const o = M3(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && E3.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function U3(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Zo(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Zo(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function Cg(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : w3;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const u = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (u) {
        const m = a.get(u) || 0;
        s = u + "-" + m, a.set(u, m + 1);
      }
    }
    const l = zC(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function M3(e, n, r) {
  const i = h3(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? r3(r) : b3(r)), i.property === "style") {
      let a = typeof r == "object" ? r : B3(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = q3(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? v3[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function B3(e, n) {
  const r = {};
  try {
    N3(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Yt("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = VC + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(F3, W3)), r[s] = o;
  }
}
function MC(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = Tx(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = Tx(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return jg.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Zo(e);
}
function Zo(e, n) {
  const r = new Yt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = VC + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function q3(e) {
  const n = {};
  let r;
  for (r in e)
    jg.call(e, r) && (n[H3(r)] = e[r]);
  return n;
}
function H3(e) {
  let n = e.replace(C3, K3);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function W3(e, n) {
  return n.toUpperCase();
}
function K3(e) {
  return "-" + e.toLowerCase();
}
const bm = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, G3 = {};
function Y3(e, n) {
  const r = G3, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return BC(e, i, a);
}
function BC(e, n, r) {
  if (Q3(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Ux(e.children, n, r);
  }
  return Array.isArray(e) ? Ux(e, n, r) : "";
}
function Ux(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = BC(e[a], n, r);
  return i.join("");
}
function Q3(e) {
  return !!(e && typeof e == "object");
}
const Mx = document.createElement("i");
function Fg(e) {
  const n = "&" + e + ";";
  Mx.innerHTML = n;
  const r = Mx.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Kr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function br(e, n) {
  return e.length > 0 ? (Kr(e, e.length, 0, n), e) : n;
}
const Bx = {}.hasOwnProperty;
function J3(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    X3(n, e[r]);
  return n;
}
function X3(e, n) {
  let r;
  for (r in n) {
    const a = (Bx.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        Bx.call(a, s) || (a[s] = []);
        const l = o[s];
        Z3(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function Z3(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Kr(e, 0, 0, i);
}
function qC(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function ja(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Ur = Ci(/[A-Za-z]/), gr = Ci(/[\dA-Za-z]/), ez = Ci(/[#-'*+\--9=?A-Z^-~]/);
function sy(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const ly = Ci(/\d/), nz = Ci(/[\dA-Fa-f]/), tz = Ci(/[!-/:-@[-`{-~]/);
function $n(e) {
  return e !== null && e < -2;
}
function cr(e) {
  return e !== null && (e < 0 || e === 32);
}
function Jn(e) {
  return e === -2 || e === -1 || e === 32;
}
const rz = Ci(new RegExp("\\p{P}|\\p{S}", "u")), iz = Ci(/\s/);
function Ci(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function qa(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && gr(e.charCodeAt(r + 1)) && gr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function ut(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(u) {
    return Jn(u) ? (e.enter(r), l(u)) : n(u);
  }
  function l(u) {
    return Jn(u) && o++ < a ? (e.consume(u), l) : (e.exit(r), n(u));
  }
}
const az = {
  tokenize: oz
};
function oz(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), ut(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const u = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = u), r = u, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return $n(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const sz = {
  tokenize: lz
}, qx = {
  tokenize: cz
};
function lz(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(L) {
    if (i < r.length) {
      const $ = r[i];
      return n.containerState = $[1], e.attempt($[0].continuation, u, m)(L);
    }
    return m(L);
  }
  function u(L) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && y();
      const $ = n.events.length;
      let C = $, F;
      for (; C--; )
        if (n.events[C][0] === "exit" && n.events[C][1].type === "chunkFlow") {
          F = n.events[C][1].end;
          break;
        }
      _(i);
      let z = $;
      for (; z < n.events.length; )
        n.events[z][1].end = {
          ...F
        }, z++;
      return Kr(n.events, C + 1, 0, n.events.slice($)), n.events.length = z, m(L);
    }
    return l(L);
  }
  function m(L) {
    if (i === r.length) {
      if (!a)
        return h(L);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return I(L);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(qx, d, f)(L);
  }
  function d(L) {
    return a && y(), _(i), h(L);
  }
  function f(L) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, I(L);
  }
  function h(L) {
    return n.containerState = {}, e.attempt(qx, v, I)(L);
  }
  function v(L) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(L);
  }
  function I(L) {
    if (L === null) {
      a && y(), _(0), e.consume(L);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), w(L);
  }
  function w(L) {
    if (L === null) {
      j(e.exit("chunkFlow"), !0), _(0), e.consume(L);
      return;
    }
    return $n(L) ? (e.consume(L), j(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(L), w);
  }
  function j(L, $) {
    const C = n.sliceStream(L);
    if ($ && C.push(null), L.previous = o, o && (o.next = L), o = L, a.defineSkip(L.start), a.write(C), n.parser.lazy[L.start.line]) {
      let F = a.events.length;
      for (; F--; )
        if (
          // The token starts before the line ending…
          a.events[F][1].start.offset < s && // …and either is not ended yet…
          (!a.events[F][1].end || // …or ends after it.
          a.events[F][1].end.offset > s)
        )
          return;
      const z = n.events.length;
      let Q = z, J, te;
      for (; Q--; )
        if (n.events[Q][0] === "exit" && n.events[Q][1].type === "chunkFlow") {
          if (J) {
            te = n.events[Q][1].end;
            break;
          }
          J = !0;
        }
      for (_(i), F = z; F < n.events.length; )
        n.events[F][1].end = {
          ...te
        }, F++;
      Kr(n.events, Q + 1, 0, n.events.slice(z)), n.events.length = F;
    }
  }
  function _(L) {
    let $ = r.length;
    for (; $-- > L; ) {
      const C = r[$];
      n.containerState = C[1], C[0].exit.call(n, e);
    }
    r.length = L;
  }
  function y() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function cz(e, n, r) {
  return ut(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function Hx(e) {
  if (e === null || cr(e) || iz(e))
    return 1;
  if (rz(e))
    return 2;
}
function Ig(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const cy = {
  name: "attention",
  resolveAll: uz,
  tokenize: dz
};
function uz(e, n) {
  let r = -1, i, a, o, s, l, u, m, d;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          u = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          Wx(f, -u), Wx(h, u), s = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: u > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = br(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = br(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = br(m, Ig(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), m = br(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (d = 2, m = br(m, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : d = 0, Kr(e, i - 1, r - i + 3, m), r = i + m.length - d - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function dz(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = Hx(i);
  let o;
  return s;
  function s(u) {
    return o = u, e.enter("attentionSequence"), l(u);
  }
  function l(u) {
    if (u === o)
      return e.consume(u), l;
    const m = e.exit("attentionSequence"), d = Hx(u), f = !d || d === 2 && a || r.includes(u), h = !a || a === 2 && d || r.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (d || !f)), n(u);
  }
}
function Wx(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const mz = {
  name: "autolink",
  tokenize: pz
};
function pz(e, n, r) {
  let i = 0;
  return a;
  function a(v) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(v) {
    return Ur(v) ? (e.consume(v), s) : v === 64 ? r(v) : m(v);
  }
  function s(v) {
    return v === 43 || v === 45 || v === 46 || gr(v) ? (i = 1, l(v)) : m(v);
  }
  function l(v) {
    return v === 58 ? (e.consume(v), i = 0, u) : (v === 43 || v === 45 || v === 46 || gr(v)) && i++ < 32 ? (e.consume(v), l) : (i = 0, m(v));
  }
  function u(v) {
    return v === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : v === null || v === 32 || v === 60 || sy(v) ? r(v) : (e.consume(v), u);
  }
  function m(v) {
    return v === 64 ? (e.consume(v), d) : ez(v) ? (e.consume(v), m) : r(v);
  }
  function d(v) {
    return gr(v) ? f(v) : r(v);
  }
  function f(v) {
    return v === 46 ? (e.consume(v), i = 0, d) : v === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(v);
  }
  function h(v) {
    if ((v === 45 || gr(v)) && i++ < 63) {
      const I = v === 45 ? h : f;
      return e.consume(v), I;
    }
    return r(v);
  }
}
const rc = {
  partial: !0,
  tokenize: fz
};
function fz(e, n, r) {
  return i;
  function i(o) {
    return Jn(o) ? ut(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || $n(o) ? n(o) : r(o);
  }
}
const HC = {
  continuation: {
    tokenize: yz
  },
  exit: gz,
  name: "blockQuote",
  tokenize: hz
};
function hz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return Jn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function yz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return Jn(s) ? ut(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(HC, n, r)(s);
  }
}
function gz(e) {
  e.exit("blockQuote");
}
const WC = {
  name: "characterEscape",
  tokenize: vz
};
function vz(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return tz(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const KC = {
  name: "characterReference",
  tokenize: kz
};
function kz(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), u;
  }
  function u(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = gr, d(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = nz, d) : (e.enter("characterReferenceValue"), o = 7, s = ly, d(f));
  }
  function d(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === gr && !Fg(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), d) : r(f);
  }
}
const Kx = {
  partial: !0,
  tokenize: _z
}, Gx = {
  concrete: !0,
  name: "codeFenced",
  tokenize: bz
};
function bz(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: C
  };
  let o = 0, s = 0, l;
  return u;
  function u(F) {
    return m(F);
  }
  function m(F) {
    const z = i.events[i.events.length - 1];
    return o = z && z[1].type === "linePrefix" ? z[2].sliceSerialize(z[1], !0).length : 0, l = F, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), d(F);
  }
  function d(F) {
    return F === l ? (s++, e.consume(F), d) : s < 3 ? r(F) : (e.exit("codeFencedFenceSequence"), Jn(F) ? ut(e, f, "whitespace")(F) : f(F));
  }
  function f(F) {
    return F === null || $n(F) ? (e.exit("codeFencedFence"), i.interrupt ? n(F) : e.check(Kx, w, $)(F)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(F));
  }
  function h(F) {
    return F === null || $n(F) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(F)) : Jn(F) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), ut(e, v, "whitespace")(F)) : F === 96 && F === l ? r(F) : (e.consume(F), h);
  }
  function v(F) {
    return F === null || $n(F) ? f(F) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), I(F));
  }
  function I(F) {
    return F === null || $n(F) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(F)) : F === 96 && F === l ? r(F) : (e.consume(F), I);
  }
  function w(F) {
    return e.attempt(a, $, j)(F);
  }
  function j(F) {
    return e.enter("lineEnding"), e.consume(F), e.exit("lineEnding"), _;
  }
  function _(F) {
    return o > 0 && Jn(F) ? ut(e, y, "linePrefix", o + 1)(F) : y(F);
  }
  function y(F) {
    return F === null || $n(F) ? e.check(Kx, w, $)(F) : (e.enter("codeFlowValue"), L(F));
  }
  function L(F) {
    return F === null || $n(F) ? (e.exit("codeFlowValue"), y(F)) : (e.consume(F), L);
  }
  function $(F) {
    return e.exit("codeFenced"), n(F);
  }
  function C(F, z, Q) {
    let J = 0;
    return te;
    function te(ee) {
      return F.enter("lineEnding"), F.consume(ee), F.exit("lineEnding"), G;
    }
    function G(ee) {
      return F.enter("codeFencedFence"), Jn(ee) ? ut(F, B, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ee) : B(ee);
    }
    function B(ee) {
      return ee === l ? (F.enter("codeFencedFenceSequence"), R(ee)) : Q(ee);
    }
    function R(ee) {
      return ee === l ? (J++, F.consume(ee), R) : J >= s ? (F.exit("codeFencedFenceSequence"), Jn(ee) ? ut(F, U, "whitespace")(ee) : U(ee)) : Q(ee);
    }
    function U(ee) {
      return ee === null || $n(ee) ? (F.exit("codeFencedFence"), z(ee)) : Q(ee);
    }
  }
}
function _z(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const _m = {
  name: "codeIndented",
  tokenize: Sz
}, xz = {
  partial: !0,
  tokenize: Nz
};
function Sz(e, n, r) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), ut(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const d = i.events[i.events.length - 1];
    return d && d[1].type === "linePrefix" && d[2].sliceSerialize(d[1], !0).length >= 4 ? s(m) : r(m);
  }
  function s(m) {
    return m === null ? u(m) : $n(m) ? e.attempt(xz, s, u)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || $n(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function u(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function Nz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : $n(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : ut(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : $n(s) ? a(s) : r(s);
  }
}
const jz = {
  name: "codeText",
  previous: Cz,
  resolve: wz,
  tokenize: Fz
};
function wz(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function Cz(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Fz(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), u(f));
  }
  function u(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), u) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, d(f)) : $n(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), u) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || $n(f) ? (e.exit("codeTextData"), u(f)) : (e.consume(f), m);
  }
  function d(f) {
    return f === 96 ? (e.consume(f), a++, d) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class Iz {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && uo(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), uo(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), uo(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        uo(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        uo(this.left, r.reverse());
      }
  }
}
function uo(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function GC(e) {
  const n = {};
  let r = -1, i, a, o, s, l, u, m;
  const d = new Iz(e);
  for (; ++r < d.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = d.get(r), r && i[1].type === "chunkFlow" && d.get(r - 1)[1].type === "listItemPrefix" && (u = i[1]._tokenizer.events, o = 0, o < u.length && u[o][1].type === "lineEndingBlank" && (o += 2), o < u.length && u[o][1].type === "content"))
      for (; ++o < u.length && u[o][1].type !== "content"; )
        u[o][1].type === "chunkText" && (u[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, Ez(d, r)), r = n[r], m = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = d.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (d.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...d.get(a)[1].start
      }, l = d.slice(a, r), l.unshift(i), d.splice(a, r - a + 1, l));
    }
  }
  return Kr(e, 0, Number.POSITIVE_INFINITY, d.slice(0)), !m;
}
function Ez(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, u = [], m = {};
  let d, f, h = -1, v = r, I = 0, w = 0;
  const j = [w];
  for (; v; ) {
    for (; e.get(++a)[1] !== v; )
      ;
    o.push(a), v._tokenizer || (d = i.sliceStream(v), v.next || d.push(null), f && s.defineSkip(v.start), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(d), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = v, v = v.next;
  }
  for (v = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (w = h + 1, j.push(w), v._tokenizer = void 0, v.previous = void 0, v = v.next);
  for (s.events = [], v ? (v._tokenizer = void 0, v.previous = void 0) : j.pop(), h = j.length; h--; ) {
    const _ = l.slice(j[h], j[h + 1]), y = o.pop();
    u.push([y, y + _.length - 1]), e.splice(y, 2, _);
  }
  for (u.reverse(), h = -1; ++h < u.length; )
    m[I + u[h][0]] = I + u[h][1], I += u[h][1] - u[h][0] - 1;
  return m;
}
const $z = {
  resolve: Dz,
  tokenize: Oz
}, Tz = {
  partial: !0,
  tokenize: Rz
};
function Dz(e) {
  return GC(e), e;
}
function Oz(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : $n(l) ? e.check(Tz, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function Rz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), ut(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || $n(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function YC(e, n, r, i, a, o, s, l, u) {
  const m = u || Number.POSITIVE_INFINITY;
  let d = 0;
  return f;
  function f(_) {
    return _ === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(_), e.exit(o), h) : _ === null || _ === 32 || _ === 41 || sy(_) ? r(_) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), w(_));
  }
  function h(_) {
    return _ === 62 ? (e.enter(o), e.consume(_), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), v(_));
  }
  function v(_) {
    return _ === 62 ? (e.exit("chunkString"), e.exit(l), h(_)) : _ === null || _ === 60 || $n(_) ? r(_) : (e.consume(_), _ === 92 ? I : v);
  }
  function I(_) {
    return _ === 60 || _ === 62 || _ === 92 ? (e.consume(_), v) : v(_);
  }
  function w(_) {
    return !d && (_ === null || _ === 41 || cr(_)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(_)) : d < m && _ === 40 ? (e.consume(_), d++, w) : _ === 41 ? (e.consume(_), d--, w) : _ === null || _ === 32 || _ === 40 || sy(_) ? r(_) : (e.consume(_), _ === 92 ? j : w);
  }
  function j(_) {
    return _ === 40 || _ === 41 || _ === 92 ? (e.consume(_), w) : w(_);
  }
}
function QC(e, n, r, i, a, o) {
  const s = this;
  let l = 0, u;
  return m;
  function m(v) {
    return e.enter(i), e.enter(a), e.consume(v), e.exit(a), e.enter(o), d;
  }
  function d(v) {
    return l > 999 || v === null || v === 91 || v === 93 && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    v === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(v) : v === 93 ? (e.exit(o), e.enter(a), e.consume(v), e.exit(a), e.exit(i), n) : $n(v) ? (e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), d) : (e.enter("chunkString", {
      contentType: "string"
    }), f(v));
  }
  function f(v) {
    return v === null || v === 91 || v === 93 || $n(v) || l++ > 999 ? (e.exit("chunkString"), d(v)) : (e.consume(v), u || (u = !Jn(v)), v === 92 ? h : f);
  }
  function h(v) {
    return v === 91 || v === 92 || v === 93 ? (e.consume(v), l++, f) : f(v);
  }
}
function JC(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, u) : r(h);
  }
  function u(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), u(s)) : h === null ? r(h) : $n(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), ut(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), d(h));
  }
  function d(h) {
    return h === s || h === null || $n(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : d);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), d) : d(h);
  }
}
function Uo(e, n) {
  let r;
  return i;
  function i(a) {
    return $n(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : Jn(a) ? ut(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const Pz = {
  name: "definition",
  tokenize: Lz
}, Az = {
  partial: !0,
  tokenize: Vz
};
function Lz(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(v) {
    return e.enter("definition"), s(v);
  }
  function s(v) {
    return QC.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(v);
  }
  function l(v) {
    return a = ja(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), v === 58 ? (e.enter("definitionMarker"), e.consume(v), e.exit("definitionMarker"), u) : r(v);
  }
  function u(v) {
    return cr(v) ? Uo(e, m)(v) : m(v);
  }
  function m(v) {
    return YC(
      e,
      d,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(v);
  }
  function d(v) {
    return e.attempt(Az, f, f)(v);
  }
  function f(v) {
    return Jn(v) ? ut(e, h, "whitespace")(v) : h(v);
  }
  function h(v) {
    return v === null || $n(v) ? (e.exit("definition"), i.parser.defined.push(a), n(v)) : r(v);
  }
}
function Vz(e, n, r) {
  return i;
  function i(l) {
    return cr(l) ? Uo(e, a)(l) : r(l);
  }
  function a(l) {
    return JC(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return Jn(l) ? ut(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || $n(l) ? n(l) : r(l);
  }
}
const zz = {
  name: "hardBreakEscape",
  tokenize: Uz
};
function Uz(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return $n(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const Mz = {
  name: "headingAtx",
  resolve: Bz,
  tokenize: qz
};
function Bz(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Kr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function qz(e, n, r) {
  let i = 0;
  return a;
  function a(d) {
    return e.enter("atxHeading"), o(d);
  }
  function o(d) {
    return e.enter("atxHeadingSequence"), s(d);
  }
  function s(d) {
    return d === 35 && i++ < 6 ? (e.consume(d), s) : d === null || cr(d) ? (e.exit("atxHeadingSequence"), l(d)) : r(d);
  }
  function l(d) {
    return d === 35 ? (e.enter("atxHeadingSequence"), u(d)) : d === null || $n(d) ? (e.exit("atxHeading"), n(d)) : Jn(d) ? ut(e, l, "whitespace")(d) : (e.enter("atxHeadingText"), m(d));
  }
  function u(d) {
    return d === 35 ? (e.consume(d), u) : (e.exit("atxHeadingSequence"), l(d));
  }
  function m(d) {
    return d === null || d === 35 || cr(d) ? (e.exit("atxHeadingText"), l(d)) : (e.consume(d), m);
  }
}
const Hz = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Yx = ["pre", "script", "style", "textarea"], Wz = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: Yz,
  tokenize: Qz
}, Kz = {
  partial: !0,
  tokenize: Xz
}, Gz = {
  partial: !0,
  tokenize: Jz
};
function Yz(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function Qz(e, n, r) {
  const i = this;
  let a, o, s, l, u;
  return m;
  function m(X) {
    return d(X);
  }
  function d(X) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(X), f;
  }
  function f(X) {
    return X === 33 ? (e.consume(X), h) : X === 47 ? (e.consume(X), o = !0, w) : X === 63 ? (e.consume(X), a = 3, i.interrupt ? n : K) : Ur(X) ? (e.consume(X), s = String.fromCharCode(X), j) : r(X);
  }
  function h(X) {
    return X === 45 ? (e.consume(X), a = 2, v) : X === 91 ? (e.consume(X), a = 5, l = 0, I) : Ur(X) ? (e.consume(X), a = 4, i.interrupt ? n : K) : r(X);
  }
  function v(X) {
    return X === 45 ? (e.consume(X), i.interrupt ? n : K) : r(X);
  }
  function I(X) {
    const Ke = "CDATA[";
    return X === Ke.charCodeAt(l++) ? (e.consume(X), l === Ke.length ? i.interrupt ? n : B : I) : r(X);
  }
  function w(X) {
    return Ur(X) ? (e.consume(X), s = String.fromCharCode(X), j) : r(X);
  }
  function j(X) {
    if (X === null || X === 47 || X === 62 || cr(X)) {
      const Ke = X === 47, an = s.toLowerCase();
      return !Ke && !o && Yx.includes(an) ? (a = 1, i.interrupt ? n(X) : B(X)) : Hz.includes(s.toLowerCase()) ? (a = 6, Ke ? (e.consume(X), _) : i.interrupt ? n(X) : B(X)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(X) : o ? y(X) : L(X));
    }
    return X === 45 || gr(X) ? (e.consume(X), s += String.fromCharCode(X), j) : r(X);
  }
  function _(X) {
    return X === 62 ? (e.consume(X), i.interrupt ? n : B) : r(X);
  }
  function y(X) {
    return Jn(X) ? (e.consume(X), y) : te(X);
  }
  function L(X) {
    return X === 47 ? (e.consume(X), te) : X === 58 || X === 95 || Ur(X) ? (e.consume(X), $) : Jn(X) ? (e.consume(X), L) : te(X);
  }
  function $(X) {
    return X === 45 || X === 46 || X === 58 || X === 95 || gr(X) ? (e.consume(X), $) : C(X);
  }
  function C(X) {
    return X === 61 ? (e.consume(X), F) : Jn(X) ? (e.consume(X), C) : L(X);
  }
  function F(X) {
    return X === null || X === 60 || X === 61 || X === 62 || X === 96 ? r(X) : X === 34 || X === 39 ? (e.consume(X), u = X, z) : Jn(X) ? (e.consume(X), F) : Q(X);
  }
  function z(X) {
    return X === u ? (e.consume(X), u = null, J) : X === null || $n(X) ? r(X) : (e.consume(X), z);
  }
  function Q(X) {
    return X === null || X === 34 || X === 39 || X === 47 || X === 60 || X === 61 || X === 62 || X === 96 || cr(X) ? C(X) : (e.consume(X), Q);
  }
  function J(X) {
    return X === 47 || X === 62 || Jn(X) ? L(X) : r(X);
  }
  function te(X) {
    return X === 62 ? (e.consume(X), G) : r(X);
  }
  function G(X) {
    return X === null || $n(X) ? B(X) : Jn(X) ? (e.consume(X), G) : r(X);
  }
  function B(X) {
    return X === 45 && a === 2 ? (e.consume(X), Se) : X === 60 && a === 1 ? (e.consume(X), fe) : X === 62 && a === 4 ? (e.consume(X), _e) : X === 63 && a === 3 ? (e.consume(X), K) : X === 93 && a === 5 ? (e.consume(X), ve) : $n(X) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(Kz, Te, R)(X)) : X === null || $n(X) ? (e.exit("htmlFlowData"), R(X)) : (e.consume(X), B);
  }
  function R(X) {
    return e.check(Gz, U, Te)(X);
  }
  function U(X) {
    return e.enter("lineEnding"), e.consume(X), e.exit("lineEnding"), ee;
  }
  function ee(X) {
    return X === null || $n(X) ? R(X) : (e.enter("htmlFlowData"), B(X));
  }
  function Se(X) {
    return X === 45 ? (e.consume(X), K) : B(X);
  }
  function fe(X) {
    return X === 47 ? (e.consume(X), s = "", ye) : B(X);
  }
  function ye(X) {
    if (X === 62) {
      const Ke = s.toLowerCase();
      return Yx.includes(Ke) ? (e.consume(X), _e) : B(X);
    }
    return Ur(X) && s.length < 8 ? (e.consume(X), s += String.fromCharCode(X), ye) : B(X);
  }
  function ve(X) {
    return X === 93 ? (e.consume(X), K) : B(X);
  }
  function K(X) {
    return X === 62 ? (e.consume(X), _e) : X === 45 && a === 2 ? (e.consume(X), K) : B(X);
  }
  function _e(X) {
    return X === null || $n(X) ? (e.exit("htmlFlowData"), Te(X)) : (e.consume(X), _e);
  }
  function Te(X) {
    return e.exit("htmlFlow"), n(X);
  }
}
function Jz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return $n(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function Xz(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(rc, n, r);
  }
}
const Zz = {
  name: "htmlText",
  tokenize: eU
};
function eU(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(K) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(K), u;
  }
  function u(K) {
    return K === 33 ? (e.consume(K), m) : K === 47 ? (e.consume(K), C) : K === 63 ? (e.consume(K), L) : Ur(K) ? (e.consume(K), Q) : r(K);
  }
  function m(K) {
    return K === 45 ? (e.consume(K), d) : K === 91 ? (e.consume(K), o = 0, I) : Ur(K) ? (e.consume(K), y) : r(K);
  }
  function d(K) {
    return K === 45 ? (e.consume(K), v) : r(K);
  }
  function f(K) {
    return K === null ? r(K) : K === 45 ? (e.consume(K), h) : $n(K) ? (s = f, fe(K)) : (e.consume(K), f);
  }
  function h(K) {
    return K === 45 ? (e.consume(K), v) : f(K);
  }
  function v(K) {
    return K === 62 ? Se(K) : K === 45 ? h(K) : f(K);
  }
  function I(K) {
    const _e = "CDATA[";
    return K === _e.charCodeAt(o++) ? (e.consume(K), o === _e.length ? w : I) : r(K);
  }
  function w(K) {
    return K === null ? r(K) : K === 93 ? (e.consume(K), j) : $n(K) ? (s = w, fe(K)) : (e.consume(K), w);
  }
  function j(K) {
    return K === 93 ? (e.consume(K), _) : w(K);
  }
  function _(K) {
    return K === 62 ? Se(K) : K === 93 ? (e.consume(K), _) : w(K);
  }
  function y(K) {
    return K === null || K === 62 ? Se(K) : $n(K) ? (s = y, fe(K)) : (e.consume(K), y);
  }
  function L(K) {
    return K === null ? r(K) : K === 63 ? (e.consume(K), $) : $n(K) ? (s = L, fe(K)) : (e.consume(K), L);
  }
  function $(K) {
    return K === 62 ? Se(K) : L(K);
  }
  function C(K) {
    return Ur(K) ? (e.consume(K), F) : r(K);
  }
  function F(K) {
    return K === 45 || gr(K) ? (e.consume(K), F) : z(K);
  }
  function z(K) {
    return $n(K) ? (s = z, fe(K)) : Jn(K) ? (e.consume(K), z) : Se(K);
  }
  function Q(K) {
    return K === 45 || gr(K) ? (e.consume(K), Q) : K === 47 || K === 62 || cr(K) ? J(K) : r(K);
  }
  function J(K) {
    return K === 47 ? (e.consume(K), Se) : K === 58 || K === 95 || Ur(K) ? (e.consume(K), te) : $n(K) ? (s = J, fe(K)) : Jn(K) ? (e.consume(K), J) : Se(K);
  }
  function te(K) {
    return K === 45 || K === 46 || K === 58 || K === 95 || gr(K) ? (e.consume(K), te) : G(K);
  }
  function G(K) {
    return K === 61 ? (e.consume(K), B) : $n(K) ? (s = G, fe(K)) : Jn(K) ? (e.consume(K), G) : J(K);
  }
  function B(K) {
    return K === null || K === 60 || K === 61 || K === 62 || K === 96 ? r(K) : K === 34 || K === 39 ? (e.consume(K), a = K, R) : $n(K) ? (s = B, fe(K)) : Jn(K) ? (e.consume(K), B) : (e.consume(K), U);
  }
  function R(K) {
    return K === a ? (e.consume(K), a = void 0, ee) : K === null ? r(K) : $n(K) ? (s = R, fe(K)) : (e.consume(K), R);
  }
  function U(K) {
    return K === null || K === 34 || K === 39 || K === 60 || K === 61 || K === 96 ? r(K) : K === 47 || K === 62 || cr(K) ? J(K) : (e.consume(K), U);
  }
  function ee(K) {
    return K === 47 || K === 62 || cr(K) ? J(K) : r(K);
  }
  function Se(K) {
    return K === 62 ? (e.consume(K), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(K);
  }
  function fe(K) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(K), e.exit("lineEnding"), ye;
  }
  function ye(K) {
    return Jn(K) ? ut(e, ve, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(K) : ve(K);
  }
  function ve(K) {
    return e.enter("htmlTextData"), s(K);
  }
}
const Eg = {
  name: "labelEnd",
  resolveAll: iU,
  resolveTo: aU,
  tokenize: oU
}, nU = {
  tokenize: sU
}, tU = {
  tokenize: lU
}, rU = {
  tokenize: cU
};
function iU(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Kr(e, 0, e.length, r), e;
}
function aU(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const u = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, d = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", u, n], ["enter", m, n]], l = br(l, e.slice(o + 1, o + i + 3)), l = br(l, [["enter", d, n]]), l = br(l, Ig(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = br(l, [["exit", d, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = br(l, e.slice(s + 1)), l = br(l, [["exit", u, n]]), Kr(e, o, e.length, l), e;
}
function oU(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(ja(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), u) : r(h);
  }
  function u(h) {
    return h === 40 ? e.attempt(nU, d, s ? d : f)(h) : h === 91 ? e.attempt(tU, d, s ? m : f)(h) : s ? d(h) : f(h);
  }
  function m(h) {
    return e.attempt(rU, d, f)(h);
  }
  function d(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function sU(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return cr(f) ? Uo(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? d(f) : YC(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return cr(f) ? Uo(e, u)(f) : d(f);
  }
  function l(f) {
    return r(f);
  }
  function u(f) {
    return f === 34 || f === 39 || f === 40 ? JC(e, m, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : d(f);
  }
  function m(f) {
    return cr(f) ? Uo(e, d)(f) : d(f);
  }
  function d(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function lU(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return QC.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(ja(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function cU(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const uU = {
  name: "labelStartImage",
  resolveAll: Eg.resolveAll,
  tokenize: dU
};
function dU(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const mU = {
  name: "labelStartLink",
  resolveAll: Eg.resolveAll,
  tokenize: pU
};
function pU(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const xm = {
  name: "lineEnding",
  tokenize: fU
};
function fU(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), ut(e, n, "linePrefix");
  }
}
const sl = {
  name: "thematicBreak",
  tokenize: hU
};
function hU(e, n, r) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), u(m)) : i >= 3 && (m === null || $n(m)) ? (e.exit("thematicBreak"), n(m)) : r(m);
  }
  function u(m) {
    return m === a ? (e.consume(m), i++, u) : (e.exit("thematicBreakSequence"), Jn(m) ? ut(e, l, "whitespace")(m) : l(m));
  }
}
const sr = {
  continuation: {
    tokenize: kU
  },
  exit: _U,
  name: "list",
  tokenize: vU
}, yU = {
  partial: !0,
  tokenize: xU
}, gU = {
  partial: !0,
  tokenize: bU
};
function vU(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(v) {
    const I = i.containerState.type || (v === 42 || v === 43 || v === 45 ? "listUnordered" : "listOrdered");
    if (I === "listUnordered" ? !i.containerState.marker || v === i.containerState.marker : ly(v)) {
      if (i.containerState.type || (i.containerState.type = I, e.enter(I, {
        _container: !0
      })), I === "listUnordered")
        return e.enter("listItemPrefix"), v === 42 || v === 45 ? e.check(sl, r, m)(v) : m(v);
      if (!i.interrupt || v === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), u(v);
    }
    return r(v);
  }
  function u(v) {
    return ly(v) && ++s < 10 ? (e.consume(v), u) : (!i.interrupt || s < 2) && (i.containerState.marker ? v === i.containerState.marker : v === 41 || v === 46) ? (e.exit("listItemValue"), m(v)) : r(v);
  }
  function m(v) {
    return e.enter("listItemMarker"), e.consume(v), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || v, e.check(
      rc,
      // Can’t be empty when interrupting.
      i.interrupt ? r : d,
      e.attempt(yU, h, f)
    );
  }
  function d(v) {
    return i.containerState.initialBlankLine = !0, o++, h(v);
  }
  function f(v) {
    return Jn(v) ? (e.enter("listItemPrefixWhitespace"), e.consume(v), e.exit("listItemPrefixWhitespace"), h) : r(v);
  }
  function h(v) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(v);
  }
}
function kU(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(rc, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, ut(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !Jn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(gU, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, ut(e, e.attempt(sr, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function bU(e, n, r) {
  const i = this;
  return ut(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function _U(e) {
  e.exit(this.containerState.type);
}
function xU(e, n, r) {
  const i = this;
  return ut(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !Jn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const Qx = {
  name: "setextUnderline",
  resolveTo: SU,
  tokenize: NU
};
function SU(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function NU(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let d = i.events.length, f;
    for (; d--; )
      if (i.events[d][1].type !== "lineEnding" && i.events[d][1].type !== "linePrefix" && i.events[d][1].type !== "content") {
        f = i.events[d][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : r(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), Jn(m) ? ut(e, u, "lineSuffix")(m) : u(m));
  }
  function u(m) {
    return m === null || $n(m) ? (e.exit("setextHeadingLine"), n(m)) : r(m);
  }
}
const jU = {
  tokenize: wU
};
function wU(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    rc,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, ut(e, e.attempt(this.parser.constructs.flow, a, e.attempt($z, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const CU = {
  resolveAll: ZC()
}, FU = XC("string"), IU = XC("text");
function XC(e) {
  return {
    resolveAll: ZC(e === "text" ? EU : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(d) {
      return m(d) ? o(d) : l(d);
    }
    function l(d) {
      if (d === null) {
        r.consume(d);
        return;
      }
      return r.enter("data"), r.consume(d), u;
    }
    function u(d) {
      return m(d) ? (r.exit("data"), o(d)) : (r.consume(d), u);
    }
    function m(d) {
      if (d === null)
        return !0;
      const f = a[d];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const v = f[h];
          if (!v.previous || v.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function ZC(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function EU(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, u;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          u = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: r === e.length || u || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(r, 0, ["enter", m, n], ["exit", m, n]), r += 2);
      }
      r++;
    }
  return e;
}
const $U = {
  42: sr,
  43: sr,
  45: sr,
  48: sr,
  49: sr,
  50: sr,
  51: sr,
  52: sr,
  53: sr,
  54: sr,
  55: sr,
  56: sr,
  57: sr,
  62: HC
}, TU = {
  91: Pz
}, DU = {
  [-2]: _m,
  [-1]: _m,
  32: _m
}, OU = {
  35: Mz,
  42: sl,
  45: [Qx, sl],
  60: Wz,
  61: Qx,
  95: sl,
  96: Gx,
  126: Gx
}, RU = {
  38: KC,
  92: WC
}, PU = {
  [-5]: xm,
  [-4]: xm,
  [-3]: xm,
  33: uU,
  38: KC,
  42: cy,
  60: [mz, Zz],
  91: mU,
  92: [zz, WC],
  93: Eg,
  95: cy,
  96: jz
}, AU = {
  null: [cy, CU]
}, LU = {
  null: [42, 95]
}, VU = {
  null: []
}, zU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: LU,
  contentInitial: TU,
  disable: VU,
  document: $U,
  flow: OU,
  flowInitial: DU,
  insideSpan: AU,
  string: RU,
  text: PU
}, Symbol.toStringTag, { value: "Module" }));
function UU(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const u = {
    attempt: z(C),
    check: z(F),
    consume: y,
    enter: L,
    exit: $,
    interrupt: z(F, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: w,
    events: [],
    now: I,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: v,
    write: f
  };
  let d = n.tokenize.call(m, u);
  return n.resolveAll && o.push(n), m;
  function f(G) {
    return s = br(s, G), j(), s[s.length - 1] !== null ? [] : (Q(n, 0), m.events = Ig(o, m.events, m), m.events);
  }
  function h(G, B) {
    return BU(v(G), B);
  }
  function v(G) {
    return MU(s, G);
  }
  function I() {
    const {
      _bufferIndex: G,
      _index: B,
      line: R,
      column: U,
      offset: ee
    } = i;
    return {
      _bufferIndex: G,
      _index: B,
      line: R,
      column: U,
      offset: ee
    };
  }
  function w(G) {
    a[G.line] = G.column, te();
  }
  function j() {
    let G;
    for (; i._index < s.length; ) {
      const B = s[i._index];
      if (typeof B == "string")
        for (G = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === G && i._bufferIndex < B.length; )
          _(B.charCodeAt(i._bufferIndex));
      else
        _(B);
    }
  }
  function _(G) {
    d = d(G);
  }
  function y(G) {
    $n(G) ? (i.line++, i.column = 1, i.offset += G === -3 ? 2 : 1, te()) : G !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = G;
  }
  function L(G, B) {
    const R = B || {};
    return R.type = G, R.start = I(), m.events.push(["enter", R, m]), l.push(R), R;
  }
  function $(G) {
    const B = l.pop();
    return B.end = I(), m.events.push(["exit", B, m]), B;
  }
  function C(G, B) {
    Q(G, B.from);
  }
  function F(G, B) {
    B.restore();
  }
  function z(G, B) {
    return R;
    function R(U, ee, Se) {
      let fe, ye, ve, K;
      return Array.isArray(U) ? (
        /* c8 ignore next 1 */
        Te(U)
      ) : "tokenize" in U ? (
        // Looks like a construct.
        Te([
          /** @type {Construct} */
          U
        ])
      ) : _e(U);
      function _e(we) {
        return Me;
        function Me(Re) {
          const Be = Re !== null && we[Re], Ae = Re !== null && we.null, Ge = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Be) ? Be : Be ? [Be] : [],
            ...Array.isArray(Ae) ? Ae : Ae ? [Ae] : []
          ];
          return Te(Ge)(Re);
        }
      }
      function Te(we) {
        return fe = we, ye = 0, we.length === 0 ? Se : X(we[ye]);
      }
      function X(we) {
        return Me;
        function Me(Re) {
          return K = J(), ve = we, we.partial || (m.currentConstruct = we), we.name && m.parser.constructs.disable.null.includes(we.name) ? an() : we.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            B ? Object.assign(Object.create(m), B) : m,
            u,
            Ke,
            an
          )(Re);
        }
      }
      function Ke(we) {
        return G(ve, K), ee;
      }
      function an(we) {
        return K.restore(), ++ye < fe.length ? X(fe[ye]) : Se;
      }
    }
  }
  function Q(G, B) {
    G.resolveAll && !o.includes(G) && o.push(G), G.resolve && Kr(m.events, B, m.events.length - B, G.resolve(m.events.slice(B), m)), G.resolveTo && (m.events = G.resolveTo(m.events, m));
  }
  function J() {
    const G = I(), B = m.previous, R = m.currentConstruct, U = m.events.length, ee = Array.from(l);
    return {
      from: U,
      restore: Se
    };
    function Se() {
      i = G, m.previous = B, m.currentConstruct = R, m.events.length = U, l = ee, te();
    }
  }
  function te() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function MU(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function BU(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function qU(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      J3([zU, ...(e || {}).extensions || []])
    ),
    content: a(az),
    defined: [],
    document: a(sz),
    flow: a(jU),
    lazy: {},
    string: a(FU),
    text: a(IU)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return UU(i, o, l);
    }
  }
}
function HU(e) {
  for (; !GC(e); )
    ;
  return e;
}
const Jx = /[\0\t\n\r]/g;
function WU() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const u = [];
    let m, d, f, h, v;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (Jx.lastIndex = f, m = Jx.exec(o), h = m && m.index !== void 0 ? m.index : o.length, v = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (v === 10 && f === h && i)
        u.push(-3), i = void 0;
      else
        switch (i && (u.push(-5), i = void 0), f < h && (u.push(o.slice(f, h)), e += h - f), v) {
          case 0: {
            u.push(65533), e++;
            break;
          }
          case 9: {
            for (d = Math.ceil(e / 4) * 4, u.push(-2); e++ < d; ) u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && u.push(-5), n && u.push(n), u.push(null)), u;
  }
}
const KU = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function GU(e) {
  return e.replace(KU, YU);
}
function YU(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return qC(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Fg(r) || e;
}
const eF = {}.hasOwnProperty;
function QU(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), JU(r)(HU(qU(r).document().write(WU()(e, n, !0))));
}
function JU(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Pe),
      autolinkProtocol: J,
      autolinkEmail: J,
      atxHeading: o(ae),
      blockQuote: o(Ae),
      characterEscape: J,
      characterReference: J,
      codeFenced: o(Ge),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(Ge, s),
      codeText: o(Ce, s),
      codeTextData: J,
      data: J,
      codeFlowValue: J,
      definition: o(qe),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(nn),
      hardBreakEscape: o(le),
      hardBreakTrailing: o(le),
      htmlFlow: o(xe, s),
      htmlFlowData: J,
      htmlText: o(xe, s),
      htmlTextData: J,
      image: o(Le),
      label: s,
      link: o(Pe),
      listItem: o(T),
      listItemValue: h,
      listOrdered: o(yn, f),
      listUnordered: o(yn),
      paragraph: o(x),
      reference: X,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(ae),
      strong: o(D),
      thematicBreak: o(Y)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: C,
      autolink: u(),
      autolinkEmail: Be,
      autolinkProtocol: Re,
      blockQuote: u(),
      characterEscapeValue: te,
      characterReferenceMarkerHexadecimal: an,
      characterReferenceMarkerNumeric: an,
      characterReferenceValue: we,
      characterReference: Me,
      codeFenced: u(j),
      codeFencedFence: w,
      codeFencedFenceInfo: v,
      codeFencedFenceMeta: I,
      codeFlowValue: te,
      codeIndented: u(_),
      codeText: u(ee),
      codeTextData: te,
      data: te,
      definition: u(),
      definitionDestinationString: $,
      definitionLabelString: y,
      definitionTitleString: L,
      emphasis: u(),
      hardBreakEscape: u(B),
      hardBreakTrailing: u(B),
      htmlFlow: u(R),
      htmlFlowData: te,
      htmlText: u(U),
      htmlTextData: te,
      image: u(fe),
      label: ve,
      labelText: ye,
      lineEnding: G,
      link: u(Se),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: Ke,
      resourceDestinationString: K,
      resourceTitleString: _e,
      resource: Te,
      setextHeading: u(Q),
      setextHeadingLineSequence: z,
      setextHeadingText: F,
      strong: u(),
      thematicBreak: u()
    }
  };
  nF(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(A) {
    let M = {
      type: "root",
      children: []
    };
    const oe = {
      stack: [M],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: d,
      data: r
    }, ge = [];
    let Ne = -1;
    for (; ++Ne < A.length; )
      if (A[Ne][1].type === "listOrdered" || A[Ne][1].type === "listUnordered")
        if (A[Ne][0] === "enter")
          ge.push(Ne);
        else {
          const rn = ge.pop();
          Ne = a(A, rn, Ne);
        }
    for (Ne = -1; ++Ne < A.length; ) {
      const rn = n[A[Ne][0]];
      eF.call(rn, A[Ne][1].type) && rn[A[Ne][1].type].call(Object.assign({
        sliceSerialize: A[Ne][2].sliceSerialize
      }, oe), A[Ne][1]);
    }
    if (oe.tokenStack.length > 0) {
      const rn = oe.tokenStack[oe.tokenStack.length - 1];
      (rn[1] || Xx).call(oe, void 0, rn[0]);
    }
    for (M.position = {
      start: vi(A.length > 0 ? A[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: vi(A.length > 0 ? A[A.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Ne = -1; ++Ne < n.transforms.length; )
      M = n.transforms[Ne](M) || M;
    return M;
  }
  function a(A, M, oe) {
    let ge = M - 1, Ne = -1, rn = !1, gn, tn, dn, wn;
    for (; ++ge <= oe; ) {
      const xn = A[ge];
      switch (xn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          xn[0] === "enter" ? Ne++ : Ne--, wn = void 0;
          break;
        }
        case "lineEndingBlank": {
          xn[0] === "enter" && (gn && !wn && !Ne && !dn && (dn = ge), wn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          wn = void 0;
      }
      if (!Ne && xn[0] === "enter" && xn[1].type === "listItemPrefix" || Ne === -1 && xn[0] === "exit" && (xn[1].type === "listUnordered" || xn[1].type === "listOrdered")) {
        if (gn) {
          let Cn = ge;
          for (tn = void 0; Cn--; ) {
            const Ze = A[Cn];
            if (Ze[1].type === "lineEnding" || Ze[1].type === "lineEndingBlank") {
              if (Ze[0] === "exit") continue;
              tn && (A[tn][1].type = "lineEndingBlank", rn = !0), Ze[1].type = "lineEnding", tn = Cn;
            } else if (!(Ze[1].type === "linePrefix" || Ze[1].type === "blockQuotePrefix" || Ze[1].type === "blockQuotePrefixWhitespace" || Ze[1].type === "blockQuoteMarker" || Ze[1].type === "listItemIndent")) break;
          }
          dn && (!tn || dn < tn) && (gn._spread = !0), gn.end = Object.assign({}, tn ? A[tn][1].start : xn[1].end), A.splice(tn || ge, 0, ["exit", gn, xn[2]]), ge++, oe++;
        }
        if (xn[1].type === "listItemPrefix") {
          const Cn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, xn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          gn = Cn, A.splice(ge, 0, ["enter", Cn, xn[2]]), ge++, oe++, dn = void 0, wn = !0;
        }
      }
    }
    return A[M][1]._spread = rn, oe;
  }
  function o(A, M) {
    return oe;
    function oe(ge) {
      l.call(this, A(ge), ge), M && M.call(this, ge);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(A, M, oe) {
    this.stack[this.stack.length - 1].children.push(A), this.stack.push(A), this.tokenStack.push([M, oe || void 0]), A.position = {
      start: vi(M.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u(A) {
    return M;
    function M(oe) {
      A && A.call(this, oe), m.call(this, oe);
    }
  }
  function m(A, M) {
    const oe = this.stack.pop(), ge = this.tokenStack.pop();
    if (ge)
      ge[0].type !== A.type && (M ? M.call(this, A, ge[0]) : (ge[1] || Xx).call(this, A, ge[0]));
    else throw new Error("Cannot close `" + A.type + "` (" + zo({
      start: A.start,
      end: A.end
    }) + "): it’s not open");
    oe.position.end = vi(A.end);
  }
  function d() {
    return Y3(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(A) {
    if (this.data.expectingFirstListItemValue) {
      const M = this.stack[this.stack.length - 2];
      M.start = Number.parseInt(this.sliceSerialize(A), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function v() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.lang = A;
  }
  function I() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.meta = A;
  }
  function w() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function j() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.value = A.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function _() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.value = A.replace(/(\r?\n|\r)$/g, "");
  }
  function y(A) {
    const M = this.resume(), oe = this.stack[this.stack.length - 1];
    oe.label = M, oe.identifier = ja(this.sliceSerialize(A)).toLowerCase();
  }
  function L() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.title = A;
  }
  function $() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.url = A;
  }
  function C(A) {
    const M = this.stack[this.stack.length - 1];
    if (!M.depth) {
      const oe = this.sliceSerialize(A).length;
      M.depth = oe;
    }
  }
  function F() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function z(A) {
    const M = this.stack[this.stack.length - 1];
    M.depth = this.sliceSerialize(A).codePointAt(0) === 61 ? 1 : 2;
  }
  function Q() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function J(A) {
    const oe = this.stack[this.stack.length - 1].children;
    let ge = oe[oe.length - 1];
    (!ge || ge.type !== "text") && (ge = H(), ge.position = {
      start: vi(A.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, oe.push(ge)), this.stack.push(ge);
  }
  function te(A) {
    const M = this.stack.pop();
    M.value += this.sliceSerialize(A), M.position.end = vi(A.end);
  }
  function G(A) {
    const M = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const oe = M.children[M.children.length - 1];
      oe.position.end = vi(A.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(M.type) && (J.call(this, A), te.call(this, A));
  }
  function B() {
    this.data.atHardBreak = !0;
  }
  function R() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.value = A;
  }
  function U() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.value = A;
  }
  function ee() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.value = A;
  }
  function Se() {
    const A = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const M = this.data.referenceType || "shortcut";
      A.type += "Reference", A.referenceType = M, delete A.url, delete A.title;
    } else
      delete A.identifier, delete A.label;
    this.data.referenceType = void 0;
  }
  function fe() {
    const A = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const M = this.data.referenceType || "shortcut";
      A.type += "Reference", A.referenceType = M, delete A.url, delete A.title;
    } else
      delete A.identifier, delete A.label;
    this.data.referenceType = void 0;
  }
  function ye(A) {
    const M = this.sliceSerialize(A), oe = this.stack[this.stack.length - 2];
    oe.label = GU(M), oe.identifier = ja(M).toLowerCase();
  }
  function ve() {
    const A = this.stack[this.stack.length - 1], M = this.resume(), oe = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, oe.type === "link") {
      const ge = A.children;
      oe.children = ge;
    } else
      oe.alt = M;
  }
  function K() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.url = A;
  }
  function _e() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.title = A;
  }
  function Te() {
    this.data.inReference = void 0;
  }
  function X() {
    this.data.referenceType = "collapsed";
  }
  function Ke(A) {
    const M = this.resume(), oe = this.stack[this.stack.length - 1];
    oe.label = M, oe.identifier = ja(this.sliceSerialize(A)).toLowerCase(), this.data.referenceType = "full";
  }
  function an(A) {
    this.data.characterReferenceType = A.type;
  }
  function we(A) {
    const M = this.sliceSerialize(A), oe = this.data.characterReferenceType;
    let ge;
    oe ? (ge = qC(M, oe === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : ge = Fg(M);
    const Ne = this.stack[this.stack.length - 1];
    Ne.value += ge;
  }
  function Me(A) {
    const M = this.stack.pop();
    M.position.end = vi(A.end);
  }
  function Re(A) {
    te.call(this, A);
    const M = this.stack[this.stack.length - 1];
    M.url = this.sliceSerialize(A);
  }
  function Be(A) {
    te.call(this, A);
    const M = this.stack[this.stack.length - 1];
    M.url = "mailto:" + this.sliceSerialize(A);
  }
  function Ae() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Ge() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ce() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function qe() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function nn() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function ae() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function le() {
    return {
      type: "break"
    };
  }
  function xe() {
    return {
      type: "html",
      value: ""
    };
  }
  function Le() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Pe() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function yn(A) {
    return {
      type: "list",
      ordered: A.type === "listOrdered",
      start: null,
      spread: A._spread,
      children: []
    };
  }
  function T(A) {
    return {
      type: "listItem",
      spread: A._spread,
      checked: null,
      children: []
    };
  }
  function x() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function D() {
    return {
      type: "strong",
      children: []
    };
  }
  function H() {
    return {
      type: "text",
      value: ""
    };
  }
  function Y() {
    return {
      type: "thematicBreak"
    };
  }
}
function vi(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function nF(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? nF(e, i) : XU(e, i);
  }
}
function XU(e, n) {
  let r;
  for (r in n)
    if (eF.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function Xx(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + zo({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + zo({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + zo({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function ZU(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return QU(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function e4(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function n4(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function t4(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function r4(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function i4(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function a4(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = qa(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const u = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, u);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [u]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function o4(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function s4(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function tF(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function l4(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return tF(e, n);
  const a = { src: qa(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function c4(e, n) {
  const r = { src: qa(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function u4(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function d4(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return tF(e, n);
  const a = { href: qa(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function m4(e, n) {
  const r = { href: qa(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function p4(e, n, r) {
  const i = e.all(n), a = r ? f4(r) : rF(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const d = i[0];
    let f;
    d && d.type === "element" && d.tagName === "p" ? f = d : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const d = i[l];
    (a || l !== 0 || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` }), d.type === "element" && d.tagName === "p" && !a ? s.push(...d.children) : s.push(d);
  }
  const u = i[i.length - 1];
  u && (a || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function f4(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = rF(r[i]);
  }
  return n;
}
function rF(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function h4(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function y4(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function g4(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function v4(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function k4(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = Ng(n.children[1]), u = AC(n.children[n.children.length - 1]);
    l && u && (s.position = { start: l, end: u }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function b4(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let u = -1;
  const m = [];
  for (; ++u < l; ) {
    const f = n.children[u], h = {}, v = s ? s[u] : void 0;
    v && (h.align = v);
    let I = { type: "element", tagName: o, properties: h, children: [] };
    f && (I.children = e.all(f), e.patch(f, I), I = e.applyData(f, I)), m.push(I);
  }
  const d = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, d), e.applyData(n, d);
}
function _4(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const Zx = 9, eS = 32;
function x4(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      nS(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(nS(n.slice(a), a > 0, !1)), o.join("");
}
function nS(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === Zx || o === eS; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === Zx || o === eS; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function S4(e, n) {
  const r = { type: "text", value: x4(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function N4(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const j4 = {
  blockquote: e4,
  break: n4,
  code: t4,
  delete: r4,
  emphasis: i4,
  footnoteReference: a4,
  heading: o4,
  html: s4,
  imageReference: l4,
  image: c4,
  inlineCode: u4,
  linkReference: d4,
  link: m4,
  listItem: p4,
  list: h4,
  paragraph: y4,
  // @ts-expect-error: root is different, but hard to type.
  root: g4,
  strong: v4,
  table: k4,
  tableCell: _4,
  tableRow: b4,
  text: S4,
  thematicBreak: N4,
  toml: Cs,
  yaml: Cs,
  definition: Cs,
  footnoteDefinition: Cs
};
function Cs() {
}
const iF = -1, ic = 0, Fl = 1, Il = 2, $g = 3, Tg = 4, Dg = 5, Og = 6, aF = 7, oF = 8, tS = typeof self == "object" ? self : globalThis, w4 = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case ic:
      case iF:
        return r(s, a);
      case Fl: {
        const l = r([], a);
        for (const u of s)
          l.push(i(u));
        return l;
      }
      case Il: {
        const l = r({}, a);
        for (const [u, m] of s)
          l[i(u)] = i(m);
        return l;
      }
      case $g:
        return r(new Date(s), a);
      case Tg: {
        const { source: l, flags: u } = s;
        return r(new RegExp(l, u), a);
      }
      case Dg: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [u, m] of s)
          l.set(i(u), i(m));
        return l;
      }
      case Og: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const u of s)
          l.add(i(u));
        return l;
      }
      case aF: {
        const { name: l, message: u } = s;
        return r(new tS[l](u), a);
      }
      case oF:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new tS[o](s), a);
  };
  return i;
}, rS = (e) => w4(/* @__PURE__ */ new Map(), e)(0), ca = "", { toString: C4 } = {}, { keys: F4 } = Object, mo = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [ic, n];
  const r = C4.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [Fl, ca];
    case "Object":
      return [Il, ca];
    case "Date":
      return [$g, ca];
    case "RegExp":
      return [Tg, ca];
    case "Map":
      return [Dg, ca];
    case "Set":
      return [Og, ca];
  }
  return r.includes("Array") ? [Fl, r] : r.includes("Error") ? [aF, r] : [Il, r];
}, Fs = ([e, n]) => e === ic && (n === "function" || n === "symbol"), I4 = (e, n, r, i) => {
  const a = (s, l) => {
    const u = i.push(s) - 1;
    return r.set(l, u), u;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, u] = mo(s);
    switch (l) {
      case ic: {
        let d = s;
        switch (u) {
          case "bigint":
            l = oF, d = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + u);
            d = null;
            break;
          case "undefined":
            return a([iF], s);
        }
        return a([l, d], s);
      }
      case Fl: {
        if (u)
          return a([u, [...s]], s);
        const d = [], f = a([l, d], s);
        for (const h of s)
          d.push(o(h));
        return f;
      }
      case Il: {
        if (u)
          switch (u) {
            case "BigInt":
              return a([u, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([u, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const d = [], f = a([l, d], s);
        for (const h of F4(s))
          (e || !Fs(mo(s[h]))) && d.push([o(h), o(s[h])]);
        return f;
      }
      case $g:
        return a([l, s.toISOString()], s);
      case Tg: {
        const { source: d, flags: f } = s;
        return a([l, { source: d, flags: f }], s);
      }
      case Dg: {
        const d = [], f = a([l, d], s);
        for (const [h, v] of s)
          (e || !(Fs(mo(h)) || Fs(mo(v)))) && d.push([o(h), o(v)]);
        return f;
      }
      case Og: {
        const d = [], f = a([l, d], s);
        for (const h of s)
          (e || !Fs(mo(h))) && d.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: u, message: m }], s);
  };
  return o;
}, iS = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return I4(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, El = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? rS(iS(e, n)) : structuredClone(e)
) : (e, n) => rS(iS(e, n));
function E4(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function $4(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function T4(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || E4, i = e.options.footnoteBackLabel || $4, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let u = -1;
  for (; ++u < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[u]
    );
    if (!m)
      continue;
    const d = e.all(m), f = String(m.identifier).toUpperCase(), h = qa(f.toLowerCase());
    let v = 0;
    const I = [], w = e.footnoteCounts.get(f);
    for (; w !== void 0 && ++v <= w; ) {
      I.length > 0 && I.push({ type: "text", value: " " });
      let y = typeof r == "string" ? r : r(u, v);
      typeof y == "string" && (y = { type: "text", value: y }), I.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (v > 1 ? "-" + v : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(u, v),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(y) ? y : [y]
      });
    }
    const j = d[d.length - 1];
    if (j && j.type === "element" && j.tagName === "p") {
      const y = j.children[j.children.length - 1];
      y && y.type === "text" ? y.value += " " : j.children.push({ type: "text", value: " " }), j.children.push(...I);
    } else
      d.push(...I);
    const _ = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(d, !0)
    };
    e.patch(m, _), l.push(_);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...El(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const sF = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return P4;
    if (typeof e == "function")
      return ac(e);
    if (typeof e == "object")
      return Array.isArray(e) ? D4(e) : O4(e);
    if (typeof e == "string")
      return R4(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function D4(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = sF(e[r]);
  return ac(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function O4(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return ac(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function R4(e) {
  return ac(n);
  function n(r) {
    return r && r.type === e;
  }
}
function ac(e) {
  return n;
  function n(r, i, a) {
    return !!(A4(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function P4() {
  return !0;
}
function A4(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const lF = [], L4 = !0, aS = !1, V4 = "skip";
function z4(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = sF(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(u, m, d) {
    const f = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof f.type == "string") {
      const v = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (u.type + (v ? "<" + v + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let v = lF, I, w, j;
      if ((!n || o(u, m, d[d.length - 1] || void 0)) && (v = U4(r(u, d)), v[0] === aS))
        return v;
      if ("children" in u && u.children) {
        const _ = (
          /** @type {UnistParent} */
          u
        );
        if (_.children && v[0] !== V4)
          for (w = (i ? _.children.length : -1) + s, j = d.concat(_); w > -1 && w < _.children.length; ) {
            const y = _.children[w];
            if (I = l(y, w, j)(), I[0] === aS)
              return I;
            w = typeof I[1] == "number" ? I[1] : w + s;
          }
      }
      return v;
    }
  }
}
function U4(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [L4, e] : e == null ? lF : [e];
}
function cF(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), z4(e, o, l, a);
  function l(u, m) {
    const d = m[m.length - 1], f = d ? d.children.indexOf(u) : void 0;
    return s(u, f, d);
  }
}
const uy = {}.hasOwnProperty, M4 = {};
function B4(e, n) {
  const r = n || M4, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...j4, ...r.handlers }, l = {
    all: m,
    applyData: H4,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: u,
    options: r,
    patch: q4,
    wrap: K4
  };
  return cF(e, function(d) {
    if (d.type === "definition" || d.type === "footnoteDefinition") {
      const f = d.type === "definition" ? i : a, h = String(d.identifier).toUpperCase();
      f.has(h) || f.set(h, d);
    }
  }), l;
  function u(d, f) {
    const h = d.type, v = l.handlers[h];
    if (uy.call(l.handlers, h) && v)
      return v(l, d, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in d) {
        const { children: w, ...j } = d, _ = El(j);
        return _.children = l.all(d), _;
      }
      return El(d);
    }
    return (l.options.unknownHandler || W4)(l, d, f);
  }
  function m(d) {
    const f = [];
    if ("children" in d) {
      const h = d.children;
      let v = -1;
      for (; ++v < h.length; ) {
        const I = l.one(h[v], d);
        if (I) {
          if (v && h[v - 1].type === "break" && (!Array.isArray(I) && I.type === "text" && (I.value = oS(I.value)), !Array.isArray(I) && I.type === "element")) {
            const w = I.children[0];
            w && w.type === "text" && (w.value = oS(w.value));
          }
          Array.isArray(I) ? f.push(...I) : f.push(I);
        }
      }
    }
    return f;
  }
}
function q4(e, n) {
  e.position && (n.position = j3(e));
}
function H4(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, El(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function W4(e, n) {
  const r = n.data || {}, i = "value" in n && !(uy.call(r, "hProperties") || uy.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function K4(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function oS(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function sS(e, n) {
  const r = B4(e, n), i = r.one(e, void 0), a = T4(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function G4(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      sS(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      sS(r, { file: i, ...e || n })
    );
  };
}
function lS(e) {
  if (e)
    throw e;
}
var Sm, cS;
function Y4() {
  if (cS) return Sm;
  cS = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var d = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !d && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, d) {
    r && d.name === "__proto__" ? r(m, d.name, {
      enumerable: !0,
      configurable: !0,
      value: d.newValue,
      writable: !0
    }) : m[d.name] = d.newValue;
  }, l = function(m, d) {
    if (d === "__proto__")
      if (e.call(m, d)) {
        if (i)
          return i(m, d).value;
      } else return;
    return m[d];
  };
  return Sm = function u() {
    var m, d, f, h, v, I, w = arguments[0], j = 1, _ = arguments.length, y = !1;
    for (typeof w == "boolean" && (y = w, w = arguments[1] || {}, j = 2), (w == null || typeof w != "object" && typeof w != "function") && (w = {}); j < _; ++j)
      if (m = arguments[j], m != null)
        for (d in m)
          f = l(w, d), h = l(m, d), w !== h && (y && h && (o(h) || (v = a(h))) ? (v ? (v = !1, I = f && a(f) ? f : []) : I = f && o(f) ? f : {}, s(w, { name: d, newValue: u(y, I, h) })) : typeof h < "u" && s(w, { name: d, newValue: h }));
    return w;
  }, Sm;
}
var Q4 = Y4();
const Nm = /* @__PURE__ */ Ay(Q4);
function dy(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function J4() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(u, ...m) {
      const d = e[++o];
      let f = -1;
      if (u) {
        s(u);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, d ? X4(d, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function X4(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let u;
    l && s.push(a);
    try {
      u = e.apply(this, s);
    } catch (m) {
      const d = (
        /** @type {Error} */
        m
      );
      if (l && r)
        throw d;
      return a(d);
    }
    l || (u instanceof Promise ? u.then(o, a) : u instanceof Error ? a(u) : o(u));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Vr = { basename: Z4, dirname: e5, extname: n5, join: t5, sep: "/" };
function Z4(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  ls(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function e5(e) {
  if (ls(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function n5(e) {
  ls(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function t5(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    ls(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : r5(r);
}
function r5(e) {
  ls(e);
  const n = e.codePointAt(0) === 47;
  let r = i5(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function i5(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, u;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (u = r.lastIndexOf("/"), u !== r.length - 1) {
              u < 0 ? (r = "", i = 0) : (r = r.slice(0, u), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function ls(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const a5 = { cwd: o5 };
function o5() {
  return "/";
}
function my(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function s5(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!my(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return l5(e);
}
function l5(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const jm = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class uF {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? my(n) ? r = { path: n } : typeof n == "string" || c5(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : a5.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < jm.length; ) {
      const o = jm[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      jm.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Vr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    Cm(n, "basename"), wm(n, "basename"), this.path = Vr.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Vr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    uS(this.basename, "dirname"), this.path = Vr.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Vr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (wm(n, "extname"), uS(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Vr.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    my(n) && (n = s5(n)), Cm(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Vr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    Cm(n, "stem"), wm(n, "stem"), this.path = Vr.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new Yt(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function wm(e, n) {
  if (e && e.includes(Vr.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Vr.sep + "`"
    );
}
function Cm(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function uS(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function c5(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const u5 = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), d5 = {}.hasOwnProperty;
class Rg extends u5 {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = J4();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Rg()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(Nm(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (Em("data", this.frozen), this.namespace[n] = r, this) : d5.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (Em("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = Is(n), i = this.parser || this.Parser;
    return Fm("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), Fm("process", this.parser || this.Parser), Im("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = Is(n), u = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(u, l, function(d, f, h) {
        if (d || !f || !h)
          return m(d);
        const v = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), I = i.stringify(v, h);
        f5(I) ? h.value = I : h.result = I, m(
          d,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(d, f) {
        d || !f ? s(d) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), Fm("processSync", this.parser || this.Parser), Im("processSync", this.compiler || this.Compiler), this.process(n, a), mS("processSync", "process", r), i;
    function a(o, s) {
      r = !0, lS(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    dS(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const u = Is(r);
      a.run(n, u, m);
      function m(d, f, h) {
        const v = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        d ? l(d) : s ? s(v) : i(void 0, v, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), mS("runSync", "run", i), a;
    function o(s, l) {
      lS(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = Is(r), a = this.compiler || this.Compiler;
    return Im("stringify", a), dS(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (Em("use", this.frozen), n != null) if (typeof n == "function")
      u(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        u(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [d, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          u(d, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = Nm(!0, a.settings, m.settings));
    }
    function l(m) {
      let d = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++d < m.length; ) {
          const f = m[d];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function u(m, d) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...d]);
      else if (d.length > 0) {
        let [v, ...I] = d;
        const w = i[h][1];
        dy(w) && dy(v) && (v = Nm(!0, w, v)), i[h] = [m, v, ...I];
      }
    }
  }
}
const m5 = new Rg().freeze();
function Fm(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Im(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Em(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function dS(e) {
  if (!dy(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function mS(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function Is(e) {
  return p5(e) ? e : new uF(e);
}
function p5(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function f5(e) {
  return typeof e == "string" || h5(e);
}
function h5(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const y5 = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", pS = [], fS = { allowDangerousHtml: !0 }, g5 = /^(https?|ircs?|mailto|xmpp)$/i, v5 = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function k5(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || pS, u = e.remarkPlugins || pS, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...fS } : fS, d = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || b5, v = m5().use(ZU).use(u).use(G4, m).use(l), I = new uF();
  typeof i == "string" && (I.value = i);
  for (const y of v5)
    Object.hasOwn(e, y.from) && ("" + y.from + (y.to ? "use `" + y.to + "` instead" : "remove it") + y5 + y.id, void 0);
  const w = v.parse(I);
  let j = v.runSync(w, I);
  return a && (j = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      j.type === "root" ? j.children : [j]
    )
  }), cF(j, _), $3(j, {
    Fragment: We.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: We.jsx,
    jsxs: We.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function _(y, L, $) {
    if (y.type === "raw" && $ && typeof L == "number")
      return d ? $.children.splice(L, 1) : $.children[L] = { type: "text", value: y.value }, L;
    if (y.type === "element") {
      let C;
      for (C in bm)
        if (Object.hasOwn(bm, C) && Object.hasOwn(y.properties, C)) {
          const F = y.properties[C], z = bm[C];
          (z === null || z.includes(y.tagName)) && (y.properties[C] = h(String(F || ""), C, y));
        }
    }
    if (y.type === "element") {
      let C = n ? !n.includes(y.tagName) : s ? s.includes(y.tagName) : !1;
      if (!C && r && typeof L == "number" && (C = !r(y, L, $)), C && $ && typeof L == "number")
        return f && y.children ? $.children.splice(L, 1, ...y.children) : $.children.splice(L, 1), L;
    }
  }
}
function b5(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    g5.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var $m = { exports: {} }, po = {}, hS;
function _5() {
  if (hS) return po;
  hS = 1;
  var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return po.Fragment = r, po.jsx = s, po.jsxs = s, po;
}
var Es = {}, yS;
function x5() {
  return yS || (yS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var g = _.ReactDebugCurrentFrame, E = g.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var $ = !1, C = !1, F = !1, z = !1, Q = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === d || z || t === v || $ || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, N = E._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (E) {
            var g = E.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (ie) {
              g = ie;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var S = ie.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var ue = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = E;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ae(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ae(t.type, c, p);
          case h: {
            var g = t, E = g._payload, O = g._init;
            try {
              return ae(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, p, g, E) {
      {
        var O = Function.call.bind(le);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + p + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe(E), y("Failed %s type: %s", p, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, p, g, E, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, p, g, E) {
      {
        var O, N = {}, S = null, ne = null;
        p !== void 0 && (A(p), S = "" + p), gn(c) && (A(c.key), S = "" + c.key), rn(c) && (ne = c.ref, tn(c));
        for (O in c)
          le.call(c, O) && !oe.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, E, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function An(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = j(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          yn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var E = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, p, g, E, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, p, E, O);
        if (W == null)
          return W;
        if (N) {
          var ue = c.children;
          if (ue !== void 0)
            if (g)
              if (x(ue)) {
                for (var Ue = 0; Ue < ue.length; Ue++)
                  Sn(ue[Ue], t);
                Object.freeze && Object.freeze(ue);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ue, t);
        }
        if (le.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var Rn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, Rn, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, p) {
      return Fn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return Fn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Es.Fragment = i, Es.jsx = Un, Es.jsxs = Kn;
  })()), Es;
}
var gS;
function S5() {
  return gS || (gS = 1, process.env.NODE_ENV === "production" ? $m.exports = _5() : $m.exports = x5()), $m.exports;
}
var se = S5();
const N5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, j5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, w5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, C5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, F5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, I5 = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": N5,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": j5,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": w5,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": C5,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": F5
};
function cs(e) {
  return I5[e] ?? {};
}
const E5 = cs(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), $5 = cs(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), $s = ({
  title: e,
  children: n
}) => /* @__PURE__ */ se.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ se.jsx(P.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), T5 = "_issueAvatar_kc0sw_1", D5 = "_issueField_kc0sw_9", O5 = "_issueDescription_kc0sw_12", Ts = {
  issueAvatar: T5,
  issueField: D5,
  issueDescription: O5
}, dF = ({ issue: e }) => /* @__PURE__ */ se.jsxs(se.Fragment, { children: [
  /* @__PURE__ */ se.jsx($s, { title: "Assignee", children: /* @__PURE__ */ se.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: Ts.issueAvatar,
      children: [
        /* @__PURE__ */ se.jsx(
          Oy,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ se.jsx(P.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ se.jsx($s, { title: "Team", children: /* @__PURE__ */ se.jsx(
    P.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Ts.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ se.jsx($s, { title: "Project", children: /* @__PURE__ */ se.jsx(
    P.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Ts.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ se.jsx($s, { title: "Description", children: /* @__PURE__ */ se.jsx(k5, { className: Ts.issueDescription, children: e.description }) })
] }), R5 = /* @__PURE__ */ se.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ se.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ se.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ se.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), P5 = /* @__PURE__ */ se.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ se.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ se.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ se.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), A5 = /* @__PURE__ */ se.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ se.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ se.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ se.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), L5 = /* @__PURE__ */ se.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ se.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ se.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ se.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), V5 = /* @__PURE__ */ se.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ se.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), mF = {
  0: R5,
  1: V5,
  2: L5,
  3: A5,
  4: P5
}, z5 = (e) => e in mF, $l = ({ priority: e }) => z5(e) ? mF[e] : /* @__PURE__ */ se.jsx(Yn, { "data-testid": "defaultPriorityTag", children: e }), U5 = (e, n) => /* @__PURE__ */ se.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ se.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), M5 = (e, n) => /* @__PURE__ */ se.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ se.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ se.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), B5 = (e, n) => /* @__PURE__ */ se.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ se.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ se.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), q5 = (e, n) => /* @__PURE__ */ se.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ se.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), H5 = (e, n) => /* @__PURE__ */ se.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ se.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), W5 = (e, n) => /* @__PURE__ */ se.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ se.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), py = {
  backlog: (e, n) => U5(e, n),
  unstarted: (e, n) => M5(e, n),
  started: (e, n) => B5(e, n),
  done: (e, n) => q5(e, n),
  canceled: (e, n) => H5(e, n),
  completed: (e, n) => W5(e, n)
}, K5 = (e) => e in py, Tl = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => K5(e) ? py[e](n, r) : py.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), G5 = "_wrapper_e0qj3_1", Y5 = "_resultTitle_e0qj3_21", Q5 = "_resultTooltipTitle_e0qj3_28", J5 = "_resultLinkIcon_e0qj3_31", fo = {
  wrapper: G5,
  resultTitle: Y5,
  resultTooltipTitle: Q5,
  resultLinkIcon: J5
}, X5 = ({
  issue: e
}) => {
  const [n, r] = de(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = Ty(uE()), o = ft(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ se.jsx(
    Xe,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ se.jsxs(b, { flexDirection: "column", gap: "300", className: fo.wrapper, children: [
        /* @__PURE__ */ se.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ se.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ se.jsx(
              Tl,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ se.jsx(P.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ se.jsx($l, { priority: e.priority })
          ] }),
          /* @__PURE__ */ se.jsx(Yn, { children: e.state.name })
        ] }),
        /* @__PURE__ */ se.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ se.jsx(
            P.Heading,
            {
              variant: "heading-3",
              className: fo.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ se.jsx(dF, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ se.jsx(
        kt.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: fo.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ se.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ se.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ se.jsx(
                    Tl,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ se.jsx(P.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ se.jsx($l, { priority: e.priority })
                ] }),
                /* @__PURE__ */ se.jsx(P.Paragraph, { variant: "4", className: fo.resultTitle, children: e.title }),
                n && /* @__PURE__ */ se.jsx(
                  he,
                  {
                    className: fo.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, Z5 = "_loader_13xpk_1", eM = "_dropdown_13xpk_8", nM = "_loadMore_13xpk_13", Tm = {
  loader: Z5,
  dropdown: eM,
  loadMore: nM
}, tM = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = de(), [a, o] = de([]), [s, l] = de(""), [u, m] = de(!1), { useLazyQuery: d } = _n(), [f, { data: h, loading: v, networkStatus: I }] = d(
    E5,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  Zi(
    () => {
      !v && s !== "" && I === dr.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), Je(() => {
    v || o([]);
  }, [s]), Je(() => {
    if (h && Object.keys(h).length > 0) {
      const j = h.Linear.searchIssues.edges.map(
        ({ node: $ }) => $
      ), _ = a.filter(
        ($) => !n.find((C) => C.id === $.id)
      ), y = _.filter(
        ($) => !j.find(
          (C) => C.id === $.id
        )
      ), L = j.filter(
        ($) => !n.find((C) => C.id === $.id)
      );
      n.length > 0 ? o(
        u ? [...y, ...L] : L
      ) : h?.Linear?.searchIssues?.edges && o(
        u ? [..._, ...j] : j
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const w = () => {
    !v && s !== "" && I === dr.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ se.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ se.jsxs(
    _i,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (j) => j?.title,
      onChange: (j) => e(j.selectedValues[0]),
      dropdownProps: { className: Tm.dropdown },
      filter: {
        value: s,
        onChange: (j) => {
          const _ = j.target.value;
          l(_);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((j) => /* @__PURE__ */ se.jsx(X5, { issue: j }, j.id)),
        r?.hasNextPage && !v && s !== "" && a.length && /* @__PURE__ */ se.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => w(),
            className: Tm.loadMore,
            children: /* @__PURE__ */ se.jsx(P.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        v && s !== "" && /* @__PURE__ */ se.jsx(b, { justifyContent: "center", className: Tm.loader, children: /* @__PURE__ */ se.jsx(vn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ se.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ se.jsx(P.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !v && /* @__PURE__ */ se.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ se.jsx(P.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, rM = "_collapse_su0f9_1", iM = "_collapseHeader_su0f9_8", aM = "_collapseContent_su0f9_31", oM = "_url_su0f9_35", sM = "_externalLink_su0f9_51", lM = "_emptyState_su0f9_55", ki = {
  collapse: rM,
  collapseHeader: iM,
  collapseContent: aM,
  url: oM,
  externalLink: sM,
  emptyState: lM
}, cM = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (d, f) => ({ ...d, [f.id]: !1 }),
    {}
  ), [l, u] = de(s), { track: m } = En();
  return n ? /* @__PURE__ */ se.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ se.jsx(vn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ se.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ se.jsx(
          P.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: ki.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ se.jsx(
          Bt,
          {
            slotEnd: /* @__PURE__ */ se.jsx(he, { name: "external-link" }),
            variant: "tertiary",
            className: ki.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ se.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((d) => {
          const f = l[d.id];
          return /* @__PURE__ */ se.jsxs(
            xr,
            {
              "data-testid": "collapseCard",
              onToggle: () => u({ ...l, [d.id]: !l[d.id] }),
              isOpen: f,
              className: ki.collapse,
              children: [
                /* @__PURE__ */ se.jsx(xr.Header, { className: ki.collapseHeader, children: /* @__PURE__ */ se.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ se.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ se.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ se.jsx(Xe, { content: /* @__PURE__ */ se.jsx(b, { children: d.state.name }), children: /* @__PURE__ */ se.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ se.jsx(
                        Tl,
                        {
                          type: d.state.type,
                          color: d.state.color,
                          name: d.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ se.jsxs(
                        P.ExternalLink,
                        {
                          className: ki.url,
                          href: d.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            d.identifier,
                            /* @__PURE__ */ se.jsx(he, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ se.jsx(Xe, { content: /* @__PURE__ */ se.jsx(b, { children: d.priorityLabel }), children: /* @__PURE__ */ se.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ se.jsx($l, { priority: d.priority }) }) })
                    ] }),
                    /* @__PURE__ */ se.jsx(Yn, { children: d.state.name })
                  ] }),
                  d.title
                ] }) }),
                /* @__PURE__ */ se.jsx(xr.Content, { className: ki.collapseContent, children: /* @__PURE__ */ se.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  d?.labels && d?.labels?.edges?.length > 0 && /* @__PURE__ */ se.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: d.labels?.edges.map((h) => /* @__PURE__ */ se.jsx(Yn, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ se.jsx(dF, { issue: d }),
                  /* @__PURE__ */ se.jsx(
                    nt,
                    {
                      slotStart: /* @__PURE__ */ se.jsx(he, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(d.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ se.jsxs(
                    Bt,
                    {
                      slotEnd: /* @__PURE__ */ se.jsx(he, { name: "external-link" }),
                      variant: "tertiary",
                      className: ki.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: d.id
                        });
                      },
                      navigate: () => window.open(d.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        d.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            d.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ se.jsx(
          nt,
          {
            slotStart: /* @__PURE__ */ se.jsx(he, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ se.jsx(
          Bt,
          {
            slotEnd: /* @__PURE__ */ se.jsx(he, { name: "external-link" }),
            variant: "tertiary",
            className: ki.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, uM = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, pF = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => pF(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, dM = "_modalBody_iv3ua_1", mM = "_error_iv3ua_5", pM = "_dropdown_iv3ua_16", ua = {
  modalBody: dM,
  error: mM,
  dropdown: pM
}, fM = cs(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), hM = cs(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), yM = cs(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), gM = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: u } = _n(), { control: m, handleSubmit: d, reset: f } = ht(), [h, v] = de([]), [I, w] = de(), [j, _] = de([]), [y, L] = de(), [$, C] = de([]), [F, z] = de(), [Q, J] = de([]), [te, G] = de(), [B, R] = de([]), [U, ee] = de(), [Se, fe] = de(!1), { useMutation: ye } = _n(), { track: ve } = En(), [K, { loading: _e }] = ye(
    fM,
    {
      onError: () => {
        fe(!1), u({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Ce) => {
        const qe = {
          identifier: Ce.Linear?.issueCreate?.issue?.identifier,
          url: Ce.Linear?.issueCreate?.issue?.url
        };
        Ce.Linear && Ce.Linear?.issueCreate?.issue?.id && (a(Ce.Linear?.issueCreate?.issue?.id), Be(qe), fe(!1), u({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${Ce.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), ve("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Te,
    { data: X, loading: Ke, error: an }
  ] = l(hM, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => u({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ce) => {
      const qe = Ce.Linear.teams.edges.map(
        ({ node: nn }) => nn
      );
      v(qe), J(Ce.Linear.issuePriorityValues), s(`${wM}${Ce.Linear.organization.urlKey}`);
    }
  }), [we, { data: Me, loading: Re }] = l(yM, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => u({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ce) => {
      const qe = Ce?.Linear?.team?.projects?.edges?.map(
        ({ node: le }) => le
      );
      _(qe);
      const nn = Ce?.Linear?.team?.states?.edges?.map(
        ({ node: le }) => le
      );
      C(nn);
      const ae = Ce?.Linear?.team?.templates?.edges?.map(
        ({ node: le }) => le
      );
      R(
        ae.filter(
          (le) => le.type === "issue"
        )
      );
    }
  }), Be = (Ce) => {
    r(!1), L(void 0), w(void 0), z(void 0), G(void 0), ee(void 0), Ce && (e(Ce), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, Ae = (Ce) => {
    X && !Ke && (K({
      variables: {
        issueTitle: Ce.title,
        issueDescription: Ce?.description,
        teamId: Ce.team.id,
        projectId: Ce?.project?.id,
        statusId: Ce?.status?.id,
        priority: Ce?.priority?.priority
      }
    }), fe(!0));
  };
  Je(() => {
    n && Te();
  }, [n]);
  const Ge = () => {
    ve("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ se.jsxs(
    $t,
    {
      isOpen: n,
      onClose: () => {
        Ge(), Be();
      },
      children: [
        /* @__PURE__ */ se.jsx(
          Tt,
          {
            title: "Create new Linear issue",
            onClose: () => {
              Ge(), Be();
            }
          }
        ),
        /* @__PURE__ */ se.jsx(
          Dt,
          {
            className: ua.modalBody,
            "data-testid": "createIssueModalBody",
            children: an ? /* @__PURE__ */ se.jsx(Tn, { error: an }) : /* @__PURE__ */ se.jsx("form", { onSubmit: d(Ae), id: "issueCreationForm", children: /* @__PURE__ */ se.jsxs(mt, { children: [
              /* @__PURE__ */ se.jsx(ce, { span: 3, children: /* @__PURE__ */ se.jsx(
                zt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: Ce, onChange: qe },
                    fieldState: { error: nn }
                  }) => /* @__PURE__ */ se.jsx(
                    en,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: nn?.message ?? null
                      },
                      children: /* @__PURE__ */ se.jsx(
                        _i,
                        {
                          dropdownProps: { className: ua.dropdown },
                          placeholder: "Select Linear team",
                          className: dt({ [ua.error]: nn }),
                          getItemTitleByValue: (ae) => ae?.name,
                          onChange: (ae) => {
                            L(void 0), z(void 0), G(void 0), ee(void 0), w(ae.selectedValues[0]), we({
                              variables: { teamId: ae.selectedValues[0].id }
                            }), qe(ae.selectedValues[0]);
                          },
                          value: I ? [Ce] : void 0,
                          children: h?.map((ae) => /* @__PURE__ */ se.jsx(
                            kt.Item,
                            {
                              value: ae,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ se.jsx(P.Paragraph, { children: ae.name })
                            },
                            ae.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ se.jsx(ce, { span: 3, children: /* @__PURE__ */ se.jsx(
                zt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: Ce, onChange: qe } }) => {
                    const nn = Re ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ se.jsx(en, { label: "Project", children: /* @__PURE__ */ se.jsx(
                      _i,
                      {
                        dropdownProps: { className: ua.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (ae) => ae?.name,
                        disabled: I === void 0,
                        placeholder: I ? "Select Linear project" : "Select a Team first",
                        onChange: (ae) => {
                          L(ae.selectedValues[0]), qe(ae.selectedValues[0]);
                        },
                        value: y ? [Ce] : nn,
                        children: /* @__PURE__ */ se.jsxs(se.Fragment, { children: [
                          Re && /* @__PURE__ */ se.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ se.jsx(vn, { size: 24 })
                            }
                          ),
                          Me && !Re && j.map((ae) => /* @__PURE__ */ se.jsx(
                            kt.Item,
                            {
                              value: ae,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ se.jsx(P.Paragraph, { children: ae.name })
                            },
                            ae.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ se.jsx(ce, { span: 6, children: /* @__PURE__ */ se.jsx(en, { label: "Template", children: /* @__PURE__ */ se.jsx(
                _i,
                {
                  clearable: !0,
                  dropdownProps: { className: ua.dropdown },
                  disabled: !I || Re,
                  placeholder: I ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (Ce) => Ce?.name,
                  onChange: (Ce) => {
                    if (Ce.selectedValues.length > 0) {
                      ee(Ce.selectedValues[0]);
                      const qe = JSON.parse(
                        Ce.selectedValues[0].templateData
                      ), nn = Q.filter(
                        (Le) => Le.priority === qe.priority
                      );
                      G(
                        nn ? nn[0] : void 0
                      );
                      const ae = $.filter(
                        (Le) => Le.id === qe.stateId
                      );
                      z(
                        ae ? ae[0] : void 0
                      );
                      const le = j.filter(
                        (Le) => Le.id === qe.projectId
                      );
                      L(
                        le ? le[0] : void 0
                      );
                      const xe = qe.description;
                      f({
                        title: qe?.title,
                        priority: nn[0],
                        status: ae[0],
                        project: le[0],
                        description: xe ? pF(xe, uM) : "",
                        team: I
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: I
                      }), L(void 0), G(void 0), z(void 0), ee(void 0);
                  },
                  value: U ? [U] : void 0,
                  children: B?.map((Ce) => /* @__PURE__ */ se.jsx(
                    kt.Item,
                    {
                      value: Ce,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ se.jsx(P.Paragraph, { children: Ce.name })
                    },
                    Ce.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ se.jsx(ce, { span: 6, children: /* @__PURE__ */ se.jsx(
                zt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: Ce, value: qe },
                    fieldState: { error: nn }
                  }) => /* @__PURE__ */ se.jsx(
                    ur,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: qe || "",
                        onChange: Ce
                      },
                      meta: {
                        error: nn?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ se.jsx(ce, { span: 3, children: /* @__PURE__ */ se.jsx(
                zt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: Ce, onChange: qe } }) => {
                    const nn = Re ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ se.jsx(en, { label: "Status", children: /* @__PURE__ */ se.jsx(
                      _i,
                      {
                        dropdownProps: { className: ua.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (ae) => ae?.name,
                        disabled: I === void 0,
                        placeholder: I ? "Select Issue status" : "Select a Team first",
                        onChange: (ae) => {
                          z(ae.selectedValues[0]), qe(ae.selectedValues[0]);
                        },
                        value: F ? [Ce] : nn,
                        children: /* @__PURE__ */ se.jsxs(se.Fragment, { children: [
                          Re && /* @__PURE__ */ se.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ se.jsx(vn, { size: 24 })
                            }
                          ),
                          Me && !Re && $.map((ae) => /* @__PURE__ */ se.jsx(
                            kt.Item,
                            {
                              value: ae,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ se.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ se.jsx(
                                      Tl,
                                      {
                                        type: ae.type,
                                        color: ae.color,
                                        name: ae.name
                                      }
                                    ),
                                    /* @__PURE__ */ se.jsx(P.Paragraph, { children: ae.name })
                                  ]
                                }
                              )
                            },
                            ae.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ se.jsx(ce, { span: 3, children: /* @__PURE__ */ se.jsx(
                zt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: Ce, onChange: qe } }) => {
                    const nn = Ke ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ se.jsx(en, { label: "Priority", children: /* @__PURE__ */ se.jsx(
                      _i,
                      {
                        clearable: !0,
                        getItemTitleByValue: (ae) => ae?.label,
                        disabled: I === void 0,
                        placeholder: I ? "Select Issue priority" : "Select a Team first",
                        onChange: (ae) => {
                          G(ae.selectedValues[0]), qe(ae.selectedValues[0]);
                        },
                        value: te ? [Ce] : nn,
                        children: /* @__PURE__ */ se.jsxs(se.Fragment, { children: [
                          Re && /* @__PURE__ */ se.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ se.jsx(vn, { size: 24 })
                            }
                          ),
                          X && !Ke && Q.map((ae) => /* @__PURE__ */ se.jsx(
                            kt.Item,
                            {
                              value: ae,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ se.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ se.jsx(
                                      $l,
                                      {
                                        priority: ae.priority
                                      }
                                    ),
                                    /* @__PURE__ */ se.jsx(P.Paragraph, { children: ae.label })
                                  ]
                                }
                              )
                            },
                            ae.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ se.jsx(ce, { children: /* @__PURE__ */ se.jsx(
                zt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: Ce, value: qe },
                    fieldState: { error: nn }
                  }) => /* @__PURE__ */ se.jsx(
                    lE,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: qe || "",
                        onChange: Ce
                      },
                      meta: {
                        error: nn?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ se.jsx(
          Ht,
          {
            confirmOnClick: d(Ae),
            confirmProps: {
              disabled: _e || !X,
              isLoading: Se || Ke || Re,
              loadingIndicator: /* @__PURE__ */ se.jsx(vn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              Ge(), Be();
            }
          }
        )
      ]
    }
  );
}, vM = "_modalWrapper_4kh9u_1", kM = "_copyButton_4kh9u_6", bM = "_copyWrapper_4kh9u_15", _M = "_copyField_4kh9u_24", xM = "_externalLink_4kh9u_47", SM = "_externalLinkIcon_4kh9u_52", NM = "_textWrapper_4kh9u_56", Ti = {
  modalWrapper: vM,
  copyButton: kM,
  copyWrapper: bM,
  copyField: _M,
  externalLink: xM,
  externalLinkIcon: SM,
  textWrapper: NM
}, jM = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ se.jsxs(
  $t,
  {
    isOpen: !!n && e,
    className: Ti.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ se.jsx(
        Tt,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ se.jsx(Dt, { children: /* @__PURE__ */ se.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ se.jsxs(P.Paragraph, { className: Ti.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ se.jsxs(
                P.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: Ti.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ se.jsx(he, { name: "external-link", className: Ti.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ se.jsx(en, { label: "Linear issue link", children: /* @__PURE__ */ se.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: Ti.copyWrapper,
                children: [
                  /* @__PURE__ */ se.jsx(
                    _r,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: Ti.copyField
                    }
                  ),
                  /* @__PURE__ */ se.jsx(
                    cE,
                    {
                      className: Ti.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ se.jsx(
        Ht,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), wM = "https://linear.app/", CM = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = de([]), [a, o] = de([]), [s, l] = de(!1), [u, m] = de(!1), [d, f] = de(!1), [h, v] = de(), { useLazyQuery: I } = _n(), [w, j] = de(""), _ = n?.enableCreateIssue, y = !!n?.enableUnlinkAll, { track: L } = En(), {
    loading: $,
    data: C,
    error: F,
    store: z
  } = $y(e?.conversationId ?? null), [
    Q,
    {
      data: J,
      loading: te,
      networkStatus: G,
      error: B
    }
  ] = I($5, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Je(() => {
    !$ && !F && C && C?.linear?.issues?.length > 0 ? (o(C.linear.issues), Q({
      variables: {
        linkedIssues: C.linear.issues
      }
    })) : !$ && !F && (i([]), o([]));
  }, [C, $, F]), Je(() => {
    J && J?.Linear && !te && G === dr.ready && Object.keys(J).length > 0 && i(J.Linear.issues?.edges?.map(({ node: fe }) => fe));
  }, [J, te, G]);
  const R = (fe) => {
    fe && fe?.team?.organization?.urlKey && L("linear:link:issue:clicked", {
      linearInstanceUrl: w,
      linearIssueKey: fe.id
    });
    const ye = (ve) => ve.id === fe?.id;
    r.some((ve) => ve && ye(ve)) || (C && a.length === 0 && o([]), z({
      linear: {
        issues: [...a, fe.id]
      }
    }));
  }, U = (fe) => {
    const ye = C?.linear.issues.filter((ve) => ve !== fe) || [];
    L("linear:unlink:issue:clicked", {
      linearInstanceUrl: w,
      linearIssueKey: fe
    }), i(r.filter(({ id: ve }) => ve !== fe)), o(ye), z({
      linear: {
        issues: ye
      }
    });
  }, ee = () => {
    l(!1), i([]), o([]), z({
      linear: {
        issues: []
      }
    });
  }, Se = $ || te || !C && !F || (C?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !$ && !te && (B || F) ? /* @__PURE__ */ se.jsx(Tn, { error: B || F }) : /* @__PURE__ */ se.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ se.jsxs(
      $t,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ se.jsx(
            Tt,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ se.jsx(Dt, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ se.jsx(
            Ht,
            {
              confirmOnClick: () => ee(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ se.jsx(
      gM,
      {
        isCreateIssueModalOpen: u,
        setIsCreateIssueModalOpen: (fe) => m(fe),
        setIsCreationSuccessfulModalOpen: (fe) => f(fe),
        addToLinkedIssueIds: (fe) => {
          z({
            linear: {
              issues: [...a, fe]
            }
          });
        },
        setCreatedIssue: (fe) => v(fe),
        organizationUrl: w,
        setOrganizationUrl: (fe) => j(fe)
      }
    ),
    /* @__PURE__ */ se.jsx(
      jM,
      {
        isCreationSuccessfulModalOpen: d,
        setIsCreationSuccessfulModalOpen: (fe) => f(fe),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ se.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          _ && /* @__PURE__ */ se.jsxs(se.Fragment, { children: [
            /* @__PURE__ */ se.jsx(
              nt,
              {
                variant: "primary",
                onClick: () => {
                  L("linear:create:new:issue:clicked", {
                    linearInstanceUrl: w
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ se.jsx(P.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ se.jsx(tM, { handleSelect: R, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ se.jsx(
      cM,
      {
        linkedIssues: r,
        isLoading: Se,
        handleUnlinkIssue: U,
        showUnlinkAllModal: (fe) => l(fe),
        showUnlinkAllButton: y,
        organizationUrl: w
      }
    )
  ] });
}, fy = [
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], Di = "LINEAR", FM = {
  enabled: !1,
  name: "",
  enableCreateIssue: !0,
  enableUnlinkAll: !0
}, IM = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ht({
    mode: "onChange",
    defaultValues: FM
  }), {
    create: u,
    update: m,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: I
  } = Gr({
    integrationId: e,
    integrationType: Di,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: w,
    error: j,
    isWidgetUnknown: _,
    refetch: y,
    widgetConfiguration: L
  } = Yr({
    integrationId: e,
    fieldDefinitions: fy,
    form: l,
    onMisconfigured: I
  }), { renderConditions: $, setRenderConditions: C, renderConditionsForSubmit: F } = Qr({
    integrationId: e,
    widgetConfiguration: L,
    renderConditionsEditor: o
  }), z = (J) => Xr(J, {
    fieldDefinitions: fy,
    isCreationMode: s,
    create: u,
    update: m,
    renderConditions: F
  }), Q = l.watch("name");
  return /* @__PURE__ */ se.jsxs(
    Jr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: z,
      error: j ?? h,
      onRetry: j ? y : void 0,
      isLoading: f || w,
      isWidgetUnknown: _,
      children: [
        v && /* @__PURE__ */ se.jsx(Zr, { cause: v }),
        /* @__PURE__ */ se.jsxs(mt, { children: [
          /* @__PURE__ */ se.jsx(ce, { children: /* @__PURE__ */ se.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ se.jsx(
            Dn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(ce, { span: 3, children: /* @__PURE__ */ se.jsx(
            Zn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ se.jsx(ce, { span: 3 }),
          /* @__PURE__ */ se.jsx(ce, { span: 3, children: /* @__PURE__ */ se.jsx(en, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ se.jsx(
            Dn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(ce, { span: 3 }),
          /* @__PURE__ */ se.jsx(ce, { span: 3, children: /* @__PURE__ */ se.jsx(en, { label: 'Enable the "Unlink all" button', children: /* @__PURE__ */ se.jsx(
            Dn,
            {
              name: "enableUnlinkAll",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(ce, { span: 3 }),
          !s && e && /* @__PURE__ */ se.jsx(
            Oa,
            {
              configuration: n,
              integrationId: e,
              integrationType: Di,
              label: "Authorize with OAuth"
            }
          ),
          o && $ !== null && /* @__PURE__ */ se.jsx(ce, { children: o({
            value: $,
            onChange: C,
            configurationKey: L?.id
          }) })
        ] }),
        /* @__PURE__ */ se.jsx(
          ei,
          {
            integrationType: Di,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ se.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ se.jsx(
                he,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ se.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ se.jsxs(P.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Di,
                  " integration, all links between Dixa and ",
                  Di,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ se.jsxs(P.Paragraph, { children: [
                  "All data in ",
                  Di,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ se.jsxs(P.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Di,
                  " ",
                  'integration "',
                  Q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Dm = { exports: {} }, ho = {}, vS;
function EM() {
  if (vS) return ho;
  vS = 1;
  var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ho.Fragment = r, ho.jsx = s, ho.jsxs = s, ho;
}
var Ds = {}, kS;
function $M() {
  return kS || (kS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var g = _.ReactDebugCurrentFrame, E = g.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var $ = !1, C = !1, F = !1, z = !1, Q = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === d || z || t === v || $ || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, N = E._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (E) {
            var g = E.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (ie) {
              g = ie;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var S = ie.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var ue = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = E;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ae(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ae(t.type, c, p);
          case h: {
            var g = t, E = g._payload, O = g._init;
            try {
              return ae(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, p, g, E) {
      {
        var O = Function.call.bind(le);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + p + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe(E), y("Failed %s type: %s", p, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, p, g, E, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, p, g, E) {
      {
        var O, N = {}, S = null, ne = null;
        p !== void 0 && (A(p), S = "" + p), gn(c) && (A(c.key), S = "" + c.key), rn(c) && (ne = c.ref, tn(c));
        for (O in c)
          le.call(c, O) && !oe.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, E, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function An(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = j(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          yn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var E = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, p, g, E, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, p, E, O);
        if (W == null)
          return W;
        if (N) {
          var ue = c.children;
          if (ue !== void 0)
            if (g)
              if (x(ue)) {
                for (var Ue = 0; Ue < ue.length; Ue++)
                  Sn(ue[Ue], t);
                Object.freeze && Object.freeze(ue);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ue, t);
        }
        if (le.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var Rn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, Rn, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, p) {
      return Fn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return Fn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Ds.Fragment = i, Ds.jsx = Un, Ds.jsxs = Kn;
  })()), Ds;
}
var bS;
function TM() {
  return bS || (bS = 1, process.env.NODE_ENV === "production" ? Dm.exports = EM() : Dm.exports = $M()), Dm.exports;
}
var Ie = TM();
const DM = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, OM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, RM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, PM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, AM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, LM = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": DM,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": OM,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": RM,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": PM,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": AM
};
function oc(e) {
  return LM[e] ?? {};
}
const VM = oc(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), zM = oc(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), UM = oc(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), MM = oc(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function Om(e = !1, n) {
  const [r, i] = de(e);
  return Je(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const BM = "_wrapper_27vny_1", qM = "_copyIcon_27vny_12", yo = {
  wrapper: BM,
  copyIcon: qM
}, HM = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = Om(), { isCopied: i, copy: a } = Om(), { isCopied: o, copy: s } = Om();
  if (!e)
    return null;
  const l = 14, {
    email: u,
    properties: m,
    metadata: d,
    birthday: f,
    created_at: h,
    enrolled: v,
    enrolled_at: I,
    referral_url: w
  } = e, j = f ? Qn(f).isSame(Date.now(), "day") : !1, { name: _, first_name: y, last_name: L } = m ?? {}, $ = _ ?? (`${y} ${L}`.trim() || "A customer has no name"), C = d?.shopify_source_url ? d.shopify_source_url.startsWith("https://") ? d.shopify_source_url : `https://${d.shopify_source_url}` : "";
  return /* @__PURE__ */ Ie.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ie.jsxs(b, { className: yo.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Ie.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: yo.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ Ie.jsx(P.Heading, { variant: "heading-2", children: $ }),
          j && /* @__PURE__ */ Ie.jsx(P.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ Ie.jsx(P.Paragraph, { variant: "4", color: "secondary", children: Qn(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    v && /* @__PURE__ */ Ie.jsx(b, { gap: "200", children: /* @__PURE__ */ Ie.jsxs(P.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Qn(I).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Ie.jsx(he, { size: l, name: "mail" }),
        /* @__PURE__ */ Ie.jsx(P.ExternalLink, { href: `mailto:${u}`, children: u })
      ] }),
      /* @__PURE__ */ Ie.jsx(Xe, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ Ie.jsx(
        he,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(u),
          className: yo.copyIcon
        }
      ) })
    ] }),
    C && /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Ie.jsx(he, { size: l, name: "link" }),
        /* @__PURE__ */ Ie.jsx(Xe, { content: "Shopify shop", children: /* @__PURE__ */ Ie.jsx(
          P.ExternalLink,
          {
            href: C,
            target: "_blank",
            rel: "noreferrer",
            children: C.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Ie.jsx(Xe, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ Ie.jsx(
        he,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(C),
          className: yo.copyIcon
        }
      ) })
    ] }),
    w && /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Ie.jsx(he, { size: l, name: "external-link" }),
        /* @__PURE__ */ Ie.jsx(Xe, { content: "Referral link", children: /* @__PURE__ */ Ie.jsx(
          P.ExternalLink,
          {
            href: w,
            target: "_blank",
            rel: "noreferrer",
            children: w.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Ie.jsx(Xe, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ Ie.jsx(
        he,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(w),
          className: yo.copyIcon
        }
      ) })
    ] })
  ] }) });
}, WM = "_list_1q5b5_5", KM = "_listItem_1q5b5_8", GM = "_listItemEdit_1q5b5_15", YM = "_notificationText_1q5b5_19", $a = {
  list: WM,
  listItem: KM,
  listItemEdit: GM,
  notificationText: YM
}, QM = "_modalBody_1clhs_1", JM = {
  modalBody: QM
}, XM = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = _n(), { track: l } = En(), [u, m] = de(n), [d, f] = de(""), [h, v] = de(), [I, { loading: w }] = o(
    UM,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), G();
      }
    }
  ), [j, { loading: _ }] = o(MM), y = w || _, L = !!h, $ = n === u ? "Change the value to update the points" : "", C = isNaN(u), F = C ? "Points can not be empty" : "", z = u > n && u - n > 1e6, Q = z ? "Points can not exceed 1,000,000" : "", J = () => {
    if (!r) {
      v(["Merchant information is missing."]), u > n ? l("loyaltylion:add:points:failed") : u < n && l("loyaltylion:remove:points:failed");
      return;
    }
    u > n && I({
      variables: {
        input: {
          points: u - n,
          reason: d
        },
        merchantId: r
      }
    }).catch((B) => {
      const R = B?.networkError;
      (R ? R?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), G()) : (l("loyaltylion:add:points:failed"), v(["Failed to add points, try again later."]));
    }), u < n && j({
      variables: {
        input: {
          points: n - u,
          reason: d
        },
        merchantId: r
      }
    }).then((B) => {
      B.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), G()) : "errors" in B && (l("loyaltylion:remove:points:failed"), v(
        B.errors?.map((R) => R.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), v(["Failed to remove points, try again later."]);
    });
  }, te = () => {
    C && m(n), f(""), i();
  }, G = () => {
    a(), te();
  };
  return /* @__PURE__ */ Ie.jsxs(
    $t,
    {
      isOpen: e,
      onClose: te,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ Ie.jsx(Tt, { title: "Change points", onClose: te }),
        /* @__PURE__ */ Ie.jsxs(Dt, { className: JM.modalBody, children: [
          /* @__PURE__ */ Ie.jsxs(mt, { children: [
            /* @__PURE__ */ Ie.jsx(ce, { span: 6, children: /* @__PURE__ */ Ie.jsx(
              ur,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: Q || F,
                  warning: $
                },
                input: {
                  name: "points",
                  value: u.toString(),
                  onChange: (B) => m(B?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ Ie.jsx(ce, { span: 6, children: /* @__PURE__ */ Ie.jsx(
              ur,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: d,
                  onChange: (B) => f(B?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !y && L && /* @__PURE__ */ Ie.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ Ie.jsx(Qe, { children: h?.map((B, R) => /* @__PURE__ */ Ie.jsx(
            Qe.Item,
            {
              variant: "dense",
              title: B,
              contentLeft: /* @__PURE__ */ Ie.jsx(
                he,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            R
          )) }) })
        ] }),
        /* @__PURE__ */ Ie.jsx(
          Ht,
          {
            confirmName: "Save",
            confirmOnClick: () => J(),
            confirmProps: {
              isLoading: y,
              disabled: C || z || n === u,
              loadingIndicator: /* @__PURE__ */ Ie.jsx(vn, { size: 16 })
            },
            cancelOnClick: te
          }
        )
      ]
    }
  );
}, ZM = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ Ie.jsx(Qe.Text, { variant: "dense", className: $a.listItem, children: /* @__PURE__ */ Ie.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ie.jsx(he, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ Ie.jsx(P.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ Ie.jsx(Xe, { content: "Edit points", children: /* @__PURE__ */ Ie.jsx(
        he,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: $a.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ Ie.jsx(Bn, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, eB = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = de(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: u
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: u ?? 0
    }
  ];
  return /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ie.jsx(P.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ Ie.jsx(Qe, { className: $a.list, children: m.map(({ id: d, points: f, label: h, setIsModalOpen: v }) => /* @__PURE__ */ Ie.jsx(
      ZM,
      {
        points: f,
        label: h,
        setIsModalOpen: v
      },
      d
    )) }),
    /* @__PURE__ */ Ie.jsx(
      XM,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, nB = "_reward_1wxia_1", tB = {
  reward: nB
}, rB = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ Ie.jsx(b, { gap: "100", flexDirection: "column", className: tB.reward, children: /* @__PURE__ */ Ie.jsx(Xe, { content: a ?? "No description", children: /* @__PURE__ */ Ie.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ Ie.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ Ie.jsx(he, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ Ie.jsxs(Bn, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ Ie.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ie.jsx(he, { size: 14, name: "external-link" }),
      /* @__PURE__ */ Ie.jsx(
        P.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, iB = ({ customer: e }) => {
  const { useQuery: n } = _n(), [r, i] = de(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(zM, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (Je(() => {
    if (l?.LoyaltyLion) {
      const u = l.LoyaltyLion?.getAvailableRewards?.rewards;
      u && i(u);
    }
  }, [l]), s) {
    const u = s.graphQLErrors;
    return Ra({ errors: u }) ? /* @__PURE__ */ Ie.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: $a.notificationText,
        children: "No rewards found"
      }
    ) : Kw({ errors: u }) ? /* @__PURE__ */ Ie.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: $a.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ Ie.jsx(Tn, { error: s });
  }
  return /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ie.jsx(P.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ Ie.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ie.jsx(vn, {}) }) : /* @__PURE__ */ Ie.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((u) => /* @__PURE__ */ Ie.jsx(rB, { reward: u }, u.id)) })
  ] });
}, aB = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ Ie.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Ie.jsx(Yn, { children: /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ie.jsx(
        he,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ Ie.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Ie.jsx(Yn, { children: /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ie.jsx(he, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ Ie.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Ie.jsx(Xe, { content: "Insights segment", children: /* @__PURE__ */ Ie.jsx(Yn, { children: /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ie.jsx(he, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, oB = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = _n(), { track: i } = En(), [a, o] = de(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: u,
    showPointsBalance: m,
    showAvailableRewards: d
  } = n, f = !l && !u && !m && !d, {
    loading: h,
    error: v,
    data: I,
    refetch: w
  } = r(VM, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return Je(() => {
    if (I && !h) {
      const j = (I?.LoyaltyLion?.getCustomers).customers;
      j && j.length > 0 && (o(j[0]), i("loyaltylion:customer:received"));
    }
  }, [I, h]), s?.email ? v ? Ra({
    errors: v.graphQLErrors
  }) ? /* @__PURE__ */ Ie.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: $a.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ Ie.jsx(Tn, { error: v }) : h ? /* @__PURE__ */ Ie.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ie.jsx(vn, {}) }) : f ? /* @__PURE__ */ Ie.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ Ie.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ Ie.jsxs(Ie.Fragment, { children: [
        l && /* @__PURE__ */ Ie.jsx(HM, { customer: a }),
        u && /* @__PURE__ */ Ie.jsx(aB, { customer: a }),
        m && /* @__PURE__ */ Ie.jsx(
          eB,
          {
            customer: a,
            refetchCustomerData: w
          }
        ),
        d && /* @__PURE__ */ Ie.jsx(iB, { customer: a })
      ] }) : /* @__PURE__ */ Ie.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ Ie.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, hy = [
  {
    key: "basicAuthorization",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerSummary",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showTags",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], _S = "LOYALTYLION", sB = {
  enabled: !1,
  name: "",
  basicAuthorization: "",
  showCustomerSummary: !0,
  showTags: !0,
  showPointsBalance: !0,
  showAvailableRewards: !0
}, lB = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ht({
    mode: "onChange",
    defaultValues: sB
  }), {
    create: l,
    update: u,
    remove: m,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = Gr({
    integrationId: e,
    integrationType: _S,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: I,
    error: w,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: y
  } = Yr({
    integrationId: e,
    fieldDefinitions: hy,
    form: s,
    onMisconfigured: v
  }), { renderConditions: L, setRenderConditions: $, renderConditionsForSubmit: C } = Qr({
    integrationId: e,
    widgetConfiguration: y,
    renderConditionsEditor: a
  }), F = (Q) => Xr(Q, {
    fieldDefinitions: hy,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: C
  }), z = s.watch("name");
  return /* @__PURE__ */ Ie.jsxs(
    Jr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: w ?? f,
      onRetry: w ? _ : void 0,
      isLoading: d || I,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ Ie.jsx(Zr, { cause: h }),
        /* @__PURE__ */ Ie.jsxs(mt, { children: [
          /* @__PURE__ */ Ie.jsx(ce, { children: /* @__PURE__ */ Ie.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ie.jsx(
            Dn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(ce, { span: 3, children: /* @__PURE__ */ Ie.jsx(
            Zn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ie.jsx(ce, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(ce, { span: 3, children: /* @__PURE__ */ Ie.jsx(
            GI,
            {
              name: "basicAuthorization",
              label: "LoyaltyLion authorization",
              control: s.control,
              isCreationMode: o,
              rules: { required: "Please insert a value for both fields" },
              usernameLabel: "Token",
              passwordLabel: "Secret",
              usernamePlaceholder: "Insert your token",
              passwordPlaceholder: "Insert your secret"
            }
          ) }),
          /* @__PURE__ */ Ie.jsx(ce, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(ce, { span: 3, children: /* @__PURE__ */ Ie.jsx(en, { label: "Show customer summary", children: /* @__PURE__ */ Ie.jsx(
            Dn,
            {
              name: "showCustomerSummary",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(ce, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(ce, { span: 3, children: /* @__PURE__ */ Ie.jsx(en, { label: "Show tags", children: /* @__PURE__ */ Ie.jsx(
            Dn,
            {
              name: "showTags",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(ce, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(ce, { span: 3, children: /* @__PURE__ */ Ie.jsx(en, { label: "Show points balance", children: /* @__PURE__ */ Ie.jsx(
            Dn,
            {
              name: "showPointsBalance",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(ce, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(ce, { span: 3, children: /* @__PURE__ */ Ie.jsx(en, { label: "Show available rewards", children: /* @__PURE__ */ Ie.jsx(
            Dn,
            {
              name: "showAvailableRewards",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(ce, { span: 3 }),
          a && L !== null && /* @__PURE__ */ Ie.jsx(ce, { children: a({
            value: L,
            onChange: $,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ Ie.jsx(
          ei,
          {
            integrationType: _S,
            integrationId: e,
            widgetName: z,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Rm = { exports: {} }, go = {}, xS;
function cB() {
  if (xS) return go;
  xS = 1;
  var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return go.Fragment = r, go.jsx = s, go.jsxs = s, go;
}
var Os = {}, SS;
function uB() {
  return SS || (SS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var g = _.ReactDebugCurrentFrame, E = g.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var $ = !1, C = !1, F = !1, z = !1, Q = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === d || z || t === v || $ || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, N = E._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (E) {
            var g = E.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (ie) {
              g = ie;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var S = ie.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var ue = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = E;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ae(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ae(t.type, c, p);
          case h: {
            var g = t, E = g._payload, O = g._init;
            try {
              return ae(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, p, g, E) {
      {
        var O = Function.call.bind(le);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + p + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe(E), y("Failed %s type: %s", p, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, p, g, E, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, p, g, E) {
      {
        var O, N = {}, S = null, ne = null;
        p !== void 0 && (A(p), S = "" + p), gn(c) && (A(c.key), S = "" + c.key), rn(c) && (ne = c.ref, tn(c));
        for (O in c)
          le.call(c, O) && !oe.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, E, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function An(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = j(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          yn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var E = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, p, g, E, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, p, E, O);
        if (W == null)
          return W;
        if (N) {
          var ue = c.children;
          if (ue !== void 0)
            if (g)
              if (x(ue)) {
                for (var Ue = 0; Ue < ue.length; Ue++)
                  Sn(ue[Ue], t);
                Object.freeze && Object.freeze(ue);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ue, t);
        }
        if (le.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var Rn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, Rn, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, p) {
      return Fn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return Fn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Os.Fragment = i, Os.jsx = Un, Os.jsxs = Kn;
  })()), Os;
}
var NS;
function dB() {
  return NS || (NS = 1, process.env.NODE_ENV === "production" ? Rm.exports = cB() : Rm.exports = uB()), Rm.exports;
}
var hn = dB();
const mB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, pB = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": mB
};
function fB(e) {
  return pB[e] ?? {};
}
function jS(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, i = Array(n); r < n; r++) i[r] = e[r];
  return i;
}
function hB(e) {
  if (Array.isArray(e)) return e;
}
function yB(e, n) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var i, a, o, s, l = [], u = !0, m = !1;
    try {
      if (o = (r = r.call(e)).next, n !== 0) for (; !(u = (i = o.call(r)).done) && (l.push(i.value), l.length !== n); u = !0) ;
    } catch (d) {
      m = !0, a = d;
    } finally {
      try {
        if (!u && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (m) throw a;
      }
    }
    return l;
  }
}
function gB() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vB(e, n) {
  return hB(e) || yB(e, n) || kB(e, n) || gB();
}
function kB(e, n) {
  if (e) {
    if (typeof e == "string") return jS(e, n);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? jS(e, n) : void 0;
  }
}
const fF = Object.entries, wS = Object.setPrototypeOf, bB = Object.isFrozen, _B = Object.getPrototypeOf, xB = Object.getOwnPropertyDescriptor;
let Mt = Object.freeze, qt = Object.seal, va = Object.create, hF = typeof Reflect < "u" && Reflect, yy = hF.apply, gy = hF.construct;
Mt || (Mt = function(e) {
  return e;
});
qt || (qt = function(e) {
  return e;
});
yy || (yy = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
gy || (gy = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const vo = jt(Array.prototype.forEach), SB = jt(Array.prototype.lastIndexOf), CS = jt(Array.prototype.pop), da = jt(Array.prototype.push), NB = jt(Array.prototype.splice), Si = Array.isArray, Ro = jt(String.prototype.toLowerCase), Pm = jt(String.prototype.toString), FS = jt(String.prototype.match), ko = jt(String.prototype.replace), IS = jt(String.prototype.indexOf), jB = jt(String.prototype.trim), wB = jt(Number.prototype.toString), CB = jt(Boolean.prototype.toString), ES = typeof BigInt > "u" ? null : jt(BigInt.prototype.toString), $S = typeof Symbol > "u" ? null : jt(Symbol.prototype.toString), Et = jt(Object.prototype.hasOwnProperty), bo = jt(Object.prototype.toString), Rt = jt(RegExp.prototype.test), Oi = FB(TypeError);
function jt(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return yy(e, n, i);
  };
}
function FB(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return gy(e, r);
  };
}
function Wn(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ro;
  if (wS && wS(e, null), !Si(n))
    return e;
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (bB(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function IB(e) {
  for (let n = 0; n < e.length; n++)
    Et(e, n) || (e[n] = null);
  return e;
}
function Jt(e) {
  const n = va(null);
  for (const i of fF(e)) {
    var r = vB(i, 2);
    const a = r[0], o = r[1];
    Et(e, a) && (Si(o) ? n[a] = IB(o) : o && typeof o == "object" && o.constructor === Object ? n[a] = Jt(o) : n[a] = o);
  }
  return n;
}
function EB(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return wB(e);
    case "boolean":
      return CB(e);
    case "bigint":
      return ES ? ES(e) : "0";
    case "symbol":
      return $S ? $S(e) : "Symbol()";
    case "undefined":
      return bo(e);
    case "function":
    case "object": {
      if (e === null)
        return bo(e);
      const n = e, r = Lr(n, "toString");
      if (typeof r == "function") {
        const i = r(n);
        return typeof i == "string" ? i : bo(i);
      }
      return bo(e);
    }
    default:
      return bo(e);
  }
}
function Lr(e, n) {
  for (; e !== null; ) {
    const i = xB(e, n);
    if (i) {
      if (i.get)
        return jt(i.get);
      if (typeof i.value == "function")
        return jt(i.value);
    }
    e = _B(e);
  }
  function r() {
    return null;
  }
  return r;
}
function $B(e) {
  try {
    return Rt(e, ""), !0;
  } catch {
    return !1;
  }
}
const TS = Mt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Am = Mt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Lm = Mt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), TB = Mt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Vm = Mt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), DB = Mt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), DS = Mt(["#text"]), OS = Mt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), zm = Mt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), RS = Mt(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Rs = Mt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), OB = qt(/{{[\w\W]*|^[\w\W]*}}/g), RB = qt(/<%[\w\W]*|^[\w\W]*%>/g), PB = qt(/\${[\w\W]*/g), AB = qt(/^data-[\-\w.\u00B7-\uFFFF]+$/), LB = qt(/^aria-[\-\w]+$/), PS = qt(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), VB = qt(/^(?:\w+script|data):/i), zB = qt(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), UB = qt(/^html$/i), MB = qt(/^[a-z][.\w]*(-[.\w]+)+$/i), AS = qt(/<[/\w!]/g), BB = qt(/<[/\w]/g), qB = qt(/<\/no(script|embed|frames)/i), HB = qt(/\/>/i), Ar = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, WB = function() {
  return typeof window > "u" ? null : window;
}, KB = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, LS = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
}, bi = function(e, n, r, i) {
  return Et(e, n) && Si(e[n]) ? Wn(i.base ? Jt(i.base) : {}, e[n], i.transform) : r;
};
function yF() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : WB();
  const n = (Z) => yF(Z);
  if (n.version = "3.4.11", n.removed = [], !e || !e.document || e.document.nodeType !== Ar.document || !e.Element)
    return n.isSupported = !1, n;
  let r = e.document;
  const i = r, a = i.currentScript;
  e.DocumentFragment;
  const o = e.HTMLTemplateElement, s = e.Node, l = e.Element, u = e.NodeFilter;
  e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
  const d = e.DOMParser, f = e.trustedTypes, h = l.prototype, v = Lr(h, "cloneNode"), I = Lr(h, "remove"), w = Lr(h, "nextSibling"), j = Lr(h, "childNodes"), _ = Lr(h, "parentNode"), y = Lr(h, "shadowRoot"), L = Lr(h, "attributes"), $ = s && s.prototype ? Lr(s.prototype, "nodeType") : null, C = s && s.prototype ? Lr(s.prototype, "nodeName") : null;
  if (typeof o == "function") {
    const Z = r.createElement("template");
    Z.content && Z.content.ownerDocument && (r = Z.content.ownerDocument);
  }
  let F, z = "", Q, J = !1, te = 0;
  const G = function() {
    if (te > 0)
      throw Oi('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
  }, B = function(Z) {
    G(), te++;
    try {
      return F.createHTML(Z);
    } finally {
      te--;
    }
  }, R = function(Z) {
    G(), te++;
    try {
      return F.createScriptURL(Z);
    } finally {
      te--;
    }
  }, U = function() {
    return J || (Q = KB(f, a), J = !0), Q;
  }, ee = r, Se = ee.implementation, fe = ee.createNodeIterator, ye = ee.createDocumentFragment, ve = ee.getElementsByTagName, K = i.importNode;
  let _e = LS();
  n.isSupported = typeof fF == "function" && typeof _ == "function" && Se && Se.createHTMLDocument !== void 0;
  const Te = OB, X = RB, Ke = PB, an = AB, we = LB, Me = VB, Re = zB, Be = MB;
  let Ae = PS, Ge = null;
  const Ce = Wn({}, [...TS, ...Am, ...Lm, ...Vm, ...DS]);
  let qe = null;
  const nn = Wn({}, [...OS, ...zm, ...RS, ...Rs]);
  let ae = Object.seal(va(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), le = null, xe = null;
  const Le = Object.seal(va(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Pe = !0, yn = !0, T = !1, x = !0, D = !1, H = !0, Y = !1, A = !1, M = null, oe = null, ge = !1, Ne = !1, rn = !1, gn = !1, tn = !0, dn = !1;
  const wn = "user-content-";
  let xn = !0, Cn = !1, Ze = {}, kn = null;
  const ze = Wn({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
    // the UA (customizable <select>) — including any on* handlers — and the
    // engine re-mirrors synchronously whenever a removal changes which
    // option/selectedcontent is current, even inside DOMPurify's inert
    // DOMParser document. Hoisting its children on removal re-inserts a fresh
    // mirror target ahead of the walk, which the engine refills, looping
    // forever (DoS) and amplifying output. Dropping its content on removal
    // (rather than hoisting) breaks that cascade; the content is a duplicate
    // of the option, which is sanitized on its own. See campaign-3 F1/F6.
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let mn = null;
  const pn = Wn({}, ["audio", "video", "img", "source", "image", "track"]);
  let jn = null;
  const qn = Wn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Nn = "http://www.w3.org/1998/Math/MathML", An = "http://www.w3.org/2000/svg", bn = "http://www.w3.org/1999/xhtml";
  let Sn = bn, Ln = !1, Vn = null;
  const In = Wn({}, [Nn, An, bn], Pm), Fn = Mt(["mi", "mo", "mn", "ms", "mtext"]);
  let zn = Wn({}, Fn);
  const Hn = Mt(["annotation-xml"]);
  let Un = Wn({}, Hn);
  const Kn = Wn({}, ["title", "style", "font", "a", "script"]);
  let t = null;
  const c = ["application/xhtml+xml", "text/html"], p = "text/html";
  let g = null, E = null;
  const O = r.createElement("form"), N = function(Z) {
    return Z instanceof RegExp || Z instanceof Function;
  }, S = function() {
    let Z = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (E && E === Z)
      return;
    (!Z || typeof Z != "object") && (Z = {}), Z = Jt(Z), t = // eslint-disable-next-line unicorn/prefer-includes
    c.indexOf(Z.PARSER_MEDIA_TYPE) === -1 ? p : Z.PARSER_MEDIA_TYPE, g = t === "application/xhtml+xml" ? Pm : Ro, Ge = bi(Z, "ALLOWED_TAGS", Ce, {
      transform: g
    }), qe = bi(Z, "ALLOWED_ATTR", nn, {
      transform: g
    }), Vn = bi(Z, "ALLOWED_NAMESPACES", In, {
      transform: Pm
    }), jn = bi(Z, "ADD_URI_SAFE_ATTR", qn, {
      transform: g,
      base: qn
    }), mn = bi(Z, "ADD_DATA_URI_TAGS", pn, {
      transform: g,
      base: pn
    }), kn = bi(Z, "FORBID_CONTENTS", ze, {
      transform: g
    }), le = bi(Z, "FORBID_TAGS", Jt({}), {
      transform: g
    }), xe = bi(Z, "FORBID_ATTR", Jt({}), {
      transform: g
    }), Ze = Et(Z, "USE_PROFILES") ? Z.USE_PROFILES && typeof Z.USE_PROFILES == "object" ? Jt(Z.USE_PROFILES) : Z.USE_PROFILES : !1, Pe = Z.ALLOW_ARIA_ATTR !== !1, yn = Z.ALLOW_DATA_ATTR !== !1, T = Z.ALLOW_UNKNOWN_PROTOCOLS || !1, x = Z.ALLOW_SELF_CLOSE_IN_ATTR !== !1, D = Z.SAFE_FOR_TEMPLATES || !1, H = Z.SAFE_FOR_XML !== !1, Y = Z.WHOLE_DOCUMENT || !1, Ne = Z.RETURN_DOM || !1, rn = Z.RETURN_DOM_FRAGMENT || !1, gn = Z.RETURN_TRUSTED_TYPE || !1, ge = Z.FORCE_BODY || !1, tn = Z.SANITIZE_DOM !== !1, dn = Z.SANITIZE_NAMED_PROPS || !1, xn = Z.KEEP_CONTENT !== !1, Cn = Z.IN_PLACE || !1, Ae = $B(Z.ALLOWED_URI_REGEXP) ? Z.ALLOWED_URI_REGEXP : PS, Sn = typeof Z.NAMESPACE == "string" ? Z.NAMESPACE : bn, zn = Et(Z, "MATHML_TEXT_INTEGRATION_POINTS") && Z.MATHML_TEXT_INTEGRATION_POINTS && typeof Z.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Jt(Z.MATHML_TEXT_INTEGRATION_POINTS) : Wn({}, Fn), Un = Et(Z, "HTML_INTEGRATION_POINTS") && Z.HTML_INTEGRATION_POINTS && typeof Z.HTML_INTEGRATION_POINTS == "object" ? Jt(Z.HTML_INTEGRATION_POINTS) : Wn({}, Hn);
    const Ee = Et(Z, "CUSTOM_ELEMENT_HANDLING") && Z.CUSTOM_ELEMENT_HANDLING && typeof Z.CUSTOM_ELEMENT_HANDLING == "object" ? Jt(Z.CUSTOM_ELEMENT_HANDLING) : va(null);
    if (ae = va(null), Et(Ee, "tagNameCheck") && N(Ee.tagNameCheck) && (ae.tagNameCheck = Ee.tagNameCheck), Et(Ee, "attributeNameCheck") && N(Ee.attributeNameCheck) && (ae.attributeNameCheck = Ee.attributeNameCheck), Et(Ee, "allowCustomizedBuiltInElements") && typeof Ee.allowCustomizedBuiltInElements == "boolean" && (ae.allowCustomizedBuiltInElements = Ee.allowCustomizedBuiltInElements), qt(ae), D && (yn = !1), rn && (Ne = !0), Ze && (Ge = Wn({}, DS), qe = va(null), Ze.html === !0 && (Wn(Ge, TS), Wn(qe, OS)), Ze.svg === !0 && (Wn(Ge, Am), Wn(qe, zm), Wn(qe, Rs)), Ze.svgFilters === !0 && (Wn(Ge, Lm), Wn(qe, zm), Wn(qe, Rs)), Ze.mathMl === !0 && (Wn(Ge, Vm), Wn(qe, RS), Wn(qe, Rs))), Le.tagCheck = null, Le.attributeCheck = null, Et(Z, "ADD_TAGS") && (typeof Z.ADD_TAGS == "function" ? Le.tagCheck = Z.ADD_TAGS : Si(Z.ADD_TAGS) && (Ge === Ce && (Ge = Jt(Ge)), Wn(Ge, Z.ADD_TAGS, g))), Et(Z, "ADD_ATTR") && (typeof Z.ADD_ATTR == "function" ? Le.attributeCheck = Z.ADD_ATTR : Si(Z.ADD_ATTR) && (qe === nn && (qe = Jt(qe)), Wn(qe, Z.ADD_ATTR, g))), Et(Z, "ADD_URI_SAFE_ATTR") && Si(Z.ADD_URI_SAFE_ATTR) && Wn(jn, Z.ADD_URI_SAFE_ATTR, g), Et(Z, "FORBID_CONTENTS") && Si(Z.FORBID_CONTENTS) && (kn === ze && (kn = Jt(kn)), Wn(kn, Z.FORBID_CONTENTS, g)), Et(Z, "ADD_FORBID_CONTENTS") && Si(Z.ADD_FORBID_CONTENTS) && (kn === ze && (kn = Jt(kn)), Wn(kn, Z.ADD_FORBID_CONTENTS, g)), xn && (Ge["#text"] = !0), Y && Wn(Ge, ["html", "head", "body"]), Ge.table && (Wn(Ge, ["tbody"]), delete le.tbody), Z.TRUSTED_TYPES_POLICY) {
      if (typeof Z.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw Oi('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof Z.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw Oi('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      const He = F;
      F = Z.TRUSTED_TYPES_POLICY;
      try {
        z = B("");
      } catch (un) {
        throw F = He, un;
      }
    } else Z.TRUSTED_TYPES_POLICY === null ? (F = void 0, z = "") : (F === void 0 && (F = U()), F && typeof z == "string" && (z = B("")));
    Mt && Mt(Z), E = Z;
  }, ne = Wn({}, [...Am, ...Lm, ...TB]), q = Wn({}, [...Vm, ...DB]), W = function(Z, Ee, He) {
    return Ee.namespaceURI === bn ? Z === "svg" : Ee.namespaceURI === Nn ? Z === "svg" && (He === "annotation-xml" || zn[He]) : !!ne[Z];
  }, ue = function(Z, Ee, He) {
    return Ee.namespaceURI === bn ? Z === "math" : Ee.namespaceURI === An ? Z === "math" && Un[He] : !!q[Z];
  }, Ue = function(Z, Ee, He) {
    return Ee.namespaceURI === An && !Un[He] || Ee.namespaceURI === Nn && !zn[He] ? !1 : !q[Z] && (Kn[Z] || !ne[Z]);
  }, De = function(Z) {
    let Ee = _(Z);
    (!Ee || !Ee.tagName) && (Ee = {
      namespaceURI: Sn,
      tagName: "template"
    });
    const He = Ro(Z.tagName), un = Ro(Ee.tagName);
    return Vn[Z.namespaceURI] ? Z.namespaceURI === An ? W(He, Ee, un) : Z.namespaceURI === Nn ? ue(He, Ee, un) : Z.namespaceURI === bn ? Ue(He, Ee, un) : !!(t === "application/xhtml+xml" && Vn[Z.namespaceURI]) : !1;
  }, ie = function(Z) {
    da(n.removed, {
      element: Z
    });
    try {
      _(Z).removeChild(Z);
    } catch {
      if (I(Z), !_(Z))
        throw Oi("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
    }
  }, fn = function(Z) {
    const Ee = j(Z);
    if (Ee) {
      const un = [];
      vo(Ee, (Pn) => {
        da(un, Pn);
      }), vo(un, (Pn) => {
        try {
          I(Pn);
        } catch {
        }
      });
    }
    const He = L(Z);
    if (He)
      for (let un = He.length - 1; un >= 0; --un) {
        const Pn = He[un], tt = Pn && Pn.name;
        if (typeof tt == "string")
          try {
            Z.removeAttribute(tt);
          } catch {
          }
      }
  }, Rn = function(Z, Ee) {
    try {
      da(n.removed, {
        attribute: Ee.getAttributeNode(Z),
        from: Ee
      });
    } catch {
      da(n.removed, {
        attribute: null,
        from: Ee
      });
    }
    if (Ee.removeAttribute(Z), Z === "is")
      if (Ne || rn)
        try {
          ie(Ee);
        } catch {
        }
      else
        try {
          Ee.setAttribute(Z, "");
        } catch {
        }
  }, Gn = function(Z) {
    const Ee = L(Z);
    if (Ee)
      for (let He = Ee.length - 1; He >= 0; --He) {
        const un = Ee[He], Pn = un && un.name;
        if (!(typeof Pn != "string" || qe[g(Pn)]))
          try {
            Z.removeAttribute(Pn);
          } catch {
          }
      }
  }, II = function(Z) {
    const Ee = [Z];
    for (; Ee.length > 0; ) {
      const He = Ee.pop();
      ($ ? $(He) : He.nodeType) === Ar.element && Gn(He);
      const un = j(He);
      if (un)
        for (let Pn = un.length - 1; Pn >= 0; --Pn)
          Ee.push(un[Pn]);
    }
  }, gv = function(Z) {
    let Ee = null, He = null;
    if (ge)
      Z = "<remove></remove>" + Z;
    else {
      const tt = FS(Z, /^[\r\n\t ]+/);
      He = tt && tt[0];
    }
    t === "application/xhtml+xml" && Sn === bn && (Z = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + Z + "</body></html>");
    const un = F ? B(Z) : Z;
    if (Sn === bn)
      try {
        Ee = new d().parseFromString(un, t);
      } catch {
      }
    if (!Ee || !Ee.documentElement) {
      Ee = Se.createDocument(Sn, "template", null);
      try {
        Ee.documentElement.innerHTML = Ln ? z : un;
      } catch {
      }
    }
    const Pn = Ee.body || Ee.documentElement;
    return Z && He && Pn.insertBefore(r.createTextNode(He), Pn.childNodes[0] || null), Sn === bn ? ve.call(Ee, Y ? "html" : "body")[0] : Y ? Ee.documentElement : Pn;
  }, vv = function(Z) {
    return fe.call(
      Z.ownerDocument || Z,
      Z,
      // eslint-disable-next-line no-bitwise
      u.SHOW_ELEMENT | u.SHOW_COMMENT | u.SHOW_TEXT | u.SHOW_PROCESSING_INSTRUCTION | u.SHOW_CDATA_SECTION,
      null
    );
  }, fs = function(Z) {
    return Z = ko(Z, Te, " "), Z = ko(Z, X, " "), Z = ko(Z, Ke, " "), Z;
  }, yc = function(Z) {
    var Ee;
    Z.normalize();
    const He = fe.call(
      Z.ownerDocument || Z,
      Z,
      // eslint-disable-next-line no-bitwise
      u.SHOW_TEXT | u.SHOW_COMMENT | u.SHOW_CDATA_SECTION | u.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let un = He.nextNode();
    for (; un; )
      un.data = fs(un.data), un = He.nextNode();
    const Pn = (Ee = Z.querySelectorAll) === null || Ee === void 0 ? void 0 : Ee.call(Z, "template");
    Pn && vo(Pn, (tt) => {
      ia(tt.content) && yc(tt.content);
    });
  }, hs = function(Z) {
    const Ee = C ? C(Z) : null;
    return typeof Ee != "string" || g(Ee) !== "form" ? !1 : typeof Z.nodeName != "string" || typeof Z.textContent != "string" || typeof Z.removeChild != "function" || // Realm-safe NamedNodeMap detection: equality against the cached
    // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
    // makes the direct read diverge from the cached read; a clean form
    // (same-realm OR foreign-realm) has both reads pointing at the same
    // canonical NamedNodeMap.
    Z.attributes !== L(Z) || typeof Z.removeAttribute != "function" || typeof Z.setAttribute != "function" || typeof Z.namespaceURI != "string" || typeof Z.insertBefore != "function" || typeof Z.hasChildNodes != "function" || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
    // returns the integer 1 for any Element regardless of realm; direct
    // read on a clobbered form (e.g. <input name="nodeType">) returns
    // the named child element. Cheap addition — nodeType is read from
    // an internal slot, no serialization cost — and removes a residual
    // clobbering surface used by several mXSS / PI / comment branches
    // in _sanitizeElements that compare currentNode.nodeType directly.
    Z.nodeType !== $(Z) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
    // "childNodes" shadows the prototype getter. Direct reads of
    // form.childNodes from a clobbered form return the named child
    // instead of the real NodeList, so any walk that reads it directly
    // skips the form's real children. Compare the direct read to the
    // cached Node.prototype getter — when the form's named-property
    // getter intercepts the read, the two values differ and we flag
    // the form. This catches every clobbering child type (input,
    // select, etc.) regardless of whether the named child happens to
    // carry a numeric .length, which a typeof-based probe would miss
    // (e.g. HTMLSelectElement.length is a defined unsigned-long).
    Z.childNodes !== j(Z);
  }, ia = function(Z) {
    if (!$ || typeof Z != "object" || Z === null)
      return !1;
    try {
      return $(Z) === Ar.documentFragment;
    } catch {
      return !1;
    }
  }, Ga = function(Z) {
    if (!$ || typeof Z != "object" || Z === null)
      return !1;
    try {
      return typeof $(Z) == "number";
    } catch {
      return !1;
    }
  };
  function ii(Z, Ee, He) {
    Z.length !== 0 && vo(Z, (un) => {
      un.call(n, Ee, He, E);
    });
  }
  const EI = function(Z, Ee) {
    return !!(H && Z.hasChildNodes() && !Ga(Z.firstElementChild) && Rt(AS, Z.textContent) && Rt(AS, Z.innerHTML) || H && Z.namespaceURI === bn && Ee === "style" && Ga(Z.firstElementChild) || Z.nodeType === Ar.processingInstruction || H && Z.nodeType === Ar.comment && Rt(BB, Z.data));
  }, $I = function(Z, Ee) {
    if (!le[Ee] && _v(Ee) && (ae.tagNameCheck instanceof RegExp && Rt(ae.tagNameCheck, Ee) || ae.tagNameCheck instanceof Function && ae.tagNameCheck(Ee)))
      return !1;
    if (xn && !kn[Ee]) {
      const He = _(Z), un = j(Z);
      if (un && He) {
        const Pn = un.length;
        for (let tt = Pn - 1; tt >= 0; --tt) {
          const rt = Cn ? un[tt] : v(un[tt], !0);
          He.insertBefore(rt, w(Z));
        }
      }
    }
    return ie(Z), !0;
  }, kv = function(Z) {
    if (ii(_e.beforeSanitizeElements, Z, null), hs(Z))
      return ie(Z), !0;
    const Ee = g(C ? C(Z) : Z.nodeName);
    if (ii(_e.uponSanitizeElement, Z, {
      tagName: Ee,
      allowedTags: Ge
    }), EI(Z, Ee))
      return ie(Z), !0;
    if (le[Ee] || !(Le.tagCheck instanceof Function && Le.tagCheck(Ee)) && !Ge[Ee])
      return $I(Z, Ee);
    if (($ ? $(Z) : Z.nodeType) === Ar.element && !De(Z) || (Ee === "noscript" || Ee === "noembed" || Ee === "noframes") && Rt(qB, Z.innerHTML))
      return ie(Z), !0;
    if (D && Z.nodeType === Ar.text) {
      const He = fs(Z.textContent);
      Z.textContent !== He && (da(n.removed, {
        element: Z.cloneNode()
      }), Z.textContent = He);
    }
    return ii(_e.afterSanitizeElements, Z, null), !1;
  }, bv = function(Z, Ee, He) {
    if (xe[Ee] || tn && (Ee === "id" || Ee === "name") && (He in r || He in O))
      return !1;
    const un = qe[Ee] || Le.attributeCheck instanceof Function && Le.attributeCheck(Ee, Z);
    if (!(yn && Rt(an, Ee)) && !(Pe && Rt(we, Ee))) {
      if (un) {
        if (!jn[Ee] && !Rt(Ae, ko(He, Re, "")) && !((Ee === "src" || Ee === "xlink:href" || Ee === "href") && Z !== "script" && IS(He, "data:") === 0 && mn[Z]) && !(T && !Rt(Me, ko(He, Re, ""))) && He)
          return !1;
      } else if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        !(_v(Z) && (ae.tagNameCheck instanceof RegExp && Rt(ae.tagNameCheck, Z) || ae.tagNameCheck instanceof Function && ae.tagNameCheck(Z)) && (ae.attributeNameCheck instanceof RegExp && Rt(ae.attributeNameCheck, Ee) || ae.attributeNameCheck instanceof Function && ae.attributeNameCheck(Ee, Z)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        Ee === "is" && ae.allowCustomizedBuiltInElements && (ae.tagNameCheck instanceof RegExp && Rt(ae.tagNameCheck, He) || ae.tagNameCheck instanceof Function && ae.tagNameCheck(He)))
      ) return !1;
    }
    return !0;
  }, TI = Wn({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), _v = function(Z) {
    return !TI[Ro(Z)] && Rt(Be, Z);
  }, DI = function(Z, Ee, He, un) {
    if (F && typeof f == "object" && typeof f.getAttributeType == "function" && !He)
      switch (f.getAttributeType(Z, Ee)) {
        case "TrustedHTML":
          return B(un);
        case "TrustedScriptURL":
          return R(un);
      }
    return un;
  }, OI = function(Z, Ee, He, un) {
    try {
      He ? Z.setAttributeNS(He, Ee, un) : Z.setAttribute(Ee, un), hs(Z) ? ie(Z) : CS(n.removed);
    } catch {
      Rn(Ee, Z);
    }
  }, xv = function(Z) {
    ii(_e.beforeSanitizeAttributes, Z, null);
    const Ee = Z.attributes;
    if (!Ee || hs(Z))
      return;
    const He = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: qe,
      forceKeepAttr: void 0
    };
    let un = Ee.length;
    const Pn = g(Z.nodeName);
    for (; un--; ) {
      const tt = Ee[un], rt = tt.name, Ii = tt.namespaceURI, yi = tt.value, ar = g(rt), gi = yi;
      let Qt = rt === "value" ? gi : jB(gi);
      if (He.attrName = ar, He.attrValue = Qt, He.keepAttr = !0, He.forceKeepAttr = void 0, ii(_e.uponSanitizeAttribute, Z, He), Qt = He.attrValue, dn && (ar === "id" || ar === "name") && IS(Qt, wn) !== 0 && (Rn(rt, Z), Qt = wn + Qt), H && Rt(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, Qt)) {
        Rn(rt, Z);
        continue;
      }
      if (ar === "attributename" && FS(Qt, "href")) {
        Rn(rt, Z);
        continue;
      }
      if (!He.forceKeepAttr) {
        if (!He.keepAttr) {
          Rn(rt, Z);
          continue;
        }
        if (!x && Rt(HB, Qt)) {
          Rn(rt, Z);
          continue;
        }
        if (D && (Qt = fs(Qt)), !bv(Pn, ar, Qt)) {
          Rn(rt, Z);
          continue;
        }
        Qt = DI(Pn, ar, Ii, Qt), Qt !== gi && OI(Z, rt, Ii, Qt);
      }
    }
    ii(_e.afterSanitizeAttributes, Z, null);
  }, ys = function(Z) {
    let Ee = null;
    const He = vv(Z);
    for (ii(_e.beforeSanitizeShadowDOM, Z, null); Ee = He.nextNode(); )
      if (ii(_e.uponSanitizeShadowNode, Ee, null), kv(Ee), xv(Ee), ia(Ee.content) && ys(Ee.content), ($ ? $(Ee) : Ee.nodeType) === Ar.element) {
        const un = y(Ee);
        ia(un) && (gc(un), ys(un));
      }
    ii(_e.afterSanitizeShadowDOM, Z, null);
  }, gc = function(Z) {
    const Ee = [{
      node: Z,
      shadow: null
    }];
    for (; Ee.length > 0; ) {
      const He = Ee.pop();
      if (He.shadow) {
        ys(He.shadow);
        continue;
      }
      const un = He.node, Pn = ($ ? $(un) : un.nodeType) === Ar.element, tt = j(un);
      if (tt)
        for (let rt = tt.length - 1; rt >= 0; --rt)
          Ee.push({
            node: tt[rt],
            shadow: null
          });
      if (Pn) {
        const rt = C ? C(un) : null;
        if (typeof rt == "string" && g(rt) === "template") {
          const Ii = un.content;
          ia(Ii) && Ee.push({
            node: Ii,
            shadow: null
          });
        }
      }
      if (Pn) {
        const rt = y(un);
        ia(rt) && Ee.push({
          node: null,
          shadow: rt
        }, {
          node: rt,
          shadow: null
        });
      }
    }
  };
  return n.sanitize = function(Z) {
    let Ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, He = null, un = null, Pn = null, tt = null;
    if (Ln = !Z, Ln && (Z = "<!-->"), typeof Z != "string" && !Ga(Z) && (Z = EB(Z), typeof Z != "string"))
      throw Oi("dirty is not a string, aborting");
    if (!n.isSupported)
      return Z;
    A ? (Ge = M, qe = oe) : S(Ee), (_e.uponSanitizeElement.length > 0 || _e.uponSanitizeAttribute.length > 0) && (Ge = Jt(Ge)), _e.uponSanitizeAttribute.length > 0 && (qe = Jt(qe)), n.removed = [];
    const rt = Cn && typeof Z != "string" && Ga(Z);
    if (rt) {
      const ar = C ? C(Z) : Z.nodeName;
      if (typeof ar == "string") {
        const gi = g(ar);
        if (!Ge[gi] || le[gi])
          throw Oi("root node is forbidden and cannot be sanitized in-place");
      }
      if (hs(Z))
        throw Oi("root node is clobbered and cannot be sanitized in-place");
      try {
        gc(Z);
      } catch (gi) {
        throw fn(Z), gi;
      }
    } else if (Ga(Z))
      He = gv("<!---->"), un = He.ownerDocument.importNode(Z, !0), un.nodeType === Ar.element && un.nodeName === "BODY" || un.nodeName === "HTML" ? He = un : He.appendChild(un), gc(un);
    else {
      if (!Ne && !D && !Y && // eslint-disable-next-line unicorn/prefer-includes
      Z.indexOf("<") === -1)
        return F && gn ? B(Z) : Z;
      if (He = gv(Z), !He)
        return Ne ? null : gn ? z : "";
    }
    He && ge && ie(He.firstChild);
    const Ii = vv(rt ? Z : He);
    try {
      for (; Pn = Ii.nextNode(); )
        kv(Pn), xv(Pn), ia(Pn.content) && ys(Pn.content);
    } catch (ar) {
      throw rt && fn(Z), ar;
    }
    if (rt)
      return vo(n.removed, (ar) => {
        ar.element && II(ar.element);
      }), D && yc(Z), Z;
    if (Ne) {
      if (D && yc(He), rn)
        for (tt = ye.call(He.ownerDocument); He.firstChild; )
          tt.appendChild(He.firstChild);
      else
        tt = He;
      return (qe.shadowroot || qe.shadowrootmode) && (tt = K.call(i, tt, !0)), tt;
    }
    let yi = Y ? He.outerHTML : He.innerHTML;
    return Y && Ge["!doctype"] && He.ownerDocument && He.ownerDocument.doctype && He.ownerDocument.doctype.name && Rt(UB, He.ownerDocument.doctype.name) && (yi = "<!DOCTYPE " + He.ownerDocument.doctype.name + `>
` + yi), D && (yi = fs(yi)), F && gn ? B(yi) : yi;
  }, n.setConfig = function() {
    let Z = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    S(Z), A = !0, M = Ge, oe = qe;
  }, n.clearConfig = function() {
    E = null, A = !1, M = null, oe = null, F = Q, z = "";
  }, n.isValidAttribute = function(Z, Ee, He) {
    E || S({});
    const un = g(Z), Pn = g(Ee);
    return bv(un, Pn, He);
  }, n.addHook = function(Z, Ee) {
    typeof Ee == "function" && Et(_e, Z) && da(_e[Z], Ee);
  }, n.removeHook = function(Z, Ee) {
    if (Et(_e, Z)) {
      if (Ee !== void 0) {
        const He = SB(_e[Z], Ee);
        return He === -1 ? void 0 : NB(_e[Z], He, 1)[0];
      }
      return CS(_e[Z]);
    }
  }, n.removeHooks = function(Z) {
    Et(_e, Z) && (_e[Z] = []);
  }, n.removeAllHooks = function() {
    _e = LS();
  }, n;
}
var GB = yF();
const YB = "_messageContainer_1rxr4_1", QB = "_chip_1rxr4_7", JB = "_chipLabel_1rxr4_10", XB = "_chipValue_1rxr4_13", Ps = {
  messageContainer: YB,
  chip: QB,
  chipLabel: JB,
  chipValue: XB
}, VS = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, ZB = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  Je(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: u,
      email: m,
      phone_number: d
    } = i.customer;
    return s ?? l ?? u ?? m ?? d ?? o;
  };
  return /* @__PURE__ */ hn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ hn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ hn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ hn.jsx(Xe, { content: "Conversation Attributes", children: /* @__PURE__ */ hn.jsx(
        Oy,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ hn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ hn.jsx(Yn, { className: Ps.chip, children: /* @__PURE__ */ hn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ hn.jsxs(ct, { className: Ps.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ hn.jsx(ct, { className: Ps.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ hn.jsx(
      b,
      {
        className: Ps.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? VS[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? VS[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ hn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ hn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ hn.jsx(P.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ hn.jsx(P.Paragraph, { variant: "4", children: /* @__PURE__ */ hn.jsx(dE, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ hn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: GB.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ hn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ hn.jsx(
      mE,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ hn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, eq = "_conversation_1draa_1", nq = "_conversationSubLine_1draa_9", tq = "_modal_1draa_14", Um = {
  conversation: eq,
  conversationSubLine: nq,
  modal: tq
}, rq = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), iq = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), aq = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = de(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ hn.jsxs(b, { className: Um.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ hn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ hn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ hn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ hn.jsx(P.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ hn.jsx(Bn, { size: "small", variant: "info", children: Qn(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ hn.jsx(
          P.Heading,
          {
            variant: "heading-4",
            className: Um.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ hn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ hn.jsx(Yn, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ hn.jsx(Xe, { content: "Show conversation preview", children: /* @__PURE__ */ hn.jsx(
        mr,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ hn.jsxs(
      $t,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Um.modal,
        children: [
          /* @__PURE__ */ hn.jsx(
            Tt,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ hn.jsx(Dt, { children: /* @__PURE__ */ hn.jsx(
            ZB,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: rq(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: iq(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, oq = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = de(!1), o = r > 0 ? r : 1, s = e?.length > o, l = Xn(
    () => e?.sort((u, m) => m?.created_at.localeCompare(u?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ hn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((u, m) => /* @__PURE__ */ hn.jsx(
      aq,
      {
        conversation: u,
        conversationContext: n
      },
      `${m}-${u?.id}`
    )),
    s && /* @__PURE__ */ hn.jsxs(
      nt,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, sq = fB(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), lq = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = de([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((d) => !!d).map((d) => `'${d}'`).join(","), { useQuery: s } = _n(), { data: l, loading: u, error: m } = s(sq, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return Je(() => {
    if (l?.Miuros) {
      const d = l?.Miuros?.findTickets?.data;
      d && i(d);
    }
  }, [l]), m ? /* @__PURE__ */ hn.jsx(Tn, { error: m }) : u ? /* @__PURE__ */ hn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ hn.jsx(vn, {}) }) : r?.length === 0 ? /* @__PURE__ */ hn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ hn.jsx(
    oq,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, vy = [
  {
    key: "miurosClientId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "miurosClientSecret",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "amountOfConversationsToShow",
    type: "string",
    secret: !1,
    defaultValue: "1"
  }
], Mm = "MIUROS", cq = {
  enabled: !1,
  name: "",
  miurosClientId: "",
  miurosClientSecret: "",
  amountOfConversationsToShow: "1"
}, uq = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ht({
    mode: "onChange",
    defaultValues: cq
  }), {
    create: u,
    update: m,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: I
  } = Gr({
    integrationId: e,
    integrationType: Mm,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: w,
    error: j,
    isWidgetUnknown: _,
    refetch: y,
    widgetConfiguration: L
  } = Yr({
    integrationId: e,
    fieldDefinitions: vy,
    form: l,
    onMisconfigured: I
  }), { renderConditions: $, setRenderConditions: C, renderConditionsForSubmit: F } = Qr({
    integrationId: e,
    widgetConfiguration: L,
    renderConditionsEditor: o
  }), z = (J) => Xr(J, {
    fieldDefinitions: vy,
    isCreationMode: s,
    create: u,
    update: m,
    renderConditions: F
  }), Q = l.watch("name");
  return /* @__PURE__ */ hn.jsxs(
    Jr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: z,
      error: j ?? h,
      onRetry: j ? y : void 0,
      isLoading: f || w,
      isWidgetUnknown: _,
      children: [
        v && /* @__PURE__ */ hn.jsx(Zr, { cause: v }),
        /* @__PURE__ */ hn.jsxs(mt, { children: [
          /* @__PURE__ */ hn.jsx(ce, { children: /* @__PURE__ */ hn.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ hn.jsx(
            Dn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ hn.jsx(ce, { span: 3, children: /* @__PURE__ */ hn.jsx(
            Zn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ hn.jsx(ce, { span: 3 }),
          /* @__PURE__ */ hn.jsx(ce, { span: 3, children: /* @__PURE__ */ hn.jsx(
            Zn,
            {
              name: "miurosClientId",
              label: "Authorization: Client ID",
              control: l.control,
              rules: { required: "Client ID is required" },
              componentProps: {
                placeholder: "Insert client ID",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ hn.jsx(ce, { span: 3 }),
          /* @__PURE__ */ hn.jsx(ce, { span: 3, children: /* @__PURE__ */ hn.jsx(
            Da,
            {
              name: "miurosClientSecret",
              label: "Authorization: Client secret",
              control: l.control,
              isCreationMode: s,
              rules: { required: "Client secret is required" },
              componentProps: {
                placeholder: "Insert client secret",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ hn.jsx(ce, { span: 3 }),
          /* @__PURE__ */ hn.jsx(ce, { span: 3, children: /* @__PURE__ */ hn.jsx(
            Zn,
            {
              name: "amountOfConversationsToShow",
              label: "Number of conversation to show before the fold",
              control: l.control,
              rules: {
                required: "Please enter a number",
                validate: (J) => !Number.isNaN(Number.parseInt(J, 10)) || "Please enter a number"
              },
              componentProps: {
                placeholder: "Enter number",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ hn.jsx(ce, { span: 3 }),
          !s && e && /* @__PURE__ */ hn.jsx(
            Oa,
            {
              configuration: n,
              integrationId: e,
              integrationType: Mm,
              label: "Authorize"
            }
          ),
          o && $ !== null && /* @__PURE__ */ hn.jsx(ce, { children: o({
            value: $,
            onChange: C,
            configurationKey: L?.id
          }) })
        ] }),
        /* @__PURE__ */ hn.jsx(
          ei,
          {
            integrationType: Mm,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Bm = { exports: {} }, _o = {}, zS;
function dq() {
  if (zS) return _o;
  zS = 1;
  var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return _o.Fragment = r, _o.jsx = s, _o.jsxs = s, _o;
}
var As = {}, US;
function mq() {
  return US || (US = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var g = _.ReactDebugCurrentFrame, E = g.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var $ = !1, C = !1, F = !1, z = !1, Q = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === d || z || t === v || $ || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, N = E._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (E) {
            var g = E.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (ie) {
              g = ie;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var S = ie.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var ue = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = E;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ae(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ae(t.type, c, p);
          case h: {
            var g = t, E = g._payload, O = g._init;
            try {
              return ae(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, p, g, E) {
      {
        var O = Function.call.bind(le);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + p + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe(E), y("Failed %s type: %s", p, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, p, g, E, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, p, g, E) {
      {
        var O, N = {}, S = null, ne = null;
        p !== void 0 && (A(p), S = "" + p), gn(c) && (A(c.key), S = "" + c.key), rn(c) && (ne = c.ref, tn(c));
        for (O in c)
          le.call(c, O) && !oe.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, E, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function An(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = j(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          yn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var E = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, p, g, E, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, p, E, O);
        if (W == null)
          return W;
        if (N) {
          var ue = c.children;
          if (ue !== void 0)
            if (g)
              if (x(ue)) {
                for (var Ue = 0; Ue < ue.length; Ue++)
                  Sn(ue[Ue], t);
                Object.freeze && Object.freeze(ue);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ue, t);
        }
        if (le.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var Rn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, Rn, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, p) {
      return Fn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return Fn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    As.Fragment = i, As.jsx = Un, As.jsxs = Kn;
  })()), As;
}
var MS;
function pq() {
  return MS || (MS = 1, process.env.NODE_ENV === "production" ? Bm.exports = dq() : Bm.exports = mq()), Bm.exports;
}
var Fe = pq();
const fq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, hq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, yq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, gq = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": fq,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": hq,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": yq
};
function Pg(e) {
  return gq[e] ?? {};
}
const vq = Pg(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), kq = Pg(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), bq = Pg(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function ky(e = !1, n) {
  const [r, i] = de(e);
  return Je(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const _q = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, gF = "DD MMM YYYY @ HH:mm", xq = "_list_2c4dq_1", Sq = "_listItem_2c4dq_4", Nq = "_copyIcon_2c4dq_12", Wi = {
  list: xq,
  listItem: Sq,
  copyIcon: Nq
}, by = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = ky(), l = 14, {
    first_name: u,
    last_name: m,
    address1: d,
    address2: f,
    city: h,
    zip: v,
    country_code: I
  } = e ?? {}, w = `${u} ${m}`.trim() || void 0, j = `${h} ${v}`.trim() || void 0, _ = [w, d, f, j, I].filter(
    Boolean
  );
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(he, { size: l, name: n }),
      i ? /* @__PURE__ */ Fe.jsx(vn, { size: l }) : /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: _.map((y, L) => /* @__PURE__ */ Fe.jsx(ct, { children: y }, L)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Fe.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Fe.jsx(Xe, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Fe.jsx(
        he,
        {
          size: l,
          name: "exclamation",
          className: Wi.copyIcon
        }
      ) }),
      /* @__PURE__ */ Fe.jsx(Xe, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ Fe.jsx(
        he,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(_.join(", ")),
          className: Wi.copyIcon
        }
      ) })
    ] })
  ] });
}, jq = "_wrapper_1nher_1", wq = {
  wrapper: jq
}, Cq = ({
  customer: e,
  store: n
}) => {
  const { track: r } = En(), { isCopied: i, copy: a } = ky(), { isCopied: o, copy: s } = ky(), { useQuery: l } = _n(), u = e?.id, {
    loading: m,
    error: d,
    data: f
  } = l(kq, {
    skip: !u,
    variables: {
      customerId: u?.toString()
    }
  }), h = f?.Recharge?.getAddresses, v = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, I = (h?.addresses?.length ?? 0) > 1;
  if (Je(() => {
    v && r("recharge:profile:received");
  }, [v, r]), d)
    return /* @__PURE__ */ Fe.jsx(Tn, { error: d });
  if (!e)
    return null;
  const {
    id: w,
    phone: j,
    email: _,
    first_name: y,
    last_name: L,
    created_at: $,
    has_valid_payment_method: C
  } = e, F = 14, z = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${w}` : null, Q = `${y || ""} ${L || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Fe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Fe.jsxs(b, { className: wq.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(P.Heading, { variant: "heading-2", children: Q }),
    $ && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: Qn($).format(gF) })
    ] }),
    _ && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(he, { size: F, name: "mail" }),
        /* @__PURE__ */ Fe.jsx(P.ExternalLink, { href: `mailto:${_}`, children: _ })
      ] }),
      /* @__PURE__ */ Fe.jsx(Xe, { content: "Copy email", children: /* @__PURE__ */ Fe.jsx(
        he,
        {
          size: F,
          name: i ? "done" : "copy",
          onClick: () => a(_),
          className: Wi.copyIcon
        }
      ) })
    ] }),
    j && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(he, { size: F, name: "phone" }),
        /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: j })
      ] }),
      /* @__PURE__ */ Fe.jsx(Xe, { content: "Copy phone number", children: /* @__PURE__ */ Fe.jsx(
        he,
        {
          size: F,
          name: o ? "done" : "copy",
          onClick: () => s(j),
          className: Wi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Fe.jsx(
      by,
      {
        address: v,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: I
      }
    ),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(he, { size: F, name: "credit-card" }),
        /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Fe.jsx(
        he,
        {
          size: F,
          name: C ? "check-circle" : "close-circle-filled",
          color: C ? "green.500" : "red.500"
        }
      )
    ] }),
    z && /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(he, { size: F, name: "external-link" }),
      /* @__PURE__ */ Fe.jsx(
        P.ExternalLink,
        {
          href: z,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, Fq = "_order_1dlaa_1", Iq = "_orderIsOpen_1dlaa_9", Eq = "_orderHeader_1dlaa_12", $q = "_note_1dlaa_16", Ls = {
  order: Fq,
  orderIsOpen: Iq,
  orderHeader: Eq,
  note: $q
}, Tq = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = En(), [a, o] = de(n), {
    id: s,
    status: l,
    charge: u,
    currency: m,
    note: d,
    created_at: f,
    billing_address: h,
    shipping_address: v,
    total_price: I,
    is_prepaid: w
  } = e, j = 14, _ = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, y = u?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Fe.jsxs(
    b,
    {
      className: dt(Ls.order, {
        [Ls.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Fe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ls.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Fe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: Qn(f).format(gF) }) }),
                /* @__PURE__ */ Fe.jsxs(P.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Fe.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          d && /* @__PURE__ */ Fe.jsx(Xe, { content: "Note", children: /* @__PURE__ */ Fe.jsx(
            P.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: Ls.note,
              children: d
            }
          ) }),
          l && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(he, { size: j, name: "activity" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: _q(l) })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(he, { size: j, name: "credit-card" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: w ? "Yes" : "No" })
            ] })
          ] }),
          y && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(he, { size: j, name: "cog" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: y })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(he, { size: j, name: "chart-bar" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Fe.jsxs(P.Paragraph, { variant: "4", children: [
                I,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsx(
            by,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Fe.jsx(
            by,
            {
              address: v,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          _ && /* @__PURE__ */ Fe.jsx(
            Bt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(_, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Fe.jsx(he, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, Dq = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = En(), { useQuery: i } = _n(), {
    loading: a,
    error: o,
    data: s
  } = i(bq, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, u = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ Fe.jsx(Tn, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(P.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ Fe.jsx(Bn, { variant: "success", size: "small", children: u.length })
    ] }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(vn, {}) }),
      !a && u.length === 0 && /* @__PURE__ */ Fe.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Fe.jsx(P.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && u.length > 0 && /* @__PURE__ */ Fe.jsx(b, { gap: "200", flexDirection: "column", children: u.map((d, f) => /* @__PURE__ */ Fe.jsx(
        Tq,
        {
          order: d,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${d.id}`
      )) }),
      m && /* @__PURE__ */ Fe.jsx(
        Bt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Fe.jsx(he, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, Oq = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(P.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Fe.jsxs(Qe, { className: Wi.list, children: [
      /* @__PURE__ */ Fe.jsx(Qe.Text, { variant: "dense", className: Wi.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Fe.jsx(Qe.Text, { variant: "dense", className: Wi.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, Rq = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = _n(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: u,
    error: m,
    data: d
  } = r(vq, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !u && d ? d?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !u && d ? d?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (m) {
    const v = m.graphQLErrors;
    return Ul({ errors: v }) ? /* @__PURE__ */ Fe.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Ml({ errors: v }) ? /* @__PURE__ */ Fe.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Fe.jsx(Tn, { error: m });
  }
  return u ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(vn, {}) }) : f ? l ? /* @__PURE__ */ Fe.jsx(
    P.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Fe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ Fe.jsx(Cq, { customer: f, store: h }),
        o && /* @__PURE__ */ Fe.jsx(Oq, { customer: f }),
        s && /* @__PURE__ */ Fe.jsx(Dq, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ Fe.jsx(
    P.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, _y = [
  {
    key: "rechargeAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], Pq = {
  enabled: !1,
  name: "",
  rechargeAccessToken: "",
  displayCustomerDetails: !0,
  displaysubscriptionOverview: !0,
  displayOrders: !0
}, Aq = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ht({
    mode: "onChange",
    defaultValues: Pq
  }), {
    create: l,
    update: u,
    remove: m,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = Gr({
    integrationId: e,
    integrationType: "RECHARGE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: I,
    error: w,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: y
  } = Yr({
    integrationId: e,
    fieldDefinitions: _y,
    form: s,
    onMisconfigured: v
  }), { renderConditions: L, setRenderConditions: $, renderConditionsForSubmit: C } = Qr({
    integrationId: e,
    widgetConfiguration: y,
    renderConditionsEditor: a
  }), F = (Q) => Xr(Q, {
    fieldDefinitions: _y,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: C
  }), z = s.watch("name");
  return /* @__PURE__ */ Fe.jsxs(
    Jr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: w ?? f,
      onRetry: w ? _ : void 0,
      isLoading: d || I,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ Fe.jsx(Zr, { cause: h }),
        /* @__PURE__ */ Fe.jsxs(mt, { children: [
          /* @__PURE__ */ Fe.jsx(ce, { children: /* @__PURE__ */ Fe.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Fe.jsx(
            Dn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(ce, { span: 3, children: /* @__PURE__ */ Fe.jsx(
            Zn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Fe.jsx(ce, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(ce, { span: 3, children: /* @__PURE__ */ Fe.jsx(
            Da,
            {
              name: "rechargeAccessToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "Insert the Admin API token for Recharge",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Fe.jsx(ce, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(ce, { span: 3, children: /* @__PURE__ */ Fe.jsx(en, { label: "Displays details of a customer", children: /* @__PURE__ */ Fe.jsx(
            Dn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(ce, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(ce, { span: 3, children: /* @__PURE__ */ Fe.jsx(en, { label: "Displays the subscription overview", children: /* @__PURE__ */ Fe.jsx(
            Dn,
            {
              name: "displaysubscriptionOverview",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(ce, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(ce, { span: 3, children: /* @__PURE__ */ Fe.jsx(en, { label: "Displays the last 5 orders", children: /* @__PURE__ */ Fe.jsx(
            Dn,
            {
              name: "displayOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(ce, { span: 3 }),
          a && L !== null && /* @__PURE__ */ Fe.jsx(ce, { children: a({
            value: L,
            onChange: $,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ Fe.jsx(
          ei,
          {
            integrationType: "RECHARGE",
            integrationId: e,
            widgetName: z,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._wrapper_l5y5y_54{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_l5y5y_59{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_l5y5y_67{text-align:center}._inputSeparator_l5y5y_71{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_l5y5y_76{color:var(--dixa-typography-color-link)}._noIssuesFound_l5y5y_80{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._list_l5y5y_85{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_l5y5y_95{background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_l5y5y_95:last-child{box-shadow:none}._listItemHighlighted_l5y5y_103{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._listItemEdit_l5y5y_106{cursor:pointer}._fullWidth_l5y5y_110{width:100%}._boxWrapper_l5y5y_114{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._clickableIcon_l5y5y_120{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._list_rxh85_1{padding:0;overflow-y:auto;max-height:230px}._listItem_rxh85_6{cursor:pointer;font-size:var(--dixa-typography-size-100);background-color:transparent;padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_rxh85_6:last-child{box-shadow:none}._listItemHighlighted_rxh85_16{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._modalBody_1clhs_1{width:400px}._reward_1gmba_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1gmba_1:hover{border-color:var(--dixa-color-neutral-400)}._clickable_1gmba_10{cursor:pointer}._voucherCode_1gmba_14{font-family:monospace}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var qm = { exports: {} }, xo = {}, BS;
function Lq() {
  if (BS) return xo;
  BS = 1;
  var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return xo.Fragment = r, xo.jsx = s, xo.jsxs = s, xo;
}
var Vs = {}, qS;
function Vq() {
  return qS || (qS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var g = _.ReactDebugCurrentFrame, E = g.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var $ = !1, C = !1, F = !1, z = !1, Q = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === d || z || t === v || $ || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, N = E._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (E) {
            var g = E.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (ie) {
              g = ie;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var S = ie.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var ue = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = E;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ae(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ae(t.type, c, p);
          case h: {
            var g = t, E = g._payload, O = g._init;
            try {
              return ae(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, p, g, E) {
      {
        var O = Function.call.bind(le);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + p + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe(E), y("Failed %s type: %s", p, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, p, g, E, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, p, g, E) {
      {
        var O, N = {}, S = null, ne = null;
        p !== void 0 && (A(p), S = "" + p), gn(c) && (A(c.key), S = "" + c.key), rn(c) && (ne = c.ref, tn(c));
        for (O in c)
          le.call(c, O) && !oe.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, E, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function An(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = j(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          yn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var E = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, p, g, E, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, p, E, O);
        if (W == null)
          return W;
        if (N) {
          var ue = c.children;
          if (ue !== void 0)
            if (g)
              if (x(ue)) {
                for (var Ue = 0; Ue < ue.length; Ue++)
                  Sn(ue[Ue], t);
                Object.freeze && Object.freeze(ue);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ue, t);
        }
        if (le.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var Rn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, Rn, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, p) {
      return Fn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return Fn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Vs.Fragment = i, Vs.jsx = Un, Vs.jsxs = Kn;
  })()), Vs;
}
var HS;
function zq() {
  return HS || (HS = 1, process.env.NODE_ENV === "production" ? qm.exports = Lq() : qm.exports = Vq()), qm.exports;
}
var ke = zq(), vF = /* @__PURE__ */ ((e) => (e.CustomAction = "custom_action", e.FacebookLike = "facebook_like", e.FacebookShare = "facebook_share", e.InstagramFollow = "instagram_follow", e.Manual = "manual", e.ReferralComplete = "referral_complete", e.TiktokFollow = "tiktok_follow", e.TwitterFollow = "twitter_follow", e.TwitterShare = "twitter_share", e.VisitUrl = "visit_url", e))(vF || {}), wa = /* @__PURE__ */ ((e) => (e.Excluded = "excluded", e.Guest = "guest", e.Member = "member", e))(wa || {});
const Uq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "adjustCustomerPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "RivoLoyalty_adjust_customer_points_request_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "adjust_customer_points" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, Mq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "return_customer" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_identifier" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "StringValue", value: "lifetime_earnings_tally,next_vip_tier", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "accepts_marketing" } }, { kind: "Field", name: { kind: "Name", value: "orders_count" } }, { kind: "Field", name: { kind: "Name", value: "verified_email" } }, { kind: "Field", name: { kind: "Name", value: "total_spent" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_status" } }, { kind: "Field", name: { kind: "Name", value: "points_tally" } }, { kind: "Field", name: { kind: "Name", value: "credits_tally" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }] } }, { kind: "Field", name: { kind: "Name", value: "points_expire_at" } }, { kind: "Field", name: { kind: "Name", value: "next_vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }, { kind: "Field", name: { kind: "Name", value: "to_spend_or_earn" } }] } }, { kind: "Field", name: { kind: "Name", value: "lifetime_earnings_tally" } }] } }] } }] } }] } }] } }] }, Bq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFavoriteProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_customer_favorite_products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "data_source" }, value: { kind: "EnumValue", value: "shopify" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "product_id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "handle" } }] } }] } }] } }] } }] }, qq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPointsRedemptions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_points_redemptions" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "used_at" } }, { kind: "Field", name: { kind: "Name", value: "refunded_at" } }, { kind: "Field", name: { kind: "Name", value: "revoked_at" } }] } }] } }] } }] } }] } }] }, Hq = {
  "\n  mutation adjustCustomerPoints(\n    $input: RivoLoyalty_adjust_customer_points_request_Input\n  ) {\n    RivoLoyalty {\n      adjust_customer_points(input: $input)\n    }\n  }\n": Uq,
  '\n  query getCustomer($email: String!) {\n    RivoLoyalty {\n      return_customer(\n        customer_identifier: $email\n        fields: "lifetime_earnings_tally,next_vip_tier"\n      ) {\n        data {\n          attributes {\n            id\n            email\n            first_name\n            last_name\n            accepts_marketing\n            orders_count\n            verified_email\n            total_spent\n            loyalty_status\n            points_tally\n            credits_tally\n            vip_tier {\n              name\n              threshold\n            }\n            points_expire_at\n            next_vip_tier {\n              name\n              threshold\n              to_spend_or_earn\n            }\n            lifetime_earnings_tally\n          }\n        }\n      }\n    }\n  }\n': Mq,
  "\n  query getFavoriteProducts($customerId: String!) {\n    RivoLoyalty {\n      list_customer_favorite_products(\n        customer_id: $customerId\n        data_source: shopify\n      ) {\n        data {\n          product_id\n          title\n          handle\n        }\n      }\n    }\n  }\n": Bq,
  "\n  query getPointsRedemptions($customerId: String!) {\n    RivoLoyalty {\n      list_points_redemptions(\n        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId\n      ) {\n        data {\n          id\n          attributes {\n            points_amount\n            name\n            code\n            expires_at\n            used_at\n            refunded_at\n            revoked_at\n          }\n        }\n      }\n    }\n  }\n": qq
};
function sc(e) {
  return Hq[e] ?? {};
}
const Wq = sc(
  /* GraphQL */
  `
  query getCustomer($email: String!) {
    RivoLoyalty {
      return_customer(
        customer_identifier: $email
        fields: "lifetime_earnings_tally,next_vip_tier"
      ) {
        data {
          attributes {
            id
            email
            first_name
            last_name
            accepts_marketing
            orders_count
            verified_email
            total_spent
            loyalty_status
            points_tally
            credits_tally
            vip_tier {
              name
              threshold
            }
            points_expire_at
            next_vip_tier {
              name
              threshold
              to_spend_or_earn
            }
            lifetime_earnings_tally
          }
        }
      }
    }
  }
`
), Kq = sc(
  /* GraphQL */
  `
  query getFavoriteProducts($customerId: String!) {
    RivoLoyalty {
      list_customer_favorite_products(
        customer_id: $customerId
        data_source: shopify
      ) {
        data {
          product_id
          title
          handle
        }
      }
    }
  }
`
), Gq = sc(
  /* GraphQL */
  `
  query getPointsRedemptions($customerId: String!) {
    RivoLoyalty {
      list_points_redemptions(
        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId
      ) {
        data {
          id
          attributes {
            points_amount
            name
            code
            expires_at
            used_at
            refunded_at
            revoked_at
          }
        }
      }
    }
  }
`
), Yq = sc(
  /* GraphQL */
  `
  mutation adjustCustomerPoints(
    $input: RivoLoyalty_adjust_customer_points_request_Input
  ) {
    RivoLoyalty {
      adjust_customer_points(input: $input)
    }
  }
`
), Qq = "_list_l5y5y_85", Jq = "_listItem_l5y5y_95", Xq = "_listItemHighlighted_l5y5y_103", Zq = "_listItemEdit_l5y5y_106", e6 = "_clickableIcon_l5y5y_120", Fr = {
  list: Qq,
  listItem: Jq,
  listItemHighlighted: Xq,
  listItemEdit: Zq,
  clickableIcon: e6
}, Ag = "rivoLoyaltyShopifyApiHostName", kF = "https://admin.shopify.com";
function bF(e) {
  return e.split(".")[0];
}
const n6 = "_wrapper_1xucg_1", WS = {
  wrapper: n6
}, t6 = ({
  customerDetails: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { track: r } = En(), { isCopied: i, copy: a } = ir(), { attributes: o } = e, {
    first_name: s,
    last_name: l,
    email: u,
    verified_email: m
  } = o, d = 14, f = `${s || ""} ${l || ""}`.trim() || "No name found for customer";
  return /* @__PURE__ */ ke.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ke.jsxs(b, { className: WS.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ke.jsx(
      b,
      {
        justifyContent: "space-between",
        className: WS.block,
        alignItems: "center",
        children: /* @__PURE__ */ ke.jsx(P.Heading, { variant: "heading-2", children: f })
      }
    ),
    u && /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ ke.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ ke.jsx(he, { size: d, name: "mail" }),
        /* @__PURE__ */ ke.jsx(P.ExternalLink, { href: `mailto:${u}`, children: u }),
        /* @__PURE__ */ ke.jsx(
          Xe,
          {
            content: m ? "Verified email" : "Email is not verified",
            children: /* @__PURE__ */ ke.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ke.jsx(
              he,
              {
                size: d,
                color: m ? "green.500" : "red.500",
                name: m ? "check-circle" : "exclamation"
              }
            ) })
          }
        )
      ] }),
      /* @__PURE__ */ ke.jsx(Xe, { content: "Copy Email", children: /* @__PURE__ */ ke.jsx(
        he,
        {
          size: d,
          name: i ? "done" : "copy",
          onClick: () => a(u),
          className: Fr.clickableIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ ke.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ke.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ke.jsx(he, { size: d, name: "sign-in" }),
        /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "2", children: "Marketing consent" })
      ] }),
      /* @__PURE__ */ ke.jsx(
        he,
        {
          name: o.accepts_marketing ? "check-circle-filled" : "close-circle-filled",
          color: o.accepts_marketing ? "green.500" : "neutral.500"
        }
      )
    ] }),
    /* @__PURE__ */ ke.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ ke.jsx(he, { size: d, name: "external-link" }),
      /* @__PURE__ */ ke.jsx(
        P.ExternalLink,
        {
          href: r6(n, o.id),
          target: "_blank",
          rel: "noreferrer",
          onClick: () => {
            r("rivoloyalty:customer:clicked", {});
          },
          children: "View customer in Rivo Loyalty"
        }
      )
    ] })
  ] }) });
};
function r6(e, n) {
  const r = bF(e);
  return `${kF}/store/${r}/apps/rivo-loyalty/customers/${n}`;
}
const i6 = "_list_rxh85_1", a6 = "_listItem_rxh85_6", KS = {
  list: i6,
  listItem: a6
}, o6 = ({
  customerId: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { useQuery: r } = _n(), {
    loading: i,
    error: a,
    data: o
  } = r(Kq, {
    skip: !e,
    variables: {
      customerId: e?.toString()
    }
  }), s = !i && o ? o.RivoLoyalty?.list_customer_favorite_products?.data ?? [] : [], l = 14, u = () => a ? /* @__PURE__ */ ke.jsx(Tn, { error: a }) : i ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ke.jsx(vn, {}) }) : s.length === 0 ? /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No favorite products found." }) : /* @__PURE__ */ ke.jsx(Qe, { className: KS.list, children: s.map((m) => /* @__PURE__ */ ke.jsxs(
    b,
    {
      alignItems: "center",
      gap: "200",
      className: KS.listItem,
      children: [
        /* @__PURE__ */ ke.jsx(he, { size: l, name: "external-link" }),
        /* @__PURE__ */ ke.jsx(
          P.ExternalLink,
          {
            href: s6(
              n,
              m.product_id
            ),
            target: "_blank",
            rel: "noreferrer",
            children: m.title
          }
        )
      ]
    },
    m.product_id
  )) });
  return /* @__PURE__ */ ke.jsx(ke.Fragment, { children: /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ke.jsx(P.Heading, { variant: "heading-3", children: "Favorite products" }),
    u()
  ] }) });
};
function s6(e, n) {
  const r = bF(e);
  return `${kF}/store/${r}/products/${n}`;
}
const l6 = "_modalBody_1clhs_1", c6 = {
  modalBody: l6
};
function u6(e, n) {
  if (isNaN(e))
    return "Points can not be empty";
  if (e < n.min)
    return `Points cannot be below ${n.min}`;
  if (e > n.max)
    return `Points can not exceed ${n.max}`;
}
function d6(e, n) {
  if (e === n)
    return "Change the value to update the points";
}
const m6 = vF, zs = {
  addPoints: {
    successEventName: "rivoloyalty:points:add:succeeded",
    successEventText: "Added points successfully",
    failEventName: "rivoloyalty:points:add:failed",
    failEventText: "Failed to add points, try again later."
  },
  removePoints: {
    successEventName: "rivoloyalty:points:remove:succeeded",
    successEventText: "Removed points successfully",
    failEventName: "rivoloyalty:points:remove:failed",
    failEventText: "Failed to remove points, try again later."
  }
}, p6 = ({
  customerIdentifier: e,
  isOpen: n,
  points: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = _n(), { track: l } = En(), [u, m] = de(r), [d, f] = de(""), [h, v] = de(!0), [I, w] = de(), j = {
    min: 0,
    max: 1e5
  }, [_, { loading: y }] = o(
    Yq,
    {
      onCompleted: () => {
        const te = u > r ? zs.addPoints : zs.removePoints;
        s({
          title: "Success",
          text: te.successEventText,
          icon: "check-circle-filled",
          severity: "success"
        }), l(te.successEventName), J();
      }
    }
  ), L = () => {
    m(r), f(""), v(!0), w(void 0);
  };
  Je(() => {
    n && L();
  }, [n]);
  const $ = !!I, C = u6(u, j), F = d6(r, u), z = () => {
    if (u !== r) {
      const te = u > r ? zs.addPoints : zs.removePoints, G = !h;
      _({
        variables: {
          input: {
            // eslint-disable-next-line camelcase
            points_amount: u - r,
            // eslint-disable-next-line camelcase
            ...d && { internal_note: d },
            // eslint-disable-next-line camelcase
            customer_identifier: e?.toString(),
            source: m6.Manual,
            // eslint-disable-next-line camelcase
            skip_email: G
          }
        }
      }).catch(() => {
        l(te.failEventName), w([te.failEventText]);
      });
    }
  }, Q = () => {
    L(), i();
  }, J = () => {
    a(), Q();
  };
  return /* @__PURE__ */ ke.jsxs(
    $t,
    {
      isOpen: n,
      onClose: Q,
      "data-testid": "rivo-loyalty-change-points-modal",
      children: [
        /* @__PURE__ */ ke.jsx(Tt, { title: "Change points", onClose: Q }),
        /* @__PURE__ */ ke.jsxs(Dt, { className: c6.modalBody, children: [
          /* @__PURE__ */ ke.jsxs(mt, { children: [
            /* @__PURE__ */ ke.jsx(ce, { span: 6, "data-testid": "rivo-loyalty-points-input", children: /* @__PURE__ */ ke.jsx(
              ur,
              {
                label: "New points balance",
                type: "number",
                placeholder: "Insert points balance",
                min: j.min,
                max: j.max,
                meta: {
                  error: C,
                  warning: F
                },
                input: {
                  name: "points",
                  value: u.toString(),
                  onChange: (te) => m(te?.target.valueAsNumber ?? 0)
                }
              }
            ) }),
            /* @__PURE__ */ ke.jsx(ce, { span: 6, children: /* @__PURE__ */ ke.jsx(
              ur,
              {
                label: "Internal note",
                placeholder: "Insert an internal note (optional)",
                input: {
                  name: "internalNote",
                  value: d,
                  onChange: (te) => f(te?.target.value ?? "")
                }
              }
            ) }),
            /* @__PURE__ */ ke.jsx(ce, { span: 6, children: /* @__PURE__ */ ke.jsx(en, { label: "Notify the customer by email", children: /* @__PURE__ */ ke.jsx(
              Ry,
              {
                input: {
                  name: "sendEmail",
                  value: "sendEmail",
                  checked: h,
                  onChange: () => v(!h)
                }
              }
            ) }) })
          ] }),
          !y && $ && /* @__PURE__ */ ke.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ ke.jsx(Qe, { children: I?.map((te, G) => /* @__PURE__ */ ke.jsx(
            Qe.Item,
            {
              variant: "dense",
              title: te,
              contentLeft: /* @__PURE__ */ ke.jsx(
                he,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            G
          )) }) })
        ] }),
        /* @__PURE__ */ ke.jsx(
          Ht,
          {
            confirmName: "Save",
            confirmOnClick: () => z(),
            confirmProps: {
              isLoading: y,
              loadingIndicator: /* @__PURE__ */ ke.jsx(vn, { size: 16 }),
              disabled: !!(C || F)
            },
            cancelOnClick: Q
          }
        )
      ]
    }
  );
}, ma = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = Yw(n);
  return /* @__PURE__ */ ke.jsx(
    Qe.Text,
    {
      variant: "dense",
      className: dt(Fr.listItem, {
        [Fr.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ ke.jsx(Xe, { content: r, children: /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", children: e }),
        a ? n : Gi(n)
      ] }) })
    }
  );
}, GS = {
  [wa.Guest]: {
    name: "Guest",
    tooltip: "Customers who can participate in your loyalty program without creating a full account. They can earn and redeem points through email verification or one-time codes.",
    badgeColor: "info"
  },
  [wa.Member]: {
    name: "Member",
    tooltip: "Customers who have activated their loyalty membership and have full access to all program features, including account dashboards and advanced features.",
    badgeColor: "success"
  },
  [wa.Excluded]: {
    name: "Excluded",
    tooltip: "Customers who have been excluded from the loyalty program (typically through the “Rivo Excluded” tag or manual exclusion).",
    badgeColor: "warning"
  }
}, f6 = ({
  customer: e,
  allowAdjustLoyaltyPoints: n,
  refetchCustomerData: r
}) => {
  const { attributes: i } = e, a = i.loyalty_status ? GS[i.loyalty_status] : GS[wa.Guest], o = a?.name === wa.Excluded, s = i.lifetime_earnings_tally, l = i.total_spent ?? 0, u = i.points_tally ?? 0, m = i.next_vip_tier, d = i.next_vip_tier?.to_spend_or_earn, f = m?.name ?? "None", [h, v] = de(!1), I = 10, w = () => /* @__PURE__ */ ke.jsx(
    Qe.Text,
    {
      variant: "dense",
      className: dt(Fr.listItem),
      children: /* @__PURE__ */ ke.jsx(Xe, { content: a.tooltip, children: /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", children: "Loyalty status" }),
        /* @__PURE__ */ ke.jsx(Bn, { variant: a.badgeColor, size: "small", children: a.name })
      ] }) })
    }
  ), j = () => o ? w() : /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
    /* @__PURE__ */ ke.jsx(
      Qe.Text,
      {
        variant: "dense",
        className: dt(
          Fr.listItem,
          Fr.listItemHighlighted,
          {
            [Fr.listItemEdit]: n
          }
        ),
        onClick: () => n ? v(!0) : void 0,
        children: /* @__PURE__ */ ke.jsx(Xe, { content: "The current balance of loyalty points for the customer.", children: /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", children: "Points balance" }),
          /* @__PURE__ */ ke.jsxs(
            b,
            {
              alignItems: "center",
              justifyContent: "space-between",
              gap: "100",
              children: [
                n && /* @__PURE__ */ ke.jsx(
                  he,
                  {
                    name: "pen",
                    size: I,
                    "aria-label": "Edit points"
                  }
                ),
                /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", children: Gi(u) })
              ]
            }
          )
        ] }) })
      }
    ),
    d != null && f && /* @__PURE__ */ ke.jsx(
      ma,
      {
        description: `Points until ${f} tier`,
        tooltip: `Loyalty points until the customer advances to ${f} tier`,
        content: d
      }
    ),
    /* @__PURE__ */ ke.jsx(
      ma,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: i.points_expire_at ?? "No expiry"
      }
    ),
    /* @__PURE__ */ ke.jsx(
      ma,
      {
        description: "Total points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: s
      }
    ),
    /* @__PURE__ */ ke.jsx(
      ma,
      {
        description: "Total points spent",
        tooltip: "The total number of loyalty points spent by the customer.",
        content: l
      }
    ),
    w(),
    /* @__PURE__ */ ke.jsx(
      ma,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: i.vip_tier?.name ?? "None"
      }
    ),
    /* @__PURE__ */ ke.jsx(
      ma,
      {
        description: "Next VIP tier",
        tooltip: "The name of the customer's next VIP tier status.",
        content: f
      }
    )
  ] });
  return /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
    /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ ke.jsx(P.Heading, { variant: "heading-3", children: "Loyalty" }),
      /* @__PURE__ */ ke.jsx(Qe, { className: Fr.list, children: j() })
    ] }),
    /* @__PURE__ */ ke.jsx(
      p6,
      {
        customerIdentifier: i.id,
        isOpen: h,
        points: u,
        onClose: () => v(!1),
        refetchCustomerData: r
      }
    )
  ] });
}, h6 = ({
  ordersCount: e
}) => /* @__PURE__ */ ke.jsx(ke.Fragment, { children: /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ ke.jsx(P.Heading, { variant: "heading-3", children: "Orders overview" }),
  /* @__PURE__ */ ke.jsx(Qe, { className: Fr.list, children: /* @__PURE__ */ ke.jsx(Qe.Text, { variant: "dense", className: Fr.listItem, children: /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", children: "Total orders" }),
    /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", children: e ?? 0 })
  ] }) }) })
] }) }), y6 = "_reward_1gmba_1", g6 = "_voucherCode_1gmba_14", YS = {
  reward: y6,
  voucherCode: g6
}, v6 = ({
  pointsRedemption: e
}) => {
  const { isCopied: n, copy: r } = ir(), {
    name: i,
    code: a,
    points_amount: o
  } = e.attributes;
  return /* @__PURE__ */ ke.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "column", className: YS.reward, children: [
    /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ke.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ke.jsx(he, { name: "star", size: 12, color: "neutral.500" }),
        i
      ] }),
      /* @__PURE__ */ ke.jsxs(Bn, { size: "small", variant: "info", children: [
        o ?? 0,
        " points"
      ] })
    ] }),
    /* @__PURE__ */ ke.jsxs(
      b,
      {
        gap: "100",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ ke.jsx(he, { size: 14, name: "tag" }),
            /* @__PURE__ */ ke.jsx(b, { children: /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", className: YS.voucherCode, children: a }) })
          ] }),
          /* @__PURE__ */ ke.jsx(Xe, { content: "Copy reward code", children: /* @__PURE__ */ ke.jsx(
            he,
            {
              size: 14,
              name: n ? "done" : "copy",
              className: Fr.clickableIcon,
              onClick: () => r(a)
            }
          ) })
        ]
      }
    )
  ] }) });
}, k6 = ({
  customer: e
}) => {
  const { useQuery: n } = _n(), {
    loading: r,
    error: i,
    data: a
  } = n(Gq, {
    skip: !e,
    variables: {
      customerId: e.attributes.id.toString()
    }
  }), o = (!r && e && a ? a?.RivoLoyalty?.list_points_redemptions?.data ?? [] : []).filter(
    ({ attributes: l }) => b6({
      usedAt: l.used_at,
      revokedAt: l.revoked_at,
      refundedAt: l.refunded_at
    }) === "Issued"
  ), s = () => i ? /* @__PURE__ */ ke.jsx(Tn, { error: i }) : r ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ke.jsx(vn, {}) }) : o.length > 0 ? /* @__PURE__ */ ke.jsx(b, { gap: "200", flexDirection: "column", children: o.map((l) => /* @__PURE__ */ ke.jsx(
    v6,
    {
      pointsRedemption: l
    },
    l.id
  )) }) : /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No loyalty rewards found." });
  return /* @__PURE__ */ ke.jsx(ke.Fragment, { children: /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ke.jsx(P.Heading, { variant: "heading-3", children: "Available rewards" }),
    s()
  ] }) });
};
function b6(e) {
  return e.usedAt ? "Used" : e.revokedAt ? "Revoked" : e.refundedAt ? "Refunded" : "Issued";
}
const _6 = (e) => {
  const { conversationContext: n, settings: r } = e, {
    rivoLoyaltyShowOrders: i,
    rivoLoyaltyShowLoyalty: a,
    rivoLoyaltyAdjustLoyaltyPoints: o,
    rivoLoyaltyShowFavoriteProducts: s,
    rivoLoyaltyShowPointsRedemptions: l
  } = r, u = r[Ag].toString(), { useQuery: m } = _n(), { track: d } = En(), [f, h] = de(!1), v = n?.customer?.email, {
    loading: I,
    error: w,
    data: j,
    refetch: _
  } = m(Wq, {
    skip: !v,
    variables: {
      email: v
    }
  }), y = !I && j ? j.RivoLoyalty?.return_customer?.data : void 0;
  Je(() => {
    !I && y && !f && (d("rivoloyalty:customer:received"), h(!0));
  }, [I, y]);
  const L = () => /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (w) {
    const $ = w.graphQLErrors;
    return Ra({ errors: $ }) ? L() : Ul({ errors: $ }) ? /* @__PURE__ */ ke.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Ml({ errors: $ }) ? /* @__PURE__ */ ke.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Rivo Loyalty. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ke.jsx(Tn, { error: w });
  }
  return I ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ke.jsx(vn, {}) }) : !v || !y ? L() : /* @__PURE__ */ ke.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ ke.jsx(
          t6,
          {
            customerDetails: y,
            rivoLoyaltyShopifyApiHostName: u
          }
        ),
        i && /* @__PURE__ */ ke.jsx(
          h6,
          {
            ordersCount: y.attributes?.orders_count ?? 0
          }
        ),
        a && /* @__PURE__ */ ke.jsx(
          f6,
          {
            customer: y,
            refetchCustomerData: _,
            allowAdjustLoyaltyPoints: !!o
          }
        ),
        s && /* @__PURE__ */ ke.jsx(
          o6,
          {
            customerId: y.attributes.id,
            rivoLoyaltyShopifyApiHostName: u
          }
        ),
        l && /* @__PURE__ */ ke.jsx(k6, { customer: y })
      ]
    }
  );
};
var us = (e) => e.type === "checkbox", Ui = (e) => e instanceof Date, tr = (e) => e == null;
const _F = (e) => typeof e == "object";
var _t = (e) => !tr(e) && !Array.isArray(e) && _F(e) && !Ui(e), xF = (e) => _t(e) && e.target ? us(e.target) ? e.target.checked : e.target.value : e, x6 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, SF = (e, n) => e.has(x6(n)), S6 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return _t(n) && n.hasOwnProperty("isPrototypeOf");
}, Lg = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Lt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Lg && (e instanceof Blob || i)) && (r || _t(e)))
    if (n = r ? [] : {}, !r && !S6(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Lt(e[a]));
  else
    return e;
  return n;
}
var lc = (e) => Array.isArray(e) ? e.filter(Boolean) : [], gt = (e) => e === void 0, sn = (e, n, r) => {
  if (!n || !_t(e))
    return r;
  const i = lc(n.split(/[,[\].]+?/)).reduce((a, o) => tr(a) ? a : a[o], e);
  return gt(i) || i === e ? gt(e[n]) ? r : e[n] : i;
}, hr = (e) => typeof e == "boolean", Vg = (e) => /^\w*$/.test(e), NF = (e) => lc(e.replace(/["|']|\]/g, "").split(/\.|\[/)), at = (e, n, r) => {
  let i = -1;
  const a = Vg(n) ? [n] : NF(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let u = r;
    if (i !== s) {
      const m = e[l];
      u = _t(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = u, e = e[l];
  }
};
const Dl = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Ir = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ci = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, N6 = $e.createContext(null), zg = () => $e.useContext(N6);
var jF = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== Ir.all && (n._proxyFormState[s] = !i || Ir.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function j6(e) {
  const n = zg(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = $e.useState(r._formState), u = $e.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = $e.useRef(a);
  return m.current = a, $e.useEffect(() => r._subscribe({
    name: m.current,
    formState: u.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...r._formState,
        ...d
      });
    }
  }), [r, i, o]), $e.useEffect(() => {
    u.current.isValid && r._setValid(!0);
  }, [r]), $e.useMemo(() => jF(s, r, u.current, !1), [s, r]);
}
var qr = (e) => typeof e == "string", wF = (e, n, r, i, a) => qr(e) ? (i && n.watch.add(e), sn(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), sn(r, o))) : (i && (n.watchAll = !0), r);
function w6(e) {
  const n = zg(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = $e.useRef(i), u = $e.useRef(a);
  l.current = i, $e.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && d(wF(l.current, r._names, f.values || r._formValues, !1, u.current))
  }), [r, o, s]);
  const [m, d] = $e.useState(r._getWatch(i, a));
  return $e.useEffect(() => r._removeUnmounted()), m;
}
function C6(e) {
  const n = zg(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = SF(a._names.array, r), l = w6({
    control: a,
    name: r,
    defaultValue: sn(a._formValues, r, sn(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), u = j6({
    control: a,
    name: r,
    exact: !0
  }), m = $e.useRef(e), d = $e.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...hr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = $e.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!sn(u.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!sn(u.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!sn(u.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!sn(u.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => sn(u.errors, r)
    }
  }), [u, r]), h = $e.useCallback((j) => d.current.onChange({
    target: {
      value: xF(j),
      name: r
    },
    type: Dl.CHANGE
  }), [r]), v = $e.useCallback(() => d.current.onBlur({
    target: {
      value: sn(a._formValues, r),
      name: r
    },
    type: Dl.BLUR
  }), [r, a._formValues]), I = $e.useCallback((j) => {
    const _ = sn(a._fields, r);
    _ && j && (_._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (y) => j.setCustomValidity(y),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), w = $e.useMemo(() => ({
    name: r,
    value: l,
    ...hr(i) || u.disabled ? { disabled: u.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: I
  }), [r, i, u.disabled, h, v, I, l]);
  return $e.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...hr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const _ = (y, L) => {
      const $ = sn(a._fields, y);
      $ && $._f && ($._f.mount = L);
    };
    if (_(r, !0), j) {
      const y = Lt(sn(a._options.defaultValues, r));
      at(a._defaultValues, r, y), gt(sn(a._formValues, r)) && at(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : _(r, !1);
    };
  }, [r, a, s, o]), $e.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), $e.useMemo(() => ({
    field: w,
    formState: u,
    fieldState: f
  }), [w, u, f]);
}
var F6 = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Mo = (e) => Array.isArray(e) ? e : [e], QS = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, xy = (e) => tr(e) || !_F(e);
function Ni(e, n) {
  if (xy(e) || xy(n))
    return e === n;
  if (Ui(e) && Ui(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Ui(o) && Ui(s) || _t(o) && _t(s) || Array.isArray(o) && Array.isArray(s) ? !Ni(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Zt = (e) => _t(e) && !Object.keys(e).length, Ug = (e) => e.type === "file", Er = (e) => typeof e == "function", Ol = (e) => {
  if (!Lg)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, CF = (e) => e.type === "select-multiple", Mg = (e) => e.type === "radio", I6 = (e) => Mg(e) || us(e), Hm = (e) => Ol(e) && e.isConnected;
function E6(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = gt(e) ? i++ : e[n[i++]];
  return e;
}
function $6(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !gt(e[n]))
      return !1;
  return !0;
}
function Ct(e, n) {
  const r = Array.isArray(n) ? n : Vg(n) ? [n] : NF(n), i = r.length === 1 ? e : E6(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (_t(i) && Zt(i) || Array.isArray(i) && $6(i)) && Ct(e, r.slice(0, -1)), e;
}
var FF = (e) => {
  for (const n in e)
    if (Er(e[n]))
      return !0;
  return !1;
};
function Rl(e, n = {}) {
  const r = Array.isArray(e);
  if (_t(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || _t(e[i]) && !FF(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Rl(e[i], n[i])) : tr(e[i]) || (n[i] = !0);
  return n;
}
function IF(e, n, r) {
  const i = Array.isArray(e);
  if (_t(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || _t(e[a]) && !FF(e[a]) ? gt(n) || xy(r[a]) ? r[a] = Array.isArray(e[a]) ? Rl(e[a], []) : { ...Rl(e[a]) } : IF(e[a], tr(n) ? {} : n[a], r[a]) : r[a] = !Ni(e[a], n[a]);
  return r;
}
var So = (e, n) => IF(e, n, Rl(n));
const JS = {
  value: !1,
  isValid: !1
}, XS = { value: !0, isValid: !0 };
var EF = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !gt(e[0].attributes.value) ? gt(e[0].value) || e[0].value === "" ? XS : { value: e[0].value, isValid: !0 } : XS
    ) : JS;
  }
  return JS;
}, $F = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => gt(e) ? e : n ? e === "" ? NaN : e && +e : r && qr(e) ? new Date(e) : i ? i(e) : e;
const ZS = {
  isValid: !1,
  value: null
};
var TF = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, ZS) : ZS;
function e0(e) {
  const n = e.ref;
  return Ug(n) ? n.files : Mg(n) ? TF(e.refs).value : CF(n) ? [...n.selectedOptions].map(({ value: r }) => r) : us(n) ? EF(e.refs).value : $F(gt(n.value) ? e.ref.value : n.value, e);
}
var T6 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = sn(n, o);
    s && at(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Pl = (e) => e instanceof RegExp, No = (e) => gt(e) ? e : Pl(e) ? e.source : _t(e) ? Pl(e.value) ? e.value.source : e.value : e, n0 = (e) => ({
  isOnSubmit: !e || e === Ir.onSubmit,
  isOnBlur: e === Ir.onBlur,
  isOnChange: e === Ir.onChange,
  isOnAll: e === Ir.all,
  isOnTouch: e === Ir.onTouched
});
const t0 = "AsyncFunction";
var D6 = (e) => !!e && !!e.validate && !!(Er(e.validate) && e.validate.constructor.name === t0 || _t(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === t0)), O6 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), r0 = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Bo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = sn(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Bo(l, n))
          break;
      } else if (_t(l) && Bo(l, n))
        break;
    }
  }
};
function i0(e, n, r) {
  const i = sn(e, r);
  if (i || Vg(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = sn(n, o), l = sn(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var R6 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Zt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || Ir.all));
}, P6 = (e, n, r) => !e || !n || e === n || Mo(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), A6 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, L6 = (e, n) => !lc(sn(e, n)).length && Ct(e, n), V6 = (e, n, r) => {
  const i = Mo(sn(e, r));
  return at(i, "root", n[r]), at(e, r, i), e;
}, ll = (e) => qr(e);
function a0(e, n, r = "validate") {
  if (ll(e) || Array.isArray(e) && e.every(ll) || hr(e) && !e)
    return {
      type: r,
      message: ll(e) ? e : "",
      ref: n
    };
}
var pa = (e) => _t(e) && !Pl(e) ? e : {
  value: e,
  message: ""
}, o0 = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: u, maxLength: m, minLength: d, min: f, max: h, pattern: v, validate: I, name: w, valueAsNumber: j, mount: _ } = e._f, y = sn(r, w);
  if (!_ || n.has(w))
    return {};
  const L = l ? l[0] : s, $ = (B) => {
    a && L.reportValidity && (L.setCustomValidity(hr(B) ? "" : B || ""), L.reportValidity());
  }, C = {}, F = Mg(s), z = us(s), Q = F || z, J = (j || Ug(s)) && gt(s.value) && gt(y) || Ol(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, te = F6.bind(null, w, i, C), G = (B, R, U, ee = ci.maxLength, Se = ci.minLength) => {
    const fe = B ? R : U;
    C[w] = {
      type: B ? ee : Se,
      message: fe,
      ref: s,
      ...te(B ? ee : Se, fe)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : u && (!Q && (J || tr(y)) || hr(y) && !y || z && !EF(l).isValid || F && !TF(l).isValid)) {
    const { value: B, message: R } = ll(u) ? { value: !!u, message: u } : pa(u);
    if (B && (C[w] = {
      type: ci.required,
      message: R,
      ref: L,
      ...te(ci.required, R)
    }, !i))
      return $(R), C;
  }
  if (!J && (!tr(f) || !tr(h))) {
    let B, R;
    const U = pa(h), ee = pa(f);
    if (!tr(y) && !isNaN(y)) {
      const Se = s.valueAsNumber || y && +y;
      tr(U.value) || (B = Se > U.value), tr(ee.value) || (R = Se < ee.value);
    } else {
      const Se = s.valueAsDate || new Date(y), fe = (K) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + K), ye = s.type == "time", ve = s.type == "week";
      qr(U.value) && y && (B = ye ? fe(y) > fe(U.value) : ve ? y > U.value : Se > new Date(U.value)), qr(ee.value) && y && (R = ye ? fe(y) < fe(ee.value) : ve ? y < ee.value : Se < new Date(ee.value));
    }
    if ((B || R) && (G(!!B, U.message, ee.message, ci.max, ci.min), !i))
      return $(C[w].message), C;
  }
  if ((m || d) && !J && (qr(y) || o && Array.isArray(y))) {
    const B = pa(m), R = pa(d), U = !tr(B.value) && y.length > +B.value, ee = !tr(R.value) && y.length < +R.value;
    if ((U || ee) && (G(U, B.message, R.message), !i))
      return $(C[w].message), C;
  }
  if (v && !J && qr(y)) {
    const { value: B, message: R } = pa(v);
    if (Pl(B) && !y.match(B) && (C[w] = {
      type: ci.pattern,
      message: R,
      ref: s,
      ...te(ci.pattern, R)
    }, !i))
      return $(R), C;
  }
  if (I) {
    if (Er(I)) {
      const B = await I(y, r), R = a0(B, L);
      if (R && (C[w] = {
        ...R,
        ...te(ci.validate, R.message)
      }, !i))
        return $(R.message), C;
    } else if (_t(I)) {
      let B = {};
      for (const R in I) {
        if (!Zt(B) && !i)
          break;
        const U = a0(await I[R](y, r), L, R);
        U && (B = {
          ...U,
          ...te(R, U.message)
        }, $(U.message), i && (C[w] = B));
      }
      if (!Zt(B) && (C[w] = {
        ref: L,
        ...B
      }, !i))
        return C;
    }
  }
  return $(!0), C;
};
const z6 = {
  mode: Ir.onSubmit,
  reValidateMode: Ir.onChange,
  shouldFocusError: !0
};
function U6(e = {}) {
  let n = {
    ...z6,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Er(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = _t(n.defaultValues) || _t(n.values) ? Lt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Lt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, m = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...d
  };
  const h = {
    array: QS(),
    state: QS()
  }, v = n0(n.mode), I = n0(n.reValidateMode), w = n.criteriaMode === Ir.all, j = (T) => (x) => {
    clearTimeout(m), m = setTimeout(T, x);
  }, _ = async (T) => {
    if (!n.disabled && (d.isValid || f.isValid || T)) {
      const x = n.resolver ? Zt((await J()).errors) : await G(i, !0);
      x !== r.isValid && h.state.next({
        isValid: x
      });
    }
  }, y = (T, x) => {
    !n.disabled && (d.isValidating || d.validatingFields || f.isValidating || f.validatingFields) && ((T || Array.from(l.mount)).forEach((D) => {
      D && (x ? at(r.validatingFields, D, x) : Ct(r.validatingFields, D));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Zt(r.validatingFields)
    }));
  }, L = (T, x = [], D, H, Y = !0, A = !0) => {
    if (H && D && !n.disabled) {
      if (s.action = !0, A && Array.isArray(sn(i, T))) {
        const M = D(sn(i, T), H.argA, H.argB);
        Y && at(i, T, M);
      }
      if (A && Array.isArray(sn(r.errors, T))) {
        const M = D(sn(r.errors, T), H.argA, H.argB);
        Y && at(r.errors, T, M), L6(r.errors, T);
      }
      if ((d.touchedFields || f.touchedFields) && A && Array.isArray(sn(r.touchedFields, T))) {
        const M = D(sn(r.touchedFields, T), H.argA, H.argB);
        Y && at(r.touchedFields, T, M);
      }
      (d.dirtyFields || f.dirtyFields) && (r.dirtyFields = So(a, o)), h.state.next({
        name: T,
        isDirty: R(T, x),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      at(o, T, x);
  }, $ = (T, x) => {
    at(r.errors, T, x), h.state.next({
      errors: r.errors
    });
  }, C = (T) => {
    r.errors = T, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, F = (T, x, D, H) => {
    const Y = sn(i, T);
    if (Y) {
      const A = sn(o, T, gt(D) ? sn(a, T) : D);
      gt(A) || H && H.defaultChecked || x ? at(o, T, x ? A : e0(Y._f)) : Se(T, A), s.mount && _();
    }
  }, z = (T, x, D, H, Y) => {
    let A = !1, M = !1;
    const oe = {
      name: T
    };
    if (!n.disabled) {
      if (!D || H) {
        (d.isDirty || f.isDirty) && (M = r.isDirty, r.isDirty = oe.isDirty = R(), A = M !== oe.isDirty);
        const ge = Ni(sn(a, T), x);
        M = !!sn(r.dirtyFields, T), ge ? Ct(r.dirtyFields, T) : at(r.dirtyFields, T, !0), oe.dirtyFields = r.dirtyFields, A = A || (d.dirtyFields || f.dirtyFields) && M !== !ge;
      }
      if (D) {
        const ge = sn(r.touchedFields, T);
        ge || (at(r.touchedFields, T, D), oe.touchedFields = r.touchedFields, A = A || (d.touchedFields || f.touchedFields) && ge !== D);
      }
      A && Y && h.state.next(oe);
    }
    return A ? oe : {};
  }, Q = (T, x, D, H) => {
    const Y = sn(r.errors, T), A = (d.isValid || f.isValid) && hr(x) && r.isValid !== x;
    if (n.delayError && D ? (u = j(() => $(T, D)), u(n.delayError)) : (clearTimeout(m), u = null, D ? at(r.errors, T, D) : Ct(r.errors, T)), (D ? !Ni(Y, D) : Y) || !Zt(H) || A) {
      const M = {
        ...H,
        ...A && hr(x) ? { isValid: x } : {},
        errors: r.errors,
        name: T
      };
      r = {
        ...r,
        ...M
      }, h.state.next(M);
    }
  }, J = async (T) => {
    y(T, !0);
    const x = await n.resolver(o, n.context, T6(T || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(T), x;
  }, te = async (T) => {
    const { errors: x } = await J(T);
    if (T)
      for (const D of T) {
        const H = sn(x, D);
        H ? at(r.errors, D, H) : Ct(r.errors, D);
      }
    else
      r.errors = x;
    return x;
  }, G = async (T, x, D = {
    valid: !0
  }) => {
    for (const H in T) {
      const Y = T[H];
      if (Y) {
        const { _f: A, ...M } = Y;
        if (A) {
          const oe = l.array.has(A.name), ge = Y._f && D6(Y._f);
          ge && d.validatingFields && y([H], !0);
          const Ne = await o0(Y, l.disabled, o, w, n.shouldUseNativeValidation && !x, oe);
          if (ge && d.validatingFields && y([H]), Ne[A.name] && (D.valid = !1, x))
            break;
          !x && (sn(Ne, A.name) ? oe ? V6(r.errors, Ne, A.name) : at(r.errors, A.name, Ne[A.name]) : Ct(r.errors, A.name));
        }
        !Zt(M) && await G(M, x, D);
      }
    }
    return D.valid;
  }, B = () => {
    for (const T of l.unMount) {
      const x = sn(i, T);
      x && (x._f.refs ? x._f.refs.every((D) => !Hm(D)) : !Hm(x._f.ref)) && Be(T);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (T, x) => !n.disabled && (T && x && at(o, T, x), !Ni(Te(), a)), U = (T, x, D) => wF(T, l, {
    ...s.mount ? o : gt(x) ? a : qr(T) ? { [T]: x } : x
  }, D, x), ee = (T) => lc(sn(s.mount ? o : a, T, n.shouldUnregister ? sn(a, T, []) : [])), Se = (T, x, D = {}) => {
    const H = sn(i, T);
    let Y = x;
    if (H) {
      const A = H._f;
      A && (!A.disabled && at(o, T, $F(x, A)), Y = Ol(A.ref) && tr(x) ? "" : x, CF(A.ref) ? [...A.ref.options].forEach((M) => M.selected = Y.includes(M.value)) : A.refs ? us(A.ref) ? A.refs.length > 1 ? A.refs.forEach((M) => (!M.defaultChecked || !M.disabled) && (M.checked = Array.isArray(Y) ? !!Y.find((oe) => oe === M.value) : Y === M.value)) : A.refs[0] && (A.refs[0].checked = !!Y) : A.refs.forEach((M) => M.checked = M.value === Y) : Ug(A.ref) ? A.ref.value = "" : (A.ref.value = Y, A.ref.type || h.state.next({
        name: T,
        values: Lt(o)
      })));
    }
    (D.shouldDirty || D.shouldTouch) && z(T, Y, D.shouldTouch, D.shouldDirty, !0), D.shouldValidate && _e(T);
  }, fe = (T, x, D) => {
    for (const H in x) {
      const Y = x[H], A = `${T}.${H}`, M = sn(i, A);
      (l.array.has(T) || _t(Y) || M && !M._f) && !Ui(Y) ? fe(A, Y, D) : Se(A, Y, D);
    }
  }, ye = (T, x, D = {}) => {
    const H = sn(i, T), Y = l.array.has(T), A = Lt(x);
    at(o, T, A), Y ? (h.array.next({
      name: T,
      values: Lt(o)
    }), (d.isDirty || d.dirtyFields || f.isDirty || f.dirtyFields) && D.shouldDirty && h.state.next({
      name: T,
      dirtyFields: So(a, o),
      isDirty: R(T, A)
    })) : H && !H._f && !tr(A) ? fe(T, A, D) : Se(T, A, D), r0(T, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? T : void 0,
      values: Lt(o)
    });
  }, ve = async (T) => {
    s.mount = !0;
    const x = T.target;
    let D = x.name, H = !0;
    const Y = sn(i, D), A = (M) => {
      H = Number.isNaN(M) || Ui(M) && isNaN(M.getTime()) || Ni(M, sn(o, D, M));
    };
    if (Y) {
      let M, oe;
      const ge = x.type ? e0(Y._f) : xF(T), Ne = T.type === Dl.BLUR || T.type === Dl.FOCUS_OUT, rn = !O6(Y._f) && !n.resolver && !sn(r.errors, D) && !Y._f.deps || A6(Ne, sn(r.touchedFields, D), r.isSubmitted, I, v), gn = r0(D, l, Ne);
      at(o, D, ge), Ne ? (Y._f.onBlur && Y._f.onBlur(T), u && u(0)) : Y._f.onChange && Y._f.onChange(T);
      const tn = z(D, ge, Ne), dn = !Zt(tn) || gn;
      if (!Ne && h.state.next({
        name: D,
        type: T.type,
        values: Lt(o)
      }), rn)
        return (d.isValid || f.isValid) && (n.mode === "onBlur" ? Ne && _() : Ne || _()), dn && h.state.next({ name: D, ...gn ? {} : tn });
      if (!Ne && gn && h.state.next({ ...r }), n.resolver) {
        const { errors: wn } = await J([D]);
        if (A(ge), H) {
          const xn = i0(r.errors, i, D), Cn = i0(wn, i, xn.name || D);
          M = Cn.error, D = Cn.name, oe = Zt(wn);
        }
      } else
        y([D], !0), M = (await o0(Y, l.disabled, o, w, n.shouldUseNativeValidation))[D], y([D]), A(ge), H && (M ? oe = !1 : (d.isValid || f.isValid) && (oe = await G(i, !0)));
      H && (Y._f.deps && _e(Y._f.deps), Q(D, oe, M, tn));
    }
  }, K = (T, x) => {
    if (sn(r.errors, x) && T.focus)
      return T.focus(), 1;
  }, _e = async (T, x = {}) => {
    let D, H;
    const Y = Mo(T);
    if (n.resolver) {
      const A = await te(gt(T) ? T : Y);
      D = Zt(A), H = T ? !Y.some((M) => sn(A, M)) : D;
    } else T ? (H = (await Promise.all(Y.map(async (A) => {
      const M = sn(i, A);
      return await G(M && M._f ? { [A]: M } : M);
    }))).every(Boolean), !(!H && !r.isValid) && _()) : H = D = await G(i);
    return h.state.next({
      ...!qr(T) || (d.isValid || f.isValid) && D !== r.isValid ? {} : { name: T },
      ...n.resolver || !T ? { isValid: D } : {},
      errors: r.errors
    }), x.shouldFocus && !H && Bo(i, K, T ? Y : l.mount), H;
  }, Te = (T) => {
    const x = {
      ...s.mount ? o : a
    };
    return gt(T) ? x : qr(T) ? sn(x, T) : T.map((D) => sn(x, D));
  }, X = (T, x) => ({
    invalid: !!sn((x || r).errors, T),
    isDirty: !!sn((x || r).dirtyFields, T),
    error: sn((x || r).errors, T),
    isValidating: !!sn(r.validatingFields, T),
    isTouched: !!sn((x || r).touchedFields, T)
  }), Ke = (T) => {
    T && Mo(T).forEach((x) => Ct(r.errors, x)), h.state.next({
      errors: T ? r.errors : {}
    });
  }, an = (T, x, D) => {
    const H = (sn(i, T, { _f: {} })._f || {}).ref, Y = sn(r.errors, T) || {}, { ref: A, message: M, type: oe, ...ge } = Y;
    at(r.errors, T, {
      ...ge,
      ...x,
      ref: H
    }), h.state.next({
      name: T,
      errors: r.errors,
      isValid: !1
    }), D && D.shouldFocus && H && H.focus && H.focus();
  }, we = (T, x) => Er(T) ? h.state.subscribe({
    next: (D) => T(U(void 0, x), D)
  }) : U(T, x, !0), Me = (T) => h.state.subscribe({
    next: (x) => {
      P6(T.name, x.name, T.exact) && R6(x, T.formState || d, Pe, T.reRenderRoot) && T.callback({
        values: { ...o },
        ...r,
        ...x
      });
    }
  }).unsubscribe, Re = (T) => (s.mount = !0, f = {
    ...f,
    ...T.formState
  }, Me({
    ...T,
    formState: f
  })), Be = (T, x = {}) => {
    for (const D of T ? Mo(T) : l.mount)
      l.mount.delete(D), l.array.delete(D), x.keepValue || (Ct(i, D), Ct(o, D)), !x.keepError && Ct(r.errors, D), !x.keepDirty && Ct(r.dirtyFields, D), !x.keepTouched && Ct(r.touchedFields, D), !x.keepIsValidating && Ct(r.validatingFields, D), !n.shouldUnregister && !x.keepDefaultValue && Ct(a, D);
    h.state.next({
      values: Lt(o)
    }), h.state.next({
      ...r,
      ...x.keepDirty ? { isDirty: R() } : {}
    }), !x.keepIsValid && _();
  }, Ae = ({ disabled: T, name: x }) => {
    (hr(T) && s.mount || T || l.disabled.has(x)) && (T ? l.disabled.add(x) : l.disabled.delete(x));
  }, Ge = (T, x = {}) => {
    let D = sn(i, T);
    const H = hr(x.disabled) || hr(n.disabled);
    return at(i, T, {
      ...D || {},
      _f: {
        ...D && D._f ? D._f : { ref: { name: T } },
        name: T,
        mount: !0,
        ...x
      }
    }), l.mount.add(T), D ? Ae({
      disabled: hr(x.disabled) ? x.disabled : n.disabled,
      name: T
    }) : F(T, !0, x.value), {
      ...H ? { disabled: x.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!x.required,
        min: No(x.min),
        max: No(x.max),
        minLength: No(x.minLength),
        maxLength: No(x.maxLength),
        pattern: No(x.pattern)
      } : {},
      name: T,
      onChange: ve,
      onBlur: ve,
      ref: (Y) => {
        if (Y) {
          Ge(T, x), D = sn(i, T);
          const A = gt(Y.value) && Y.querySelectorAll && Y.querySelectorAll("input,select,textarea")[0] || Y, M = I6(A), oe = D._f.refs || [];
          if (M ? oe.find((ge) => ge === A) : A === D._f.ref)
            return;
          at(i, T, {
            _f: {
              ...D._f,
              ...M ? {
                refs: [
                  ...oe.filter(Hm),
                  A,
                  ...Array.isArray(sn(a, T)) ? [{}] : []
                ],
                ref: { type: A.type, name: T }
              } : { ref: A }
            }
          }), F(T, !1, void 0, A);
        } else
          D = sn(i, T, {}), D._f && (D._f.mount = !1), (n.shouldUnregister || x.shouldUnregister) && !(SF(l.array, T) && s.action) && l.unMount.add(T);
      }
    };
  }, Ce = () => n.shouldFocusError && Bo(i, K, l.mount), qe = (T) => {
    hr(T) && (h.state.next({ disabled: T }), Bo(i, (x, D) => {
      const H = sn(i, D);
      H && (x.disabled = H._f.disabled || T, Array.isArray(H._f.refs) && H._f.refs.forEach((Y) => {
        Y.disabled = H._f.disabled || T;
      }));
    }, 0, !1));
  }, nn = (T, x) => async (D) => {
    let H;
    D && (D.preventDefault && D.preventDefault(), D.persist && D.persist());
    let Y = Lt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: A, values: M } = await J();
      r.errors = A, Y = M;
    } else
      await G(i);
    if (l.disabled.size)
      for (const A of l.disabled)
        at(Y, A, void 0);
    if (Ct(r.errors, "root"), Zt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await T(Y, D);
      } catch (A) {
        H = A;
      }
    } else
      x && await x({ ...r.errors }, D), Ce(), setTimeout(Ce);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Zt(r.errors) && !H,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), H)
      throw H;
  }, ae = (T, x = {}) => {
    sn(i, T) && (gt(x.defaultValue) ? ye(T, Lt(sn(a, T))) : (ye(T, x.defaultValue), at(a, T, Lt(x.defaultValue))), x.keepTouched || Ct(r.touchedFields, T), x.keepDirty || (Ct(r.dirtyFields, T), r.isDirty = x.defaultValue ? R(T, Lt(sn(a, T))) : R()), x.keepError || (Ct(r.errors, T), d.isValid && _()), h.state.next({ ...r }));
  }, le = (T, x = {}) => {
    const D = T ? Lt(T) : a, H = Lt(D), Y = Zt(T), A = Y ? a : H;
    if (x.keepDefaultValues || (a = D), !x.keepValues) {
      if (x.keepDirtyValues) {
        const M = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(So(a, o))
        ]);
        for (const oe of Array.from(M))
          sn(r.dirtyFields, oe) ? at(A, oe, sn(o, oe)) : ye(oe, sn(A, oe));
      } else {
        if (Lg && gt(T))
          for (const M of l.mount) {
            const oe = sn(i, M);
            if (oe && oe._f) {
              const ge = Array.isArray(oe._f.refs) ? oe._f.refs[0] : oe._f.ref;
              if (Ol(ge)) {
                const Ne = ge.closest("form");
                if (Ne) {
                  Ne.reset();
                  break;
                }
              }
            }
          }
        for (const M of l.mount)
          ye(M, sn(A, M));
      }
      o = Lt(A), h.array.next({
        values: { ...A }
      }), h.state.next({
        values: { ...A }
      });
    }
    l = {
      mount: x.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!x.keepIsValid || !!x.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: x.keepSubmitCount ? r.submitCount : 0,
      isDirty: Y ? !1 : x.keepDirty ? r.isDirty : !!(x.keepDefaultValues && !Ni(T, a)),
      isSubmitted: x.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: Y ? {} : x.keepDirtyValues ? x.keepDefaultValues && o ? So(a, o) : r.dirtyFields : x.keepDefaultValues && T ? So(a, T) : x.keepDirty ? r.dirtyFields : {},
      touchedFields: x.keepTouched ? r.touchedFields : {},
      errors: x.keepErrors ? r.errors : {},
      isSubmitSuccessful: x.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, xe = (T, x) => le(Er(T) ? T(o) : T, x), Le = (T, x = {}) => {
    const D = sn(i, T), H = D && D._f;
    if (H) {
      const Y = H.refs ? H.refs[0] : H.ref;
      Y.focus && (Y.focus(), x.shouldSelect && Er(Y.select) && Y.select());
    }
  }, Pe = (T) => {
    r = {
      ...r,
      ...T
    };
  }, yn = {
    control: {
      register: Ge,
      unregister: Be,
      getFieldState: X,
      handleSubmit: nn,
      setError: an,
      _subscribe: Me,
      _runSchema: J,
      _getWatch: U,
      _getDirty: R,
      _setValid: _,
      _setFieldArray: L,
      _setDisabledField: Ae,
      _setErrors: C,
      _getFieldArray: ee,
      _reset: le,
      _resetDefaultValues: () => Er(n.defaultValues) && n.defaultValues().then((T) => {
        xe(T, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: qe,
      _subjects: h,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(T) {
        s = T;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(T) {
        l = T;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(T) {
        n = {
          ...n,
          ...T
        };
      }
    },
    subscribe: Re,
    trigger: _e,
    register: Ge,
    handleSubmit: nn,
    watch: we,
    setValue: ye,
    getValues: Te,
    reset: xe,
    resetField: ae,
    clearErrors: Ke,
    unregister: Be,
    setError: an,
    setFocus: Le,
    getFieldState: X
  };
  return {
    ...yn,
    formControl: yn
  };
}
function M6(e = {}) {
  const n = $e.useRef(void 0), r = $e.useRef(void 0), [i, a] = $e.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Er(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Er(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : U6(e),
    formState: i
  }, e.formControl && e.defaultValues && !Er(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, $e.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), $e.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), $e.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), $e.useEffect(() => {
    e.values && !Ni(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), $e.useEffect(() => {
    e.errors && !Zt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), $e.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), $e.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = jF(i, o), n.current;
}
var Us = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function DF(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Wm = { exports: {} }, jo = {}, s0;
function B6() {
  if (s0) return jo;
  s0 = 1;
  var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return jo.Fragment = r, jo.jsx = s, jo.jsxs = s, jo;
}
var Ms = {}, l0;
function q6() {
  return l0 || (l0 = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var g = _.ReactDebugCurrentFrame, E = g.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var $ = !1, C = !1, F = !1, z = !1, Q = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === d || z || t === v || $ || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, N = E._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (E) {
            var g = E.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (ie) {
              g = ie;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var S = ie.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var ue = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = E;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ae(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ae(t.type, c, p);
          case h: {
            var g = t, E = g._payload, O = g._init;
            try {
              return ae(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, p, g, E) {
      {
        var O = Function.call.bind(le);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + p + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe(E), y("Failed %s type: %s", p, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, p, g, E, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, p, g, E) {
      {
        var O, N = {}, S = null, ne = null;
        p !== void 0 && (A(p), S = "" + p), gn(c) && (A(c.key), S = "" + c.key), rn(c) && (ne = c.ref, tn(c));
        for (O in c)
          le.call(c, O) && !oe.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, E, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function An(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = j(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          yn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var E = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, p, g, E, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, p, E, O);
        if (W == null)
          return W;
        if (N) {
          var ue = c.children;
          if (ue !== void 0)
            if (g)
              if (x(ue)) {
                for (var Ue = 0; Ue < ue.length; Ue++)
                  Sn(ue[Ue], t);
                Object.freeze && Object.freeze(ue);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ue, t);
        }
        if (le.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var Rn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, Rn, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, p) {
      return Fn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return Fn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Ms.Fragment = i, Ms.jsx = Un, Ms.jsxs = Kn;
  })()), Ms;
}
var c0;
function H6() {
  return c0 || (c0 = 1, process.env.NODE_ENV === "production" ? Wm.exports = B6() : Wm.exports = q6()), Wm.exports;
}
var qo = H6();
function W6(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Km, u0;
function Fi() {
  if (u0) return Km;
  u0 = 1;
  var e = Array.isArray;
  return Km = e, Km;
}
var Gm, d0;
function OF() {
  if (d0) return Gm;
  d0 = 1;
  var e = typeof Us == "object" && Us && Us.Object === Object && Us;
  return Gm = e, Gm;
}
var Ym, m0;
function ri() {
  if (m0) return Ym;
  m0 = 1;
  var e = OF(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Ym = r, Ym;
}
var Qm, p0;
function ds() {
  if (p0) return Qm;
  p0 = 1;
  var e = ri(), n = e.Symbol;
  return Qm = n, Qm;
}
var Jm, f0;
function K6() {
  if (f0) return Jm;
  f0 = 1;
  var e = ds(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), u = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var d = i.call(s);
    return m && (l ? s[a] = u : delete s[a]), d;
  }
  return Jm = o, Jm;
}
var Xm, h0;
function G6() {
  if (h0) return Xm;
  h0 = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Xm = r, Xm;
}
var Zm, y0;
function Ha() {
  if (y0) return Zm;
  y0 = 1;
  var e = ds(), n = K6(), r = G6(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Zm = s, Zm;
}
var ep, g0;
function ta() {
  if (g0) return ep;
  g0 = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return ep = e, ep;
}
var np, v0;
function Bg() {
  if (v0) return np;
  v0 = 1;
  var e = Ha(), n = ta(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return np = i, np;
}
var tp, k0;
function Y6() {
  if (k0) return tp;
  k0 = 1;
  var e = Fi(), n = Bg(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return tp = a, tp;
}
var rp, b0;
function Wa() {
  if (b0) return rp;
  b0 = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return rp = e, rp;
}
var ip, _0;
function RF() {
  if (_0) return ip;
  _0 = 1;
  var e = Ha(), n = Wa(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var u = e(l);
    return u == i || u == a || u == r || u == o;
  }
  return ip = s, ip;
}
var ap, x0;
function Q6() {
  if (x0) return ap;
  x0 = 1;
  var e = ri(), n = e["__core-js_shared__"];
  return ap = n, ap;
}
var op, S0;
function J6() {
  if (S0) return op;
  S0 = 1;
  var e = Q6(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return op = r, op;
}
var sp, N0;
function PF() {
  if (N0) return sp;
  N0 = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return sp = r, sp;
}
var lp, j0;
function X6() {
  if (j0) return lp;
  j0 = 1;
  var e = RF(), n = J6(), r = Wa(), i = PF(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, u = s.toString, m = l.hasOwnProperty, d = RegExp(
    "^" + u.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? d : o;
    return v.test(i(h));
  }
  return lp = f, lp;
}
var cp, w0;
function Z6() {
  if (w0) return cp;
  w0 = 1;
  function e(n, r) {
    return n?.[r];
  }
  return cp = e, cp;
}
var up, C0;
function ra() {
  if (C0) return up;
  C0 = 1;
  var e = X6(), n = Z6();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return up = r, up;
}
var dp, F0;
function cc() {
  if (F0) return dp;
  F0 = 1;
  var e = ra(), n = e(Object, "create");
  return dp = n, dp;
}
var mp, I0;
function eH() {
  if (I0) return mp;
  I0 = 1;
  var e = cc();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return mp = n, mp;
}
var pp, E0;
function nH() {
  if (E0) return pp;
  E0 = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return pp = e, pp;
}
var fp, $0;
function tH() {
  if ($0) return fp;
  $0 = 1;
  var e = cc(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return fp = a, fp;
}
var hp, T0;
function rH() {
  if (T0) return hp;
  T0 = 1;
  var e = cc(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return hp = i, hp;
}
var yp, D0;
function iH() {
  if (D0) return yp;
  D0 = 1;
  var e = cc(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return yp = r, yp;
}
var gp, O0;
function aH() {
  if (O0) return gp;
  O0 = 1;
  var e = eH(), n = nH(), r = tH(), i = rH(), a = iH();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, gp = o, gp;
}
var vp, R0;
function oH() {
  if (R0) return vp;
  R0 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return vp = e, vp;
}
var kp, P0;
function AF() {
  if (P0) return kp;
  P0 = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return kp = e, kp;
}
var bp, A0;
function uc() {
  if (A0) return bp;
  A0 = 1;
  var e = AF();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return bp = n, bp;
}
var _p, L0;
function sH() {
  if (L0) return _p;
  L0 = 1;
  var e = uc(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return _p = i, _p;
}
var xp, V0;
function lH() {
  if (V0) return xp;
  V0 = 1;
  var e = uc();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return xp = n, xp;
}
var Sp, z0;
function cH() {
  if (z0) return Sp;
  z0 = 1;
  var e = uc();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return Sp = n, Sp;
}
var Np, U0;
function uH() {
  if (U0) return Np;
  U0 = 1;
  var e = uc();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return Np = n, Np;
}
var jp, M0;
function dc() {
  if (M0) return jp;
  M0 = 1;
  var e = oH(), n = sH(), r = lH(), i = cH(), a = uH();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, jp = o, jp;
}
var wp, B0;
function qg() {
  if (B0) return wp;
  B0 = 1;
  var e = ra(), n = ri(), r = e(n, "Map");
  return wp = r, wp;
}
var Cp, q0;
function dH() {
  if (q0) return Cp;
  q0 = 1;
  var e = aH(), n = dc(), r = qg();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return Cp = i, Cp;
}
var Fp, H0;
function mH() {
  if (H0) return Fp;
  H0 = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return Fp = e, Fp;
}
var Ip, W0;
function mc() {
  if (W0) return Ip;
  W0 = 1;
  var e = mH();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return Ip = n, Ip;
}
var Ep, K0;
function pH() {
  if (K0) return Ep;
  K0 = 1;
  var e = mc();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return Ep = n, Ep;
}
var $p, G0;
function fH() {
  if (G0) return $p;
  G0 = 1;
  var e = mc();
  function n(r) {
    return e(this, r).get(r);
  }
  return $p = n, $p;
}
var Tp, Y0;
function hH() {
  if (Y0) return Tp;
  Y0 = 1;
  var e = mc();
  function n(r) {
    return e(this, r).has(r);
  }
  return Tp = n, Tp;
}
var Dp, Q0;
function yH() {
  if (Q0) return Dp;
  Q0 = 1;
  var e = mc();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return Dp = n, Dp;
}
var Op, J0;
function LF() {
  if (J0) return Op;
  J0 = 1;
  var e = dH(), n = pH(), r = fH(), i = hH(), a = yH();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Op = o, Op;
}
var Rp, X0;
function gH() {
  if (X0) return Rp;
  X0 = 1;
  var e = LF(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], u = o.cache;
      if (u.has(l))
        return u.get(l);
      var m = i.apply(this, s);
      return o.cache = u.set(l, m) || u, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, Rp = r, Rp;
}
var Pp, Z0;
function vH() {
  if (Z0) return Pp;
  Z0 = 1;
  var e = gH(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return Pp = r, Pp;
}
var Ap, eN;
function kH() {
  if (eN) return Ap;
  eN = 1;
  var e = vH(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, u, m) {
      o.push(u ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return Ap = i, Ap;
}
var Lp, nN;
function VF() {
  if (nN) return Lp;
  nN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return Lp = e, Lp;
}
var Vp, tN;
function bH() {
  if (tN) return Vp;
  tN = 1;
  var e = ds(), n = VF(), r = Fi(), i = Bg(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var u = l + "";
    return u == "0" && 1 / l == -1 / 0 ? "-0" : u;
  }
  return Vp = s, Vp;
}
var zp, rN;
function _H() {
  if (rN) return zp;
  rN = 1;
  var e = bH();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return zp = n, zp;
}
var Up, iN;
function Ka() {
  if (iN) return Up;
  iN = 1;
  var e = Fi(), n = Y6(), r = kH(), i = _H();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return Up = a, Up;
}
var Mp, aN;
function pc() {
  if (aN) return Mp;
  aN = 1;
  var e = Bg();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return Mp = n, Mp;
}
var Bp, oN;
function zF() {
  if (oN) return Bp;
  oN = 1;
  var e = Ka(), n = pc();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Bp = r, Bp;
}
var qp, sN;
function UF() {
  if (sN) return qp;
  sN = 1;
  var e = ra(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return qp = n, qp;
}
var Hp, lN;
function MF() {
  if (lN) return Hp;
  lN = 1;
  var e = UF();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return Hp = n, Hp;
}
var Wp, cN;
function Hg() {
  if (cN) return Wp;
  cN = 1;
  var e = MF(), n = AF(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var u = o[s];
    (!(i.call(o, s) && n(u, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Wp = a, Wp;
}
var Kp, uN;
function Wg() {
  if (uN) return Kp;
  uN = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Kp = r, Kp;
}
var Gp, dN;
function xH() {
  if (dN) return Gp;
  dN = 1;
  var e = Hg(), n = Ka(), r = Wg(), i = Wa(), a = pc();
  function o(s, l, u, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var d = -1, f = l.length, h = f - 1, v = s; v != null && ++d < f; ) {
      var I = a(l[d]), w = u;
      if (I === "__proto__" || I === "constructor" || I === "prototype")
        return s;
      if (d != h) {
        var j = v[I];
        w = m ? m(j, I, v) : void 0, w === void 0 && (w = i(j) ? j : r(l[d + 1]) ? [] : {});
      }
      e(v, I, w), v = v[I];
    }
    return s;
  }
  return Gp = o, Gp;
}
var Yp, mN;
function SH() {
  if (mN) return Yp;
  mN = 1;
  var e = zF(), n = xH(), r = Ka();
  function i(a, o, s) {
    for (var l = -1, u = o.length, m = {}; ++l < u; ) {
      var d = o[l], f = e(a, d);
      s(f, d) && n(m, r(d, a), f);
    }
    return m;
  }
  return Yp = i, Yp;
}
var Qp, pN;
function NH() {
  if (pN) return Qp;
  pN = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Qp = e, Qp;
}
var Jp, fN;
function jH() {
  if (fN) return Jp;
  fN = 1;
  var e = Ha(), n = ta(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Jp = i, Jp;
}
var Xp, hN;
function Kg() {
  if (hN) return Xp;
  hN = 1;
  var e = jH(), n = ta(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Xp = o, Xp;
}
var Zp, yN;
function Gg() {
  if (yN) return Zp;
  yN = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Zp = n, Zp;
}
var ef, gN;
function wH() {
  if (gN) return ef;
  gN = 1;
  var e = Ka(), n = Kg(), r = Fi(), i = Wg(), a = Gg(), o = pc();
  function s(l, u, m) {
    u = e(u, l);
    for (var d = -1, f = u.length, h = !1; ++d < f; ) {
      var v = o(u[d]);
      if (!(h = l != null && m(l, v)))
        break;
      l = l[v];
    }
    return h || ++d != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return ef = s, ef;
}
var nf, vN;
function CH() {
  if (vN) return nf;
  vN = 1;
  var e = NH(), n = wH();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return nf = r, nf;
}
var tf, kN;
function FH() {
  if (kN) return tf;
  kN = 1;
  var e = SH(), n = CH();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return tf = r, tf;
}
var rf, bN;
function Yg() {
  if (bN) return rf;
  bN = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return rf = e, rf;
}
var af, _N;
function IH() {
  if (_N) return af;
  _N = 1;
  var e = ds(), n = Kg(), r = Fi(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return af = a, af;
}
var of, xN;
function EH() {
  if (xN) return of;
  xN = 1;
  var e = Yg(), n = IH();
  function r(i, a, o, s, l) {
    var u = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++u < m; ) {
      var d = i[u];
      a > 0 && o(d) ? a > 1 ? r(d, a - 1, o, s, l) : e(l, d) : s || (l[l.length] = d);
    }
    return l;
  }
  return of = r, of;
}
var sf, SN;
function $H() {
  if (SN) return sf;
  SN = 1;
  var e = EH();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return sf = n, sf;
}
var lf, NN;
function TH() {
  if (NN) return lf;
  NN = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return lf = e, lf;
}
var cf, jN;
function DH() {
  if (jN) return cf;
  jN = 1;
  var e = TH(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, u = n(s.length - a, 0), m = Array(u); ++l < u; )
        m[l] = s[a + l];
      l = -1;
      for (var d = Array(a + 1); ++l < a; )
        d[l] = s[l];
      return d[a] = o(m), e(i, this, d);
    };
  }
  return cf = r, cf;
}
var uf, wN;
function OH() {
  if (wN) return uf;
  wN = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return uf = e, uf;
}
var df, CN;
function BF() {
  if (CN) return df;
  CN = 1;
  function e(n) {
    return n;
  }
  return df = e, df;
}
var mf, FN;
function RH() {
  if (FN) return mf;
  FN = 1;
  var e = OH(), n = UF(), r = BF(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return mf = i, mf;
}
var pf, IN;
function PH() {
  if (IN) return pf;
  IN = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), u = n - (l - s);
      if (s = l, u > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return pf = i, pf;
}
var ff, EN;
function AH() {
  if (EN) return ff;
  EN = 1;
  var e = RH(), n = PH(), r = n(e);
  return ff = r, ff;
}
var hf, $N;
function qF() {
  if ($N) return hf;
  $N = 1;
  var e = $H(), n = DH(), r = AH();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return hf = i, hf;
}
var yf, TN;
function LH() {
  if (TN) return yf;
  TN = 1;
  var e = FH(), n = qF(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return yf = r, yf;
}
var VH = LH();
const HF = /* @__PURE__ */ DF(VH), zH = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function WF(e) {
  const n = HF(e, zH);
  return {
    controller: C6(n),
    controllerProps: n
  };
}
const UH = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function MH(e) {
  const { controller: n, controllerProps: r } = WF(e), i = {
    ...HF(e, UH),
    required: W6(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var gf, DN;
function BH() {
  if (DN) return gf;
  DN = 1;
  var e = dc();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return gf = n, gf;
}
var vf, ON;
function qH() {
  if (ON) return vf;
  ON = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return vf = e, vf;
}
var kf, RN;
function HH() {
  if (RN) return kf;
  RN = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return kf = e, kf;
}
var bf, PN;
function WH() {
  if (PN) return bf;
  PN = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return bf = e, bf;
}
var _f, AN;
function KH() {
  if (AN) return _f;
  AN = 1;
  var e = dc(), n = qg(), r = LF(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var u = l.__data__;
      if (!n || u.length < i - 1)
        return u.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(u);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return _f = a, _f;
}
var xf, LN;
function GH() {
  if (LN) return xf;
  LN = 1;
  var e = dc(), n = BH(), r = qH(), i = HH(), a = WH(), o = KH();
  function s(l) {
    var u = this.__data__ = new e(l);
    this.size = u.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, xf = s, xf;
}
var Sf, VN;
function YH() {
  if (VN) return Sf;
  VN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return Sf = e, Sf;
}
var Nf, zN;
function ms() {
  if (zN) return Nf;
  zN = 1;
  var e = Hg(), n = MF();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var u = -1, m = a.length; ++u < m; ) {
      var d = a[u], f = s ? s(o[d], i[d], d, o, i) : void 0;
      f === void 0 && (f = i[d]), l ? n(o, d, f) : e(o, d, f);
    }
    return o;
  }
  return Nf = r, Nf;
}
var jf, UN;
function QH() {
  if (UN) return jf;
  UN = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return jf = e, jf;
}
var cl = { exports: {} }, wf, MN;
function JH() {
  if (MN) return wf;
  MN = 1;
  function e() {
    return !1;
  }
  return wf = e, wf;
}
cl.exports;
var BN;
function KF() {
  return BN || (BN = 1, (function(e, n) {
    var r = ri(), i = JH(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, u = l ? l.isBuffer : void 0, m = u || i;
    e.exports = m;
  })(cl, cl.exports)), cl.exports;
}
var Cf, qN;
function XH() {
  if (qN) return Cf;
  qN = 1;
  var e = Ha(), n = Gg(), r = ta(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", u = "[object Function]", m = "[object Map]", d = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", I = "[object String]", w = "[object WeakMap]", j = "[object ArrayBuffer]", _ = "[object DataView]", y = "[object Float32Array]", L = "[object Float64Array]", $ = "[object Int8Array]", C = "[object Int16Array]", F = "[object Int32Array]", z = "[object Uint8Array]", Q = "[object Uint8ClampedArray]", J = "[object Uint16Array]", te = "[object Uint32Array]", G = {};
  G[y] = G[L] = G[$] = G[C] = G[F] = G[z] = G[Q] = G[J] = G[te] = !0, G[i] = G[a] = G[j] = G[o] = G[_] = G[s] = G[l] = G[u] = G[m] = G[d] = G[f] = G[h] = G[v] = G[I] = G[w] = !1;
  function B(R) {
    return r(R) && n(R.length) && !!G[e(R)];
  }
  return Cf = B, Cf;
}
var Ff, HN;
function Qg() {
  if (HN) return Ff;
  HN = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return Ff = e, Ff;
}
var ul = { exports: {} };
ul.exports;
var WN;
function Jg() {
  return WN || (WN = 1, (function(e, n) {
    var r = OF(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var u = a && a.require && a.require("util").types;
        return u || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(ul, ul.exports)), ul.exports;
}
var If, KN;
function ZH() {
  if (KN) return If;
  KN = 1;
  var e = XH(), n = Qg(), r = Jg(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return If = a, If;
}
var Ef, GN;
function GF() {
  if (GN) return Ef;
  GN = 1;
  var e = QH(), n = Kg(), r = Fi(), i = KF(), a = Wg(), o = ZH(), s = Object.prototype, l = s.hasOwnProperty;
  function u(m, d) {
    var f = r(m), h = !f && n(m), v = !f && !h && i(m), I = !f && !h && !v && o(m), w = f || h || v || I, j = w ? e(m.length, String) : [], _ = j.length;
    for (var y in m)
      (d || l.call(m, y)) && !(w && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      I && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      a(y, _))) && j.push(y);
    return j;
  }
  return Ef = u, Ef;
}
var $f, YN;
function Xg() {
  if (YN) return $f;
  YN = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return $f = n, $f;
}
var Tf, QN;
function YF() {
  if (QN) return Tf;
  QN = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return Tf = e, Tf;
}
var Df, JN;
function eW() {
  if (JN) return Df;
  JN = 1;
  var e = YF(), n = e(Object.keys, Object);
  return Df = n, Df;
}
var Of, XN;
function nW() {
  if (XN) return Of;
  XN = 1;
  var e = Xg(), n = eW(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return Of = a, Of;
}
var Rf, ZN;
function QF() {
  if (ZN) return Rf;
  ZN = 1;
  var e = RF(), n = Gg();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Rf = r, Rf;
}
var Pf, ej;
function Zg() {
  if (ej) return Pf;
  ej = 1;
  var e = GF(), n = nW(), r = QF();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return Pf = i, Pf;
}
var Af, nj;
function tW() {
  if (nj) return Af;
  nj = 1;
  var e = ms(), n = Zg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Af = r, Af;
}
var Lf, tj;
function rW() {
  if (tj) return Lf;
  tj = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return Lf = e, Lf;
}
var Vf, rj;
function iW() {
  if (rj) return Vf;
  rj = 1;
  var e = Wa(), n = Xg(), r = rW(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), u = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || u.push(m);
    return u;
  }
  return Vf = o, Vf;
}
var zf, ij;
function ev() {
  if (ij) return zf;
  ij = 1;
  var e = GF(), n = iW(), r = QF();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return zf = i, zf;
}
var Uf, aj;
function aW() {
  if (aj) return Uf;
  aj = 1;
  var e = ms(), n = ev();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Uf = r, Uf;
}
var dl = { exports: {} };
dl.exports;
var oj;
function oW() {
  return oj || (oj = 1, (function(e, n) {
    var r = ri(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function u(m, d) {
      if (d)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = u;
  })(dl, dl.exports)), dl.exports;
}
var Mf, sj;
function sW() {
  if (sj) return Mf;
  sj = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return Mf = e, Mf;
}
var Bf, lj;
function lW() {
  if (lj) return Bf;
  lj = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Bf = e, Bf;
}
var qf, cj;
function JF() {
  if (cj) return qf;
  cj = 1;
  function e() {
    return [];
  }
  return qf = e, qf;
}
var Hf, uj;
function nv() {
  if (uj) return Hf;
  uj = 1;
  var e = lW(), n = JF(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Hf = o, Hf;
}
var Wf, dj;
function cW() {
  if (dj) return Wf;
  dj = 1;
  var e = ms(), n = nv();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Wf = r, Wf;
}
var Kf, mj;
function tv() {
  if (mj) return Kf;
  mj = 1;
  var e = YF(), n = e(Object.getPrototypeOf, Object);
  return Kf = n, Kf;
}
var Gf, pj;
function XF() {
  if (pj) return Gf;
  pj = 1;
  var e = Yg(), n = tv(), r = nv(), i = JF(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return Gf = o, Gf;
}
var Yf, fj;
function uW() {
  if (fj) return Yf;
  fj = 1;
  var e = ms(), n = XF();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Yf = r, Yf;
}
var Qf, hj;
function ZF() {
  if (hj) return Qf;
  hj = 1;
  var e = Yg(), n = Fi();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Qf = r, Qf;
}
var Jf, yj;
function dW() {
  if (yj) return Jf;
  yj = 1;
  var e = ZF(), n = nv(), r = Zg();
  function i(a) {
    return e(a, r, n);
  }
  return Jf = i, Jf;
}
var Xf, gj;
function eI() {
  if (gj) return Xf;
  gj = 1;
  var e = ZF(), n = XF(), r = ev();
  function i(a) {
    return e(a, r, n);
  }
  return Xf = i, Xf;
}
var Zf, vj;
function mW() {
  if (vj) return Zf;
  vj = 1;
  var e = ra(), n = ri(), r = e(n, "DataView");
  return Zf = r, Zf;
}
var eh, kj;
function pW() {
  if (kj) return eh;
  kj = 1;
  var e = ra(), n = ri(), r = e(n, "Promise");
  return eh = r, eh;
}
var nh, bj;
function fW() {
  if (bj) return nh;
  bj = 1;
  var e = ra(), n = ri(), r = e(n, "Set");
  return nh = r, nh;
}
var th, _j;
function hW() {
  if (_j) return th;
  _j = 1;
  var e = ra(), n = ri(), r = e(n, "WeakMap");
  return th = r, th;
}
var rh, xj;
function rv() {
  if (xj) return rh;
  xj = 1;
  var e = mW(), n = qg(), r = pW(), i = fW(), a = hW(), o = Ha(), s = PF(), l = "[object Map]", u = "[object Object]", m = "[object Promise]", d = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), I = s(n), w = s(r), j = s(i), _ = s(a), y = o;
  return (e && y(new e(new ArrayBuffer(1))) != h || n && y(new n()) != l || r && y(r.resolve()) != m || i && y(new i()) != d || a && y(new a()) != f) && (y = function(L) {
    var $ = o(L), C = $ == u ? L.constructor : void 0, F = C ? s(C) : "";
    if (F)
      switch (F) {
        case v:
          return h;
        case I:
          return l;
        case w:
          return m;
        case j:
          return d;
        case _:
          return f;
      }
    return $;
  }), rh = y, rh;
}
var ih, Sj;
function yW() {
  if (Sj) return ih;
  Sj = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return ih = r, ih;
}
var ah, Nj;
function gW() {
  if (Nj) return ah;
  Nj = 1;
  var e = ri(), n = e.Uint8Array;
  return ah = n, ah;
}
var oh, jj;
function iv() {
  if (jj) return oh;
  jj = 1;
  var e = gW();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return oh = n, oh;
}
var sh, wj;
function vW() {
  if (wj) return sh;
  wj = 1;
  var e = iv();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return sh = n, sh;
}
var lh, Cj;
function kW() {
  if (Cj) return lh;
  Cj = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return lh = n, lh;
}
var ch, Fj;
function bW() {
  if (Fj) return ch;
  Fj = 1;
  var e = ds(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return ch = i, ch;
}
var uh, Ij;
function _W() {
  if (Ij) return uh;
  Ij = 1;
  var e = iv();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return uh = n, uh;
}
var dh, Ej;
function xW() {
  if (Ej) return dh;
  Ej = 1;
  var e = iv(), n = vW(), r = kW(), i = bW(), a = _W(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", u = "[object Number]", m = "[object RegExp]", d = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", I = "[object DataView]", w = "[object Float32Array]", j = "[object Float64Array]", _ = "[object Int8Array]", y = "[object Int16Array]", L = "[object Int32Array]", $ = "[object Uint8Array]", C = "[object Uint8ClampedArray]", F = "[object Uint16Array]", z = "[object Uint32Array]";
  function Q(J, te, G) {
    var B = J.constructor;
    switch (te) {
      case v:
        return e(J);
      case o:
      case s:
        return new B(+J);
      case I:
        return n(J, G);
      case w:
      case j:
      case _:
      case y:
      case L:
      case $:
      case C:
      case F:
      case z:
        return a(J, G);
      case l:
        return new B();
      case u:
      case f:
        return new B(J);
      case m:
        return r(J);
      case d:
        return new B();
      case h:
        return i(J);
    }
  }
  return dh = Q, dh;
}
var mh, $j;
function SW() {
  if ($j) return mh;
  $j = 1;
  var e = Wa(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return mh = r, mh;
}
var ph, Tj;
function NW() {
  if (Tj) return ph;
  Tj = 1;
  var e = SW(), n = tv(), r = Xg();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return ph = i, ph;
}
var fh, Dj;
function jW() {
  if (Dj) return fh;
  Dj = 1;
  var e = rv(), n = ta(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return fh = i, fh;
}
var hh, Oj;
function wW() {
  if (Oj) return hh;
  Oj = 1;
  var e = jW(), n = Qg(), r = Jg(), i = r && r.isMap, a = i ? n(i) : e;
  return hh = a, hh;
}
var yh, Rj;
function CW() {
  if (Rj) return yh;
  Rj = 1;
  var e = rv(), n = ta(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return yh = i, yh;
}
var gh, Pj;
function FW() {
  if (Pj) return gh;
  Pj = 1;
  var e = CW(), n = Qg(), r = Jg(), i = r && r.isSet, a = i ? n(i) : e;
  return gh = a, gh;
}
var vh, Aj;
function IW() {
  if (Aj) return vh;
  Aj = 1;
  var e = GH(), n = YH(), r = Hg(), i = tW(), a = aW(), o = oW(), s = sW(), l = cW(), u = uW(), m = dW(), d = eI(), f = rv(), h = yW(), v = xW(), I = NW(), w = Fi(), j = KF(), _ = wW(), y = Wa(), L = FW(), $ = Zg(), C = ev(), F = 1, z = 2, Q = 4, J = "[object Arguments]", te = "[object Array]", G = "[object Boolean]", B = "[object Date]", R = "[object Error]", U = "[object Function]", ee = "[object GeneratorFunction]", Se = "[object Map]", fe = "[object Number]", ye = "[object Object]", ve = "[object RegExp]", K = "[object Set]", _e = "[object String]", Te = "[object Symbol]", X = "[object WeakMap]", Ke = "[object ArrayBuffer]", an = "[object DataView]", we = "[object Float32Array]", Me = "[object Float64Array]", Re = "[object Int8Array]", Be = "[object Int16Array]", Ae = "[object Int32Array]", Ge = "[object Uint8Array]", Ce = "[object Uint8ClampedArray]", qe = "[object Uint16Array]", nn = "[object Uint32Array]", ae = {};
  ae[J] = ae[te] = ae[Ke] = ae[an] = ae[G] = ae[B] = ae[we] = ae[Me] = ae[Re] = ae[Be] = ae[Ae] = ae[Se] = ae[fe] = ae[ye] = ae[ve] = ae[K] = ae[_e] = ae[Te] = ae[Ge] = ae[Ce] = ae[qe] = ae[nn] = !0, ae[R] = ae[U] = ae[X] = !1;
  function le(xe, Le, Pe, yn, T, x) {
    var D, H = Le & F, Y = Le & z, A = Le & Q;
    if (Pe && (D = T ? Pe(xe, yn, T, x) : Pe(xe)), D !== void 0)
      return D;
    if (!y(xe))
      return xe;
    var M = w(xe);
    if (M) {
      if (D = h(xe), !H)
        return s(xe, D);
    } else {
      var oe = f(xe), ge = oe == U || oe == ee;
      if (j(xe))
        return o(xe, H);
      if (oe == ye || oe == J || ge && !T) {
        if (D = Y || ge ? {} : I(xe), !H)
          return Y ? u(xe, a(D, xe)) : l(xe, i(D, xe));
      } else {
        if (!ae[oe])
          return T ? xe : {};
        D = v(xe, oe, H);
      }
    }
    x || (x = new e());
    var Ne = x.get(xe);
    if (Ne)
      return Ne;
    x.set(xe, D), L(xe) ? xe.forEach(function(tn) {
      D.add(le(tn, Le, Pe, tn, xe, x));
    }) : _(xe) && xe.forEach(function(tn, dn) {
      D.set(dn, le(tn, Le, Pe, dn, xe, x));
    });
    var rn = A ? Y ? d : m : Y ? C : $, gn = M ? void 0 : rn(xe);
    return n(gn || xe, function(tn, dn) {
      gn && (dn = tn, tn = xe[dn]), r(D, dn, le(tn, Le, Pe, dn, xe, x));
    }), D;
  }
  return vh = le, vh;
}
var kh, Lj;
function EW() {
  if (Lj) return kh;
  Lj = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return kh = e, kh;
}
var bh, Vj;
function $W() {
  if (Vj) return bh;
  Vj = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return bh = e, bh;
}
var _h, zj;
function TW() {
  if (zj) return _h;
  zj = 1;
  var e = zF(), n = $W();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return _h = r, _h;
}
var xh, Uj;
function DW() {
  if (Uj) return xh;
  Uj = 1;
  var e = Ka(), n = EW(), r = TW(), i = pc(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, u) {
    u = e(u, l);
    var m = -1, d = u.length;
    if (!d)
      return !0;
    for (; ++m < d; ) {
      var f = i(u[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < d - 1)
        return !1;
    }
    var h = r(l, u);
    return h == null || delete h[i(n(u))];
  }
  return xh = s, xh;
}
var Sh, Mj;
function OW() {
  if (Mj) return Sh;
  Mj = 1;
  var e = Ha(), n = tv(), r = ta(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, u = s.call(Object);
  function m(d) {
    if (!r(d) || e(d) != i)
      return !1;
    var f = n(d);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == u;
  }
  return Sh = m, Sh;
}
var Nh, Bj;
function RW() {
  if (Bj) return Nh;
  Bj = 1;
  var e = OW();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return Nh = n, Nh;
}
var jh, qj;
function PW() {
  if (qj) return jh;
  qj = 1;
  var e = VF(), n = IW(), r = DW(), i = Ka(), a = ms(), o = RW(), s = qF(), l = eI(), u = 1, m = 2, d = 4, f = s(function(h, v) {
    var I = {};
    if (h == null)
      return I;
    var w = !1;
    v = e(v, function(_) {
      return _ = i(_, h), w || (w = _.length > 1), _;
    }), a(h, l(h), I), w && (I = n(I, u | m | d, o));
    for (var j = v.length; j--; )
      r(I, v[j]);
    return I;
  });
  return jh = f, jh;
}
PW();
var AW = BF();
const LW = /* @__PURE__ */ DF(AW), fa = ({
  transformValue: e = LW,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = WF(a);
  return /* @__PURE__ */ qo.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ qo.jsx(
      hl,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ qo.jsx(Jw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, Hj = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = MH(e);
  return /* @__PURE__ */ qo.jsx(en, { ...i, children: /* @__PURE__ */ qo.jsx(
    _r,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: en.getStatus(i.meta)
    }
  ) });
}, Sy = [
  {
    key: "rivoLoyaltyApiKey",
    defaultValue: "",
    secret: !0,
    type: "string"
  },
  {
    key: Ag,
    defaultValue: "",
    secret: !1,
    type: "string"
  },
  {
    key: "rivoLoyaltyShowOrders",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowLoyalty",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyAdjustLoyaltyPoints",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowFavoriteProducts",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowPointsRedemptions",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  }
], Wj = "RIVOLOYALTY", Bs = "Rivo Loyalty", VW = {
  enabled: !1,
  name: "",
  rivoLoyaltyApiKey: "",
  [Ag]: "",
  rivoLoyaltyShowOrders: !0,
  rivoLoyaltyShowLoyalty: !0,
  rivoLoyaltyAdjustLoyaltyPoints: !0,
  rivoLoyaltyShowFavoriteProducts: !0,
  rivoLoyaltyShowPointsRedemptions: !0
}, zW = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = M6({
    mode: "onChange",
    defaultValues: VW
  }), {
    create: l,
    update: u,
    remove: m,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = Gr({
    integrationId: e,
    integrationType: Wj,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: I,
    error: w,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: y
  } = Yr({
    integrationId: e,
    fieldDefinitions: Sy,
    form: s,
    onMisconfigured: v
  }), { renderConditions: L, setRenderConditions: $, renderConditionsForSubmit: C } = Qr({
    integrationId: e,
    widgetConfiguration: y,
    renderConditionsEditor: a
  }), F = (Q) => Xr(Q, {
    fieldDefinitions: Sy,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: C
  }), z = s.watch("name");
  return /* @__PURE__ */ ke.jsxs(
    Jr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: w ?? f,
      onRetry: w ? _ : void 0,
      isLoading: d || I,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ ke.jsx(Zr, { cause: h }),
        /* @__PURE__ */ ke.jsxs(mt, { children: [
          /* @__PURE__ */ ke.jsx(ce, { children: /* @__PURE__ */ ke.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ke.jsx(
            fa,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(ce, { span: 3, children: /* @__PURE__ */ ke.jsx(
            Hj,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ke.jsx(ce, { span: 3 }),
          /* @__PURE__ */ ke.jsx(ce, { span: 3, children: /* @__PURE__ */ ke.jsx(
            Hj,
            {
              name: "rivoLoyaltyShopifyApiHostName",
              label: "Shopify API host name",
              control: s.control,
              rules: {
                required: "Shopify API host name is required",
                validate: (Q) => Ey(Q) ?? void 0
              },
              componentProps: {
                placeholder: 'Host name of your Shopify shop, e.g. "my-webshop.myshopify.com"',
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ ke.jsx(ce, { span: 3 }),
          /* @__PURE__ */ ke.jsx(ce, { span: 3, children: /* @__PURE__ */ ke.jsx(
            Da,
            {
              name: "rivoLoyaltyApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your Rivo API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ke.jsx(ce, { span: 3 }),
          /* @__PURE__ */ ke.jsx(ce, { span: 3, children: /* @__PURE__ */ ke.jsx(en, { label: "Show orders overview", children: /* @__PURE__ */ ke.jsx(
            fa,
            {
              name: "rivoLoyaltyShowOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(ce, { span: 3 }),
          /* @__PURE__ */ ke.jsx(ce, { span: 3, children: /* @__PURE__ */ ke.jsx(en, { label: "Show loyalty", children: /* @__PURE__ */ ke.jsx(
            fa,
            {
              name: "rivoLoyaltyShowLoyalty",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(ce, { span: 3 }),
          /* @__PURE__ */ ke.jsx(ce, { span: 3, children: /* @__PURE__ */ ke.jsx(en, { label: "Allow adjusting loyalty points", children: /* @__PURE__ */ ke.jsx(
            fa,
            {
              name: "rivoLoyaltyAdjustLoyaltyPoints",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(ce, { span: 3 }),
          /* @__PURE__ */ ke.jsx(ce, { span: 3, children: /* @__PURE__ */ ke.jsx(en, { label: "Show favorite products", children: /* @__PURE__ */ ke.jsx(
            fa,
            {
              name: "rivoLoyaltyShowFavoriteProducts",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(ce, { span: 3 }),
          /* @__PURE__ */ ke.jsx(ce, { span: 3, children: /* @__PURE__ */ ke.jsx(en, { label: "Show available rewards", children: /* @__PURE__ */ ke.jsx(
            fa,
            {
              name: "rivoLoyaltyShowPointsRedemptions",
              control: s.control
            }
          ) }) }),
          a && L !== null && /* @__PURE__ */ ke.jsx(ce, { children: a({
            value: L,
            onChange: $,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ ke.jsx(
          ei,
          {
            integrationType: Wj,
            integrationId: e,
            widgetName: z,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ ke.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ ke.jsx(
                he,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ ke.jsxs(P.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Bs,
                  " integration, all links between Dixa and ",
                  Bs,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ ke.jsxs(P.Paragraph, { children: [
                  "All data in ",
                  Bs,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ ke.jsxs(P.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Bs,
                  " ",
                  'integration "',
                  z,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._copyIcon_1dlzg_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1yp2k_1,._copyIcon_1yp2k_2,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._copyIcon_yc0fe_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._order_yc0fe_6{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_yc0fe_6:hover,._orderIsOpen_yc0fe_14{border-color:var(--dixa-color-neutral-400)}._orderHeader_yc0fe_17{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var wh = { exports: {} }, wo = {}, Kj;
function UW() {
  if (Kj) return wo;
  Kj = 1;
  var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return wo.Fragment = r, wo.jsx = s, wo.jsxs = s, wo;
}
var qs = {}, Gj;
function MW() {
  return Gj || (Gj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var g = _.ReactDebugCurrentFrame, E = g.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var $ = !1, C = !1, F = !1, z = !1, Q = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === d || z || t === v || $ || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, N = E._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (E) {
            var g = E.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (ie) {
              g = ie;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var S = ie.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var ue = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = E;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ae(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ae(t.type, c, p);
          case h: {
            var g = t, E = g._payload, O = g._init;
            try {
              return ae(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, p, g, E) {
      {
        var O = Function.call.bind(le);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + p + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe(E), y("Failed %s type: %s", p, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, p, g, E, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, p, g, E) {
      {
        var O, N = {}, S = null, ne = null;
        p !== void 0 && (A(p), S = "" + p), gn(c) && (A(c.key), S = "" + c.key), rn(c) && (ne = c.ref, tn(c));
        for (O in c)
          le.call(c, O) && !oe.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, E, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function An(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = j(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          yn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var E = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, p, g, E, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, p, E, O);
        if (W == null)
          return W;
        if (N) {
          var ue = c.children;
          if (ue !== void 0)
            if (g)
              if (x(ue)) {
                for (var Ue = 0; Ue < ue.length; Ue++)
                  Sn(ue[Ue], t);
                Object.freeze && Object.freeze(ue);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ue, t);
        }
        if (le.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var Rn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, Rn, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, p) {
      return Fn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return Fn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    qs.Fragment = i, qs.jsx = Un, qs.jsxs = Kn;
  })()), qs;
}
var Yj;
function BW() {
  return Yj || (Yj = 1, process.env.NODE_ENV === "production" ? wh.exports = UW() : wh.exports = MW()), wh.exports;
}
var k = BW();
const Qj = "__PairingContext__", qW = () => globalThis[Qj] ?? (() => {
  const e = Qw({});
  return globalThis[Qj] = e, e;
})(), HW = qW(), WW = () => Ty(HW), KW = "_banner_d9pot_1", GW = "_list_d9pot_8", Jj = {
  banner: KW,
  list: GW
}, Xj = "https://apps.shopify.com/dixa-dashboard", YW = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, nI = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = WW(), [i, a] = de(!1), [o, s] = de(null), l = YW[n], u = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const d = await r();
        window.open(
          d ?? Xj,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(Xj, "_blank", "noopener,noreferrer");
  }, m = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", className: Jj.banner, children: [
    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(he, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ k.jsx(P.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ k.jsx(P.Paragraph, { as: "div", children: /* @__PURE__ */ k.jsx(m, { className: Jj.list, children: l.listItems.map((d, f) => /* @__PURE__ */ k.jsx("li", { children: d }, f)) }) })
    ] }),
    o && /* @__PURE__ */ k.jsx(P.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ k.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ k.jsx(
      nt,
      {
        onClick: u,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(vn, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, QW = (e) => /* @__PURE__ */ k.jsx(nI, { ...e, bannerVariant: "install" }), JW = (e) => /* @__PURE__ */ k.jsx(nI, { ...e, bannerVariant: "migration" }), XW = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], ZW = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], e9 = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: QW
  }
], n9 = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], Zj = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: JW,
    additionalProperties: { renderAboveForm: !0 }
  }
], tI = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], ew = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => Ey(e)
  },
  ...tI
];
var ka = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(ka || {}), Ki = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(Ki || {}), Mr = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Mr || {}), rI = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(rI || {}), Li = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(Li || {}), di = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(di || {}), ml = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(ml || {}), iI = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(iI || {});
const t9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, r9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, i9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, a9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, o9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, s9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, l9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, c9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, u9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, d9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, m9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, p9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, f9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, h9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, y9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, g9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, v9 = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": t9,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": r9,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": i9,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": a9,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": o9,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": s9,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": l9,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": c9,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": u9,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": d9,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": m9,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": p9,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": f9,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": h9,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": y9,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": g9
};
function Nr(e) {
  return v9[e] ?? {};
}
const k9 = Nr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), b9 = Nr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), _9 = Nr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), x9 = Nr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), av = Nr(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), S9 = Nr(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), N9 = Nr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), j9 = Nr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), w9 = Nr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), C9 = Nr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), F9 = Nr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), I9 = Nr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), aI = Hl`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, E9 = Hl`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, $9 = ({
  conversationContext: e,
  forcePhoneLookup: n
}) => {
  const { useQuery: r } = _n(), i = e.customer?.email, a = e.customer?.phone_number, o = i ? `email:"${i}"` : null, s = a ? `phone:"${a}"` : null, l = n ? s : o ?? s, {
    loading: u,
    error: m,
    data: d,
    refetch: f,
    networkStatus: h
  } = r(k9, {
    skip: !l,
    variables: {
      query: l
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: u,
    customerError: m,
    customerData: d,
    refetchCustomer: f,
    customerNetworkStatus: h
  };
}, T9 = () => {
  const { useLazyQuery: e } = _n(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(b9);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Wr(e = !1, n) {
  const [r, i] = de(e);
  return Je(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const D9 = "_list_alvh6_1", O9 = "_listItem_alvh6_4", R9 = "_fullWidth_alvh6_15", P9 = "_boxWrapper_alvh6_19", Gt = {
  list: D9,
  listItem: O9,
  fullWidth: R9,
  boxWrapper: P9
}, A9 = "_modal_1vkwz_1", L9 = "_disabled_1vkwz_5", Ch = {
  modal: A9,
  disabled: L9
}, nw = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: Ki.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: Ki.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: Ki.Unknown
  }
], tw = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: Mr.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: Mr.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: Mr.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: Mr.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: Mr.Unsubscribed
  }
], V9 = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = En(), { useMutation: l, showNotification: u } = _n(), [m, d] = de(), [f, h] = de(), [v, I] = Z_(!0), [w, j] = Z_(!0), _ = !!m, y = e.customer?.email, L = e.customer?.phone_number, $ = e.customer?.given_name, C = e.customer?.family_name, F = {
    email: y ?? "",
    phone: L ?? "",
    firstName: $ ?? "",
    lastName: C ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, z = ht({
    defaultValues: F
  });
  Je(() => {
    f?.forEach((R) => {
      const U = R?.field?.[0];
      U && (z.setError(U, {
        type: "server",
        message: R.message
      }), z.setFocus(U));
    });
  }, [f, z]);
  const [Q, { error: J, reset: te }] = l(F9, {
    onError: (R) => {
      d(R.message), a(!1), u({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (R) => {
      const U = R?.Shopify?.customerCreate?.userErrors || [];
      U.length > 0 ? (h(U), a(!1), u({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), u({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), G = ft(
    (R) => {
      a(!0), d(void 0), Q({
        variables: {
          input: {
            firstName: R.firstName,
            lastName: R.lastName,
            ...v && { email: R.email },
            ...w && { phone: R.phone },
            ...R.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: R.smsMarketingState,
                marketingOptInLevel: R.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [Q, a, w, v]
  ), B = () => {
    r(!1), te(), d(void 0), z.reset(F);
  };
  return /* @__PURE__ */ k.jsxs($t, { isOpen: n, onClose: B, className: Ch.modal, children: [
    /* @__PURE__ */ k.jsx(Tt, { title: "Create new customer", onClose: B }),
    /* @__PURE__ */ k.jsx(Dt, { children: /* @__PURE__ */ k.jsxs(mt, { children: [
      /* @__PURE__ */ k.jsx(ce, { span: 3, children: /* @__PURE__ */ k.jsx(
        Zn,
        {
          label: "First name",
          name: "firstName",
          control: z.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(ce, { span: 3, children: /* @__PURE__ */ k.jsx(
        Zn,
        {
          label: "Last name",
          name: "lastName",
          control: z.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(
        Zn,
        {
          label: "Email",
          name: "email",
          control: z.control,
          rules: {
            required: v ? "Email is required" : void 0
          },
          componentProps: {
            className: dt({
              [Ch.disabled]: !v
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                hl,
                {
                  disabled: !w,
                  name: "hasEmail",
                  value: "email",
                  checked: v,
                  onChange: () => I()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(
        Zn,
        {
          label: "Phone",
          name: "phone",
          control: z.control,
          rules: {
            required: w ? "Phone is required" : void 0
          },
          componentProps: {
            className: dt({
              [Ch.disabled]: !w
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                hl,
                {
                  disabled: !v,
                  name: "hasPhone",
                  value: "phone",
                  checked: w,
                  onChange: () => j()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(
        Dr,
        {
          control: z.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (R, U) => R === U,
            getItemTitleByValue: (R) => {
              const U = tw.find(
                (ee) => ee.value === R
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: U.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: U.description })
                  ]
                }
              );
            }
          },
          children: tw.map((R) => /* @__PURE__ */ k.jsx(kt.Item, { value: R.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(
        Dr,
        {
          control: z.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (R, U) => R === U,
            getItemTitleByValue: (R) => {
              const U = nw.find(
                (ee) => ee.value === R
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: U.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: U.description })
                  ]
                }
              );
            }
          },
          children: nw.map((R) => /* @__PURE__ */ k.jsx(kt.Item, { value: R.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      _ && /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(he, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Ht,
      {
        confirmProps: {
          disabled: !(z.formState.isValid && z.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 })
        },
        confirmOnClick: z.handleSubmit(G),
        cancelOnClick: B,
        confirmName: J ? "Close" : "Save",
        cancelName: J ? void 0 : "Cancel"
      }
    )
  ] });
}, z9 = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = de(!1), [a, o] = de(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsx(
      nt,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 }),
        slotStart: /* @__PURE__ */ k.jsx(he, { size: 14, name: "user-plus", color: "green.500" }),
        className: Gt.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ k.jsx(
      V9,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, ov = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, Ny = "DD MMM YYYY @ HH:mm", U9 = "_wrapper_10fld_1", M9 = "_copyIcon_10fld_7", Hs = {
  wrapper: U9,
  copyIcon: M9
}, B9 = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Wr(), { isCopied: l, copy: u } = Wr(), { track: m } = En();
  if (!e)
    return null;
  const {
    id: d,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: v,
    tags: I = [],
    verifiedEmail: w
  } = e, j = h?.emailAddress, _ = v?.phoneNumber, y = ov(d), L = `https://${n}/admin/customers/${y ?? ""}`, $ = i && a === dr.refetch, C = 14;
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { className: Hs.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: f }),
        $ ? /* @__PURE__ */ k.jsx(vn, { size: C }) : /* @__PURE__ */ k.jsx(Xe, { content: "Reload customer", children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: C,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: d }), r();
            },
            className: Hs.copyIcon
          }
        ) })
      ] }),
      j && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(he, { size: C, name: "mail" }),
          /* @__PURE__ */ k.jsx(P.ExternalLink, { href: `mailto:${j}`, children: j }),
          /* @__PURE__ */ k.jsx(
            Xe,
            {
              content: w ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(
                he,
                {
                  size: C,
                  color: w ? "green.500" : "red.500",
                  name: w ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ k.jsx(Xe, { content: "Copy Email", children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: C,
            name: o ? "done" : "copy",
            onClick: () => s(j),
            className: Hs.copyIcon
          }
        ) })
      ] }),
      _ && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(he, { size: C, name: "phone" }),
          /* @__PURE__ */ k.jsx(P.ExternalLink, { href: `tel:${_}`, children: _ })
        ] }),
        /* @__PURE__ */ k.jsx(Xe, { content: "Copy phone number", children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: C,
            name: l ? "done" : "copy",
            onClick: () => u(_),
            className: Hs.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ k.jsx(he, { size: C, name: "external-link" }),
        /* @__PURE__ */ k.jsx(
          P.ExternalLink,
          {
            href: L,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    I.length > 0 && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: I.map((F) => /* @__PURE__ */ k.jsx(Yn, { children: F }, `${d}-${F}`)) })
    ] })
  ] });
}, q9 = "_creationModal_pbe64_1", H9 = "_detailsModal_pbe64_5", W9 = "_percentageSuffix_pbe64_9", Fh = {
  creationModal: q9,
  detailsModal: H9,
  percentageSuffix: W9
}, K9 = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, G9 = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: rI.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, rw = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], iw = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], aw = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], Y9 = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = ir(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ k.jsxs(Qe, { children: [
      /* @__PURE__ */ k.jsx(Qe.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ k.jsx(Qe.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(
            he,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ k.jsx(Qe.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ k.jsx(Qe.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ k.jsx(Qe.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: Qn(e?.startsAt).format(It) })
      ] }) })
    ] }),
    /* @__PURE__ */ k.jsx(en, { label: "Discount code", children: /* @__PURE__ */ k.jsx(
      _r,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, Q9 = "shopify-discount-code-form", ow = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, J9 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = En(), { useMutation: i, showNotification: a } = _n(), [o, s] = de(
    []
  ), [l, u] = de(), m = ht({
    mode: "all",
    defaultValues: ow
  });
  Je(() => {
    o?.forEach((C) => {
      const F = C?.field?.[1];
      F && m.setError(F, {
        type: "server",
        message: C.message
      });
    });
  }, [o, m]);
  const d = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), v = Xn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      default:
        return "";
    }
  }, [f]), [
    I,
    {
      loading: w,
      error: j,
      reset: _
    }
  ] = i(I9, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (C) => {
      const F = C?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (F && F.length > 0)
        s(F);
      else {
        const z = C?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        z && "codes" in z && u(z), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), y = () => {
    m.setValue("code", K9(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, L = (C) => {
    I({
      variables: {
        input: G9(C)
      }
    });
  }, $ = () => {
    m.reset(ow), s([]), _(), u(void 0), n(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    $t,
    {
      isOpen: e,
      onClose: $,
      className: dt({
        [Fh.creationModal]: !d,
        [Fh.detailsModal]: d
      }),
      children: [
        /* @__PURE__ */ k.jsx(
          Tt,
          {
            title: d ? "Discount code details" : "Create new discount code",
            onClose: $
          }
        ),
        /* @__PURE__ */ k.jsxs(Dt, { children: [
          d && /* @__PURE__ */ k.jsx(Y9, { codeDiscount: l }),
          !d && /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: Q9, onSubmit: m.handleSubmit(L), children: [
            /* @__PURE__ */ k.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ k.jsx(
              ql,
              {
                variant: "info",
                description: /* @__PURE__ */ k.jsx(P.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ k.jsxs(mt, { children: [
              /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(
                Zn,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(ce, { span: 3, children: /* @__PURE__ */ k.jsx(
                Dr,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (C, F) => C === F,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (C) => {
                      const F = rw.find(
                        (z) => z.value === C
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: F?.label }) });
                    }
                  },
                  children: rw.map((C) => /* @__PURE__ */ k.jsx(kt.Item, { value: C.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(ce, { span: 3, children: /* @__PURE__ */ k.jsx(
                Zn,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (C) => {
                      if (C) {
                        if (h === "percentage" && (C < 0 || C > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && C < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ k.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: Fh.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(
                Zn,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: y
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(ce, { span: 3, children: /* @__PURE__ */ k.jsx(
                Dr,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (C, F) => C === F,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (C) => {
                      const F = iw.find(
                        (z) => z.value === C
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: F?.label }) });
                    }
                  },
                  children: iw.map((C) => /* @__PURE__ */ k.jsx(kt.Item, { value: C.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(ce, { span: 3, children: /* @__PURE__ */ k.jsx(
                Zn,
                {
                  name: "minimumRequirementValue",
                  label: v,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (C) => {
                      if (C && f !== "none" && C < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(
                Dr,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (C, F) => C === F,
                    getItemTitleByValue: (C) => {
                      const F = aw.find(
                        (z) => z.value === C
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: F?.label }) });
                    }
                  },
                  children: aw.map((C) => /* @__PURE__ */ k.jsx(kt.Item, { value: C.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) })
            ] })
          ] }),
          j && /* @__PURE__ */ k.jsx(Tn, { error: j })
        ] }),
        /* @__PURE__ */ k.jsx(
          Ht,
          {
            confirmProps: {
              disabled: !d && !(m.formState.isValid && m.formState.isDirty),
              isLoading: w,
              loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 })
            },
            confirmName: d ? "Close" : "Save",
            confirmOnClick: d ? $ : m.handleSubmit(L),
            cancelOnClick: d ? void 0 : $
          }
        )
      ]
    }
  );
}, X9 = ({ code: e }) => {
  const { isCopied: n, copy: r } = Wr();
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(he, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ k.jsx(
          mr,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, Z9 = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const r = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: n.title }),
    r && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ k.jsx(Qe, { children: i.map((a) => /* @__PURE__ */ k.jsx(Qe.Item, { className: Gt.listItem, children: /* @__PURE__ */ k.jsx(X9, { code: a.code }, a.id) }, a.id)) })
  ] });
}, e7 = "_modal_11d6e_1", n7 = "_modalBody_11d6e_4", t7 = "_codeContainer_11d6e_9", Ih = {
  modal: e7,
  modalBody: n7,
  codeContainer: t7
}, r7 = [50, 100, 250], oI = 50, i7 = {
  maxNumberOfCodesToDisplay: oI
}, a7 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: r } = _n(), [i, a] = de(
    oI
  ), [o, s] = de([]), l = o.length === 0, u = o.length > i, m = ht({
    mode: "all",
    defaultValues: i7
  }), { loading: d, error: f } = r(S9, {
    variables: {
      first: i
    },
    onCompleted: (v) => {
      const I = v?.Shopify?.codeDiscountNodes?.nodes ?? [];
      I && I.length > 0 && s(I);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ k.jsxs($t, { isOpen: e, onClose: h, className: Ih.modal, children: [
    /* @__PURE__ */ k.jsx(Tt, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ k.jsxs(Dt, { className: Ih.modalBody, children: [
      u && /* @__PURE__ */ k.jsx(mt, { children: /* @__PURE__ */ k.jsx(ce, { span: 3, children: /* @__PURE__ */ k.jsx(
        Dr,
        {
          control: m.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (v) => {
              a(v.selectedValues[0]);
            },
            getItemTitleByValue: (v) => /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: v }) })
          },
          children: r7.map((v) => /* @__PURE__ */ k.jsx(kt.Item, { value: v, children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: v }) }, v))
        }
      ) }) }),
      d && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(vn, {}) }),
      f && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(P.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !d && l && /* @__PURE__ */ k.jsx(
        yl,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !d && !f && !l && o.map((v) => /* @__PURE__ */ k.jsx("div", { className: Ih.codeContainer, children: /* @__PURE__ */ k.jsx(Z9, { discountCode: v }) }, v.id))
    ] }),
    /* @__PURE__ */ k.jsx(Ht, { confirmName: "Close", confirmOnClick: h })
  ] });
}, o7 = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = de(!1), [i, a] = de(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          nt,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          nt,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      a7,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ k.jsx(
      J9,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, s7 = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? Ww(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case ka.Invalid:
      case ka.NotSubscribed:
      case Mr.NotSubscribed:
        return "red.500";
      case ka.Pending:
      case Mr.Pending:
      case ka.Unsubscribed:
      case Mr.Unsubscribed:
        return "orange.500";
      case ka.Subscribed:
      case Mr.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case Ki.SingleOptIn:
      case Ki.ConfirmedOptIn:
        return "green.500";
      case Ki.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: u
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: d,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(he, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ k.jsx(Xe, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Bn, { size: "small", variant: "info", children: Qn(l).format(Ny) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Xe, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Yn, { color: o(u), children: i(u) }) }),
        /* @__PURE__ */ k.jsx(Xe, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Yn, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(he, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      d && /* @__PURE__ */ k.jsx(Xe, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Bn, { size: "small", variant: "info", children: Qn(d).format(Ny) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Xe, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Yn, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ k.jsx(Xe, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Yn, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, l7 = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: r.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a ?? "",
          kind: iI.Refund,
          orderId: r.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    refunds: r.refunds
  }));
}, sw = [
  {
    value: di.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: di.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: di.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: di.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: di.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: di.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: di.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], lw = [
  {
    value: ml.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: ml.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: ml.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], sI = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), ba = (e) => c7(u7(e)), c7 = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), u7 = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, Ri = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ k.jsx(
  zt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ k.jsx(
      ur,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), d7 = "_modal_1wlra_1", m7 = {
  modal: d7
};
function cw(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const uw = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], dw = "shopify-shiping-address-form", p7 = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: u
}) => {
  const { useMutation: m, showNotification: d } = _n(), { track: f } = En(), [h, v] = de(!1), [I, w] = de({}), j = !l, [
    _,
    { error: y, reset: L }
  ] = m(N9, {
    onError: () => {
      v(!1), d({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (G) => {
      v(!1);
      const B = G?.Shopify?.orderUpdate?.userErrors;
      if (B != null && B.length > 0) {
        const R = B.reduce(
          (U, ee) => {
            const Se = ee.field;
            if (Se == null || Se.length === 0)
              return U;
            const fe = Se[Se.length - 1];
            return fe != null && (U[fe] = ee.message), U;
          },
          {}
        );
        w(R);
      } else
        d({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), u(), te();
    }
  }), $ = ft(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: uw.find(
        (G) => G === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: C, handleSubmit: F, formState: z, reset: Q } = ht({
    mode: "all",
    defaultValues: $()
  }), J = F((G) => {
    if (j) {
      if (v(!0), !o || !a) {
        v(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: B, ...R } = G, U = {
        ...R,
        countryCode: B
      };
      _({
        variables: {
          input: {
            id: a,
            shippingAddress: U
          }
        }
      });
    } else
      l(G), te();
  });
  Je(() => {
    r && Q($());
  }, [r, n, Q, $]);
  const te = () => {
    Q($()), w({}), L(), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    $t,
    {
      isOpen: r,
      onClose: te,
      className: m7.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ k.jsx(Tt, { title: e, onClose: () => te() }),
        /* @__PURE__ */ k.jsx(Dt, { children: /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: dw, onSubmit: J, children: [
          y && /* @__PURE__ */ k.jsx(Tn, { error: y }),
          /* @__PURE__ */ k.jsxs(mt, { children: [
            /* @__PURE__ */ k.jsx(ce, { span: 3, children: /* @__PURE__ */ k.jsx(
              Ri,
              {
                required: !0,
                control: C,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: I
              }
            ) }),
            /* @__PURE__ */ k.jsx(ce, { span: 3, children: /* @__PURE__ */ k.jsx(
              Ri,
              {
                required: !0,
                control: C,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: I
              }
            ) }),
            /* @__PURE__ */ k.jsx(ce, { span: 6, children: /* @__PURE__ */ k.jsx(
              Ri,
              {
                control: C,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ k.jsx(ce, { span: 6, children: /* @__PURE__ */ k.jsx(
              Ri,
              {
                required: !0,
                control: C,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: I
              }
            ) }),
            /* @__PURE__ */ k.jsx(ce, { span: 6, children: /* @__PURE__ */ k.jsx(
              Ri,
              {
                control: C,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ k.jsx(ce, { span: 3, children: /* @__PURE__ */ k.jsx(
              Ri,
              {
                required: !0,
                control: C,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: I
              }
            ) }),
            /* @__PURE__ */ k.jsx(ce, { span: 3, children: /* @__PURE__ */ k.jsx(
              Ri,
              {
                required: !0,
                control: C,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: I
              }
            ) }),
            /* @__PURE__ */ k.jsx(ce, { span: 6, children: /* @__PURE__ */ k.jsx(
              Dr,
              {
                name: "countryCodeV2",
                control: C,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (G) => G ? cw(G) : ""
                },
                children: uw.filter((G) => s.includes(G)).map((G) => /* @__PURE__ */ k.jsx(kt.Item, { value: G, children: /* @__PURE__ */ k.jsx(P.Paragraph, { children: cw(G) }) }, G))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ k.jsx(
          Ht,
          {
            confirmProps: {
              disabled: !(z.isValid && z.isDirty),
              type: "submit",
              form: dw,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 })
            },
            confirmOnClick: () => {
              y && te();
            },
            cancelOnClick: () => {
              o && a && !y && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), te();
            },
            confirmName: y ? "Close" : "Save",
            cancelName: y ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, f7 = "_clickableIcon_33mqm_1", Eh = {
  clickableIcon: f7
}, mw = ({
  formFieldName: e,
  ...n
}) => {
  const r = ni(), { field: i } = eg({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ k.jsx(
    jy,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, jy = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: u,
  openByDefault: m = !1
}) => {
  const [d, f] = de(!1), [h, v] = de(m), { isCopied: I, copy: w } = Wr(), { track: j } = En(), _ = 14, y = o && (!!r || !!l), L = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), $ = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), C = n?.countryCodeV2 && YI(n.countryCodeV2), F = ft(() => [
    $,
    n?.company,
    n?.address1,
    n?.address2,
    L,
    n?.province,
    C
  ].filter(Boolean).join(`
`), [n, $, L, C]);
  if (!n)
    return null;
  const z = () => {
    i && r && j("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(he, { size: _, name: s, color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => v(!h),
              className: Eh.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ k.jsx(
                  he,
                  {
                    size: _,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
            $ && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: $ }),
            n?.company && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.address2 }),
            L && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: L }),
            n?.province && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.province }),
            C && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: C })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        y && /* @__PURE__ */ k.jsx(Xe, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: _,
            name: "pen",
            onClick: () => z(),
            className: Eh.clickableIcon
          }
        ) }),
        /* @__PURE__ */ k.jsx(Xe, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: _,
            name: I ? "done" : "copy",
            onClick: () => w(F()),
            className: Eh.clickableIcon
          }
        ) })
      ] })
    ] }),
    y && /* @__PURE__ */ k.jsx(
      p7,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: d,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: u
      }
    )
  ] });
}, sv = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = ni(), i = Ao({ control: r.control, name: "lineItems" }), a = Ao({
    control: r.control,
    name: "billingAddress"
  }), o = Ao({
    control: r.control,
    name: "shippingAddress"
  }), s = Xn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (m) => n.includes(m.id)
  ) : i, [i, n]), l = Xn(() => !s || s.length === 0 ? 0 : s.reduce((m, d) => {
    const f = d.priceRangeV2?.minVariantPrice?.amount || 0, h = d.quantity || 0;
    return m + f * h;
  }, 0), [s]), u = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ k.jsx(
        mw,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ k.jsx(
        mw,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${u}` })
    ] }),
    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, h7 = "_productTableHeader_6h6pl_1", y7 = "_productImage_6h6pl_5", Ho = {
  productTableHeader: h7,
  productImage: y7
}, lv = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, g7 = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = ni(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), u = lv(e);
  return /* @__PURE__ */ k.jsxs(st.Tr, { children: [
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
      u && /* @__PURE__ */ k.jsx(
        Pa,
        {
          src: u,
          alt: e.title,
          className: Ho.productImage
        }
      ),
      /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(
      Zn,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(mr, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, v7 = 300, Co = 2, k7 = 25, b7 = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = _n(), [i, a] = de(""), [o, s] = de([]), l = ni(), u = l.watch("selectedProductId"), [m, { loading: d, networkStatus: f }] = n(av, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (w) => {
      const j = w?.Shopify?.products?.nodes || [];
      s(
        j.filter((_) => !!_).sort((_, y) => _.title.localeCompare(y.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  Zi(
    () => {
      i.trim().length >= Co && !d && f === dr.ready ? m({
        variables: {
          query: i.trim(),
          productCount: k7,
          mediaCount: 1
        }
      }) : i.trim().length < Co && s([]);
    },
    v7,
    [i]
  ), Je(() => {
    if (!u) return;
    const w = o.find(
      (j) => j.id === u
    );
    w && e(w), l.setValue("selectedProductId", void 0);
  }, [u, o, l, e]);
  const h = d && f !== dr.ready, v = i.trim().length >= Co, I = !o.length && !h && v;
  return /* @__PURE__ */ k.jsx(
    Dr,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${Co} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (w) => {
          const j = o.find(
            (_) => _.id === w
          );
          return j ? /* @__PURE__ */ k.jsx(P.Paragraph, { children: j.title }) : null;
        },
        filter: {
          value: i,
          onChange: (w) => {
            a(w.target.value);
          }
        },
        onToggleDropdown: (w) => {
          !w && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        h && /* @__PURE__ */ k.jsx(kt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ k.jsx(vn, {}) }) }),
        !h && o.map((w) => {
          const j = w.totalInventory <= 0, _ = lv(w);
          return /* @__PURE__ */ k.jsx(
            kt.Item,
            {
              value: w.id,
              isDisabled: j,
              children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                  _ && /* @__PURE__ */ k.jsx(
                    Pa,
                    {
                      src: _,
                      alt: w.title,
                      className: Ho.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ k.jsx(
                    pE,
                    {
                      text: w.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: w.title })
                ] }),
                /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", children: j ? "Out of stock" : `${w.totalInventory} in stock` })
              ] })
            },
            w.id
          );
        }),
        I && /* @__PURE__ */ k.jsx(kt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          yl,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !v && !h && /* @__PURE__ */ k.jsx(kt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          yl,
          {
            title: "Search for products",
            description: `Type at least ${Co} characters to search.`
          }
        ) })
      ] })
    }
  );
}, cv = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: u
}) => {
  const m = ni(), d = m.watch("lineItems"), f = !!d?.length, h = n && f ? d.filter(
    (j) => !o.includes(j?.id)
  ) : [], v = h.length > 0 && h.every(
    (j) => a.includes(j?.id)
  ), I = h.some(
    (j) => a.includes(j?.id)
  ) && !v, w = ft(
    (j) => {
      const _ = m.getValues("lineItems"), y = _.findIndex(
        (L) => L?.id === j.id
      );
      if (y > -1) {
        const L = m.getValues(`lineItems.${y}.quantity`) || 0, $ = [..._];
        $[y] = {
          ...$[y],
          quantity: L + 1
        }, m.setValue("lineItems", $);
      } else
        m.setValue("lineItems", [
          ..._,
          { ...j, quantity: 1 }
        ]);
    },
    [m]
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ k.jsx(b7, { onProductSelected: w }),
    !f && e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Gt.boxWrapper,
        children: /* @__PURE__ */ k.jsx(vn, {})
      }
    ),
    !f && !e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Gt.boxWrapper,
        children: /* @__PURE__ */ k.jsx(
          yl,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ k.jsx(b, { margin: "300 0", children: /* @__PURE__ */ k.jsxs(
      st,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: Ho.productTable,
        children: [
          /* @__PURE__ */ k.jsx(st.Thead, { className: Ho.productTableHeader, children: /* @__PURE__ */ k.jsxs(st.Tr, { children: [
            n && /* @__PURE__ */ k.jsx(st.Th, { children: /* @__PURE__ */ k.jsx(
              Sv,
              {
                checked: v,
                indeterminate: I,
                onChange: () => u?.(!v)
              }
            ) }),
            /* @__PURE__ */ k.jsx(st.Th, { children: "Product" }),
            /* @__PURE__ */ k.jsx(st.Th, { children: "In stock" }),
            /* @__PURE__ */ k.jsx(st.Th, { children: "Price" }),
            /* @__PURE__ */ k.jsx(st.Th, { children: "Quantity" }),
            /* @__PURE__ */ k.jsx(st.Th, { children: "Total" }),
            !r && /* @__PURE__ */ k.jsx(st.Th, {})
          ] }) }),
          /* @__PURE__ */ k.jsx(st.Tbody, { children: d?.map((j, _) => {
            if (!n)
              return /* @__PURE__ */ k.jsx(
                g7,
                {
                  product: j,
                  index: _,
                  onRemove: () => {
                    const B = d.filter(
                      (R, U) => U !== _
                    );
                    m.setValue("lineItems", B);
                  }
                },
                `${j?.id}-${_}`
              );
            const y = j, L = y.priceRangeV2.minVariantPrice.amount, $ = y.priceRangeV2.minVariantPrice.currencyCode, C = `lineItems.${_}.quantity`, F = m.watch(C) || 0, z = L * F, Q = lv(y), J = a.includes(y.id), te = o.includes(y.id), G = s?.[y.id] ?? y.totalInventory;
            return /* @__PURE__ */ k.jsxs(
              st.Tr,
              {
                style: te ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(
                    Sv,
                    {
                      checked: J,
                      disabled: te,
                      onChange: () => l?.(y.id, !J)
                    }
                  ) }),
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                    Q && /* @__PURE__ */ k.jsx(
                      Pa,
                      {
                        src: Q,
                        alt: y.title,
                        className: Ho.productImage
                      }
                    ),
                    /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: y.title }),
                      te && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: y.totalInventory }) }),
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${L} ${$}` }) }),
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(
                    Zn,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: te || G <= 1,
                      name: C,
                      control: m.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: G,
                        tabIndex: 0
                      }
                    },
                    `${C}-${m.watch(C)}`
                  ) }),
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${z} ${$}` }) }),
                  !r && /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(
                    mr,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const B = d.filter(
                          (R, U) => U !== _
                        );
                        m.setValue("lineItems", B), J && l?.(y.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${y.id}-${_}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, lI = ({
  previousOrderStatus: e
} = {}) => {
  const n = ni();
  return /* @__PURE__ */ k.jsx(
    Dr,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = sw.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ k.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: sw.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ k.jsx(kt.Item, { value: r.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, cI = () => {
  const e = ni();
  return /* @__PURE__ */ k.jsx(
    Dr,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = lw.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: lw.map((n) => /* @__PURE__ */ k.jsx(kt.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, _7 = "_modal_1mprq_1", x7 = {
  modal: _7
}, $h = "create-shopify-order-form", S7 = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = _n(), { track: l } = En(), [u, m] = de(!1), [
    d,
    f
  ] = de(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, v = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: di.Pending,
    fulfillmentStatus: void 0
  }, [I, w] = de([]), j = ht({
    mode: "all",
    defaultValues: v
  }), _ = j.watch("lineItems").length > 0, y = () => {
    j.reset(v), w([]), i(!1);
  };
  Je(() => {
    I.length > 0 && j.setValue("tags", I, { shouldDirty: !0 });
  }, [I, j]);
  const [L, { error: $ }] = o(
    aI,
    {
      onError: () => {
        m(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), y();
      },
      onCompleted: () => {
        a(), m(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), y();
      }
    }
  ), [C, { error: F }] = o(
    E9,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), y();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), y();
      }
    }
  ), z = (J) => {
    const te = J.lineItems.map((R) => ({
      productId: R.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: R.priceRangeV2.maxVariantPrice.amount,
          currencyCode: R.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: R.quantity
    }));
    m(!0);
    const G = ba(J?.billingAddress), B = ba(
      J?.shippingAddress
    );
    L({
      variables: {
        order: {
          lineItems: te,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: J.customNote,
          tags: J.tags,
          financialStatus: J.financialStatus,
          fulfillmentStatus: J.fulfillmentStatus,
          shippingAddress: B,
          billingAddress: G
        }
      }
    });
  }, Q = (J) => {
    const te = J.lineItems.map((R) => ({
      title: R.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: R.priceRangeV2.maxVariantPrice.amount,
        currencyCode: R.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: R.quantity
    }));
    f(!0);
    const G = ba(J?.billingAddress), B = ba(
      J?.shippingAddress
    );
    C({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: J.customNote,
          tags: J.tags,
          lineItems: te,
          shippingAddress: B,
          billingAddress: G
        }
      }
    });
  };
  return /* @__PURE__ */ k.jsxs(
    $t,
    {
      isOpen: e,
      onClose: y,
      className: x7.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(Tt, { title: "Create new order", onClose: y }),
        /* @__PURE__ */ k.jsxs(Dt, { children: [
          /* @__PURE__ */ k.jsx(Zy, { ...j, children: /* @__PURE__ */ k.jsx("form", { id: $h, children: /* @__PURE__ */ k.jsxs(mt, { children: [
            /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(cv, {}) }),
            /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(
              zt,
              {
                name: "tags",
                render: ({ fieldState: { error: J } }) => /* @__PURE__ */ k.jsx(
                  en,
                  {
                    label: "Tags",
                    meta: {
                      error: J?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (te) => {
                          te.key === "Enter" && (te.preventDefault(), te.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Bl,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: I,
                            onChange: (te) => {
                              w(te);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(ce, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(lI, {}),
              /* @__PURE__ */ k.jsx(cI, {}),
              /* @__PURE__ */ k.jsx(
                Zn,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(ce, { span: 2, children: /* @__PURE__ */ k.jsx(en, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Gt.boxWrapper,
                children: /* @__PURE__ */ k.jsx(sv, {})
              }
            ) }) })
          ] }) }) }),
          ($ || F) && /* @__PURE__ */ k.jsx(Tn, { error: $ || F })
        ] }),
        /* @__PURE__ */ k.jsx(
          Ht,
          {
            confirmProps: {
              type: "submit",
              form: $h,
              disabled: !_ || u,
              isLoading: u,
              loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: j.handleSubmit(z),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                j.handleSubmit(Q)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: $h,
                disabled: !_ || d,
                isLoading: d,
                loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, N7 = "_modal_al73g_1", j7 = {
  modal: N7
}, pw = [
  {
    label: "Customer",
    value: Li.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: Li.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: Li.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: Li.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: Li.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: Li.Staff,
    description: "Staff made an error."
  }
], w7 = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = En(), { useMutation: u, showNotification: m } = _n(), [d, f] = de([]), h = d.length > 0, v = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, I = ht({
    defaultValues: v
  }), [w, { error: j, reset: _ }] = u(w9, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async ($) => {
      const C = $.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (C.length > 0)
        o(!1), f(C), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const F = $.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, F ? 0 : 4e3), m({
          title: "Success",
          text: `${F ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), y = ft(
    ($) => {
      $.reason != null && (o(!0), w({
        variables: {
          orderId: $.orderId,
          reason: $.reason,
          refundMethod: $.refundMethod,
          restock: $.restock,
          notifyCustomer: $.notifyCustomer,
          staffNote: $.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), L = () => {
    i(!1), _(), f([]), I.reset(v);
  };
  return /* @__PURE__ */ k.jsxs($t, { isOpen: n, onClose: L, className: j7.modal, children: [
    /* @__PURE__ */ k.jsx(Tt, { title: `Cancel order ${r}`, onClose: L }),
    /* @__PURE__ */ k.jsx(Dt, { children: /* @__PURE__ */ k.jsxs(mt, { children: [
      /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(
        Dr,
        {
          control: I.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: ($, C) => $ === C,
            getItemTitleByValue: ($) => {
              if (!$)
                return "";
              const C = pw.find(
                (F) => F.value === $
              );
              return /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: C.label }),
                /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: C.description })
              ] });
            }
          },
          children: pw.map(($) => /* @__PURE__ */ k.jsx(kt.Item, { value: $.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: $.label }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: $.description })
          ] }) }, $.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(en, { label: "Refund order", children: /* @__PURE__ */ k.jsx(
        Dn,
        {
          control: I.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(en, { label: "Restock items", children: /* @__PURE__ */ k.jsx(Dn, { control: I.control, name: "restock" }) }) }),
      /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(en, { label: "Notify the customer", children: /* @__PURE__ */ k.jsx(Dn, { control: I.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(
        Zn,
        {
          name: "staffNote",
          label: "Staff note",
          control: I.control
        }
      ) }),
      h && /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: d.map(($) => /* @__PURE__ */ k.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ k.jsx(he, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: $.code }),
            /* @__PURE__ */ k.jsxs(P.Paragraph, { children: [
              "(",
              $.field?.join(","),
              ") ",
              $.message
            ] })
          ]
        },
        $.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Ht,
      {
        confirmProps: {
          disabled: !(I.formState.isValid && I.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 })
        },
        confirmOnClick: I.handleSubmit(y),
        cancelOnClick: L,
        confirmName: j ? "Close" : "Cancel order",
        cancelName: j ? void 0 : "Cancel"
      }
    )
  ] });
}, C7 = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = de(!1), [s, l] = de(!1);
  return /* @__PURE__ */ k.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ k.jsx(
      nt,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ k.jsx(
          he,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Gt.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ k.jsx(
      w7,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, F7 = "_modal_1mprq_1", I7 = {
  modal: F7
}, E7 = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: u } = _n(), { track: m } = En(), [d, f] = de(!1), [h, v] = de(e?.tags || []), I = "duplicate-shopify-order-form", w = (B) => ({
    firstName: B?.firstName,
    lastName: B?.lastName,
    company: B?.company,
    address1: B?.address1,
    address2: B?.address2,
    city: B?.city,
    provinceCode: B?.provinceCode,
    zip: B?.zip,
    countryCode: B?.countryCodeV2,
    phone: B?.phone
  }), j = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: w(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: w(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0
  }, _ = ht({
    mode: "all",
    defaultValues: j
  }), y = _.watch("lineItems").length > 0, L = Xn(
    () => (e?.lineItems || []).map((B) => B.product?.id).filter((B) => !!B),
    [e]
  ), $ = Xn(
    () => sI(L),
    [L]
  ), {
    data: C,
    loading: F,
    error: z
  } = u(av, {
    skip: !$,
    variables: {
      query: $,
      productCount: L.length,
      mediaCount: 1
    }
  });
  Je(() => {
    z && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [z, l]), Je(() => {
    if (!r || F || !C || _.getValues("lineItems")?.length)
      return;
    const B = C?.Shopify?.products?.nodes || [], R = [];
    e?.lineItems?.forEach((U) => {
      const ee = B.find(
        (Se) => Se.id === U.product?.id
      );
      ee && R.push({
        ...ee,
        quantity: U.quantity || 1,
        sku: U.sku,
        discountedUnitPrice: U.discountedUnitPriceSet?.shopMoney
      });
    }), R.length > 0 && _.setValue("lineItems", R, { shouldDirty: !0 });
  }, [r, C, F, e, _]), Je(() => {
    (h.length > 0 || (_.getValues("tags") || []).length > 0) && _.setValue("tags", h, { shouldDirty: !0 });
  }, [h, _]);
  const [Q, { error: J }] = s(
    aI,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), m("shopify:order:duplicate:failed"), G();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), m("shopify:order:duplicate:succeeded"), G();
      }
    }
  ), te = (B) => {
    const R = B.lineItems.map((ee) => ({
      productId: ee.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: ee.discountedUnitPrice?.amount ?? ee.priceRangeV2.maxVariantPrice.amount,
          currencyCode: ee.discountedUnitPrice?.currencyCode ?? ee.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: ee.quantity,
      sku: ee.sku
    })), U = (e?.shippingLines ?? []).map(
      (ee) => ({
        title: ee.title,
        code: ee.code,
        source: ee.source,
        priceSet: {
          shopMoney: {
            amount: ee.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: ee.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0), Q({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: R,
          shippingLines: U,
          note: B.customNote,
          tags: B.tags,
          financialStatus: B.financialStatus,
          fulfillmentStatus: B.fulfillmentStatus,
          shippingAddress: ba(B?.shippingAddress),
          billingAddress: ba(B?.billingAddress)
        }
      }
    });
  }, G = () => {
    _.reset(j), v(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    $t,
    {
      isOpen: r,
      onClose: G,
      className: I7.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(Tt, { title: `Duplicate order ${n}`, onClose: G }),
        /* @__PURE__ */ k.jsxs(Dt, { children: [
          /* @__PURE__ */ k.jsx(Zy, { ..._, children: /* @__PURE__ */ k.jsx("form", { id: I, children: /* @__PURE__ */ k.jsxs(mt, { children: [
            /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(cv, { loading: F }) }),
            /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(
              zt,
              {
                name: "tags",
                render: ({ fieldState: { error: B } }) => /* @__PURE__ */ k.jsx(
                  en,
                  {
                    label: "Tags",
                    meta: {
                      error: B?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (R) => {
                          R.key === "Enter" && (R.preventDefault(), R.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Bl,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (R) => {
                              v(R);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(ce, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(
                lI,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ k.jsx(cI, {}),
              /* @__PURE__ */ k.jsx(
                Zn,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(ce, { span: 2, children: /* @__PURE__ */ k.jsx(en, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Gt.boxWrapper,
                children: /* @__PURE__ */ k.jsx(sv, {})
              }
            ) }) })
          ] }) }) }),
          J && /* @__PURE__ */ k.jsx(Tn, { error: J })
        ] }),
        /* @__PURE__ */ k.jsx(
          Ht,
          {
            confirmProps: {
              type: "submit",
              form: I,
              disabled: !y || d || F,
              isLoading: d || F,
              loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: _.handleSubmit(te)
          }
        )
      ]
    }
  );
}, $7 = "_copyIcon_1dlzg_1", T7 = {
  copyIcon: $7
}, D7 = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  const { isCopied: i, copy: a } = Wr();
  if (!n || n?.length === 0)
    return null;
  const o = Object.values(r).some(
    (l) => l > 0
  ), s = n.map(
    ({ title: l, quantity: u, variantTitle: m }) => m ? `${u}x ${l} (${m})` : `${u}x ${l}`
  ).join(`
`);
  return /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(
      b,
      {
        gap: "250",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(he, { size: 14, name: "shopify", color: "green.500" }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Line items" })
          ] }),
          /* @__PURE__ */ k.jsx(Xe, { content: "Copy line items", children: /* @__PURE__ */ k.jsx(
            he,
            {
              size: 14,
              name: i ? "done" : "copy",
              onClick: () => a(s),
              className: T7.copyIcon
            }
          ) })
        ]
      }
    ),
    o && /* @__PURE__ */ k.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ k.jsx(Yn, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ k.jsx(Qe, { children: n.map(({ id: l, title: u, quantity: m, variantTitle: d, image: f }) => {
      const h = r[l], v = h > 0, I = h > 1 ? `Refunded (${h} items)` : "Refunded";
      return /* @__PURE__ */ k.jsx(
        Qe.Item,
        {
          contentLeft: /* @__PURE__ */ k.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ k.jsx(P.Paragraph, { children: m }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "4", children: [
            u,
            " ",
            d && `(${d})`,
            v && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", color: "red.500", children: I })
          ] }),
          contentRight: f?.url && /* @__PURE__ */ k.jsx(Pa, { src: `${f?.url}&height=48`, alt: u })
        },
        `list-${e}-${l}`
      );
    }) })
  ] });
}, O7 = Hl`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, R7 = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, uI = (e) => {
  const n = {}, r = R7(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, P7 = "_modal_21e62_1", A7 = {
  modal: P7
}, fw = "partial-refund-shopify-order-form", L7 = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = _n(), { track: l } = En(), { useQuery: u } = _n(), [m, d] = de(!1), [f, h] = de([]), v = Xn(
    () => e?.refunds ? uI(e) : {},
    [e]
  ), I = Xn(
    () => (e?.lineItems || []).filter((B) => (v[B.id] || 0) >= (B.quantity || 0)).map((B) => B.product?.id).filter((B) => !!B),
    [e, v]
  ), w = Xn(() => {
    const B = {};
    return (e?.lineItems || []).forEach((R) => {
      if (R.product?.id) {
        const U = v[R.id] || 0, ee = Math.max(
          0,
          (R.quantity || 0) - U
        );
        B[R.product.id] = ee;
      }
    }), B;
  }, [e, v]), j = Xn(
    () => (e?.lineItems || []).map((B) => B.product?.id).filter((B) => !!B),
    [e]
  ), _ = Xn(
    () => sI(j),
    [j]
  ), {
    data: y,
    loading: L,
    error: $
  } = u(av, {
    skip: !_,
    variables: {
      query: _,
      productCount: j.length,
      mediaCount: 1
    }
  });
  Je(() => {
    $ && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [$, s]);
  const C = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, F = ht({
    mode: "all",
    defaultValues: C
  }), z = f.length > 0, [Q, { error: J }] = o(
    O7,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), G();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), G();
      }
    }
  );
  Je(() => {
    if (!r || L || !y || F.getValues("lineItems")?.length)
      return;
    const B = y?.Shopify?.products?.nodes || [], R = [];
    e?.lineItems?.forEach((U) => {
      const ee = B.find(
        (Se) => Se.id === U.product?.id
      );
      if (ee) {
        const Se = v[U.id] || 0, fe = (U.quantity || 1) - Se;
        R.push({
          ...ee,
          quantity: fe > 0 ? fe : U.quantity || 1
        });
      }
    }), R.length > 0 && (F.setValue("lineItems", R, { shouldDirty: !0 }), h([]));
  }, [
    r,
    y,
    L,
    e,
    F,
    v
  ]);
  const te = (B) => {
    d(!0);
    const R = (B.lineItems || []).filter(
      (U) => f.includes(U.id)
    ).map((U) => {
      const ee = e?.lineItems?.find(
        (ve) => ve.product?.id === U.id
      ), Se = v[ee?.id || ""] || 0, fe = (ee?.quantity || 0) - Se, ye = Math.max(
        0,
        Math.min(fe, U.quantity || 0)
      );
      return ee && ye > 0 ? { lineItemId: ee.id, quantity: ye } : void 0;
    }).filter((U) => !!U);
    Q({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: R,
          note: B.customNote || void 0,
          notify: !0
        }
      }
    });
  }, G = () => {
    F.reset(C), d(!1), i(!1);
  };
  return /* @__PURE__ */ k.jsxs($t, { isOpen: r, onClose: G, className: A7.modal, children: [
    /* @__PURE__ */ k.jsx(Tt, { title: `Refund order ${n}`, onClose: G }),
    /* @__PURE__ */ k.jsxs(Dt, { children: [
      /* @__PURE__ */ k.jsx(Zy, { ...F, children: /* @__PURE__ */ k.jsx("form", { id: fw, children: /* @__PURE__ */ k.jsxs(mt, { children: [
        /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(
          cv,
          {
            loading: L,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: I,
            maxQuantities: w,
            onToggleSelect: (B, R) => {
              h((U) => R ? Array.from(/* @__PURE__ */ new Set([...U, B])) : U.filter((ee) => ee !== B));
            },
            onToggleSelectAll: (B) => {
              const R = (F.getValues("lineItems") || []).map((U) => U.id).filter((U) => !I.includes(U));
              h(B ? R : []);
            }
          }
        ) }),
        /* @__PURE__ */ k.jsx(ce, { span: 4, children: /* @__PURE__ */ k.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ k.jsx(
          Zn,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ k.jsx(ce, { span: 2, children: /* @__PURE__ */ k.jsx(en, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Gt.boxWrapper,
            children: /* @__PURE__ */ k.jsx(
              sv,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      J && /* @__PURE__ */ k.jsx(Tn, { error: J })
    ] }),
    /* @__PURE__ */ k.jsx(
      Ht,
      {
        confirmProps: {
          type: "submit",
          form: fw,
          disabled: !z || m || L,
          isLoading: m || L,
          loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: F.handleSubmit(te)
      }
    )
  ] });
}, V7 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = _n(), { track: l } = En(), { suggestedRefund: u, currencyCode: m, id: d, name: f } = e, h = parseFloat(String(u?.amount)), v = !isNaN(h) && h > 0, [I] = a(j9, {
    onError: (_) => {
      setTimeout(() => j(_), 500);
    },
    onCompleted: (_) => {
      const y = _.Shopify?.refundCreate?.userErrors;
      y && y.length > 0 ? j(
        new n1({
          graphQLErrors: y.map((L) => ({
            message: L.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), w = ft(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: d });
    const { amount: _, ...y } = u;
    s(v ? {
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ k.jsxs(P.Paragraph, { children: [
        "You are about to refund ",
        _,
        " ",
        m,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: d }), I({
          variables: {
            input: y
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: d })
    } : {
      headline: `Refund Order ${f}`,
      children: /* @__PURE__ */ k.jsx(P.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [
    n,
    d,
    f,
    m,
    u,
    v,
    s,
    I,
    l
  ]), j = ft(
    (_) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(Tn, { error: _ }),
          /* @__PURE__ */ k.jsx(
            Bt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(r, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(he, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [r]
  );
  return /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
    nt,
    {
      variant: "secondary",
      onClick: w,
      disabled: u?.refundLineItems?.length === 0 || !v,
      slotStart: /* @__PURE__ */ k.jsx(he, { size: 14, name: "undo" }),
      className: Gt.fullWidth,
      children: "Full refund"
    }
  ) });
}, z7 = "_modal_al73g_1", U7 = {
  modal: z7
}, M7 = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = En(), { useMutation: s, showNotification: l } = _n(), [u, m] = de(n), [d, f] = de(!1), h = ht({
    defaultValues: {
      tags: n
    }
  });
  Je(() => {
    u && h.setValue("tags", u, { shouldDirty: !0 });
  }, [u]);
  const [v, { error: I, reset: w }] = s(C9, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), j = ft(
    (y) => {
      f(!0), v({
        variables: {
          input: {
            id: e,
            tags: y.tags
          }
        }
      }).then((L) => {
        const $ = L.data?.Shopify?.orderUpdate?.order?.tags ?? y.tags;
        h.reset({ tags: $ });
      });
    },
    [e, h, v]
  ), _ = () => {
    i(!1), w();
  };
  return /* @__PURE__ */ k.jsxs($t, { isOpen: r, onClose: _, className: U7.modal, children: [
    /* @__PURE__ */ k.jsx(Tt, { title: "Manage tags for order", onClose: _ }),
    /* @__PURE__ */ k.jsxs(Dt, { children: [
      /* @__PURE__ */ k.jsx(mt, { children: /* @__PURE__ */ k.jsx(ce, { children: /* @__PURE__ */ k.jsx(
        zt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: y } }) => /* @__PURE__ */ k.jsx(
            en,
            {
              label: "Tags",
              meta: {
                error: y?.message
              },
              children: /* @__PURE__ */ k.jsx(
                Bl,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (L) => m(L)
                }
              )
            }
          )
        }
      ) }) }),
      I && /* @__PURE__ */ k.jsx(Tn, { error: I })
    ] }),
    /* @__PURE__ */ k.jsx(
      Ht,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: d,
          loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(j),
        cancelOnClick: _,
        confirmName: I ? "Close" : "Save",
        cancelName: I ? void 0 : "Cancel"
      }
    )
  ] });
}, B7 = "_editIcon_1yp2k_1", q7 = "_copyIcon_1yp2k_2", hw = {
  editIcon: B7,
  copyIcon: q7
}, H7 = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = de(!1), { isCopied: o, copy: s } = Wr(), l = 14, u = n.length > 0;
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(he, { size: l, name: "tag", color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !u && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            u && n.map((m, d) => /* @__PURE__ */ k.jsx(Bn, { size: "small", variant: "primary", children: m }, d))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Xe, { content: "Edit tags", children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: l,
            name: "pen",
            className: hw.editIcon,
            onClick: () => a(!0)
          }
        ) }),
        u && /* @__PURE__ */ k.jsx(Xe, { content: "Copy tags", children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: l,
            name: o ? "done" : "copy",
            className: hw.copyIcon,
            onClick: () => s(n.join(", "))
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      M7,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, W7 = "_icon_cddi1_1", K7 = "_link_cddi1_6", yw = {
  icon: W7,
  link: K7
}, G7 = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = Wr(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ k.jsx(
    Qe.Item,
    {
      contentLeft: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ k.jsx(
        P.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: yw.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ k.jsx(Xe, { content: "Copy tracking code", children: /* @__PURE__ */ k.jsx(
        he,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: yw.icon
        }
      ) })
    }
  );
}, Y7 = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ k.jsx(he, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ k.jsx(Qe, { children: e.map((n) => /* @__PURE__ */ k.jsx(G7, { trackingInfo: n }, n.number)) })
] }), Q7 = "_copyIcon_yc0fe_1", J7 = "_order_yc0fe_6", X7 = "_orderIsOpen_yc0fe_14", Z7 = "_orderHeader_yc0fe_17", ha = {
  copyIcon: Q7,
  order: J7,
  orderIsOpen: X7,
  orderHeader: Z7
}, eK = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: u,
  displayPartialRefundOrder: m,
  refetchOrders: d
}) => {
  const { track: f } = En(), { isCopied: h, copy: v } = Wr(), { isCopied: I, copy: w } = Wr(), { isCopied: j, copy: _ } = Wr(), [y, L] = de(!1), [$, C] = de(!1), [F, z] = de(r), {
    id: Q,
    name: J,
    createdAt: te,
    status: G,
    currentTotalPriceSet: B,
    currencyCode: R,
    lineItems: U,
    billingAddress: ee,
    shippingAddress: Se,
    trackingInfos: fe,
    tags: ye
  } = e, ve = !!Se, K = ov(Q), _e = `https://${l}/admin/orders/${K ?? ""}`, Te = B?.shopMoney?.amount ?? 0, X = G.includes("cancelled"), Ke = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: R
  }).format(Te), an = e?.refunds ? uI(e) : {}, we = !!U?.length && U.every((Me) => (an[Me.id] || 0) >= (Me.quantity || 0));
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      className: dt(ha.order, {
        [ha.orderIsOpen]: F
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ k.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ha.orderHeader,
            onClick: () => z(!F),
            children: [
              /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
                te && /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: Qn(te).format(Ny) }) }),
                /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "1", children: [
                  "Order ",
                  J
                ] })
              ] }),
              /* @__PURE__ */ k.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: F ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        F && /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(he, { size: 14, name: "info", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Order number" }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: J.replace("#", "") })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(Xe, { content: "Copy order number", children: /* @__PURE__ */ k.jsx(
                  he,
                  {
                    size: 14,
                    name: h ? "done" : "copy",
                    onClick: () => v(J.replace("#", "")),
                    className: ha.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(he, { size: 14, name: "activity", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Order status" }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: G })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(Xe, { content: "Copy order status", children: /* @__PURE__ */ k.jsx(
                  he,
                  {
                    size: 14,
                    name: j ? "done" : "copy",
                    onClick: () => _(G),
                    className: ha.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(he, { size: 14, name: "chart-bar", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Order value" }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: Ke })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(Xe, { content: "Copy order value", children: /* @__PURE__ */ k.jsx(
                  he,
                  {
                    size: 14,
                    name: I ? "done" : "copy",
                    onClick: () => w(Te),
                    className: ha.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsx(
            H7,
            {
              orderId: Q,
              tags: ye,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ k.jsx(
            jy,
            {
              openByDefault: !ve,
              labelText: "Billing address",
              address: ee,
              shippingCountryCodes: i,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ k.jsx(
            jy,
            {
              openByDefault: ve,
              shopifyId: n,
              orderId: Q,
              icon: "map-pin",
              labelText: "Shipping address",
              address: Se,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ k.jsx(
            D7,
            {
              orderId: Q,
              lineItems: U,
              refundedQuantities: an
            }
          ),
          /* @__PURE__ */ k.jsx(Y7, { trackingInfos: fe }),
          (o || m) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ k.jsx(
              V7,
              {
                order: e,
                shopifyId: n,
                refetchOrders: d,
                orderLink: _e
              }
            ),
            m && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              nt,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => C(!0),
                className: Gt.fullWidth,
                disabled: X || we,
                children: "Partial refund"
              }
            ) })
          ] }),
          (u || s) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            u && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              nt,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => L(!0),
                className: Gt.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ k.jsx(
              C7,
              {
                orderId: Q,
                orderName: J,
                disabled: X,
                refetchOrders: d
              }
            )
          ] }),
          /* @__PURE__ */ k.jsx(
            Bt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(_e, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(he, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: Q
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        y && /* @__PURE__ */ k.jsx(
          E7,
          {
            order: e,
            shopifyId: n,
            orderName: J,
            isOpen: y,
            setIsOpen: L,
            refetchOrders: d
          }
        ),
        $ && /* @__PURE__ */ k.jsx(
          L7,
          {
            order: e,
            orderName: J,
            isOpen: $,
            setIsOpen: C,
            refetchOrders: () => {
              d();
            }
          }
        )
      ]
    }
  );
}, nK = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: u,
  shopifyCustomer: m
}) => {
  const { track: d } = En(), [f, h] = de([]), [v, I] = de(!1), w = ov(m?.id), j = `https://${n}/admin/orders?customer_id=${w ?? ""}`, {
    getCustomerOrders: _,
    isCustomerOrdersLoading: y,
    customerOrdersError: L,
    customerOrders: $,
    refetchCustomerOrders: C
  } = T9();
  return Je(() => {
    !y && w && _({
      variables: {
        query: `customer_id:${w}`
      }
    });
  }, [w]), Je(() => {
    const F = $?.Shopify?.orders?.edges;
    F && h(l7({ ordersData: F }));
  }, [$]), m ? L ? /* @__PURE__ */ k.jsx(Tn, { error: L }) : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Customer orders" }),
      !y && /* @__PURE__ */ k.jsx(Bn, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ k.jsx(
      nt,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => I(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      y && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(vn, {}) }),
      !y && f.length === 0 && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ k.jsx(P.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !y && f.length > 0 && /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: f.map((F, z) => /* @__PURE__ */ k.jsx(
        eK,
        {
          order: F,
          openByDefault: z === 0,
          shopifyId: m?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: u,
          customerCountryCodes: e,
          refetchOrders: C,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${z}-${F.id}`
      )) }),
      /* @__PURE__ */ k.jsx(
        Bt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(j, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ k.jsx(he, { name: "external-link" }),
          onClick: () => d("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ k.jsx(
      S7,
      {
        isOpen: v,
        setIsOpen: I,
        shopifyCustomer: m,
        refetchCustomerOrders: C,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, tK = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ k.jsx(k.Fragment, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ k.jsxs(Qe, { className: Gt.list, children: [
      /* @__PURE__ */ k.jsx(Qe.Text, { variant: "dense", className: Gt.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ k.jsx(Qe.Text, { variant: "dense", className: Gt.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, rK = "_segmentName_1dkhk_1", iK = {
  segmentName: rK
}, aK = 100, Ws = 10, oK = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = _n(), [i, a] = de([]), [o, s] = de(Ws), [l, u] = de(!1), m = Xn(
    () => i.filter((w) => w.isMember).length,
    [i]
  ), { loading: d, error: f } = n(
    _9,
    {
      skip: !e,
      variables: {
        first: aK
      },
      onCompleted: (w) => {
        const j = w?.Shopify?.segments?.edges;
        if (j && j.length > 0) {
          const _ = j.map(({ node: y }) => ({
            ...y,
            isMember: !1
          })).sort((y, L) => y.name.localeCompare(L.name));
          a(_), h({
            variables: {
              customerId: e,
              segmentIds: _.map((y) => y.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: v, error: I }
  ] = r(x9, {
    onCompleted: (w) => {
      const j = w?.Shopify?.customerSegmentMembership?.memberships;
      if (j && j.length > 0) {
        const _ = i.map((y) => {
          const L = j.find(
            ($) => $.segmentId === y.id
          );
          return {
            ...y,
            ...L?.isMember && { isMember: L.isMember }
          };
        }).sort(
          (y, L) => y.isMember === L.isMember ? 0 : y.isMember ? -1 : 1
        );
        a(_);
      }
    }
  });
  return Je(() => {
    s(l ? i.length : Ws);
  }, [l]), e ? /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Segment membership" }),
      !d && /* @__PURE__ */ k.jsx(Bn, { variant: "success", size: "small", children: m })
    ] }),
    d && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(vn, {}) }),
    !d && i.length === 0 && /* @__PURE__ */ k.jsx(P.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ k.jsx(Tn, { error: f }),
    I && /* @__PURE__ */ k.jsx(Tn, { error: I }),
    !d && i.length > 0 && /* @__PURE__ */ k.jsxs(Qe, { className: Gt.list, children: [
      i.slice(0, o).map(({ id: w, name: j, isMember: _ }) => /* @__PURE__ */ k.jsx(Qe.Text, { className: Gt.listItem, children: /* @__PURE__ */ k.jsx(
        Xe,
        {
          content: `${_ ? "Member of" : "Not a member of"} ${j}`,
          children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", className: iK.segmentName, children: j }),
            v && /* @__PURE__ */ k.jsx(vn, { size: 12 }),
            !v && /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(
              he,
              {
                color: _ ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, w)),
      i.length > Ws && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ k.jsx(
        nt,
        {
          variant: "secondary",
          onClick: () => u(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - Ws} more`
        }
      ) })
    ] })
  ] }) : null;
}, sK = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = de(!1);
  Je(() => {
    i(!1);
  }, [
    e.customer?.phone_number,
    e.customer?.email
  ]);
  const {
    isCustomerLoading: a,
    customerError: o,
    customerData: s,
    refetchCustomer: l,
    customerNetworkStatus: u
  } = $9({ conversationContext: e, forcePhoneLookup: r }), [m, d] = de(), [f, h] = de(
    []
  ), v = n.apiHostName, I = n.displayRefundOrder ?? !1, w = n.displayCancelOrder ?? !1, j = n.enableEditShippingAddress ?? !1, _ = n.displayEmailMarketingConsent ?? !1, y = n.displayOrdersOverview ?? !1, L = n.displaySegmentMembership ?? !1, $ = n.displayDiscountCodeCreation ?? !1, C = n.displayDiscountCodes ?? !1, F = n.displayCreateOrder ?? !1, z = n.displayDuplicateOrder ?? !1, Q = n.displayCreateDraftOrder ?? !1, J = n.displayPartialRefundOrder ?? !1;
  if (Je(() => {
    const te = s?.Shopify?.customers?.edges[0]?.node, G = !!e.customer?.phone_number && !!e.customer?.email;
    te && !a ? (h(
      s?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), d(te)) : !te && !a && G && !r ? i(!0) : d(void 0);
  }, [s, e]), !a && o)
    return /* @__PURE__ */ k.jsx(Tn, { error: o, retry: l });
  if (!a && !o && !m) {
    const te = `https://${v}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ k.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ k.jsx(
              z9,
              {
                refetchCustomer: l,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ k.jsx(
              Bt,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(te, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ k.jsx(he, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return a && u !== dr.refetch ? /* @__PURE__ */ k.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ k.jsx(vn, {}) }) : /* @__PURE__ */ k.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ k.jsx(
          B9,
          {
            customer: m,
            shopifyDomain: v,
            refresh: l,
            loading: a,
            networkStatus: u
          }
        ),
        y && /* @__PURE__ */ k.jsx(
          tK,
          {
            totalOrders: m?.numberOfOrders,
            amountSpent: m?.amountSpent
          }
        ),
        L && /* @__PURE__ */ k.jsx(oK, { shopifyId: m?.id }),
        _ && /* @__PURE__ */ k.jsx(s7, { customer: m }),
        C && /* @__PURE__ */ k.jsx(
          o7,
          {
            displayDiscountCodeCreation: $
          }
        ),
        /* @__PURE__ */ k.jsx(
          nK,
          {
            shopifyCustomer: m,
            shopifyDomain: v,
            displayRefund: I,
            displayCancel: w,
            displayCreateOrder: F,
            displayCreateDraftOrder: Q,
            enableEditShippingAddress: j,
            customerCountryCodes: f,
            displayDuplicateOrder: z,
            displayPartialRefundOrder: J
          }
        )
      ]
    }
  );
}, Pt = [];
for (let e = 0; e < 256; ++e)
  Pt.push((e + 256).toString(16).slice(1));
function lK(e, n = 0) {
  return (Pt[e[n + 0]] + Pt[e[n + 1]] + Pt[e[n + 2]] + Pt[e[n + 3]] + "-" + Pt[e[n + 4]] + Pt[e[n + 5]] + "-" + Pt[e[n + 6]] + Pt[e[n + 7]] + "-" + Pt[e[n + 8]] + Pt[e[n + 9]] + "-" + Pt[e[n + 10]] + Pt[e[n + 11]] + Pt[e[n + 12]] + Pt[e[n + 13]] + Pt[e[n + 14]] + Pt[e[n + 15]]).toLowerCase();
}
const cK = new Uint8Array(16);
function uK() {
  return crypto.getRandomValues(cK);
}
function dK(e, n, r) {
  return crypto.randomUUID ? crypto.randomUUID() : mK(e);
}
function mK(e, n, r) {
  e = e || {};
  const i = e.random ?? e.rng?.() ?? uK();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, lK(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._pointer_pn2q5_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_pn2q5_59{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_pn2q5_69{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_pn2q5_69:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_4z55u_54{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_4z55u_54:hover,._messageIsOpen_4z55u_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_4z55u_66{cursor:pointer}._messageText_4z55u_70{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_4z55u_70::-webkit-scrollbar{width:7px;height:7px}._messageText_4z55u_70::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_4z55u_70::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_4z55u_70::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._buttonLink_4z55u_93{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Th = { exports: {} }, Fo = {}, gw;
function pK() {
  if (gw) return Fo;
  gw = 1;
  var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Fo.Fragment = r, Fo.jsx = s, Fo.jsxs = s, Fo;
}
var Ks = {}, vw;
function fK() {
  return vw || (vw = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var g = _.ReactDebugCurrentFrame, E = g.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var $ = !1, C = !1, F = !1, z = !1, Q = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === d || z || t === v || $ || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, N = E._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (E) {
            var g = E.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (ie) {
              g = ie;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var S = ie.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var ue = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = E;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ae(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ae(t.type, c, p);
          case h: {
            var g = t, E = g._payload, O = g._init;
            try {
              return ae(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, p, g, E) {
      {
        var O = Function.call.bind(le);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + p + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe(E), y("Failed %s type: %s", p, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, p, g, E, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, p, g, E) {
      {
        var O, N = {}, S = null, ne = null;
        p !== void 0 && (A(p), S = "" + p), gn(c) && (A(c.key), S = "" + c.key), rn(c) && (ne = c.ref, tn(c));
        for (O in c)
          le.call(c, O) && !oe.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, E, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function An(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = j(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          yn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var E = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, p, g, E, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, p, E, O);
        if (W == null)
          return W;
        if (N) {
          var ue = c.children;
          if (ue !== void 0)
            if (g)
              if (x(ue)) {
                for (var Ue = 0; Ue < ue.length; Ue++)
                  Sn(ue[Ue], t);
                Object.freeze && Object.freeze(ue);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ue, t);
        }
        if (le.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var Rn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, Rn, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, p) {
      return Fn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return Fn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Ks.Fragment = i, Ks.jsx = Un, Ks.jsxs = Kn;
  })()), Ks;
}
var kw;
function hK() {
  return kw || (kw = 1, process.env.NODE_ENV === "production" ? Th.exports = pK() : Th.exports = fK()), Th.exports;
}
var V = hK(), dI = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(dI || {}), wy = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(wy || {});
const yK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, gK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, vK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, kK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, bK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, _K = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, xK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, SK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, NK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, jK = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": yK,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": gK,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": vK,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": kK,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": bK,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": _K,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": xK,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": SK,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": NK
};
function hi(e) {
  return jK[e] ?? {};
}
const wK = hi(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), CK = hi(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), FK = hi(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), IK = hi(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), EK = hi(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), $K = hi(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), TK = hi(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), DK = hi(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), OK = hi(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), RK = ({
  contactId: e
}) => {
  const { useQuery: n } = _n(), { track: r } = En(), [i, a] = de(), [o, s] = de(), [l, u] = de(), {
    loading: m,
    error: d,
    data: f,
    refetch: h
  } = n(wK, {
    skip: !e,
    variables: { contactId: e }
  });
  return Je(() => {
    const v = f?.Voyado?.ContactsV_GetContactById;
    !m && v && typeof v == "object" && ("id" in v && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in v && a(v.attributes), "preferences" in v && s(v.preferences), "consents" in v && u(
      v?.consents?.filter(
        (I) => I !== null
      ) || void 0
    )), !m && (!v || typeof v != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), Xn(
    () => ({
      isLoading: m,
      error: d,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [d, i, o, l]
  );
};
function pl(e = !1, n) {
  const [r, i] = de(e);
  return Je(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const PK = {
  count: 0,
  items: []
}, AK = ({
  contactId: e
}) => {
  const { useQuery: n } = _n(), { track: r } = En(), [i, a] = de(PK), {
    loading: o,
    error: s,
    data: l
  } = n(IK, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Je(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const u = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, d = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (d?.count ?? 0) + (u?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...u.items ?? [],
          ...d.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: u.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: d.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, LK = {
  count: 0,
  totalCount: 0,
  items: []
}, VK = ({
  contactId: e
}) => {
  const { useQuery: n } = _n(), { track: r } = En(), [i, a] = de(
    LK
  ), {
    loading: o,
    error: s,
    data: l
  } = n(EK, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Je(() => {
    const u = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && u) {
      a(
        u
      );
      const { count: m } = u;
      m && r("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, zK = ({
  conversationContext: e
}) => {
  const { useQuery: n } = _n(), [r, i] = de(void 0), [a, o] = de(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: u,
    error: m,
    data: d,
    refetch: f
  } = n(FK, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return Je(() => {
    const h = d?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [d?.Voyado, u]), {
    isLoading: u,
    contactId: r,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, UK = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = _n(), [i, a] = de(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: u
  } = r(CK, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return Je(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const d = m?.memberlevel;
      a({
        levelName: d?.levelName,
        remainingToUpgrade: d?.remainingToUpgrade,
        basedOnRewardPoints: d?.basedOnRewardPoints,
        levelId: d?.levelId,
        latestChange: d?.latestChange,
        expires: d?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Xn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: u
    }),
    [o, s, i, u]
  );
}, MK = "_pointer_pn2q5_54", BK = "_list_pn2q5_59", qK = "_listItem_pn2q5_69", pt = {
  pointer: MK,
  list: BK,
  listItem: qK
}, HK = "_modalBody_1clhs_1", WK = {
  modalBody: HK
}, KK = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = _n(), { track: l } = En(), u = r?.id, m = r?.balance ?? 0, d = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: v } = ht({
    defaultValues: d,
    mode: "onChange"
  }), I = Ao({ control: f }), w = parseInt(I?.balance ?? "0", 10), j = m === w, _ = j ? "Change the value to update the points" : "", y = w < 0, L = y ? "Points can not be negative" : "", $ = I.description === "", C = $ ? "Description can not be empty" : "";
  Je(() => {
    w > m ? h(
      "transactionType",
      wy.Addition
    ) : w < m && h(
      "transactionType",
      wy.Deduction
    );
  }, [m, w, h]);
  const [F, { loading: z, error: Q, reset: J }] = o(OK, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), te = () => {
    if (u) {
      const B = dK();
      F({
        variables: {
          input: {
            accountId: u,
            transactionId: B,
            amount: Math.abs(w - m),
            transactionType: I.transactionType,
            description: I.description,
            source: dI.UpdateBalance
          }
        }
      }).then(async (R) => {
        R?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), G());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, G = () => {
    v(d), J(), n();
  };
  return /* @__PURE__ */ V.jsxs(
    $t,
    {
      isOpen: e,
      onClose: G,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ V.jsx(Tt, { title: "Update points balance", onClose: G }),
        /* @__PURE__ */ V.jsxs(Dt, { className: WK.modalBody, children: [
          /* @__PURE__ */ V.jsxs(mt, { children: [
            /* @__PURE__ */ V.jsx(ce, { span: 6, children: /* @__PURE__ */ V.jsx(
              zt,
              {
                name: "balance",
                control: f,
                render: ({ field: B }) => /* @__PURE__ */ V.jsx(
                  ur,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: _ || L
                    },
                    input: {
                      ...B,
                      value: B.value.toString(),
                      onChange: (R) => B.onChange(R)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ V.jsx(ce, { span: 6, children: /* @__PURE__ */ V.jsx(
              zt,
              {
                name: "description",
                control: f,
                render: ({ field: B }) => /* @__PURE__ */ V.jsx(
                  ur,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: B,
                    meta: {
                      warning: C
                    }
                  }
                )
              }
            ) })
          ] }),
          Q && /* @__PURE__ */ V.jsx(Tn, { error: Q })
        ] }),
        /* @__PURE__ */ V.jsx(
          Ht,
          {
            confirmName: "Save",
            confirmOnClick: () => te(),
            confirmProps: {
              isLoading: z,
              disabled: j || y || $,
              loadingIndicator: /* @__PURE__ */ V.jsx(vn, { size: 16 })
            },
            cancelOnClick: G
          }
        )
      ]
    }
  );
}, GK = "_wrapper_1ge6c_1", YK = "_block_1ge6c_12", bw = {
  wrapper: GK,
  block: YK
}, QK = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = _n(), { isCopied: i, copy: a } = pl(), { isCopied: o, copy: s } = pl(), { isCopied: l, copy: u } = pl(), [m, d] = de(!1), [f, h] = de(), [v, I] = de(!1), {
    loading: w,
    data: j,
    refetch: _
  } = r(TK, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  Je(() => {
    if (j) {
      const ee = j?.Voyado?.PointAccountV_GetPointAccounts;
      ee && ee?.length > 0 && h(ee[0]);
    }
  }, [j]);
  const y = !!f?.id, L = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: $,
    lastName: C,
    street: F,
    zipCode: z,
    city: Q,
    country: J,
    isRegistrationCompleted: te,
    email: G,
    mobilePhone: B
  } = e, R = 14, U = `${$ || ""} ${C || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", className: bw.wrapper, children: [
    /* @__PURE__ */ V.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: bw.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-2", children: U }),
          w && /* @__PURE__ */ V.jsx(vn, { size: 12 }),
          y && !w && /* @__PURE__ */ V.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ V.jsxs(Bn, { size: "small", variant: "warning", children: [
              L,
              " points"
            ] }),
            /* @__PURE__ */ V.jsx(Xe, { content: "Update points balance", children: /* @__PURE__ */ V.jsx(
              he,
              {
                name: "pen",
                size: 12,
                onClick: () => d(!0),
                className: pt.pointer
              }
            ) }),
            v && /* @__PURE__ */ V.jsx(Xe, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ V.jsx(
              he,
              {
                name: "info",
                size: 12,
                className: pt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (F || Q || z || J || B || G) && /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
      B && /* @__PURE__ */ V.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ V.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ V.jsx(he, { size: R, name: "phone" }),
          /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: B })
        ] }),
        /* @__PURE__ */ V.jsx(
          he,
          {
            size: R,
            name: o ? "done" : "copy",
            onClick: () => s(B),
            className: pt.pointer
          }
        )
      ] }),
      G && /* @__PURE__ */ V.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ V.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ V.jsx(he, { size: R, name: "mail" }),
          /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: G })
        ] }),
        /* @__PURE__ */ V.jsx(
          he,
          {
            size: R,
            name: i ? "done" : "copy",
            onClick: () => a(G),
            className: pt.pointer
          }
        )
      ] }),
      (F || Q || z || J) && /* @__PURE__ */ V.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ V.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ V.jsx(he, { size: R, name: "home" }),
          /* @__PURE__ */ V.jsxs(P.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ V.jsx(ct, { children: F }),
            /* @__PURE__ */ V.jsxs(ct, { children: [
              z,
              " ",
              Q
            ] }),
            /* @__PURE__ */ V.jsx(ct, { children: J })
          ] })
        ] }),
        /* @__PURE__ */ V.jsx(
          he,
          {
            size: R,
            name: l ? "done" : "copy",
            onClick: () => u(`${F}, ${z} ${Q}, ${J}`),
            className: pt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ V.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ V.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ V.jsx(he, { size: R, name: "sign-in" }),
          /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ V.jsx(
          he,
          {
            name: te ? "check-circle-filled" : "close-circle-filled",
            color: te ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    y && /* @__PURE__ */ V.jsx(
      KK,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => d(!1),
        setHasPointsBeenUpdated: I,
        refetchPointsQuery: _
      }
    )
  ] });
}, JK = "_list_yud4a_7", XK = "_listItem_yud4a_11", ZK = "_listItemTooltip_yud4a_15", eG = "_listItemTimestamp_yud4a_18", Gs = {
  list: JK,
  listItem: XK,
  listItemTooltip: ZK,
  listItemTimestamp: eG
}, nG = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ V.jsx(Qe, { className: Gs.list, children: e.map((n, r) => /* @__PURE__ */ V.jsx(Qe.Text, { variant: "dense", className: Gs.listItem, children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ V.jsx(Xe, { content: n?.comment, children: /* @__PURE__ */ V.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: dt({
          [Gs.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ V.jsx(P.Paragraph, { className: Gs.listItemTimestamp, children: Qn(n.date).format(It) }),
          n?.comment && /* @__PURE__ */ V.jsx(he, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ V.jsx(
      he,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), tG = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Qn(e.latestChange).format(It) : null, o = e?.expires ? `${Qn(e.expires).fromNow()} (${Qn(e.expires).format(It)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ V.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ V.jsx(Xe, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ V.jsx(
        he,
        {
          name: "question",
          size: 14,
          className: pt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ V.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ V.jsxs(Qe, { className: pt.list, children: [
      s && /* @__PURE__ */ V.jsx(Qe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ V.jsx(Qe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ V.jsx(Xe, { content: "", children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ V.jsx(Bn, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ V.jsx(Qe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ V.jsx(Xe, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ V.jsx(Bn, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ V.jsx(Qe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ V.jsx(Xe, { content: "", children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ V.jsx(Bn, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ V.jsx(Qe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ V.jsx(Xe, { content: "", children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ V.jsx(Qe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ V.jsx(Xe, { content: "", children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, rG = "_tagHover_kzbzk_1", iG = "_channelUnsubscribed_kzbzk_6", _w = {
  tagHover: rG,
  channelUnsubscribed: iG
}, Dh = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = En(), { useMutation: l } = _n(), [u, m] = de(!1), [d, { loading: f }] = l(DK), h = async ({
    newPreference: I,
    isSubscribed: w,
    channelType: j
  }) => {
    m(!0), (await d({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...I
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? w ? s("voyado:channel:unsubscribe:succeeded", { channel: j }) : s("voyado:channel:subscribe:succeeded", { channel: j }) : w ? s("voyado:channel:unsubscribe:failed", { channel: j }) : s("voyado:channel:subscribe:failed", { channel: j }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, v = u || f;
  return /* @__PURE__ */ V.jsx(Xe, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ V.jsx(
    Yn,
    {
      className: _w.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ V.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: dt({
            [_w.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            v ? /* @__PURE__ */ V.jsx(vn, { size: 16 }) : /* @__PURE__ */ V.jsx(he, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, aG = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ V.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ V.jsx(
        Dh,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ V.jsx(
        Dh,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ V.jsx(
        Dh,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, oG = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: u,
    refetch: m,
    attributes: d,
    preferences: f,
    consents: h
  } = RK({ contactId: e }), {
    isLoading: v,
    error: I,
    memberLevel: w
  } = UK({ contactId: e, skip: !s }), j = v || l, _ = Xn(
    () => h?.filter(
      (y) => y !== null
    ),
    [h]
  );
  return u || I ? Ra({
    errors: u?.graphQLErrors || I?.graphQLErrors || []
  }) ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ V.jsx(P.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ V.jsx(Tn, { error: u || I }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ V.jsx(P.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : j ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ V.jsx(vn, {}) }) : /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
    r && /* @__PURE__ */ V.jsx(
      QK,
      {
        contactAttributes: d,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ V.jsx(tG, { memberLevel: w }),
    i && /* @__PURE__ */ V.jsx(
      aG,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ V.jsx(nG, { contactConsents: _ })
  ] });
}, Cy = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, sG = "_list_zu4s7_1", lG = "_listItem_zu4s7_4", cG = "_listSum_zu4s7_7", Ys = {
  list: sG,
  listItem: lG,
  listSum: cG
}, uG = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ V.jsxs(Qe, { className: Ys.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ V.jsx(Qe.Text, { variant: "dense", className: Ys.listItem, children: /* @__PURE__ */ V.jsx(Xe, { content: s, children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ V.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ V.jsx(b, { flex: "auto", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ V.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: Cy(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ V.jsx(
    Qe.Text,
    {
      variant: "dense",
      className: dt(Ys.listItem, Ys.listSum),
      children: /* @__PURE__ */ V.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: Cy(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), dG = "_transaction_1kr8d_1", mG = "_transactionIsOpen_1kr8d_9", pG = "_transactionHeader_1kr8d_12", fG = "_transactionHeaderSubLine_1kr8d_15", hG = "_transactionHeaderAlignItemRight_1kr8d_19", ya = {
  transaction: dG,
  transactionIsOpen: mG,
  transactionHeader: pG,
  transactionHeaderSubLine: fG,
  transactionHeaderAlignItemRight: hG
}, yG = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = de(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: u,
    lineItems: m,
    localCurrency: d,
    localNetPriceSum: f
  } = e, h = d ?? "", v = f ?? 0, I = m?.length ? m : [];
  return /* @__PURE__ */ V.jsxs(
    b,
    {
      className: dt(ya.transaction, {
        [ya.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ V.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ya.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ V.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ V.jsx(Bn, { size: "small", variant: "info", children: Qn(o).format(It) }),
                  /* @__PURE__ */ V.jsxs(
                    P.Heading,
                    {
                      variant: "heading-4",
                      className: ya.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ V.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: ya.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-4", children: Cy(v, h) }),
                      /* @__PURE__ */ V.jsxs(
                        P.Heading,
                        {
                          variant: "heading-4",
                          className: ya.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ V.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ V.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ V.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ V.jsx(Dy, {}),
              /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-2", children: s }),
                u && /* @__PURE__ */ V.jsx(Yn, { children: /* @__PURE__ */ V.jsx(b, { alignItems: "center", children: u }) }),
                /* @__PURE__ */ V.jsx(
                  uG,
                  {
                    lineItems: I,
                    localCurrency: h,
                    localNetPriceSum: v
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, gG = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = VK({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ V.jsx(Tn, { error: r }) : /* @__PURE__ */ V.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ V.jsx(Bn, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ V.jsx(vn, {}) }) : /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
          s === 0 && /* @__PURE__ */ V.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, u) => /* @__PURE__ */ V.jsx(
            yG,
            {
              transaction: l,
              openByDefault: u === 0
            },
            u
          ))
        ] })
      ]
    }
  );
}, vG = "_message_4z55u_54", kG = "_messageIsOpen_4z55u_62", bG = "_messageHeader_4z55u_66", _G = "_messageText_4z55u_70", xG = "_buttonLink_4z55u_93", Io = {
  message: vG,
  messageIsOpen: kG,
  messageHeader: bG,
  messageText: _G,
  buttonLink: xG
}, Oh = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Rh = (e, n) => n && e in Oh && n in Oh[e] ? Oh[e][n] : null, SG = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = de(n), { track: a } = En();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: u,
    isTransactional: m,
    status: d,
    messageLink: f,
    messageText: h
  } = e, v = l ? Rh("type", l) : null, I = u ? Rh("source", u) : null, w = d ? Rh("status", d) : null, j = l?.replace("Message", "");
  return /* @__PURE__ */ V.jsxs(
    b,
    {
      className: dt(Io.message, {
        [Io.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ V.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Io.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ V.jsxs(b, { gap: "200", alignItems: "center", children: [
                  v && /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
                    /* @__PURE__ */ V.jsx(he, { name: v, size: 16 }),
                    " ",
                    j
                  ] }),
                  s && /* @__PURE__ */ V.jsx(Bn, { size: "small", variant: "info", children: Qn(s).format(It) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ V.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ V.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ V.jsx(Dy, {}),
          /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            w && /* @__PURE__ */ V.jsx(Yn, { children: /* @__PURE__ */ V.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ V.jsx(he, { name: w }),
              " ",
              d
            ] }) }),
            I && /* @__PURE__ */ V.jsx(Yn, { children: /* @__PURE__ */ V.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ V.jsx(he, { name: I }),
              " ",
              u
            ] }) }),
            m && /* @__PURE__ */ V.jsx(Yn, { children: /* @__PURE__ */ V.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ V.jsx(he, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", className: Io.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ V.jsx(
            Bt,
            {
              slotEnd: /* @__PURE__ */ V.jsx(he, { name: "external-link" }),
              variant: "tertiary",
              className: Io.buttonLink,
              navigate: () => {
                j && a("voyado:message:external-link:opened", {
                  channel: j.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, NG = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = AK({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ V.jsx(Tn, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ V.jsx(Bn, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ V.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ V.jsx(vn, {}) }) : /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
      l && o?.map((u, m) => /* @__PURE__ */ V.jsx(
        SG,
        {
          message: u || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, fc = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, xw = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = pl(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = ft(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ V.jsx(he, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ V.jsx(Xe, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ V.jsx(
      he,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: pt.pointer
      }
    ) })
  ] });
}, jG = "_order_19t4p_1", wG = "_orderIsOpen_19t4p_9", CG = "_orderHeader_19t4p_12", FG = "_orderIconColor_19t4p_15", zr = {
  order: jG,
  orderIsOpen: wG,
  orderHeader: CG,
  orderIconColor: FG
}, IG = "_delivery_1m9nb_1", EG = "_deliveryCode_1m9nb_4", Ph = {
  delivery: IG,
  deliveryCode: EG
}, $G = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = ir();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ V.jsx(
      he,
      {
        size: l,
        name: "eye",
        className: zr.orderIconColor
      }
    ),
    /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ V.jsx(
        Xe,
        {
          content: /* @__PURE__ */ V.jsxs(P.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Qn(s).format(It)
          ] }),
          children: /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ V.jsx(
              P.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ V.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: Ph.delivery,
                    children: [
                      /* @__PURE__ */ V.jsx(he, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ V.jsx(
              P.Paragraph,
              {
                variant: "4",
                className: dt(Ph.delivery, Ph.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ V.jsx(Xe, { content: "Copy tracking code", children: /* @__PURE__ */ V.jsx(
      he,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: pt.pointer
      }
    ) })
  ] });
}, TG = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ V.jsx(
        he,
        {
          size: 14,
          name: "file-text",
          className: zr.orderIconColor
        }
      ),
      /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ V.jsx(Qe, { className: pt.list, children: r?.map((i, a) => /* @__PURE__ */ V.jsx(Qe.Item, { className: pt.listItem, children: /* @__PURE__ */ V.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ V.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ V.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: pt.listItemAlignRight,
              children: [
                /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: fc({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, DG = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ V.jsx(
        he,
        {
          size: 14,
          name: "tag",
          className: zr.orderIconColor
        }
      ),
      /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ V.jsx(Qe, { className: pt.list, children: r?.map((i) => /* @__PURE__ */ V.jsx(
      Qe.Item,
      {
        className: pt.listItem,
        contentLeft: /* @__PURE__ */ V.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ V.jsx(
          Xe,
          {
            content: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ V.jsx(b, { children: /* @__PURE__ */ V.jsx(Bn, { size: "small", variant: "info", children: fc({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ V.jsx(
          Pa,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, OG = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ V.jsx(
        he,
        {
          size: 14,
          name: "credit-card",
          className: zr.orderIconColor
        }
      ),
      /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ V.jsx(Qe, { className: pt.list, children: r?.map((i, a) => /* @__PURE__ */ V.jsx(
      Qe.Item,
      {
        className: pt.listItem,
        children: /* @__PURE__ */ V.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ V.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: pt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "5", children: Qn(i?.paidAt).format(It) }),
                    /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: fc({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, RG = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = de(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: u,
    createdAt: m,
    lastChangedAt: d,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: v,
    totalPrice: I
  } = e, w = 14;
  return /* @__PURE__ */ V.jsxs(
    b,
    {
      className: dt(zr.order, {
        [zr.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ V.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: zr.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ V.jsx(b, { alignItems: "center", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: Qn(m).format(It) }) }),
                /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ V.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ V.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ V.jsx(
              he,
              {
                size: w,
                name: "activity",
                className: zr.orderIconColor
              }
            ),
            /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ V.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ V.jsx(Xe, { content: "Internal status", children: /* @__PURE__ */ V.jsx(Bn, { size: "small", variant: "info", children: /* @__PURE__ */ V.jsx(V.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ V.jsx(Xe, { content: "External status", children: /* @__PURE__ */ V.jsx(Bn, { size: "small", variant: "info", children: /* @__PURE__ */ V.jsx(V.Fragment, { children: s }) }) }),
                /* @__PURE__ */ V.jsx(Xe, { content: "Last updated at", children: /* @__PURE__ */ V.jsx(P.Paragraph, { as: "span", variant: "5", children: Qn(d).format(It) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ V.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ V.jsx(
              he,
              {
                size: w,
                name: "chart-bar",
                className: zr.orderIconColor
              }
            ),
            /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: fc({
                value: I,
                currencyCode: l
              }) })
            ] })
          ] }),
          u && /* @__PURE__ */ V.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ V.jsx(
              he,
              {
                size: w,
                name: "channels",
                className: zr.orderIconColor
              }
            ),
            /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: /* @__PURE__ */ V.jsx(Bn, { size: "small", variant: "info", children: /* @__PURE__ */ V.jsx(V.Fragment, { children: u }) }) })
            ] })
          ] }),
          /* @__PURE__ */ V.jsx(xw, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ V.jsx(
            xw,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: v
            }
          ),
          /* @__PURE__ */ V.jsx($G, { delivery: e.delivery }),
          /* @__PURE__ */ V.jsx(DG, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ V.jsx(TG, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ V.jsx(
            OG,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, PG = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || Ra({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ V.jsx(Tn, { error: e }) : /* @__PURE__ */ V.jsx(V.Fragment, { children: r }), AG = ({
  contactId: e
}) => {
  const { useQuery: n } = _n(), [r, i] = de([]), { track: a } = En(), {
    loading: o,
    error: s,
    data: l
  } = n($K, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return Je(() => {
    if (l?.Voyado) {
      const u = l?.Voyado.Orders_GetAllByContact;
      if (!o && u?.items) {
        i(u.items);
        const { totalCount: m } = u;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ V.jsx(Bn, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ V.jsx(vn, {}) }) : /* @__PURE__ */ V.jsx(PG, { error: s, itemCount: r.length, children: r.map((u, m) => /* @__PURE__ */ V.jsx(
      RG,
      {
        order: u,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, LG = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = zK({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: u,
    showPreferences: m,
    showAudiences: d,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: v,
    showOrders: I
  } = n;
  return s ? /* @__PURE__ */ V.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ V.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? Ra({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ V.jsx(Tn, { error: o }) : !u && !m && !d && !f && !h && !v ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ V.jsx(vn, {}) }) : /* @__PURE__ */ V.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ V.jsx(oG, { contactId: i, settings: n }),
        h && /* @__PURE__ */ V.jsx(NG, { contactId: i }),
        v && /* @__PURE__ */ V.jsx(gG, { contactId: i }),
        I && /* @__PURE__ */ V.jsx(AG, { contactId: i }),
        !l && /* @__PURE__ */ V.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, Fy = [
  {
    key: "voyadoApiKey",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "apiHostName",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "showCustomerAttributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPreferences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAudiences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showConsents",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], VG = {
  enabled: !1,
  name: "",
  voyadoApiKey: "",
  apiHostName: "",
  showCustomerAttributes: !0,
  showPreferences: !0,
  showAudiences: !0,
  showConsents: !0,
  showLastMessages: !0,
  showCustomerTransactions: !0,
  showOrders: !0,
  showMemberLevel: !0
}, zG = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ht({
    mode: "onChange",
    defaultValues: VG
  }), {
    create: l,
    update: u,
    remove: m,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = Gr({
    integrationId: e,
    integrationType: "VOYADO",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: I,
    error: w,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: y
  } = Yr({
    integrationId: e,
    fieldDefinitions: Fy,
    form: s,
    onMisconfigured: v
  }), { renderConditions: L, setRenderConditions: $, renderConditionsForSubmit: C } = Qr({
    integrationId: e,
    widgetConfiguration: y,
    renderConditionsEditor: a
  }), F = (Q) => Xr(Q, {
    fieldDefinitions: Fy,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: C
  }), z = s.watch("name");
  return /* @__PURE__ */ V.jsxs(
    Jr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: w ?? f,
      onRetry: w ? _ : void 0,
      isLoading: d || I,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ V.jsx(Zr, { cause: h }),
        /* @__PURE__ */ V.jsxs(mt, { children: [
          /* @__PURE__ */ V.jsx(ce, { children: /* @__PURE__ */ V.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ V.jsx(
            Dn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(ce, { span: 3, children: /* @__PURE__ */ V.jsx(
            Zn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ V.jsx(ce, { span: 3 }),
          /* @__PURE__ */ V.jsx(ce, { span: 3, children: /* @__PURE__ */ V.jsx(
            Da,
            {
              name: "voyadoApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "API key from Voyado",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ V.jsx(ce, { span: 3 }),
          /* @__PURE__ */ V.jsx(ce, { span: 3, children: /* @__PURE__ */ V.jsx(
            Zn,
            {
              name: "apiHostName",
              label: "API URL",
              control: s.control,
              rules: { required: "API URL is required" },
              componentProps: {
                placeholder: "The URL of the Voyado API",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ V.jsx(ce, { span: 3 }),
          /* @__PURE__ */ V.jsx(ce, { span: 3, children: /* @__PURE__ */ V.jsx(en, { label: "Show the customer attributes", children: /* @__PURE__ */ V.jsx(
            Dn,
            {
              name: "showCustomerAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(ce, { span: 3 }),
          /* @__PURE__ */ V.jsx(ce, { span: 3, children: /* @__PURE__ */ V.jsx(en, { label: "Show preferences", children: /* @__PURE__ */ V.jsx(
            Dn,
            {
              name: "showPreferences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(ce, { span: 3 }),
          /* @__PURE__ */ V.jsx(ce, { span: 3, children: /* @__PURE__ */ V.jsx(en, { label: "Show audiences", children: /* @__PURE__ */ V.jsx(
            Dn,
            {
              name: "showAudiences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(ce, { span: 3 }),
          /* @__PURE__ */ V.jsx(ce, { span: 3, children: /* @__PURE__ */ V.jsx(en, { label: "Show consents", children: /* @__PURE__ */ V.jsx(
            Dn,
            {
              name: "showConsents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(ce, { span: 3 }),
          /* @__PURE__ */ V.jsx(ce, { span: 3, children: /* @__PURE__ */ V.jsx(en, { label: "Show the last 5 messages", children: /* @__PURE__ */ V.jsx(
            Dn,
            {
              name: "showLastMessages",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(ce, { span: 3 }),
          /* @__PURE__ */ V.jsx(ce, { span: 3, children: /* @__PURE__ */ V.jsx(en, { label: "Show customer transactions", children: /* @__PURE__ */ V.jsx(
            Dn,
            {
              name: "showCustomerTransactions",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(ce, { span: 3 }),
          /* @__PURE__ */ V.jsx(ce, { span: 3, children: /* @__PURE__ */ V.jsx(en, { label: "Show orders by contact", children: /* @__PURE__ */ V.jsx(
            Dn,
            {
              name: "showOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(ce, { span: 3 }),
          /* @__PURE__ */ V.jsx(ce, { span: 3, children: /* @__PURE__ */ V.jsx(en, { label: "Show member level", children: /* @__PURE__ */ V.jsx(
            Dn,
            {
              name: "showMemberLevel",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(ce, { span: 3 }),
          a && L !== null && /* @__PURE__ */ V.jsx(ce, { children: a({
            value: L,
            onChange: $,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ V.jsx(
          ei,
          {
            integrationType: "VOYADO",
            integrationId: e,
            widgetName: z,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._copyIcon_1pfts_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1pfts_59{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1pfts_69{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_1pfts_69:last-child{box-shadow:none}._listItemHighlighted_1pfts_78{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ah = { exports: {} }, Eo = {}, Sw;
function UG() {
  if (Sw) return Eo;
  Sw = 1;
  var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Eo.Fragment = r, Eo.jsx = s, Eo.jsxs = s, Eo;
}
var Qs = {}, Nw;
function MG() {
  return Nw || (Nw = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = $e, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var g = _.ReactDebugCurrentFrame, E = g.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var $ = !1, C = !1, F = !1, z = !1, Q = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === d || z || t === v || $ || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, N = E._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (E) {
            var g = E.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (ie) {
              g = ie;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var S = ie.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var ue = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = E;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ae(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ae(t.type, c, p);
          case h: {
            var g = t, E = g._payload, O = g._init;
            try {
              return ae(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, p, g, E) {
      {
        var O = Function.call.bind(le);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + p + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe(E), y("Failed %s type: %s", p, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, p, g, E, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, p, g, E) {
      {
        var O, N = {}, S = null, ne = null;
        p !== void 0 && (A(p), S = "" + p), gn(c) && (A(c.key), S = "" + c.key), rn(c) && (ne = c.ref, tn(c));
        for (O in c)
          le.call(c, O) && !oe.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, E, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, p = ae(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function An(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = j(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          yn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var E = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, p, g, E, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, p, E, O);
        if (W == null)
          return W;
        if (N) {
          var ue = c.children;
          if (ue !== void 0)
            if (g)
              if (x(ue)) {
                for (var Ue = 0; Ue < ue.length; Ue++)
                  Sn(ue[Ue], t);
                Object.freeze && Object.freeze(ue);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ue, t);
        }
        if (le.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var Rn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, Rn, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, p) {
      return Fn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return Fn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Qs.Fragment = i, Qs.jsx = Un, Qs.jsxs = Kn;
  })()), Qs;
}
var jw;
function BG() {
  return jw || (jw = 1, process.env.NODE_ENV === "production" ? Ah.exports = UG() : Ah.exports = MG()), Ah.exports;
}
var Ve = BG();
const qG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_on" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, HG = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": qG
};
function WG(e) {
  return HG[e] ?? {};
}
const KG = WG(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              default_language
              dafault_currency
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
                next_points_expire_on
                next_points_expire_amount
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), GG = "_copyIcon_1pfts_54", YG = "_list_1pfts_59", QG = "_listItem_1pfts_69", JG = "_listItemHighlighted_1pfts_78", Ta = {
  copyIcon: GG,
  list: YG,
  listItem: QG,
  listItemHighlighted: JG
}, XG = "_wrapper_1xucg_1", ZG = "_externalLink_1xucg_7", Lh = {
  wrapper: XG,
  externalLink: ZG
}, e8 = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = ir(), { isCopied: i, copy: a } = ir();
  if (!e)
    return null;
  const {
    first_name: o,
    last_name: s,
    email: l,
    phone_number: u,
    account_created_at: m
  } = e, d = 14, f = `${o || ""} ${s || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ve.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ve.jsxs(b, { className: Lh.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ve.jsx(
      b,
      {
        justifyContent: "space-between",
        className: Lh.block,
        alignItems: "center",
        children: /* @__PURE__ */ Ve.jsx(P.Heading, { variant: "heading-2", children: f })
      }
    ),
    m && /* @__PURE__ */ Ve.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", children: Qn(m).format(It) })
    ] }),
    l && /* @__PURE__ */ Ve.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ve.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ve.jsx(he, { size: d, name: "mail" }),
        /* @__PURE__ */ Ve.jsx("span", { className: Lh.externalLink, children: l })
      ] }),
      /* @__PURE__ */ Ve.jsx(Xe, { content: "Copy email", children: /* @__PURE__ */ Ve.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ve.jsx(
        he,
        {
          size: d,
          name: n ? "done" : "copy",
          onClick: () => r(l),
          className: Ta.copyIcon
        }
      ) }) })
    ] }),
    u && /* @__PURE__ */ Ve.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ve.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ve.jsx(he, { size: d, name: "phone" }),
        /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", children: u })
      ] }),
      /* @__PURE__ */ Ve.jsx(Xe, { content: "Copy phone number", children: /* @__PURE__ */ Ve.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ve.jsx(
        he,
        {
          size: d,
          name: i ? "done" : "copy",
          onClick: () => a(u),
          className: Ta.copyIcon
        }
      ) }) })
    ] })
  ] }) });
}, et = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = Yw(n);
  return /* @__PURE__ */ Ve.jsx(
    Qe.Text,
    {
      variant: "dense",
      className: dt(Ta.listItem, {
        [Ta.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ Ve.jsx(Xe, { content: r, children: /* @__PURE__ */ Ve.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", children: e }),
        a ? n : Gi(n)
      ] }) })
    }
  );
}, n8 = ({
  loyalty: e
}) => /* @__PURE__ */ Ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ve.jsx(P.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ Ve.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ Ve.jsxs(Qe, { className: Ta.list, children: [
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        isHighlighted: !0,
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        isHighlighted: !0,
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.next_points_expire_on || e.points_expire_date
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Points expiry amount",
        tooltip: "The number of points that are about to expire",
        content: e.next_points_expire_amount
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), t8 = 0.8, r8 = 0.4, ww = (e) => {
  if (e != null)
    return e >= t8 ? /* @__PURE__ */ Ve.jsx(Bn, { variant: "success", size: "small", children: "Positive" }) : e <= r8 ? /* @__PURE__ */ Ve.jsx(Bn, { variant: "error", size: "small", children: "Negative" }) : /* @__PURE__ */ Ve.jsx(Bn, { variant: "warning", size: "small", children: "Neutral" });
}, i8 = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ Ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ve.jsx(P.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ Ve.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ Ve.jsxs(Qe, { className: Ta.list, children: [
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        isHighlighted: !0,
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        isHighlighted: !0,
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        isHighlighted: !0,
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: ww(e.total_avg_sentiment)
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: ww(e.last_sentiment)
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Qn(e.last_review_date).format(
          It
        )
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      et,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ Ve.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ Ve.jsx(Bn, { variant: "info", size: "small", children: /* @__PURE__ */ Ve.jsx(Ve.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), a8 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = _n(), { track: i } = En(), [a, o] = de(), [s, l] = de(!1), u = e?.customer?.email, m = e?.customer?.phone_number, d = !u && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, v = n?.showUserGeneratedContent ?? !1, I = n?.displayLoyalty ?? !1, w = n?.displaySubscriptions ?? !1, j = !f, _ = !h && !v && !I && !w, {
    loading: y,
    error: L,
    data: $
  } = r(KG, {
    skip: d || j,
    variables: {
      ...u && { email: u },
      ...!u && m && { phone: m },
      storeId: f,
      expand: "all"
    }
  });
  if (Je(() => {
    const C = $?.Yotpo?.getCustomers?.customers?.[0];
    C ? (o(C), l(!1), i("yotpo:customer:received")) : l(!0);
  }, [$?.Yotpo, y]), j)
    return /* @__PURE__ */ Ve.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ve.jsx(
      Tn,
      {
        error: new n1({
          graphQLErrors: [
            {
              message: "Integration needs to be re-/authorized in the settings."
            }
          ]
        }),
        hideCopyButton: !0
      }
    ) });
  if (d)
    return /* @__PURE__ */ Ve.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (_)
    return /* @__PURE__ */ Ve.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (y)
    return /* @__PURE__ */ Ve.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ve.jsx(vn, {}) });
  if (s)
    return /* @__PURE__ */ Ve.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (L) {
    const C = L.graphQLErrors;
    return Ul({ errors: C }) ? /* @__PURE__ */ Ve.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Ml({ errors: C }) ? /* @__PURE__ */ Ve.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ve.jsx(Tn, { error: L });
  }
  return /* @__PURE__ */ Ve.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ Ve.jsx(e8, { customerDetails: a }),
        v && /* @__PURE__ */ Ve.jsx(
          i8,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        I && /* @__PURE__ */ Ve.jsx(n8, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
};
var ps = (e) => e.type === "checkbox", Mi = (e) => e instanceof Date, rr = (e) => e == null;
const mI = (e) => typeof e == "object";
var xt = (e) => !rr(e) && !Array.isArray(e) && mI(e) && !Mi(e), pI = (e) => xt(e) && e.target ? ps(e.target) ? e.target.checked : e.target.value : e, o8 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, fI = (e, n) => e.has(o8(n)), s8 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return xt(n) && n.hasOwnProperty("isPrototypeOf");
}, uv = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Vt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(uv && (e instanceof Blob || i)) && (r || xt(e)))
    if (n = r ? [] : {}, !r && !s8(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Vt(e[a]));
  else
    return e;
  return n;
}
var hc = (e) => Array.isArray(e) ? e.filter(Boolean) : [], vt = (e) => e === void 0, ln = (e, n, r) => {
  if (!n || !xt(e))
    return r;
  const i = hc(n.split(/[,[\].]+?/)).reduce((a, o) => rr(a) ? a : a[o], e);
  return vt(i) || i === e ? vt(e[n]) ? r : e[n] : i;
}, yr = (e) => typeof e == "boolean", dv = (e) => /^\w*$/.test(e), hI = (e) => hc(e.replace(/["|']|\]/g, "").split(/\.|\[/)), ot = (e, n, r) => {
  let i = -1;
  const a = dv(n) ? [n] : hI(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let u = r;
    if (i !== s) {
      const m = e[l];
      u = xt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = u, e = e[l];
  }
};
const Al = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, $r = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ui = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, l8 = $e.createContext(null), mv = () => $e.useContext(l8);
var yI = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== $r.all && (n._proxyFormState[s] = !i || $r.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function c8(e) {
  const n = mv(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = $e.useState(r._formState), u = $e.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = $e.useRef(a);
  return m.current = a, $e.useEffect(() => r._subscribe({
    name: m.current,
    formState: u.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...r._formState,
        ...d
      });
    }
  }), [r, i, o]), $e.useEffect(() => {
    u.current.isValid && r._setValid(!0);
  }, [r]), $e.useMemo(() => yI(s, r, u.current, !1), [s, r]);
}
var Hr = (e) => typeof e == "string", gI = (e, n, r, i, a) => Hr(e) ? (i && n.watch.add(e), ln(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), ln(r, o))) : (i && (n.watchAll = !0), r);
function vI(e) {
  const n = mv(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = $e.useRef(i), u = $e.useRef(a);
  l.current = i, $e.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && d(gI(l.current, r._names, f.values || r._formValues, !1, u.current))
  }), [r, o, s]);
  const [m, d] = $e.useState(r._getWatch(i, a));
  return $e.useEffect(() => r._removeUnmounted()), m;
}
function u8(e) {
  const n = mv(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = fI(a._names.array, r), l = vI({
    control: a,
    name: r,
    defaultValue: ln(a._formValues, r, ln(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), u = c8({
    control: a,
    name: r,
    exact: !0
  }), m = $e.useRef(e), d = $e.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...yr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = $e.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!ln(u.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!ln(u.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!ln(u.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!ln(u.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => ln(u.errors, r)
    }
  }), [u, r]), h = $e.useCallback((j) => d.current.onChange({
    target: {
      value: pI(j),
      name: r
    },
    type: Al.CHANGE
  }), [r]), v = $e.useCallback(() => d.current.onBlur({
    target: {
      value: ln(a._formValues, r),
      name: r
    },
    type: Al.BLUR
  }), [r, a._formValues]), I = $e.useCallback((j) => {
    const _ = ln(a._fields, r);
    _ && j && (_._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (y) => j.setCustomValidity(y),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), w = $e.useMemo(() => ({
    name: r,
    value: l,
    ...yr(i) || u.disabled ? { disabled: u.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: I
  }), [r, i, u.disabled, h, v, I, l]);
  return $e.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...yr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const _ = (y, L) => {
      const $ = ln(a._fields, y);
      $ && $._f && ($._f.mount = L);
    };
    if (_(r, !0), j) {
      const y = Vt(ln(a._options.defaultValues, r));
      ot(a._defaultValues, r, y), vt(ln(a._formValues, r)) && ot(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : _(r, !1);
    };
  }, [r, a, s, o]), $e.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), $e.useMemo(() => ({
    field: w,
    formState: u,
    fieldState: f
  }), [w, u, f]);
}
const Cw = (e) => e.render(u8(e));
var d8 = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Wo = (e) => Array.isArray(e) ? e : [e], Fw = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Iy = (e) => rr(e) || !mI(e);
function ji(e, n) {
  if (Iy(e) || Iy(n))
    return e === n;
  if (Mi(e) && Mi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Mi(o) && Mi(s) || xt(o) && xt(s) || Array.isArray(o) && Array.isArray(s) ? !ji(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var er = (e) => xt(e) && !Object.keys(e).length, pv = (e) => e.type === "file", Tr = (e) => typeof e == "function", Ll = (e) => {
  if (!uv)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, kI = (e) => e.type === "select-multiple", fv = (e) => e.type === "radio", m8 = (e) => fv(e) || ps(e), Vh = (e) => Ll(e) && e.isConnected;
function p8(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = vt(e) ? i++ : e[n[i++]];
  return e;
}
function f8(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !vt(e[n]))
      return !1;
  return !0;
}
function Ft(e, n) {
  const r = Array.isArray(n) ? n : dv(n) ? [n] : hI(n), i = r.length === 1 ? e : p8(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (xt(i) && er(i) || Array.isArray(i) && f8(i)) && Ft(e, r.slice(0, -1)), e;
}
var bI = (e) => {
  for (const n in e)
    if (Tr(e[n]))
      return !0;
  return !1;
};
function Vl(e, n = {}) {
  const r = Array.isArray(e);
  if (xt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || xt(e[i]) && !bI(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Vl(e[i], n[i])) : rr(e[i]) || (n[i] = !0);
  return n;
}
function _I(e, n, r) {
  const i = Array.isArray(e);
  if (xt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || xt(e[a]) && !bI(e[a]) ? vt(n) || Iy(r[a]) ? r[a] = Array.isArray(e[a]) ? Vl(e[a], []) : { ...Vl(e[a]) } : _I(e[a], rr(n) ? {} : n[a], r[a]) : r[a] = !ji(e[a], n[a]);
  return r;
}
var $o = (e, n) => _I(e, n, Vl(n));
const Iw = {
  value: !1,
  isValid: !1
}, Ew = { value: !0, isValid: !0 };
var xI = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !vt(e[0].attributes.value) ? vt(e[0].value) || e[0].value === "" ? Ew : { value: e[0].value, isValid: !0 } : Ew
    ) : Iw;
  }
  return Iw;
}, SI = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => vt(e) ? e : n ? e === "" ? NaN : e && +e : r && Hr(e) ? new Date(e) : i ? i(e) : e;
const $w = {
  isValid: !1,
  value: null
};
var NI = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, $w) : $w;
function Tw(e) {
  const n = e.ref;
  return pv(n) ? n.files : fv(n) ? NI(e.refs).value : kI(n) ? [...n.selectedOptions].map(({ value: r }) => r) : ps(n) ? xI(e.refs).value : SI(vt(n.value) ? e.ref.value : n.value, e);
}
var h8 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = ln(n, o);
    s && ot(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, zl = (e) => e instanceof RegExp, To = (e) => vt(e) ? e : zl(e) ? e.source : xt(e) ? zl(e.value) ? e.value.source : e.value : e, Dw = (e) => ({
  isOnSubmit: !e || e === $r.onSubmit,
  isOnBlur: e === $r.onBlur,
  isOnChange: e === $r.onChange,
  isOnAll: e === $r.all,
  isOnTouch: e === $r.onTouched
});
const Ow = "AsyncFunction";
var y8 = (e) => !!e && !!e.validate && !!(Tr(e.validate) && e.validate.constructor.name === Ow || xt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Ow)), g8 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Rw = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ko = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = ln(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ko(l, n))
          break;
      } else if (xt(l) && Ko(l, n))
        break;
    }
  }
};
function Pw(e, n, r) {
  const i = ln(e, r);
  if (i || dv(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = ln(n, o), l = ln(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var v8 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return er(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || $r.all));
}, k8 = (e, n, r) => !e || !n || e === n || Wo(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), b8 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, _8 = (e, n) => !hc(ln(e, n)).length && Ft(e, n), x8 = (e, n, r) => {
  const i = Wo(ln(e, r));
  return ot(i, "root", n[r]), ot(e, r, i), e;
}, fl = (e) => Hr(e);
function Aw(e, n, r = "validate") {
  if (fl(e) || Array.isArray(e) && e.every(fl) || yr(e) && !e)
    return {
      type: r,
      message: fl(e) ? e : "",
      ref: n
    };
}
var ga = (e) => xt(e) && !zl(e) ? e : {
  value: e,
  message: ""
}, Lw = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: u, maxLength: m, minLength: d, min: f, max: h, pattern: v, validate: I, name: w, valueAsNumber: j, mount: _ } = e._f, y = ln(r, w);
  if (!_ || n.has(w))
    return {};
  const L = l ? l[0] : s, $ = (B) => {
    a && L.reportValidity && (L.setCustomValidity(yr(B) ? "" : B || ""), L.reportValidity());
  }, C = {}, F = fv(s), z = ps(s), Q = F || z, J = (j || pv(s)) && vt(s.value) && vt(y) || Ll(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, te = d8.bind(null, w, i, C), G = (B, R, U, ee = ui.maxLength, Se = ui.minLength) => {
    const fe = B ? R : U;
    C[w] = {
      type: B ? ee : Se,
      message: fe,
      ref: s,
      ...te(B ? ee : Se, fe)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : u && (!Q && (J || rr(y)) || yr(y) && !y || z && !xI(l).isValid || F && !NI(l).isValid)) {
    const { value: B, message: R } = fl(u) ? { value: !!u, message: u } : ga(u);
    if (B && (C[w] = {
      type: ui.required,
      message: R,
      ref: L,
      ...te(ui.required, R)
    }, !i))
      return $(R), C;
  }
  if (!J && (!rr(f) || !rr(h))) {
    let B, R;
    const U = ga(h), ee = ga(f);
    if (!rr(y) && !isNaN(y)) {
      const Se = s.valueAsNumber || y && +y;
      rr(U.value) || (B = Se > U.value), rr(ee.value) || (R = Se < ee.value);
    } else {
      const Se = s.valueAsDate || new Date(y), fe = (K) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + K), ye = s.type == "time", ve = s.type == "week";
      Hr(U.value) && y && (B = ye ? fe(y) > fe(U.value) : ve ? y > U.value : Se > new Date(U.value)), Hr(ee.value) && y && (R = ye ? fe(y) < fe(ee.value) : ve ? y < ee.value : Se < new Date(ee.value));
    }
    if ((B || R) && (G(!!B, U.message, ee.message, ui.max, ui.min), !i))
      return $(C[w].message), C;
  }
  if ((m || d) && !J && (Hr(y) || o && Array.isArray(y))) {
    const B = ga(m), R = ga(d), U = !rr(B.value) && y.length > +B.value, ee = !rr(R.value) && y.length < +R.value;
    if ((U || ee) && (G(U, B.message, R.message), !i))
      return $(C[w].message), C;
  }
  if (v && !J && Hr(y)) {
    const { value: B, message: R } = ga(v);
    if (zl(B) && !y.match(B) && (C[w] = {
      type: ui.pattern,
      message: R,
      ref: s,
      ...te(ui.pattern, R)
    }, !i))
      return $(R), C;
  }
  if (I) {
    if (Tr(I)) {
      const B = await I(y, r), R = Aw(B, L);
      if (R && (C[w] = {
        ...R,
        ...te(ui.validate, R.message)
      }, !i))
        return $(R.message), C;
    } else if (xt(I)) {
      let B = {};
      for (const R in I) {
        if (!er(B) && !i)
          break;
        const U = Aw(await I[R](y, r), L, R);
        U && (B = {
          ...U,
          ...te(R, U.message)
        }, $(U.message), i && (C[w] = B));
      }
      if (!er(B) && (C[w] = {
        ref: L,
        ...B
      }, !i))
        return C;
    }
  }
  return $(!0), C;
};
const S8 = {
  mode: $r.onSubmit,
  reValidateMode: $r.onChange,
  shouldFocusError: !0
};
function N8(e = {}) {
  let n = {
    ...S8,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Tr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = xt(n.defaultValues) || xt(n.values) ? Vt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Vt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, m = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...d
  };
  const h = {
    array: Fw(),
    state: Fw()
  }, v = Dw(n.mode), I = Dw(n.reValidateMode), w = n.criteriaMode === $r.all, j = (T) => (x) => {
    clearTimeout(m), m = setTimeout(T, x);
  }, _ = async (T) => {
    if (!n.disabled && (d.isValid || f.isValid || T)) {
      const x = n.resolver ? er((await J()).errors) : await G(i, !0);
      x !== r.isValid && h.state.next({
        isValid: x
      });
    }
  }, y = (T, x) => {
    !n.disabled && (d.isValidating || d.validatingFields || f.isValidating || f.validatingFields) && ((T || Array.from(l.mount)).forEach((D) => {
      D && (x ? ot(r.validatingFields, D, x) : Ft(r.validatingFields, D));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !er(r.validatingFields)
    }));
  }, L = (T, x = [], D, H, Y = !0, A = !0) => {
    if (H && D && !n.disabled) {
      if (s.action = !0, A && Array.isArray(ln(i, T))) {
        const M = D(ln(i, T), H.argA, H.argB);
        Y && ot(i, T, M);
      }
      if (A && Array.isArray(ln(r.errors, T))) {
        const M = D(ln(r.errors, T), H.argA, H.argB);
        Y && ot(r.errors, T, M), _8(r.errors, T);
      }
      if ((d.touchedFields || f.touchedFields) && A && Array.isArray(ln(r.touchedFields, T))) {
        const M = D(ln(r.touchedFields, T), H.argA, H.argB);
        Y && ot(r.touchedFields, T, M);
      }
      (d.dirtyFields || f.dirtyFields) && (r.dirtyFields = $o(a, o)), h.state.next({
        name: T,
        isDirty: R(T, x),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      ot(o, T, x);
  }, $ = (T, x) => {
    ot(r.errors, T, x), h.state.next({
      errors: r.errors
    });
  }, C = (T) => {
    r.errors = T, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, F = (T, x, D, H) => {
    const Y = ln(i, T);
    if (Y) {
      const A = ln(o, T, vt(D) ? ln(a, T) : D);
      vt(A) || H && H.defaultChecked || x ? ot(o, T, x ? A : Tw(Y._f)) : Se(T, A), s.mount && _();
    }
  }, z = (T, x, D, H, Y) => {
    let A = !1, M = !1;
    const oe = {
      name: T
    };
    if (!n.disabled) {
      if (!D || H) {
        (d.isDirty || f.isDirty) && (M = r.isDirty, r.isDirty = oe.isDirty = R(), A = M !== oe.isDirty);
        const ge = ji(ln(a, T), x);
        M = !!ln(r.dirtyFields, T), ge ? Ft(r.dirtyFields, T) : ot(r.dirtyFields, T, !0), oe.dirtyFields = r.dirtyFields, A = A || (d.dirtyFields || f.dirtyFields) && M !== !ge;
      }
      if (D) {
        const ge = ln(r.touchedFields, T);
        ge || (ot(r.touchedFields, T, D), oe.touchedFields = r.touchedFields, A = A || (d.touchedFields || f.touchedFields) && ge !== D);
      }
      A && Y && h.state.next(oe);
    }
    return A ? oe : {};
  }, Q = (T, x, D, H) => {
    const Y = ln(r.errors, T), A = (d.isValid || f.isValid) && yr(x) && r.isValid !== x;
    if (n.delayError && D ? (u = j(() => $(T, D)), u(n.delayError)) : (clearTimeout(m), u = null, D ? ot(r.errors, T, D) : Ft(r.errors, T)), (D ? !ji(Y, D) : Y) || !er(H) || A) {
      const M = {
        ...H,
        ...A && yr(x) ? { isValid: x } : {},
        errors: r.errors,
        name: T
      };
      r = {
        ...r,
        ...M
      }, h.state.next(M);
    }
  }, J = async (T) => {
    y(T, !0);
    const x = await n.resolver(o, n.context, h8(T || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(T), x;
  }, te = async (T) => {
    const { errors: x } = await J(T);
    if (T)
      for (const D of T) {
        const H = ln(x, D);
        H ? ot(r.errors, D, H) : Ft(r.errors, D);
      }
    else
      r.errors = x;
    return x;
  }, G = async (T, x, D = {
    valid: !0
  }) => {
    for (const H in T) {
      const Y = T[H];
      if (Y) {
        const { _f: A, ...M } = Y;
        if (A) {
          const oe = l.array.has(A.name), ge = Y._f && y8(Y._f);
          ge && d.validatingFields && y([H], !0);
          const Ne = await Lw(Y, l.disabled, o, w, n.shouldUseNativeValidation && !x, oe);
          if (ge && d.validatingFields && y([H]), Ne[A.name] && (D.valid = !1, x))
            break;
          !x && (ln(Ne, A.name) ? oe ? x8(r.errors, Ne, A.name) : ot(r.errors, A.name, Ne[A.name]) : Ft(r.errors, A.name));
        }
        !er(M) && await G(M, x, D);
      }
    }
    return D.valid;
  }, B = () => {
    for (const T of l.unMount) {
      const x = ln(i, T);
      x && (x._f.refs ? x._f.refs.every((D) => !Vh(D)) : !Vh(x._f.ref)) && Be(T);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (T, x) => !n.disabled && (T && x && ot(o, T, x), !ji(Te(), a)), U = (T, x, D) => gI(T, l, {
    ...s.mount ? o : vt(x) ? a : Hr(T) ? { [T]: x } : x
  }, D, x), ee = (T) => hc(ln(s.mount ? o : a, T, n.shouldUnregister ? ln(a, T, []) : [])), Se = (T, x, D = {}) => {
    const H = ln(i, T);
    let Y = x;
    if (H) {
      const A = H._f;
      A && (!A.disabled && ot(o, T, SI(x, A)), Y = Ll(A.ref) && rr(x) ? "" : x, kI(A.ref) ? [...A.ref.options].forEach((M) => M.selected = Y.includes(M.value)) : A.refs ? ps(A.ref) ? A.refs.length > 1 ? A.refs.forEach((M) => (!M.defaultChecked || !M.disabled) && (M.checked = Array.isArray(Y) ? !!Y.find((oe) => oe === M.value) : Y === M.value)) : A.refs[0] && (A.refs[0].checked = !!Y) : A.refs.forEach((M) => M.checked = M.value === Y) : pv(A.ref) ? A.ref.value = "" : (A.ref.value = Y, A.ref.type || h.state.next({
        name: T,
        values: Vt(o)
      })));
    }
    (D.shouldDirty || D.shouldTouch) && z(T, Y, D.shouldTouch, D.shouldDirty, !0), D.shouldValidate && _e(T);
  }, fe = (T, x, D) => {
    for (const H in x) {
      const Y = x[H], A = `${T}.${H}`, M = ln(i, A);
      (l.array.has(T) || xt(Y) || M && !M._f) && !Mi(Y) ? fe(A, Y, D) : Se(A, Y, D);
    }
  }, ye = (T, x, D = {}) => {
    const H = ln(i, T), Y = l.array.has(T), A = Vt(x);
    ot(o, T, A), Y ? (h.array.next({
      name: T,
      values: Vt(o)
    }), (d.isDirty || d.dirtyFields || f.isDirty || f.dirtyFields) && D.shouldDirty && h.state.next({
      name: T,
      dirtyFields: $o(a, o),
      isDirty: R(T, A)
    })) : H && !H._f && !rr(A) ? fe(T, A, D) : Se(T, A, D), Rw(T, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? T : void 0,
      values: Vt(o)
    });
  }, ve = async (T) => {
    s.mount = !0;
    const x = T.target;
    let D = x.name, H = !0;
    const Y = ln(i, D), A = (M) => {
      H = Number.isNaN(M) || Mi(M) && isNaN(M.getTime()) || ji(M, ln(o, D, M));
    };
    if (Y) {
      let M, oe;
      const ge = x.type ? Tw(Y._f) : pI(T), Ne = T.type === Al.BLUR || T.type === Al.FOCUS_OUT, rn = !g8(Y._f) && !n.resolver && !ln(r.errors, D) && !Y._f.deps || b8(Ne, ln(r.touchedFields, D), r.isSubmitted, I, v), gn = Rw(D, l, Ne);
      ot(o, D, ge), Ne ? (Y._f.onBlur && Y._f.onBlur(T), u && u(0)) : Y._f.onChange && Y._f.onChange(T);
      const tn = z(D, ge, Ne), dn = !er(tn) || gn;
      if (!Ne && h.state.next({
        name: D,
        type: T.type,
        values: Vt(o)
      }), rn)
        return (d.isValid || f.isValid) && (n.mode === "onBlur" ? Ne && _() : Ne || _()), dn && h.state.next({ name: D, ...gn ? {} : tn });
      if (!Ne && gn && h.state.next({ ...r }), n.resolver) {
        const { errors: wn } = await J([D]);
        if (A(ge), H) {
          const xn = Pw(r.errors, i, D), Cn = Pw(wn, i, xn.name || D);
          M = Cn.error, D = Cn.name, oe = er(wn);
        }
      } else
        y([D], !0), M = (await Lw(Y, l.disabled, o, w, n.shouldUseNativeValidation))[D], y([D]), A(ge), H && (M ? oe = !1 : (d.isValid || f.isValid) && (oe = await G(i, !0)));
      H && (Y._f.deps && _e(Y._f.deps), Q(D, oe, M, tn));
    }
  }, K = (T, x) => {
    if (ln(r.errors, x) && T.focus)
      return T.focus(), 1;
  }, _e = async (T, x = {}) => {
    let D, H;
    const Y = Wo(T);
    if (n.resolver) {
      const A = await te(vt(T) ? T : Y);
      D = er(A), H = T ? !Y.some((M) => ln(A, M)) : D;
    } else T ? (H = (await Promise.all(Y.map(async (A) => {
      const M = ln(i, A);
      return await G(M && M._f ? { [A]: M } : M);
    }))).every(Boolean), !(!H && !r.isValid) && _()) : H = D = await G(i);
    return h.state.next({
      ...!Hr(T) || (d.isValid || f.isValid) && D !== r.isValid ? {} : { name: T },
      ...n.resolver || !T ? { isValid: D } : {},
      errors: r.errors
    }), x.shouldFocus && !H && Ko(i, K, T ? Y : l.mount), H;
  }, Te = (T) => {
    const x = {
      ...s.mount ? o : a
    };
    return vt(T) ? x : Hr(T) ? ln(x, T) : T.map((D) => ln(x, D));
  }, X = (T, x) => ({
    invalid: !!ln((x || r).errors, T),
    isDirty: !!ln((x || r).dirtyFields, T),
    error: ln((x || r).errors, T),
    isValidating: !!ln(r.validatingFields, T),
    isTouched: !!ln((x || r).touchedFields, T)
  }), Ke = (T) => {
    T && Wo(T).forEach((x) => Ft(r.errors, x)), h.state.next({
      errors: T ? r.errors : {}
    });
  }, an = (T, x, D) => {
    const H = (ln(i, T, { _f: {} })._f || {}).ref, Y = ln(r.errors, T) || {}, { ref: A, message: M, type: oe, ...ge } = Y;
    ot(r.errors, T, {
      ...ge,
      ...x,
      ref: H
    }), h.state.next({
      name: T,
      errors: r.errors,
      isValid: !1
    }), D && D.shouldFocus && H && H.focus && H.focus();
  }, we = (T, x) => Tr(T) ? h.state.subscribe({
    next: (D) => T(U(void 0, x), D)
  }) : U(T, x, !0), Me = (T) => h.state.subscribe({
    next: (x) => {
      k8(T.name, x.name, T.exact) && v8(x, T.formState || d, Pe, T.reRenderRoot) && T.callback({
        values: { ...o },
        ...r,
        ...x
      });
    }
  }).unsubscribe, Re = (T) => (s.mount = !0, f = {
    ...f,
    ...T.formState
  }, Me({
    ...T,
    formState: f
  })), Be = (T, x = {}) => {
    for (const D of T ? Wo(T) : l.mount)
      l.mount.delete(D), l.array.delete(D), x.keepValue || (Ft(i, D), Ft(o, D)), !x.keepError && Ft(r.errors, D), !x.keepDirty && Ft(r.dirtyFields, D), !x.keepTouched && Ft(r.touchedFields, D), !x.keepIsValidating && Ft(r.validatingFields, D), !n.shouldUnregister && !x.keepDefaultValue && Ft(a, D);
    h.state.next({
      values: Vt(o)
    }), h.state.next({
      ...r,
      ...x.keepDirty ? { isDirty: R() } : {}
    }), !x.keepIsValid && _();
  }, Ae = ({ disabled: T, name: x }) => {
    (yr(T) && s.mount || T || l.disabled.has(x)) && (T ? l.disabled.add(x) : l.disabled.delete(x));
  }, Ge = (T, x = {}) => {
    let D = ln(i, T);
    const H = yr(x.disabled) || yr(n.disabled);
    return ot(i, T, {
      ...D || {},
      _f: {
        ...D && D._f ? D._f : { ref: { name: T } },
        name: T,
        mount: !0,
        ...x
      }
    }), l.mount.add(T), D ? Ae({
      disabled: yr(x.disabled) ? x.disabled : n.disabled,
      name: T
    }) : F(T, !0, x.value), {
      ...H ? { disabled: x.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!x.required,
        min: To(x.min),
        max: To(x.max),
        minLength: To(x.minLength),
        maxLength: To(x.maxLength),
        pattern: To(x.pattern)
      } : {},
      name: T,
      onChange: ve,
      onBlur: ve,
      ref: (Y) => {
        if (Y) {
          Ge(T, x), D = ln(i, T);
          const A = vt(Y.value) && Y.querySelectorAll && Y.querySelectorAll("input,select,textarea")[0] || Y, M = m8(A), oe = D._f.refs || [];
          if (M ? oe.find((ge) => ge === A) : A === D._f.ref)
            return;
          ot(i, T, {
            _f: {
              ...D._f,
              ...M ? {
                refs: [
                  ...oe.filter(Vh),
                  A,
                  ...Array.isArray(ln(a, T)) ? [{}] : []
                ],
                ref: { type: A.type, name: T }
              } : { ref: A }
            }
          }), F(T, !1, void 0, A);
        } else
          D = ln(i, T, {}), D._f && (D._f.mount = !1), (n.shouldUnregister || x.shouldUnregister) && !(fI(l.array, T) && s.action) && l.unMount.add(T);
      }
    };
  }, Ce = () => n.shouldFocusError && Ko(i, K, l.mount), qe = (T) => {
    yr(T) && (h.state.next({ disabled: T }), Ko(i, (x, D) => {
      const H = ln(i, D);
      H && (x.disabled = H._f.disabled || T, Array.isArray(H._f.refs) && H._f.refs.forEach((Y) => {
        Y.disabled = H._f.disabled || T;
      }));
    }, 0, !1));
  }, nn = (T, x) => async (D) => {
    let H;
    D && (D.preventDefault && D.preventDefault(), D.persist && D.persist());
    let Y = Vt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: A, values: M } = await J();
      r.errors = A, Y = M;
    } else
      await G(i);
    if (l.disabled.size)
      for (const A of l.disabled)
        ot(Y, A, void 0);
    if (Ft(r.errors, "root"), er(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await T(Y, D);
      } catch (A) {
        H = A;
      }
    } else
      x && await x({ ...r.errors }, D), Ce(), setTimeout(Ce);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: er(r.errors) && !H,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), H)
      throw H;
  }, ae = (T, x = {}) => {
    ln(i, T) && (vt(x.defaultValue) ? ye(T, Vt(ln(a, T))) : (ye(T, x.defaultValue), ot(a, T, Vt(x.defaultValue))), x.keepTouched || Ft(r.touchedFields, T), x.keepDirty || (Ft(r.dirtyFields, T), r.isDirty = x.defaultValue ? R(T, Vt(ln(a, T))) : R()), x.keepError || (Ft(r.errors, T), d.isValid && _()), h.state.next({ ...r }));
  }, le = (T, x = {}) => {
    const D = T ? Vt(T) : a, H = Vt(D), Y = er(T), A = Y ? a : H;
    if (x.keepDefaultValues || (a = D), !x.keepValues) {
      if (x.keepDirtyValues) {
        const M = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys($o(a, o))
        ]);
        for (const oe of Array.from(M))
          ln(r.dirtyFields, oe) ? ot(A, oe, ln(o, oe)) : ye(oe, ln(A, oe));
      } else {
        if (uv && vt(T))
          for (const M of l.mount) {
            const oe = ln(i, M);
            if (oe && oe._f) {
              const ge = Array.isArray(oe._f.refs) ? oe._f.refs[0] : oe._f.ref;
              if (Ll(ge)) {
                const Ne = ge.closest("form");
                if (Ne) {
                  Ne.reset();
                  break;
                }
              }
            }
          }
        for (const M of l.mount)
          ye(M, ln(A, M));
      }
      o = Vt(A), h.array.next({
        values: { ...A }
      }), h.state.next({
        values: { ...A }
      });
    }
    l = {
      mount: x.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!x.keepIsValid || !!x.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: x.keepSubmitCount ? r.submitCount : 0,
      isDirty: Y ? !1 : x.keepDirty ? r.isDirty : !!(x.keepDefaultValues && !ji(T, a)),
      isSubmitted: x.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: Y ? {} : x.keepDirtyValues ? x.keepDefaultValues && o ? $o(a, o) : r.dirtyFields : x.keepDefaultValues && T ? $o(a, T) : x.keepDirty ? r.dirtyFields : {},
      touchedFields: x.keepTouched ? r.touchedFields : {},
      errors: x.keepErrors ? r.errors : {},
      isSubmitSuccessful: x.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, xe = (T, x) => le(Tr(T) ? T(o) : T, x), Le = (T, x = {}) => {
    const D = ln(i, T), H = D && D._f;
    if (H) {
      const Y = H.refs ? H.refs[0] : H.ref;
      Y.focus && (Y.focus(), x.shouldSelect && Tr(Y.select) && Y.select());
    }
  }, Pe = (T) => {
    r = {
      ...r,
      ...T
    };
  }, yn = {
    control: {
      register: Ge,
      unregister: Be,
      getFieldState: X,
      handleSubmit: nn,
      setError: an,
      _subscribe: Me,
      _runSchema: J,
      _getWatch: U,
      _getDirty: R,
      _setValid: _,
      _setFieldArray: L,
      _setDisabledField: Ae,
      _setErrors: C,
      _getFieldArray: ee,
      _reset: le,
      _resetDefaultValues: () => Tr(n.defaultValues) && n.defaultValues().then((T) => {
        xe(T, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: qe,
      _subjects: h,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(T) {
        s = T;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(T) {
        l = T;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(T) {
        n = {
          ...n,
          ...T
        };
      }
    },
    subscribe: Re,
    trigger: _e,
    register: Ge,
    handleSubmit: nn,
    watch: we,
    setValue: ye,
    getValues: Te,
    reset: xe,
    resetField: ae,
    clearErrors: Ke,
    unregister: Be,
    setError: an,
    setFocus: Le,
    getFieldState: X
  };
  return {
    ...yn,
    formControl: yn
  };
}
function j8(e = {}) {
  const n = $e.useRef(void 0), r = $e.useRef(void 0), [i, a] = $e.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Tr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Tr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : N8(e),
    formState: i
  }, e.formControl && e.defaultValues && !Tr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, $e.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), $e.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), $e.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), $e.useEffect(() => {
    e.values && !ji(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), $e.useEffect(() => {
    e.errors && !er(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), $e.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), $e.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = yI(i, o), n.current;
}
const w8 = "_settingsWrapper_1ycvy_1", C8 = "_settingsWrapperHeader_1ycvy_6", F8 = "_settingsWrapperContent_1ycvy_10", I8 = "_settingsWrapperContentCode_1ycvy_18", E8 = "_settingsWrapperContentCURL_1ycvy_26", Do = {
  settingsWrapper: w8,
  settingsWrapperHeader: C8,
  settingsWrapperContent: F8,
  settingsWrapperContentCode: I8,
  settingsWrapperContentCURL: E8
}, $8 = ({
  handleChangeText: e
}) => {
  const [n, r] = de(!1), { isCopied: i, copy: a } = ir(), { control: o } = j8({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = vI({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", u = ft(() => {
    const m = s.storeId, d = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${d ? ` \\
  --data '{"secret":"${d}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ Ve.jsx(Ve.Fragment, { children: /* @__PURE__ */ Ve.jsx(ce, { span: 6, children: /* @__PURE__ */ Ve.jsxs(b, { flexDirection: "column", className: Do.settingsWrapper, children: [
    /* @__PURE__ */ Ve.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: Do.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ Ve.jsx(P.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ Ve.jsx(he, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ Ve.jsxs(
      b,
      {
        flexDirection: "column",
        className: Do.settingsWrapperContent,
        children: [
          /* @__PURE__ */ Ve.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ve.jsx(
            ql,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ Ve.jsxs("ol", { children: [
                /* @__PURE__ */ Ve.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ Ve.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ Ve.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ Ve.jsx("span", { className: Do.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ Ve.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ Ve.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ Ve.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ Ve.jsx(
            Cw,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Ve.jsx(
                ur,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (d) => {
                      m.onChange(d), e({
                        target: {
                          name: "yotpoStoreId",
                          value: d?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ Ve.jsx(
            Cw,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Ve.jsx(
                ur,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ Ve.jsxs(Ve.Fragment, { children: [
            /* @__PURE__ */ Ve.jsx(en, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ Ve.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: Do.settingsWrapperContentCURL,
                children: u()
              }
            ) }),
            /* @__PURE__ */ Ve.jsx(b, { alignContent: "start", children: /* @__PURE__ */ Ve.jsx(
              Xe,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ Ve.jsx(
                  nt,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(u()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, T8 = [
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], D8 = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Oa
  }
], O8 = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: $8
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], R8 = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, P8 = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, A8 = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: e9,
  featureSettings: []
} : n ? {
  authSettings: n9,
  featureSettings: [...tI]
} : e ? {
  authSettings: [
    ...Zj,
    ...XW
  ],
  featureSettings: [...ew]
} : {
  authSettings: [
    ...Zj,
    ...ZW
  ],
  featureSettings: [...ew]
}, jI = (e, n) => ({
  hasOAuth: r = !1,
  isCreationMode: i = !1
}) => r || i ? e : n, L8 = jI(
  D8,
  O8
), V8 = jI(
  n3,
  t3
), wI = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = P8(a?.value, r), s = i !== void 0 ? i : R8(
    r
  );
  return o !== void 0 ? o : s;
}, hv = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = A8(n), s = L8(r), l = V8(i);
  return {
    SHOPIFY: {
      widget: sK,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: FL,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      fieldDefinitions: Zh,
      WidgetSettings: $L
    },
    GITHUB: {
      widget: EA,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      fieldDefinitions: Qh,
      WidgetSettings: TA
    },
    MIUROS: {
      widget: lq,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      fieldDefinitions: vy,
      WidgetSettings: uq
    },
    KLAVIYO: {
      widget: ZV,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...l, ...e3]
    },
    LINEAR: {
      widget: CM,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      fieldDefinitions: fy,
      WidgetSettings: IM
    },
    VOYADO: {
      widget: LG,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Fy,
      WidgetSettings: zG
    },
    LOYALTYLION: {
      widget: oB,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      fieldDefinitions: hy,
      WidgetSettings: lB
    },
    RECHARGE: {
      widget: Rq,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      fieldDefinitions: _y,
      WidgetSettings: Aq
    },
    BRAZE: {
      widget: rP,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      fieldDefinitions: jl,
      WidgetSettings: aP
    },
    YOTPO: {
      widget: a8,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      settingsConfiguration: [...s, ...T8]
    },
    INGRID: {
      widget: a2,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Jh,
      WidgetSettings: s2
    },
    RIVOLOYALTY: {
      widget: _6,
      icon: "rivoloyalty",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Sy,
      WidgetSettings: zW
    }
  };
}, z8 = (e, n) => {
  const r = n.find(
    (i) => i.key === e.key
  )?.value;
  return e.type === "boolean" ? QI(r, e.defaultValue) : JI(r, e.defaultValue);
}, U8 = (e, n) => e.map((r) => ({
  key: r.key,
  value: z8(r, n)
})), M8 = (e, n) => e.map(({ key: r, type: i, defaultValue: a }) => ({
  key: r,
  value: wI({
    key: r,
    configuration: n,
    settingType: i,
    settingDefault: a
  })
})), B8 = ({ fieldDefinitions: e, settingsConfiguration: n }, r) => e ? U8(
  e.filter(({ secret: i }) => !i),
  r
) : M8(
  (n ?? []).filter(({ secret: i }) => !i),
  r
), q8 = (e) => {
  const n = hv();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      renderConditions: l,
      integrationKey: u
    }) => {
      const d = n[i];
      return {
        id: r,
        type: i,
        name: a,
        settings: B8(d, o),
        misconfigured: s,
        renderConditions: l,
        icon: d.icon,
        iconColors: d.iconColors,
        widget: d.widget,
        integrationKey: u
      };
    }
  );
}, zY = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: u,
  renderConditionMatchedIndicator: m,
  widgetAnnotations: d
}) => {
  const f = Bi(
    {}
  ), h = (F) => (f.current[F] || (f.current[F] = { current: null }), f.current[F]), { track: v } = En(), I = Xn(
    () => q8(e),
    [e]
  ), w = {
    headline: "",
    text: "",
    onConfirm: () => C(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [j, _] = de(w), [y, L] = de(!1), $ = (F) => {
    L(!0), _(F);
  }, C = () => {
    L(!1), _(w);
  };
  return /* @__PURE__ */ We.jsxs(We.Fragment, { children: [
    I.map(
      ({
        id: F,
        name: z,
        type: Q,
        widget: J,
        settings: te,
        misconfigured: G,
        renderConditions: B,
        icon: R,
        iconColors: U,
        integrationKey: ee
      }, Se) => {
        const fe = `partner-integration-${Q}`, ye = d?.get(F) === !1, ve = /* @__PURE__ */ We.jsx(Oy, { icon: R, color: U }), K = te?.reduce(
          (_e, Te) => (_e[Te.key] = Te.value, _e),
          {}
        );
        return s ? /* @__PURE__ */ We.jsx("div", { className: "icon-holder", children: ve }, `partner-icon-${F}`) : /* @__PURE__ */ We.jsxs(
          xr,
          {
            onToggle: () => {
              v(
                o(ee) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: F,
                  widgetType: Q.toLowerCase()
                }
              ), a(ee);
            },
            isOpen: o(ee),
            className: fe,
            containerRef: (_e) => {
              h(ee).current = _e;
            },
            children: [
              /* @__PURE__ */ We.jsx(
                xr.Header,
                {
                  className: dt({
                    [gD.unmatchedHeader]: ye
                  }),
                  wrap: "normal",
                  avatar: ve,
                  slotBeforeTitle: u?.(
                    ee,
                    Se,
                    h(ee)
                  ),
                  slotAfterTitle: /* @__PURE__ */ We.jsx(We.Fragment, { children: l?.(ee) }),
                  children: /* @__PURE__ */ We.jsxs(b, { alignItems: "center", flexDirection: "row", gap: "200", children: [
                    z,
                    m?.(
                      B ?? [],
                      F
                    )
                  ] })
                }
              ),
              /* @__PURE__ */ We.jsx(xr.Content, { children: G ? /* @__PURE__ */ We.jsx(Tn, { isMisconfigured: !0 }) : /* @__PURE__ */ We.jsx(
                Xw.Provider,
                {
                  value: {
                    onError: (_e, Te) => console.warn(
                      `Something went wrong with a partner widget of type '${Q}' and id '${F}'`,
                      _e,
                      Te
                    )
                  },
                  children: /* @__PURE__ */ We.jsx(
                    O1,
                    {
                      integrationId: F,
                      type: Q,
                      configuration: n,
                      showNotification: i,
                      showModal: $,
                      children: oE(J, {
                        conversationContext: r,
                        settings: K
                      })
                    }
                  )
                }
              ) })
            ]
          },
          ee
        );
      }
    ),
    /* @__PURE__ */ We.jsx(
      Gw,
      {
        isOpen: y,
        setIsOpen: L,
        headline: j.headline,
        text: j.text,
        confirmLabel: j.confirmLabel,
        confirmVariant: j.confirmVariant,
        cancelLabel: j.cancelLabel,
        cancelVariant: j.cancelVariant,
        onConfirm: j.onConfirm ? () => {
          try {
            j.onConfirm && j.onConfirm();
          } finally {
            L(!1), _(w);
          }
        } : void 0,
        onCancel: j.onCancel ? () => {
          try {
            j.onCancel && j.onCancel();
          } finally {
            L(!1), _(w);
          }
        } : void 0,
        children: j.children
      }
    )
  ] });
}, H8 = Hl`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`;
function UY(e, { skip: n = !1 } = {}) {
  const [r, i] = de([]), [a, o] = de(!1);
  return Je(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), D1(e).query({
      query: H8
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (u) => u != null
        ).map((u) => ({
          ...u,
          integrationKey: `partner-integration-${u.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
const W8 = ({
  widgetConfiguration: e
}) => {
  const n = Xn(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), r = Xn(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: r,
    initialValuesForShopify: []
  };
}, K8 = "FULL_ACCESS", G8 = "2", Y8 = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((u) => u.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [K8],
        version: G8
      })
    }).then((l) => l.json())
  };
}, Q8 = "dixaApiToken", yv = "dixaApiTokenId", CI = "dixaApiTokenName", Vw = (e) => [yv, CI].every(
  (r) => e.find((i) => i?.key === r)
);
function J8({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = X8(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(r, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const X8 = (e) => [
  {
    key: Q8,
    value: e.value,
    secret: !0
  },
  {
    key: yv,
    value: e.id,
    secret: !1
  },
  {
    key: CI,
    value: e.name,
    secret: !1
  }
], Z8 = "_wrapper_1lmim_1", eY = "_wrapperBox_1lmim_4", nY = "_wrapperBoxErrorBorder_1lmim_9", zh = {
  wrapper: Z8,
  wrapperBox: eY,
  wrapperBoxErrorBorder: nY
}, tY = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: u,
  handleChangeText: m
}) => {
  const f = o?.find(
    (L) => L.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: v } = f, I = `Insert your ${h.label.toLowerCase()}`, w = `Insert your ${v.label.toLowerCase()}`, [j, _] = de({
    username: "",
    password: ""
  }), y = ft(
    (L) => {
      m({
        target: {
          name: s,
          value: L
        }
      });
    },
    [s, m]
  );
  return Je(() => {
    y(
      j.username !== "" && j.password !== "" ? window.btoa(`${j.username}:${j.password}`) : ""
    );
  }, [j]), /* @__PURE__ */ We.jsx(
    en,
    {
      required: e,
      label: a,
      meta: l,
      className: zh.wrapper,
      children: /* @__PURE__ */ We.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: dt(zh.wrapperBox, {
            [zh.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ We.jsx(
              ur,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: I,
                input: {
                  name: s,
                  value: j.username,
                  onChange: (L) => _({
                    username: L?.target.value ?? "",
                    password: j.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => u(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ We.jsx(
              ur,
              {
                noAlert: !0,
                required: e,
                label: v.label,
                readOnly: n,
                placeholder: w,
                input: {
                  name: s,
                  value: j.password,
                  onChange: (L) => _({
                    username: j.username,
                    password: L?.target.value ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => u(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function zw({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: u,
  handleEditSecret: m,
  getValueByKey: d,
  isEditingField: f,
  errors: h,
  type: v,
  isCreationMode: I,
  prefix: w,
  integrationId: j,
  integrationType: _,
  configuration: y,
  settings: L,
  otherProps: $
}) {
  const C = v === "custom" && $?.component, F = d(n)?.value;
  return C ? /* @__PURE__ */ We.jsx(
    C,
    {
      configuration: y,
      integrationId: j,
      integrationType: _,
      label: r,
      settings: L,
      getValueByKey: d,
      widgetSettingsKey: n,
      handleChangeSelect: u,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ We.jsxs(We.Fragment, { children: [
    /* @__PURE__ */ We.jsx(ce, { span: 3, children: /* @__PURE__ */ We.jsx(
      rY,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: f,
        handleEditSecret: m,
        isCreationMode: I,
        children: v === "input" ? /* @__PURE__ */ We.jsx(
          ur,
          {
            required: i,
            readOnly: a,
            label: r,
            placeholder: o,
            input: {
              name: n,
              value: F,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: w,
            ...e && !I && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : v === "basicAuthInput" ? /* @__PURE__ */ We.jsx(
          tY,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: I,
            label: r,
            widgetSettingsKey: n,
            settings: L,
            meta: { error: h[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : v === "switch" ? /* @__PURE__ */ We.jsx(en, { label: r, children: /* @__PURE__ */ We.jsx(
          Ry,
          {
            input: {
              name: n,
              value: "",
              checked: F,
              onChange: l
            }
          }
        ) }) : v === "select" ? /* @__PURE__ */ We.jsx(en, { label: r, children: /* @__PURE__ */ We.jsx(
          _i,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (z) => u(n, z),
            getItemTitleByValue: (z) => z ? /* @__PURE__ */ We.jsx(P.Paragraph, { children: z.label }) : /* @__PURE__ */ We.jsx(We.Fragment, {}),
            value: F ? [
              {
                label: ($?.selectItems || []).find(
                  (z) => z.value === F
                )?.label,
                value: F
              }
            ] : [],
            equalityFn: (z, Q) => z.value === Q.value,
            children: ($?.selectItems || []).map((z) => /* @__PURE__ */ We.jsx(kt.Item, { value: z, children: z.label }, z.value))
          }
        ) }) : /* @__PURE__ */ We.jsx(We.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ We.jsx(ce, { span: 3 })
  ] });
}
function rY({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return r || o ? a : /* @__PURE__ */ We.jsx(en, { label: n, children: /* @__PURE__ */ We.jsxs(
    nt,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const Go = "partner-integrations-widget-name-form-field", Uw = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: u
  }) => ({
    key: i,
    value: wI({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !o,
    type: s,
    ...u && { customValidation: u }
  })
), iY = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = de(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = de({}), s = ($) => i($), l = ($) => !$ || $ === "", u = ($) => {
    const { [$]: C, ...F } = a;
    o(F);
  }, m = ($) => ({
    ...$,
    settings: $.settings.filter(({ isEditing: C }) => C).map(({ key: C, value: F, secret: z }) => ({
      key: C,
      value: F,
      secret: z
    }))
  }), d = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = ($) => {
    if (!$)
      return;
    const {
      target: { name: C, value: F }
    } = $;
    a[C] && !l(F) && u(C), i({
      ...r,
      settings: r.settings.map(
        (z) => z.key === C ? { ...z, value: F } : z
      )
    });
  }, h = ($) => {
    if (!$)
      return;
    const {
      target: { name: C, checked: F }
    } = $;
    i({
      ...r,
      settings: r.settings.map(
        (z) => z.key === C ? { ...z, value: F } : z
      )
    });
  }, v = ($, C) => {
    if (!C)
      return;
    const { selectedValues: F } = C, z = F?.[0];
    if (z) {
      const Q = r.settings.map(
        (J) => J.key === $ ? { ...J, value: z?.value } : J
      );
      i({
        ...r,
        settings: Q
      });
    } else {
      const Q = r.settings.filter(
        (J) => J.key !== $
      );
      i({
        ...r,
        settings: Q
      });
    }
  }, I = ($) => {
    i({
      ...r,
      enabled: $
    });
  }, w = ($) => {
    if (!$)
      return;
    const {
      target: { value: C }
    } = $;
    a[Go] && !l(C) && u(Go), i({
      ...r,
      name: C
    });
  }, j = ($, C) => {
    const { settings: F } = r, z = F.map((Q) => Q.key === C ? {
      ...Q,
      isEditing: $,
      ...!$ && { value: "" }
    } : Q);
    a[C] && !$ && u(C), i({
      ...r,
      settings: z
    });
  }, _ = ($) => r.settings.find(
    (C) => C.key === $
  ), y = async ($) => {
    $.preventDefault(), L() && n(m(r));
  }, L = () => {
    const $ = {}, { name: C, settings: F } = r;
    return l(C) && ($[Go] = d.input), F.forEach(
      ({ key: z, value: Q, required: J, isEditing: te, type: G, customValidation: B }) => {
        if (J && te)
          if (B) {
            const R = B(Q);
            typeof R == "string" && ($[z] = R);
          } else
            typeof Q == "string" && l(Q) && ($[z] = d[G]);
      }
    ), o($), !Object.keys($)?.length;
  };
  return {
    formData: r,
    errors: a,
    handleIsEnabled: I,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: v,
    handleEditSecret: j,
    handleChangeName: w,
    handleSubmit: y,
    getSettingValueByKey: _,
    initializeFormData: s,
    validate: L
  };
}, aY = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], Mw = "The configuration of the integration is not correct. Please check the settings.", oY = (e) => {
  const n = hv()[e.type]?.WidgetSettings;
  return n ? /* @__PURE__ */ We.jsx(n, { ...e }) : /* @__PURE__ */ We.jsx(sY, { ...e });
}, sY = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => {
  const { track: l } = En(), { deleteDixaApiToken: u, createDixaApiToken: m } = Y8({
    type: n,
    baseUrl: a.baseUrl
  }), f = SE().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), h = !e && !!n && !!f, v = aY.includes(n), [I, w] = de(), [j, _] = de(!1), [y, L] = de(!1), [$, C] = de(!1), [F, z] = de(null), [Q, J] = de(), [te, G] = de(h ? [] : null);
  Je(() => {
    G(h ? [] : null);
  }, [e, h]), Je(() => {
    Q && te === null && G(Q.renderConditions ?? []);
  }, [Q, te]);
  const { isInboundOAuth: B } = XI(), R = B && h ? "Submit & Authorize" : "Submit", {
    hasShopifyWidgetOAuth: U,
    isShopifyMarketplaceApp: ee,
    initialValuesForShopify: Se
  } = W8({
    featureFlags: a.featureFlags,
    widgetConfiguration: Q
  }), fe = n === "YOTPO" && !!Q?.additionalProperties?.isUsingOAuth, ye = n === "KLAVIYO" && !!Q?.additionalProperties?.isUsingOAuth, ve = h && n === "SHOPIFY", Te = hv({
    SHOPIFY: {
      hasShopifyOAuth: U,
      isShopifyMarketplaceApp: ee,
      isCreationMode: h
    },
    YOTPO: {
      hasOAuth: fe,
      isCreationMode: h
    },
    KLAVIYO: {
      hasOAuth: ye,
      isCreationMode: h
    }
  })[n].settingsConfiguration ?? [], X = Te.filter(({ type: H }) => H !== "hidden").filter(({ hideOnCreate: H }) => h ? !H : !0), Ke = X.filter(
    ({ additionalProperties: H }) => H?.renderAboveForm === !0
  ), an = X.filter(
    ({ additionalProperties: H }) => H?.renderAboveForm !== !0
  ), {
    error: we,
    loading: Me,
    refetch: Re
  } = bE(ZI, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (H) => {
      if (Object.keys(H).length === 0)
        C(!0);
      else {
        C(!1);
        const Y = H?.Management?.widgetConfigurations?.[0];
        Y && J({
          ...Y,
          // Not needed here, just to satisfy the type
          integrationKey: `partner-integration-${Y.id}`,
          additionalProperties: Y.additionalProperties ?? void 0
        });
      }
    }
  }), [Be, { error: Ae }] = Nv(
    h ? eE : nE,
    {
      onError: (H) => {
        w(H), _(!1), i({
          title: "Something went wrong",
          text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (H) => {
        if (_(!1), Object.keys(H).length !== 0) {
          if (h && r(
            H.Management?.createWidgetConfiguration?.id
          ), !h) {
            const A = H.Management?.updateWidgetConfiguration;
            A?.misconfigured ? z(
              A.misconfigurationCause ?? Mw
            ) : z(null);
          }
          if ((h || s) && te) {
            const Y = (Q?.renderConditions?.length ?? 0) > 0;
            tE(
              l,
              h,
              te,
              Y
            );
          }
          i({
            title: `${h ? "Creating" : "Updating"} was successful`,
            text: `${h ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [Ge] = Nv(rE, {
    onError: (H) => {
      w(H), _(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      _(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: Ce,
    handleIsEnabled: qe,
    errors: nn,
    handleChangeText: ae,
    handleChangeBoolean: le,
    handleChangeSelect: xe,
    handleEditSecret: Le,
    handleChangeName: Pe,
    handleSubmit: yn,
    getSettingValueByKey: T,
    initializeFormData: x
  } = iY({
    onSubmit: async (H) => {
      h ? l("settings:create:submitted", { widgetType: n }) : e && l("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), _(!0);
      const Y = H.settings.map(
        (ge) => typeof ge.value == "boolean" ? { ...ge, value: ge.value.toString() } : ge
      ), A = Vw(Y) && h;
      let M = [];
      if (A) {
        const ge = await m().catch(
          (Ne) => {
            _(!1), console.warn("API-Token (creation) error resonse", Ne), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        ge?.data && (M = J8({
          token: ge.data,
          settings: Y
        }));
      }
      const oe = {
        ...H,
        settings: [
          ...M.length > 0 ? M : Y
        ]
      };
      (A && M.length > 1 || !A && M.length === 0) && (Be({
        variables: {
          ...!h && { id: e },
          ...h && { type: n },
          ...oe,
          ...(h || !!s) && te !== null && { renderConditions: te }
        }
      }), Y.forEach(
        (Ne) => Ne.secret && Le(!1, Ne.key)
      ));
    },
    ...h && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: Uw({
          settingsFromBackend: Se,
          settingsConfiguration: Te,
          creating: !0
        })
      }
    }
  });
  Je(() => {
    if (Q) {
      const H = Uw({
        settingsFromBackend: Q.settings,
        settingsConfiguration: Te
      });
      x({
        enabled: !!Q.enabled,
        name: Q.name,
        settings: H
      }), Q.misconfigured ? z(
        Q?.misconfigurationCause ?? Mw
      ) : z(null);
    }
  }, [Q]);
  const D = Xn(() => o ? !o.isCoupled : !0, [o]);
  return we || Ae || I ? /* @__PURE__ */ We.jsx(
    Tn,
    {
      error: we || I,
      retry: we ? Re : void 0
    }
  ) : j || Me ? /* @__PURE__ */ We.jsx(vn, { "data-testid": "widget-settings-loading" }) : $ ? /* @__PURE__ */ We.jsxs(P.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ We.jsx(Yn, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ We.jsxs("form", { children: [
    F && /* @__PURE__ */ We.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ We.jsx(
      ql,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ We.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ We.jsx(P.Paragraph, { children: F }),
          /* @__PURE__ */ We.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ We.jsx(P.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ We.jsx(P.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ We.jsxs(
      mt,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          Ke.map(
            ({ key: H, label: Y, ...A }) => /* @__PURE__ */ We.jsx(
              zw,
              {
                widgetSettingsKey: H,
                isEditingField: !1,
                handleEditSecret: () => {
                },
                handleChangeText: () => {
                },
                handleChangeBoolean: () => {
                },
                handleChangeSelect: () => {
                },
                getValueByKey: T,
                isSecret: !1,
                label: Y,
                placeholder: "",
                required: !1,
                errors: nn,
                type: "custom",
                isCreationMode: h,
                integrationId: e,
                integrationType: n,
                configuration: a,
                settings: Te,
                otherProps: A
              },
              H
            )
          ),
          !ve && /* @__PURE__ */ We.jsxs(We.Fragment, { children: [
            /* @__PURE__ */ We.jsx(ce, { children: /* @__PURE__ */ We.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ We.jsx(
              Ry,
              {
                input: {
                  name: "enabled",
                  checked: Ce.enabled,
                  value: "dummy",
                  onChange: (H) => qe(H.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ We.jsx(ce, { span: 3, children: /* @__PURE__ */ We.jsx(
              ur,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: Go,
                  value: Ce.name,
                  onChange: Pe
                },
                meta: {
                  error: nn[Go]
                }
              }
            ) }),
            /* @__PURE__ */ We.jsx(ce, { span: 3 })
          ] }),
          !ve && s && te !== null && /* @__PURE__ */ We.jsx(ce, { children: s({
            value: te,
            onChange: G,
            configurationKey: Q?.id
          }) }),
          an?.map(
            ({
              key: H,
              secret: Y,
              label: A,
              placeholder: M = "",
              required: oe = !1,
              type: ge,
              prefix: Ne,
              readOnly: rn,
              ...gn
            }) => {
              const { settings: tn } = Ce, dn = tn.find(
                (wn) => wn.key === H
              );
              return /* @__PURE__ */ We.jsx(sE, { children: /* @__PURE__ */ We.jsx(
                zw,
                {
                  widgetSettingsKey: H,
                  isEditingField: !!dn?.isEditing,
                  handleEditSecret: Le,
                  handleChangeText: ae,
                  handleChangeBoolean: le,
                  handleChangeSelect: xe,
                  getValueByKey: T,
                  isSecret: Y,
                  label: A,
                  placeholder: M,
                  required: oe,
                  errors: nn,
                  type: ge,
                  isCreationMode: h,
                  prefix: Ne,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: rn,
                  settings: Te,
                  otherProps: gn
                }
              ) }, H);
            }
          )
        ]
      }
    ),
    !ve && /* @__PURE__ */ We.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ We.jsx(nt, { onClick: yn, children: R }),
      !h && /* @__PURE__ */ We.jsx(
        Xe,
        {
          content: "The widget is used in automations",
          disabled: D,
          children: /* @__PURE__ */ We.jsx(
            nt,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && l("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), L(!0);
              },
              disabled: !D,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ We.jsx(
      Gw,
      {
        isOpen: y,
        setIsOpen: L,
        confirmVariant: v ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && l("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && l("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), Vw(Ce.settings)) {
            const H = Ce.settings.find(
              ({ key: Y }) => Y === yv
            )?.value;
            H && u(H).catch((Y) => {
              console.warn("API-Token (deletion) error response", Y), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          Ge({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ We.jsx(b, { children: v ? /* @__PURE__ */ We.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ We.jsx(
            he,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ We.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ We.jsxs(P.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ We.jsxs(P.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ We.jsxs(P.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              Ce.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ We.jsxs(We.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          Ce.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, MY = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => /* @__PURE__ */ We.jsx(
  Xw.Provider,
  {
    value: {
      onError: (l, u) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        l,
        u
      )
    },
    children: /* @__PURE__ */ We.jsx(
      O1,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ We.jsx(
          oY,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o,
            renderConditionsEditor: s
          }
        )
      }
    )
  }
), Bw = "__PairingContext__", FI = globalThis[Bw] ?? (() => {
  const e = Qw({});
  return globalThis[Bw] = e, e;
})(), BY = () => Ty(FI), qY = ({
  value: e,
  children: n
}) => /* @__PURE__ */ We.jsx(FI.Provider, { value: e, children: n });
var Js = { exports: {} }, qw;
function lY() {
  if (qw) return Js.exports;
  qw = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(C, F, z) {
    return Function.prototype.apply.call(C, F, z);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(C) {
    return Object.getOwnPropertyNames(C).concat(Object.getOwnPropertySymbols(C));
  } : r = function(C) {
    return Object.getOwnPropertyNames(C);
  };
  function i($) {
    console && console.warn && console.warn($);
  }
  var a = Number.isNaN || function(C) {
    return C !== C;
  };
  function o() {
    o.init.call(this);
  }
  Js.exports = o, Js.exports.once = _, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l($) {
    if (typeof $ != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof $);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function($) {
      if (typeof $ != "number" || $ < 0 || a($))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + $ + ".");
      s = $;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(C) {
    if (typeof C != "number" || C < 0 || a(C))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + C + ".");
    return this._maxListeners = C, this;
  };
  function u($) {
    return $._maxListeners === void 0 ? o.defaultMaxListeners : $._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return u(this);
  }, o.prototype.emit = function(C) {
    for (var F = [], z = 1; z < arguments.length; z++) F.push(arguments[z]);
    var Q = C === "error", J = this._events;
    if (J !== void 0)
      Q = Q && J.error === void 0;
    else if (!Q)
      return !1;
    if (Q) {
      var te;
      if (F.length > 0 && (te = F[0]), te instanceof Error)
        throw te;
      var G = new Error("Unhandled error." + (te ? " (" + te.message + ")" : ""));
      throw G.context = te, G;
    }
    var B = J[C];
    if (B === void 0)
      return !1;
    if (typeof B == "function")
      n(B, this, F);
    else
      for (var R = B.length, U = I(B, R), z = 0; z < R; ++z)
        n(U[z], this, F);
    return !0;
  };
  function m($, C, F, z) {
    var Q, J, te;
    if (l(F), J = $._events, J === void 0 ? (J = $._events = /* @__PURE__ */ Object.create(null), $._eventsCount = 0) : (J.newListener !== void 0 && ($.emit(
      "newListener",
      C,
      F.listener ? F.listener : F
    ), J = $._events), te = J[C]), te === void 0)
      te = J[C] = F, ++$._eventsCount;
    else if (typeof te == "function" ? te = J[C] = z ? [F, te] : [te, F] : z ? te.unshift(F) : te.push(F), Q = u($), Q > 0 && te.length > Q && !te.warned) {
      te.warned = !0;
      var G = new Error("Possible EventEmitter memory leak detected. " + te.length + " " + String(C) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      G.name = "MaxListenersExceededWarning", G.emitter = $, G.type = C, G.count = te.length, i(G);
    }
    return $;
  }
  o.prototype.addListener = function(C, F) {
    return m(this, C, F, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(C, F) {
    return m(this, C, F, !0);
  };
  function d() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f($, C, F) {
    var z = { fired: !1, wrapFn: void 0, target: $, type: C, listener: F }, Q = d.bind(z);
    return Q.listener = F, z.wrapFn = Q, Q;
  }
  o.prototype.once = function(C, F) {
    return l(F), this.on(C, f(this, C, F)), this;
  }, o.prototype.prependOnceListener = function(C, F) {
    return l(F), this.prependListener(C, f(this, C, F)), this;
  }, o.prototype.removeListener = function(C, F) {
    var z, Q, J, te, G;
    if (l(F), Q = this._events, Q === void 0)
      return this;
    if (z = Q[C], z === void 0)
      return this;
    if (z === F || z.listener === F)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Q[C], Q.removeListener && this.emit("removeListener", C, z.listener || F));
    else if (typeof z != "function") {
      for (J = -1, te = z.length - 1; te >= 0; te--)
        if (z[te] === F || z[te].listener === F) {
          G = z[te].listener, J = te;
          break;
        }
      if (J < 0)
        return this;
      J === 0 ? z.shift() : w(z, J), z.length === 1 && (Q[C] = z[0]), Q.removeListener !== void 0 && this.emit("removeListener", C, G || F);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(C) {
    var F, z, Q;
    if (z = this._events, z === void 0)
      return this;
    if (z.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : z[C] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete z[C]), this;
    if (arguments.length === 0) {
      var J = Object.keys(z), te;
      for (Q = 0; Q < J.length; ++Q)
        te = J[Q], te !== "removeListener" && this.removeAllListeners(te);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (F = z[C], typeof F == "function")
      this.removeListener(C, F);
    else if (F !== void 0)
      for (Q = F.length - 1; Q >= 0; Q--)
        this.removeListener(C, F[Q]);
    return this;
  };
  function h($, C, F) {
    var z = $._events;
    if (z === void 0)
      return [];
    var Q = z[C];
    return Q === void 0 ? [] : typeof Q == "function" ? F ? [Q.listener || Q] : [Q] : F ? j(Q) : I(Q, Q.length);
  }
  o.prototype.listeners = function(C) {
    return h(this, C, !0);
  }, o.prototype.rawListeners = function(C) {
    return h(this, C, !1);
  }, o.listenerCount = function($, C) {
    return typeof $.listenerCount == "function" ? $.listenerCount(C) : v.call($, C);
  }, o.prototype.listenerCount = v;
  function v($) {
    var C = this._events;
    if (C !== void 0) {
      var F = C[$];
      if (typeof F == "function")
        return 1;
      if (F !== void 0)
        return F.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function I($, C) {
    for (var F = new Array(C), z = 0; z < C; ++z)
      F[z] = $[z];
    return F;
  }
  function w($, C) {
    for (; C + 1 < $.length; C++)
      $[C] = $[C + 1];
    $.pop();
  }
  function j($) {
    for (var C = new Array($.length), F = 0; F < C.length; ++F)
      C[F] = $[F].listener || $[F];
    return C;
  }
  function _($, C) {
    return new Promise(function(F, z) {
      function Q(te) {
        $.removeListener(C, J), z(te);
      }
      function J() {
        typeof $.removeListener == "function" && $.removeListener("error", Q), F([].slice.call(arguments));
      }
      L($, C, J, { once: !0 }), C !== "error" && y($, Q, { once: !0 });
    });
  }
  function y($, C, F) {
    typeof $.on == "function" && L($, "error", C, F);
  }
  function L($, C, F, z) {
    if (typeof $.on == "function")
      z.once ? $.once(C, F) : $.on(C, F);
    else if (typeof $.addEventListener == "function")
      $.addEventListener(C, function Q(J) {
        z.once && $.removeEventListener(C, Q), F(J);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof $);
  }
  return Js.exports;
}
var cY = lY();
function HY() {
  const e = new cY.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  mD as GraphQLClientProvider,
  FI as PairingContext,
  qY as PairingProvider,
  zY as PartnerIntegrations,
  MY as PartnerIntegrationsSettings,
  hv as getWidgetDefinitions,
  HY as initializePartnerEventEmitter,
  BY as usePairing,
  UY as usePartnerIntegrationWidgetConfigurations,
  W8 as useShopifyConfiguration
};
